import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
};

export type AccessPeriod = {
  __typename?: 'AccessPeriod';
  agreement: Agreement;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  location: Location;
  start: Scalars['DateTime'];
  updatedDate: Scalars['DateTime'];
};

export type AccountReportInput = {
  locations: Array<Scalars['String']>;
  status: Array<ActiveStatus>;
  type: Array<MemberStatus>;
};

export enum AccountStatus {
  Active = 'Active',
  Expired = 'Expired',
  Na = 'NA',
  PastDue = 'PastDue'
}

export enum ActiveStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type Admin = {
  __typename?: 'Admin';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  organization: Organization;
  updatedDate: Scalars['DateTime'];
  user: User;
};

export type AggregatedRevenue = {
  __typename?: 'AggregatedRevenue';
  revenueGroup: Scalars['String'];
  totalAmount: Scalars['Float'];
};

export type Agreement = {
  __typename?: 'Agreement';
  Unit: Unit;
  accessPeriods?: Maybe<Array<AccessPeriod>>;
  additionalPolicies: Array<Policy>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  draftMode: DraftMode;
  draftValue?: Maybe<Scalars['Int']>;
  groupPricingType?: Maybe<GroupPricingType>;
  id: Scalars['ID'];
  initialAllotments: Array<ServiceAllotment>;
  initialCharges: Array<InitialCharge>;
  isActive: Scalars['Boolean'];
  isAutoRenew: Scalars['Boolean'];
  isGeneric: Scalars['Boolean'];
  isGroup: Scalars['Boolean'];
  isMembership: Scalars['Boolean'];
  isOrg: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  locations?: Maybe<Array<Location>>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  paymentFrequency: PaymentFrequency;
  postponeUntil?: Maybe<Scalars['DateTime']>;
  recurringAllotments: Array<ServiceAllotment>;
  recurringCharges: Array<RecurringCharge>;
  scalingPrice?: Maybe<Scalars['Int']>;
  termValue: Scalars['Int'];
  updatedDate: Scalars['DateTime'];
  version: Scalars['Int'];
  viid: Scalars['String'];
};

export type AgreementRecipient = {
  __typename?: 'AgreementRecipient';
  client: Client;
  clientGroup?: Maybe<ClientGroup>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  signedAgreement: SignedAgreement;
  signedDocs: Array<SignedDocumentGroup>;
  updatedDate: Scalars['DateTime'];
};

export type AlterAgreementRecord = {
  __typename?: 'AlterAgreementRecord';
  alterationAgreementStatus?: Maybe<AlterationAgreementStatus>;
  alterationAgreementType?: Maybe<AlterationAgreementType>;
  clientId?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  endFreezeAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  intervals: Scalars['Int'];
  location: Location;
  notes?: Maybe<Scalars['String']>;
  reason?: Maybe<AlterationReason>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  reviewedBy?: Maybe<User>;
  signedAgreement: SignedAgreement;
  startFreezeAt?: Maybe<Scalars['DateTime']>;
  updatedDate: Scalars['DateTime'];
};

export enum AlterationAgreementStatus {
  Active = 'Active',
  Approved = 'Approved',
  Completed = 'Completed',
  Denied = 'Denied',
  Requested = 'Requested'
}

export enum AlterationAgreementType {
  Cancel = 'Cancel',
  Freeze = 'Freeze'
}

export type AlterationReason = {
  __typename?: 'AlterationReason';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  location: Location;
  reason?: Maybe<Scalars['String']>;
  type?: Maybe<AlterationAgreementType>;
  updatedDate: Scalars['DateTime'];
};

export type Attendance = {
  __typename?: 'Attendance';
  attendanceStatus: AttendanceStatus;
  attendanceType: AttendanceType;
  attendee: Attendee;
  checkInAt?: Maybe<Scalars['DateTime']>;
  createdDate: Scalars['DateTime'];
  creditAllotment?: Maybe<CreditAllotment>;
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isPaid: Scalars['Boolean'];
  meeting: Meeting;
  transaction?: Maybe<Transaction>;
  updatedDate: Scalars['DateTime'];
};

export enum AttendanceStatus {
  Attended = 'Attended',
  Cancelled = 'Cancelled',
  Missed = 'Missed',
  Upcoming = 'Upcoming'
}

export enum AttendanceType {
  General = 'General',
  Group = 'Group',
  Individual = 'Individual'
}

export type Attendee = {
  __typename?: 'Attendee';
  attendeeType: AttendeeType;
  client: Client;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  organization: Organization;
  updatedDate: Scalars['DateTime'];
};

export enum AttendeeType {
  Client = 'Client',
  Guest = 'Guest',
  Lead = 'Lead'
}

export enum BankAccountType {
  Checking = 'Checking',
  Savings = 'Savings'
}

export type CalendarFilters = {
  __typename?: 'CalendarFilters';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  employee: Employee;
  id: Scalars['ID'];
  instructors?: Maybe<Array<Employee>>;
  location: Location;
  rooms?: Maybe<Array<Room>>;
  services?: Maybe<Array<LocationService>>;
  updatedDate: Scalars['DateTime'];
};

export type CartProductInput = {
  count: Scalars['Int'];
  product: GenericConnectInput;
};

export type CategoryOption = {
  __typename?: 'CategoryOption';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  organization: Organization;
  type: CategoryOptionType;
  updatedDate: Scalars['DateTime'];
};

export enum CategoryOptionType {
  Agreement = 'Agreement',
  Fee = 'Fee',
  Revenue = 'Revenue',
  Service = 'Service',
  Tag = 'Tag'
}

export type CheckIn = {
  __typename?: 'CheckIn';
  checkInAt?: Maybe<Scalars['DateTime']>;
  client: Client;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isAccepted: Scalars['Boolean'];
  isOverride: Scalars['Boolean'];
  location: Location;
  note?: Maybe<Notes>;
  updatedDate: Scalars['DateTime'];
};

export type CheckInSubscriptionPayload = {
  __typename?: 'CheckInSubscriptionPayload';
  newCheckIn: CheckIn;
};

export type CheckoutLineItem = {
  __typename?: 'CheckoutLineItem';
  commission?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  discounts?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: Maybe<Location>;
  organization?: Maybe<Organization>;
  product?: Maybe<Product>;
  productType: ProductType;
  shoppingCart?: Maybe<ShoppingCart>;
  subcharges?: Maybe<LineItemSubCharge>;
  subtotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction?: Maybe<Transaction>;
  updatedDate: Scalars['DateTime'];
};

export type Client = {
  __typename?: 'Client';
  address?: Maybe<Scalars['String']>;
  agreements: Array<SignedAgreement>;
  attendee?: Maybe<Attendee>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  credits: Array<CreditAllotment>;
  defaultLocation?: Maybe<Location>;
  deletedDate?: Maybe<Scalars['DateTime']>;
  dob?: Maybe<Scalars['String']>;
  emergencyName?: Maybe<Scalars['String']>;
  emergencyPhone?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  groups?: Maybe<Array<ClientGroup>>;
  homePhone?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idNumber?: Maybe<Scalars['String']>;
  lastVisitDate?: Maybe<Scalars['DateTime']>;
  leadStatus?: Maybe<LeadStatus>;
  locations?: Maybe<Array<Location>>;
  memberCode?: Maybe<Scalars['String']>;
  memberStatus: MemberStatus;
  memberships: Array<SignedAgreement>;
  migrationId?: Maybe<Scalars['String']>;
  notes: Array<Notes>;
  organization?: Maybe<Organization>;
  paymentMethods?: Maybe<Array<ClientPaymentMethods>>;
  preferences?: Maybe<ClientPreferences>;
  relationship?: Maybe<Scalars['String']>;
  signedAgreements: Array<SignedAgreement>;
  standing?: Maybe<AccountStatus>;
  state?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
  user: User;
  workPhone?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ClientChangeRecord = {
  __typename?: 'ClientChangeRecord';
  author: Scalars['String'];
  client: Client;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  employee?: Maybe<Employee>;
  id: Scalars['ID'];
  isJSON: Scalars['Boolean'];
  modalName: Scalars['String'];
  newValues?: Maybe<Scalars['String']>;
  oldValues?: Maybe<Scalars['String']>;
  organization: Organization;
  updatedDate: Scalars['DateTime'];
};

export type ClientGroup = {
  __typename?: 'ClientGroup';
  clientGroupType: ClientGroupType;
  clients: Array<Client>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  primaryClient: Client;
  signedAgreement?: Maybe<SignedAgreement>;
  updatedDate: Scalars['DateTime'];
};

export enum ClientGroupType {
  Both = 'Both',
  Product = 'Product',
  Subscription = 'Subscription'
}

export type ClientPaymentMethods = {
  __typename?: 'ClientPaymentMethods';
  accountType?: Maybe<BankAccountType>;
  client: Client;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  externalMerchantRef?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isComplete: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  location?: Maybe<Location>;
  mask?: Maybe<Scalars['String']>;
  merchant?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentMethods: Array<SignedAgreement>;
  routingNumber?: Maybe<Scalars['String']>;
  sharedClients?: Maybe<Array<Client>>;
  type: PaymentMethodType;
  updatedDate: Scalars['DateTime'];
  user: User;
  vendor: PaymentType;
};

export type ClientPreferences = {
  __typename?: 'ClientPreferences';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  minimumNotice: Scalars['Float'];
  notificationType: NotificationType;
  updatedDate: Scalars['DateTime'];
};

export type ClientSubscription = {
  __typename?: 'ClientSubscription';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  location: Location;
  nextDraftDate?: Maybe<Scalars['DateTime']>;
  paymentFrequency: PaymentFrequency;
  paymentStatus: PaymentStatus;
  recurringCharges: Array<RecurringCharge>;
  scheduledTransaction?: Maybe<Array<ScheduledTransaction>>;
  signedAgreement: SignedAgreement;
  startDate?: Maybe<Scalars['DateTime']>;
  subscriptionStatus?: Maybe<SubscriptionStatus>;
  transactions: Transaction;
  updatedDate: Scalars['DateTime'];
  vendor: PaymentType;
};

export type ClientsJsonArrInput = {
  data: Array<InternalClientsInput>;
};

export type ClockOutInput = {
  endedAt: Scalars['DateTime'];
  location: GenericConnectInput;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
};

export type ContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreateAccessPeriodInput = {
  agreement: GenericConnectInput;
  end: Scalars['DateTime'];
  location: GenericConnectInput;
  start: Scalars['DateTime'];
};

export type CreateAgreementInput = {
  Unit: Unit;
  additionalPolicies: Array<GenericConnectInput>;
  description?: InputMaybe<Scalars['String']>;
  draftMode: DraftMode;
  draftValue?: InputMaybe<Scalars['Float']>;
  groupPricingType?: InputMaybe<GroupPricingType>;
  isAutoRenew: Scalars['Boolean'];
  isGeneric: Scalars['Boolean'];
  isGroup: Scalars['Boolean'];
  isMembership: Scalars['Boolean'];
  isOrg: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  name: Scalars['String'];
  paymentFrequency: PaymentFrequency;
  postponeUntil?: InputMaybe<Scalars['DateTime']>;
  scalingPrice?: InputMaybe<Scalars['Int']>;
  termValue: Scalars['Int'];
};

export type CreateAgreementRecipientInput = {
  client: GenericConnectInput;
  signedAgreement: GenericConnectInput;
};

export type CreateAlterAgreementRecordInput = {
  alterationAgreementStatus?: InputMaybe<AlterationAgreementStatus>;
  alterationAgreementType?: InputMaybe<AlterationAgreementType>;
  clientId?: InputMaybe<Scalars['String']>;
  endFreezeAt?: InputMaybe<Scalars['DateTime']>;
  intervals?: InputMaybe<Scalars['Int']>;
  location: GenericConnectInput;
  notes?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<GenericConnectInput>;
  reviewedAt?: InputMaybe<Scalars['DateTime']>;
  reviewedBy?: InputMaybe<GenericConnectInput>;
  signedAgreement: GenericConnectInput;
  startFreezeAt?: InputMaybe<Scalars['DateTime']>;
};

export type CreateAlterationReasonInput = {
  location: GenericConnectInput;
  reason?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AlterationAgreementType>;
};

export type CreateAttendanceInput = {
  attendanceStatus: AttendanceStatus;
  attendanceType: AttendanceType;
  attendee: GenericConnectInput;
  checkInAt?: InputMaybe<Scalars['DateTime']>;
  creditAllotment?: InputMaybe<GenericConnectInput>;
  meeting: GenericConnectInput;
  transaction?: InputMaybe<GenericConnectInput>;
};

export type CreateCategoryOptionInput = {
  name: Scalars['String'];
  organization: GenericConnectInput;
  type: CategoryOptionType;
};

export type CreateCheckInInput = {
  client: GenericConnectInput;
  location: GenericConnectInput;
};

export type CreateClientGroupInput = {
  clientGroupType: ClientGroupType;
  name: Scalars['String'];
  primaryClient: GenericConnectInput;
};

export type CreateClientInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  defaultLocation?: InputMaybe<GenericConnectInput>;
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  emergencyName?: InputMaybe<Scalars['String']>;
  emergencyPhone?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  groups?: InputMaybe<Array<GenericConnectInput>>;
  homePhone?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  leadStatus?: InputMaybe<LeadStatus>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  memberStatus?: InputMaybe<MemberStatus>;
  middleName?: InputMaybe<Scalars['String']>;
  migrationId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<CreateClientPreferencesInput>;
  profilePicUrl?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  workPhone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateClientPaymentMethodInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<Scalars['String']>;
  mask?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sharedClients?: InputMaybe<Array<GenericConnectInput>>;
  type?: InputMaybe<PaymentMethodType>;
  vendor: PaymentType;
};

export type CreateClientPreferencesInput = {
  minimumNotice: Scalars['Float'];
  notificationType: NotificationType;
};

export type CreateClientSubscriptionInput = {
  endDate: Scalars['DateTime'];
  externalId: Scalars['String'];
  isActive: Scalars['Boolean'];
  location: GenericConnectInput;
  nextDraftDate: Scalars['DateTime'];
  paymentStatus: PaymentStatus;
  signedAgreement: GenericConnectInput;
  startDate: Scalars['DateTime'];
  subscriptionStatus: SubscriptionStatus;
  vendor: PaymentType;
};

export type CreateCreditAllotmentInput = {
  agreement?: InputMaybe<GenericConnectInput>;
  client: GenericConnectInput;
  count?: InputMaybe<Scalars['Float']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  package?: InputMaybe<GenericConnectInput>;
  privateSessions?: InputMaybe<Array<GenericConnectInput>>;
  serviceAllotment?: InputMaybe<GenericConnectInput>;
  services?: InputMaybe<Array<GenericConnectInput>>;
  transaction?: InputMaybe<GenericConnectInput>;
};

export type CreateDiscountCodeInput = {
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  discountCodeType: DiscountCodeType;
  expirationUnit?: InputMaybe<Unit>;
  expirationValue?: InputMaybe<Scalars['Int']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  isPercent?: InputMaybe<Scalars['Boolean']>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  isStaffOnly?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  mode: ExpirationMode;
  name: Scalars['String'];
  recurring?: InputMaybe<Scalars['Boolean']>;
  startAt: Scalars['DateTime'];
  useLimit?: InputMaybe<Scalars['Int']>;
  value: Scalars['Int'];
};

export type CreateEmployeeInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locations: Array<GenericConnectInput>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profilePicUrl?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<GenericConnectInput>;
  staffId?: InputMaybe<Scalars['String']>;
  stations?: InputMaybe<Array<GenericConnectInput>>;
  username: Scalars['String'];
};

export type CreateEmployeeRoleInput = {
  calendar?: InputMaybe<RolePermissionType>;
  catalog?: InputMaybe<RolePermissionType>;
  checkInQueue?: InputMaybe<RolePermissionType>;
  clients?: InputMaybe<RolePermissionType>;
  description?: InputMaybe<Scalars['String']>;
  employeeStations?: InputMaybe<RolePermissionType>;
  locAgreements?: InputMaybe<RolePermissionType>;
  locDashboard?: InputMaybe<RolePermissionType>;
  locDiscounts?: InputMaybe<RolePermissionType>;
  locEmployees?: InputMaybe<RolePermissionType>;
  locPackages?: InputMaybe<RolePermissionType>;
  locPolicies?: InputMaybe<RolePermissionType>;
  locProducts?: InputMaybe<RolePermissionType>;
  locReports?: InputMaybe<RolePermissionType>;
  locRequests?: InputMaybe<RolePermissionType>;
  locRooms?: InputMaybe<RolePermissionType>;
  locServices?: InputMaybe<RolePermissionType>;
  locSettings?: InputMaybe<RolePermissionType>;
  locTimeclock?: InputMaybe<RolePermissionType>;
  name: Scalars['String'];
  orgAgreements?: InputMaybe<RolePermissionType>;
  orgDiscounts?: InputMaybe<RolePermissionType>;
  orgLocations?: InputMaybe<RolePermissionType>;
  orgPackages?: InputMaybe<RolePermissionType>;
  orgPolicies?: InputMaybe<RolePermissionType>;
  orgRoles?: InputMaybe<RolePermissionType>;
  orgService?: InputMaybe<RolePermissionType>;
  orgSettings?: InputMaybe<RolePermissionType>;
  personalTimeClock?: InputMaybe<RolePermissionType>;
};

export type CreateEmployeeStationInput = {
  description?: InputMaybe<Scalars['String']>;
  employee: Array<GenericConnectInput>;
  location: GenericConnectInput;
  maxShift?: InputMaybe<Scalars['Float']>;
  minShift?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  payRate: Scalars['Float'];
};

export type CreateInitialChargeInput = {
  agreement?: InputMaybe<GenericConnectInput>;
  cost: Scalars['Float'];
  fee?: InputMaybe<GenericConnectInput>;
  isDiscountable?: InputMaybe<Scalars['Boolean']>;
  isPostTax?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  package?: InputMaybe<GenericConnectInput>;
  revenueCategory: GenericConnectInput;
  taxRates: Array<GenericConnectInput>;
};

export type CreateLocationInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  logoImage?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notificationSenderNumber?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<GenericConnectInput>;
  primaryContact?: InputMaybe<ContactInfoInput>;
  state?: InputMaybe<Scalars['String']>;
  stationsEnabled?: InputMaybe<Scalars['Boolean']>;
  timezone: Scalars['String'];
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateLocationMonthlyFeeInput = {
  amount: Scalars['Float'];
  location: GenericConnectInput;
  locationRevenue: GenericConnectInput;
  name: Scalars['String'];
};

export type CreateLocationOfferingInput = {
  agreement: GenericConnectInput;
  details: Array<Scalars['String']>;
  header: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  location: GenericConnectInput;
  name?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  subtext?: InputMaybe<Scalars['String']>;
};

export type CreateLocationPaymentServiceInput = {
  externalId: Scalars['String'];
  location: GenericConnectInput;
  name: Scalars['String'];
  orgPaymentService: GenericConnectInput;
  paymentType: PaymentType;
};

export type CreateLocationServiceInput = {
  cost: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isPrepay: Scalars['Boolean'];
  location: GenericConnectInput;
  organizationService: GenericConnectInput;
  rooms?: InputMaybe<Array<GenericConnectInput>>;
};

export type CreateLocationTaxRateInput = {
  location: GenericConnectInput;
  organizationTaxRate: GenericConnectInput;
  taxRate: Scalars['Float'];
};

export type CreateLocationTransactionFeeInput = {
  flatRate: Scalars['Float'];
  location: GenericConnectInput;
  locationRevenue: GenericConnectInput;
  percentage: Scalars['Float'];
  type: TransactionFeeType;
};

export type CreateMeetingInput = {
  additionalPolicies?: InputMaybe<Array<GenericConnectInput>>;
  attendees?: InputMaybe<Array<GenericConnectInput>>;
  description?: InputMaybe<Scalars['String']>;
  duration: Scalars['Int'];
  imgUrl?: InputMaybe<Scalars['String']>;
  instructor?: InputMaybe<GenericConnectInput>;
  isPrivateSession?: InputMaybe<Scalars['Boolean']>;
  isSelfEnroll: Scalars['Boolean'];
  isWaitlistEnabled: Scalars['Boolean'];
  location: GenericConnectInput;
  maxOccupancy?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  privateSession?: InputMaybe<GenericConnectInput>;
  room?: InputMaybe<GenericConnectInput>;
  service?: InputMaybe<GenericConnectInput>;
  session?: InputMaybe<GenericConnectInput>;
  startAt: Scalars['DateTime'];
  waitlistMax?: InputMaybe<Scalars['Int']>;
};

export type CreateMeetingSeriesInput = {
  attendees?: InputMaybe<Array<GenericConnectInput>>;
  description?: InputMaybe<Scalars['String']>;
  doms?: InputMaybe<Array<Scalars['Float']>>;
  dows?: InputMaybe<Array<Scalars['Float']>>;
  duration: Scalars['Int'];
  imgUrl?: InputMaybe<Scalars['String']>;
  instructor?: InputMaybe<GenericConnectInput>;
  isPrivateSession?: InputMaybe<Scalars['Boolean']>;
  isSelfEnroll: Scalars['Boolean'];
  isWaitlistEnabled: Scalars['Boolean'];
  location: GenericConnectInput;
  maxOccupancy: Scalars['Int'];
  name: Scalars['String'];
  privateSession?: InputMaybe<GenericConnectInput>;
  room?: InputMaybe<GenericConnectInput>;
  scheduleFrom: Scalars['DateTime'];
  scheduleTo: Scalars['DateTime'];
  seriesInterval?: InputMaybe<SeriesInterval>;
  service?: InputMaybe<GenericConnectInput>;
  session?: InputMaybe<GenericConnectInput>;
  startAt: Scalars['DateTime'];
  waitlistMax?: InputMaybe<Scalars['Int']>;
};

export type CreateNotesInput = {
  author?: InputMaybe<GenericConnectInput>;
  client: GenericConnectInput;
  content: Scalars['String'];
};

export type CreateOrganizationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  logoImage?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationBranding?: InputMaybe<OrganizationBrandingInput>;
  settings?: InputMaybe<OrganizationSettingsInput>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationPaymentServiceInput = {
  externalId: Scalars['String'];
  name: Scalars['String'];
  paymentService: GenericConnectInput;
  paymentType: PaymentType;
};

export type CreateOrganizationServiceInput = {
  description?: InputMaybe<Scalars['String']>;
  duration: Scalars['Int'];
  imgUrl?: InputMaybe<Scalars['String']>;
  isIndivdual?: InputMaybe<Scalars['Boolean']>;
  isSelfEnroll?: InputMaybe<Scalars['Boolean']>;
  isWaitlistEnabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  policies?: InputMaybe<Array<GenericConnectInput>>;
  revenueCategory: GenericConnectInput;
  serviceType: GenericConnectInput;
  waitlistMax: Scalars['Int'];
};

export type CreateOrganizationTaxRateInput = {
  name: Scalars['String'];
  organization: GenericConnectInput;
  taxRate?: InputMaybe<Scalars['Float']>;
};

export type CreatePackageInput = {
  additionalPolicies: Array<GenericConnectInput>;
  description?: InputMaybe<Scalars['String']>;
  isGeneric: Scalars['Boolean'];
  isOrg: Scalars['Boolean'];
  locations?: InputMaybe<Array<GenericConnectInput>>;
  name: Scalars['String'];
};

export type CreatePaymentTerminalInput = {
  externalId: Scalars['String'];
  location: GenericConnectInput;
  name: Scalars['String'];
  physicalId?: InputMaybe<Scalars['String']>;
};

export type CreatePolicyInput = {
  data?: InputMaybe<Scalars['String']>;
  fileB64?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<GenericConnectInput>;
  name: Scalars['String'];
};

export type CreatePrivateSessionDurationInput = {
  cost: Scalars['Float'];
  duration: Scalars['Int'];
  session: GenericConnectInput;
};

export type CreatePrivateSessionInput = {
  description?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  intervalDuration?: InputMaybe<Scalars['Int']>;
  isEmployeeRequired?: InputMaybe<Scalars['Boolean']>;
  isOrg: Scalars['Boolean'];
  isPostTax: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  maxDuration?: InputMaybe<Scalars['Int']>;
  minDuration?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  organization: GenericConnectInput;
  policies?: InputMaybe<Array<GenericConnectInput>>;
  revenueCategory: GenericConnectInput;
  serviceType: GenericConnectInput;
};

export type CreatePrivateSessionLocationRoomsInput = {
  location: GenericConnectInput;
  rooms: Array<GenericConnectInput>;
  session: GenericConnectInput;
  taxRates?: InputMaybe<Array<GenericConnectInput>>;
};

export type CreatePrivateSessionOverrideInput = {
  commission: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  employee: GenericConnectInput;
  isPercent: Scalars['Boolean'];
  locations: Array<GenericConnectInput>;
  maxDuration?: InputMaybe<Scalars['Int']>;
  minDuration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  session: GenericConnectInput;
};

export type CreateProductGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  location: GenericConnectInput;
  name: Scalars['String'];
  revenueCategory?: InputMaybe<GenericConnectInput>;
};

export type CreateProductInput = {
  barcode?: InputMaybe<Scalars['String']>;
  commissionValue?: InputMaybe<Scalars['Float']>;
  cost: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isCommissionPercent?: InputMaybe<Scalars['Boolean']>;
  isCommissionable?: InputMaybe<Scalars['Boolean']>;
  isPostTax?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GenericConnectInput>;
  metricValues?: InputMaybe<Array<GenericConnectInput>>;
  name: Scalars['String'];
  productGroup?: InputMaybe<GenericConnectInput>;
  revenueCategory: GenericConnectInput;
  service?: InputMaybe<GenericConnectInput>;
  sku?: InputMaybe<Scalars['String']>;
  stock: Scalars['Int'];
  tags?: InputMaybe<Array<GenericConnectInput>>;
  taxRates?: InputMaybe<Array<GenericConnectInput>>;
};

export type CreateRecurringChargeInput = {
  agreement?: InputMaybe<GenericConnectInput>;
  categoryOption: GenericConnectInput;
  cost: Scalars['Float'];
  isPostTax?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  subscription?: InputMaybe<GenericConnectInput>;
  taxRates: Array<GenericConnectInput>;
};

export type CreateRoomInput = {
  description?: InputMaybe<Scalars['String']>;
  location: GenericConnectInput;
  name: Scalars['String'];
  services: Array<GenericConnectInput>;
  totalCapacity: Scalars['Int'];
};

export type CreateScheduledChargesInput = {
  cost: Scalars['Float'];
  isPostTax?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  recurringCharge?: InputMaybe<GenericConnectInput>;
  revenueCategory: GenericConnectInput;
  scheduledTransaction: GenericConnectInput;
  subscription?: InputMaybe<GenericConnectInput>;
  taxRates: Array<GenericConnectInput>;
  transaction?: InputMaybe<GenericConnectInput>;
};

export type CreateScheduledTransactionInput = {
  client: GenericConnectInput;
  location: GenericConnectInput;
  processAt: Scalars['DateTime'];
  status: ScheduledTransactionStatus;
  subscription?: InputMaybe<GenericConnectInput>;
  transaction?: InputMaybe<GenericConnectInput>;
};

export type CreateSendgridTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  dynamicFields?: InputMaybe<Array<GenericConnectInput>>;
  fromEmail?: InputMaybe<Scalars['String']>;
  fromName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  location: GenericConnectInput;
  name: Scalars['String'];
  organization: GenericConnectInput;
  sendGridTemplateId?: InputMaybe<Scalars['String']>;
  sendGridVersionId?: InputMaybe<Scalars['String']>;
  subjectLine?: InputMaybe<Scalars['String']>;
  trigger_?: InputMaybe<TriggerListType>;
  type: TemplateType;
};

export type CreateServiceAllotmentInput = {
  credits: Scalars['Int'];
  dailyLimit: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  expirationUnit?: InputMaybe<Unit>;
  expirationValue?: InputMaybe<Scalars['Int']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  initialAgreement?: InputMaybe<GenericConnectInput>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  mode: ExpirationMode;
  name?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<GenericConnectInput>;
  privateSessions?: InputMaybe<Array<GenericConnectInput>>;
  recurringAgreement?: InputMaybe<GenericConnectInput>;
  serviceFrequency?: InputMaybe<ServiceFrequency>;
  services?: InputMaybe<Array<GenericConnectInput>>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  startMode: StartMode;
};

export type CreateShoppingCartInput = {
  client?: InputMaybe<GenericConnectInput>;
  discountCodes?: InputMaybe<Array<GenericConnectInput>>;
  employee?: InputMaybe<GenericConnectInput>;
  location?: InputMaybe<GenericConnectInput>;
  notes?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<GenericConnectInput>;
  products: Array<CartProductInput>;
};

export type CreateSignedAgreementInput = {
  agreement: GenericConnectInput;
  client: GenericConnectInput;
  clientGroup?: InputMaybe<GenericConnectInput>;
  isAutoRenew?: InputMaybe<Scalars['Boolean']>;
  location: GenericConnectInput;
  parent?: InputMaybe<GenericConnectInput>;
  paymentMethod?: InputMaybe<GenericConnectInput>;
  status?: InputMaybe<SignedAgreementStatus>;
  termEnd?: InputMaybe<Scalars['DateTime']>;
  termStart?: InputMaybe<Scalars['DateTime']>;
};

export type CreateSignedDocumentInput = {
  agreementRecipient?: InputMaybe<GenericConnectInput>;
  externalUrl: Scalars['String'];
  isMinor: Scalars['Boolean'];
  signedAgreement?: InputMaybe<GenericConnectInput>;
  signee?: InputMaybe<GenericConnectInput>;
  subject?: InputMaybe<GenericConnectInput>;
};

export type CreateSindroPaymentInput = {
  externalId: Scalars['String'];
  name: Scalars['String'];
  paymentType: PaymentType;
};

export type CreateTimeClockEntryInput = {
  employee?: InputMaybe<GenericConnectInput>;
  endedAt?: InputMaybe<Scalars['DateTime']>;
  location: GenericConnectInput;
  startedAt: Scalars['DateTime'];
  station?: InputMaybe<GenericConnectInput>;
};

export type CreateTransactionInput = {
  agreement?: InputMaybe<GenericConnectInput>;
  chargedTo?: InputMaybe<GenericConnectInput>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<Scalars['String']>;
  isRecurring?: InputMaybe<Scalars['Boolean']>;
  location: GenericConnectInput;
  package?: InputMaybe<GenericConnectInput>;
  paymentMethod?: InputMaybe<GenericConnectInput>;
  paymentTerminal?: InputMaybe<GenericConnectInput>;
  paymentType?: InputMaybe<TransactionType>;
  performedBy?: InputMaybe<GenericConnectInput>;
  shoppingCart?: InputMaybe<GenericConnectInput>;
  subscription?: InputMaybe<GenericConnectInput>;
  targetClient?: InputMaybe<GenericConnectInput>;
  transactionStatus?: InputMaybe<TransactionStatus>;
};

export type CreateVariantMetricInput = {
  name: Scalars['String'];
  productGroup: GenericConnectInput;
  values: Array<IMetricOption>;
};

export type CreateWaitlisteeInput = {
  client: GenericConnectInput;
  meeting: GenericConnectInput;
  notes?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
};

export type CreditAllotment = {
  __typename?: 'CreditAllotment';
  agreement?: Maybe<Agreement>;
  client: Client;
  count: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  locations: Array<Location>;
  name: Scalars['String'];
  package?: Maybe<Package>;
  privateSessions: Array<PrivateSessionDuration>;
  serviceAllotment?: Maybe<ServiceAllotment>;
  services: Array<OrganizationService>;
  transaction?: Maybe<Transaction>;
  updatedDate: Scalars['DateTime'];
};

export type CustomReportInput = {
  endAt: Scalars['DateTime'];
  locations: Array<Scalars['String']>;
  startAt: Scalars['DateTime'];
};

export type DashboardInput = {
  endAt: Scalars['DateTime'];
  locations: Array<GenericConnectInput>;
  startAt: Scalars['DateTime'];
};

export type DashboardObject = {
  __typename?: 'DashboardObject';
  name: Scalars['String'];
  totalRevenue: Scalars['Float'];
  totalSales: Scalars['Float'];
};

export type DashboardOrRevenueItem = {
  __typename?: 'DashboardOrRevenueItem';
  productObject?: Maybe<Array<DashboardObject>>;
  revenueItem?: Maybe<Array<RevenueItem>>;
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  agreements: Array<Agreement>;
  code: Scalars['String'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discountCodeType: DiscountCodeType;
  expiration: Expiration;
  id: Scalars['ID'];
  isPercent: Scalars['Boolean'];
  isRestricted: Scalars['Boolean'];
  isStaffOnly: Scalars['Boolean'];
  locations: Array<Location>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  products: Array<Product>;
  recurring: Scalars['Boolean'];
  startAt: Scalars['DateTime'];
  updatedDate: Scalars['DateTime'];
  useLimit?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export enum DiscountCodeType {
  Agreement = 'Agreement',
  Product = 'Product'
}

export enum DraftMode {
  Buffer = 'Buffer',
  Dynamic = 'Dynamic',
  Immediate = 'Immediate'
}

export enum DynamicFieldType {
  Date = 'Date',
  Number = 'Number',
  Text = 'Text'
}

export type Employee = {
  __typename?: 'Employee';
  activeLocation: Location;
  activeSession?: Maybe<TimeClockEntry>;
  calendarFilters?: Maybe<Array<CalendarFilters>>;
  clockedIn: Scalars['Boolean'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  locations: Array<Location>;
  meetings: Array<Meeting>;
  organization: Organization;
  pin?: Maybe<Scalars['String']>;
  role?: Maybe<EmployeeRole>;
  staffId?: Maybe<Scalars['String']>;
  stations: Array<EmployeeStation>;
  updatedDate: Scalars['DateTime'];
  user: User;
};

export type EmployeeRole = {
  __typename?: 'EmployeeRole';
  calendar: RolePermissionType;
  catalog: RolePermissionType;
  checkInQueue: RolePermissionType;
  clients: RolePermissionType;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  employeeStations: RolePermissionType;
  id: Scalars['ID'];
  locAgreements: RolePermissionType;
  locDashboard: RolePermissionType;
  locDiscounts: RolePermissionType;
  locEmployees: RolePermissionType;
  locPackages: RolePermissionType;
  locPolicies: RolePermissionType;
  locProducts: RolePermissionType;
  locReports: RolePermissionType;
  locRequests: RolePermissionType;
  locRooms: RolePermissionType;
  locServices: RolePermissionType;
  locSettings: RolePermissionType;
  locTimeclock: RolePermissionType;
  name: Scalars['String'];
  orgAgreements: RolePermissionType;
  orgDiscounts: RolePermissionType;
  orgLocations: RolePermissionType;
  orgPackages: RolePermissionType;
  orgPolicies: RolePermissionType;
  orgRoles: RolePermissionType;
  orgService: RolePermissionType;
  orgSettings: RolePermissionType;
  organization?: Maybe<Organization>;
  personalTimeClock: RolePermissionType;
  seedId?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
};

export type EmployeeStation = {
  __typename?: 'EmployeeStation';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  employee: Array<Employee>;
  id: Scalars['ID'];
  location: Location;
  maxShift?: Maybe<Scalars['Float']>;
  minShift?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  payRate: Scalars['Float'];
  updatedDate: Scalars['DateTime'];
};

export type Expiration = {
  __typename?: 'Expiration';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  expirationMode: ExpirationMode;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isExpired: Scalars['Boolean'];
  unit: Unit;
  updatedDate: Scalars['DateTime'];
  value?: Maybe<Scalars['Int']>;
};

export enum ExpirationMode {
  Date = 'Date',
  Duration = 'Duration',
  Never = 'Never'
}

export type ExternalTransaction = {
  __typename?: 'ExternalTransaction';
  amount: Scalars['Float'];
  clients: Array<Client>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  discountCodes: Array<DiscountCode>;
  id: Scalars['ID'];
  subtotal: Scalars['Float'];
  tax: Scalars['Float'];
  updatedDate: Scalars['DateTime'];
};

export type FilterBy = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  field: Scalars['String'];
  parentRelationField?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type FundingRecord = {
  __typename?: 'FundingRecord';
  achGross: Scalars['Float'];
  achPreTax: Scalars['Float'];
  achSindroFee: Scalars['Float'];
  amexGross: Scalars['Float'];
  amexPreTax: Scalars['Float'];
  amexSindroFee: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  discoveryGross: Scalars['Float'];
  discoveryPreTax: Scalars['Float'];
  discoverySindroFee: Scalars['Float'];
  externalId: Scalars['String'];
  id: Scalars['ID'];
  location: Location;
  locationId: Scalars['String'];
  mastercardGross: Scalars['Float'];
  mastercardPreTax: Scalars['Float'];
  mastercardSindroFee: Scalars['Float'];
  terminalGross: Scalars['Float'];
  terminalPreTax: Scalars['Float'];
  terminalSindroFee: Scalars['Float'];
  totalTransfer: Scalars['Float'];
  transactions?: Maybe<Transaction>;
  updatedDate: Scalars['DateTime'];
  visaGross: Scalars['Float'];
  visaPreTax: Scalars['Float'];
  visaSindroFee: Scalars['Float'];
};

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  NonBinary = 'NonBinary',
  Undisclosed = 'Undisclosed'
}

export type GenericConnectInput = {
  id: Scalars['ID'];
};

export enum GroupPricingType {
  Limit = 'Limit',
  Scaling = 'Scaling'
}

export type IMetricOption = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type InitialCharge = {
  __typename?: 'InitialCharge';
  agreement?: Maybe<Agreement>;
  categoryOptions: Array<CategoryOption>;
  cost: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  fee?: Maybe<CategoryOption>;
  id: Scalars['ID'];
  isDiscountable: Scalars['Boolean'];
  isPostTax: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  package?: Maybe<Package>;
  revenue?: Maybe<CategoryOption>;
  taxRates: Array<LocationTaxRate>;
  updatedDate: Scalars['DateTime'];
};

export type InternalClientsInput = {
  Address?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  DOB?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  EmergencyName?: InputMaybe<Scalars['String']>;
  EmergencyPhone?: InputMaybe<Scalars['String']>;
  Employer?: InputMaybe<Scalars['String']>;
  FirstName?: InputMaybe<Scalars['String']>;
  Gender?: InputMaybe<Scalars['String']>;
  HomePhone?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  License?: InputMaybe<Scalars['String']>;
  MemberId?: InputMaybe<Scalars['String']>;
  Relationship?: InputMaybe<Scalars['String']>;
  ScannableId?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  WorkPhone?: InputMaybe<Scalars['String']>;
  ZipCode?: InputMaybe<Scalars['String']>;
};

export type InternalNotesInput = {
  Content?: InputMaybe<Scalars['String']>;
  MemberId?: InputMaybe<Scalars['String']>;
};

export type InternalPaymentMethodInput = {
  ExternalMemberId: Scalars['String'];
  MerchantId: Scalars['String'];
};

export type InternalPaymentRecordInput = {
  CompletedAt?: InputMaybe<Scalars['String']>;
  ExternalMemberId?: InputMaybe<Scalars['String']>;
  Note?: InputMaybe<Scalars['String']>;
  RevenueCat?: InputMaybe<Scalars['String']>;
  Tax?: InputMaybe<Scalars['String']>;
  Total?: InputMaybe<Scalars['String']>;
};

export type InternalSubscriptionsInput = {
  CurrentCostPerCycle?: InputMaybe<Scalars['String']>;
  CycleDuration?: InputMaybe<Scalars['String']>;
  EndDate?: InputMaybe<Scalars['String']>;
  LastPaymentDate?: InputMaybe<Scalars['String']>;
  MemberId?: InputMaybe<Scalars['String']>;
  PastDue?: InputMaybe<Scalars['String']>;
  PaymentMethod?: InputMaybe<Scalars['String']>;
  RevenueCategory?: InputMaybe<Scalars['String']>;
  StartDate?: InputMaybe<Scalars['String']>;
  SubscriptionName?: InputMaybe<Scalars['String']>;
};

export enum LeadStatus {
  NotInterested = 'NotInterested',
  NotVisisted = 'NotVisisted',
  Trial = 'Trial',
  Visisted = 'Visisted'
}

export type LineItemSubCharge = {
  __typename?: 'LineItemSubCharge';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  discounts?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItem: CheckoutLineItem;
  revenueCategory: CategoryOption;
  subtotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  taxes?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  updatedDate: Scalars['DateTime'];
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clients: Array<Client>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  employees: Array<Employee>;
  id: Scalars['ID'];
  locationRevenue?: Maybe<LocationRevenue>;
  locationServices: Array<LocationService>;
  locationTaxRates: Array<LocationTaxRate>;
  logoUrl?: Maybe<Scalars['String']>;
  meetings: Array<Meeting>;
  name: Scalars['String'];
  notificationSenderNumber?: Maybe<Scalars['String']>;
  organization: Organization;
  passportLocCode?: Maybe<Scalars['Float']>;
  primaryContact?: Maybe<ContactInfo>;
  rooms: Array<Room>;
  state?: Maybe<Scalars['String']>;
  stationsEnabled?: Maybe<Scalars['Boolean']>;
  timezone: Scalars['String'];
  transactionProcessTime: Scalars['String'];
  updatedDate: Scalars['DateTime'];
  zip?: Maybe<Scalars['String']>;
};

export type LocationMonthlyFee = {
  __typename?: 'LocationMonthlyFee';
  amount: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location: Location;
  locationRevenue: LocationRevenue;
  name: Scalars['String'];
  updatedDate: Scalars['DateTime'];
};

export type LocationOffering = {
  __typename?: 'LocationOffering';
  agreement: Agreement;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  details: Array<Scalars['String']>;
  header: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  location: Location;
  name?: Maybe<Scalars['String']>;
  promoCode?: Maybe<Scalars['String']>;
  subtext?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
};

export type LocationPaymentService = {
  __typename?: 'LocationPaymentService';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  location: Location;
  name: Scalars['String'];
  orgPaymentService: OrganizationPaymentService;
  paymentType: PaymentType;
  updatedDate: Scalars['DateTime'];
};

export type LocationRevenue = {
  __typename?: 'LocationRevenue';
  createdDate: Scalars['DateTime'];
  declineFeeAmount?: Maybe<Scalars['Float']>;
  declineFeeDays?: Maybe<Scalars['Int']>;
  declineFeeSindroShare?: Maybe<Scalars['Float']>;
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lateFeeAmount?: Maybe<Scalars['Float']>;
  lateFeeDays?: Maybe<Scalars['Int']>;
  lateFeeSindroShare?: Maybe<Scalars['Float']>;
  location: Location;
  monthlyFees: Array<LocationMonthlyFee>;
  payrocAccount?: Maybe<PayrocAccount>;
  retryIntervals: Array<Scalars['Int']>;
  transactionFees: Array<LocationTransactionFee>;
  updatedDate: Scalars['DateTime'];
};

export type LocationService = {
  __typename?: 'LocationService';
  cost: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isPrepay: Scalars['Boolean'];
  location: Location;
  meetings: Array<Meeting>;
  organizationService: OrganizationService;
  product?: Maybe<Product>;
  rooms: Array<Room>;
  updatedDate: Scalars['DateTime'];
};

export type LocationTaxRate = {
  __typename?: 'LocationTaxRate';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location: Location;
  organizationTaxRate: OrganizationTaxRate;
  taxRate: Scalars['Float'];
  updatedDate: Scalars['DateTime'];
};

export type LocationTransactionFee = {
  __typename?: 'LocationTransactionFee';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  flatRate: Scalars['Float'];
  id: Scalars['ID'];
  location: Location;
  locationRevenue: LocationRevenue;
  percentage: Scalars['Float'];
  type: TransactionFeeType;
  updatedDate: Scalars['DateTime'];
};

export type Meeting = {
  __typename?: 'Meeting';
  additionalPolicies: Array<Policy>;
  attendances: Array<Attendance>;
  attendees?: Maybe<Array<Attendee>>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  endAt: Scalars['DateTime'];
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  instructor?: Maybe<Employee>;
  isPrivateSession: Scalars['Boolean'];
  isSelfEnroll: Scalars['Boolean'];
  isWaitlistEnabled: Scalars['Boolean'];
  location: Location;
  maxOccupancy?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  privateSession?: Maybe<PrivateSessionDuration>;
  room?: Maybe<Room>;
  series?: Maybe<MeetingSeries>;
  service?: Maybe<LocationService>;
  session?: Maybe<PrivateSession>;
  startAt: Scalars['DateTime'];
  updatedDate: Scalars['DateTime'];
  waitlistMax?: Maybe<Scalars['Int']>;
  waitlistees: Array<Waitlistee>;
};

export type MeetingDetailsInput = {
  attendees?: InputMaybe<Array<GenericConnectInput>>;
  description?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  instructor?: InputMaybe<GenericConnectInput>;
  isPrivateSession?: InputMaybe<Scalars['Boolean']>;
  isSelfEnroll?: InputMaybe<Scalars['Boolean']>;
  isWaitlistEnabled?: InputMaybe<Scalars['Boolean']>;
  maxOccupancy?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  privateSession?: InputMaybe<GenericConnectInput>;
  room?: InputMaybe<GenericConnectInput>;
  service?: InputMaybe<GenericConnectInput>;
  session?: InputMaybe<GenericConnectInput>;
  waitlistMax?: InputMaybe<Scalars['Float']>;
};

export type MeetingSeries = {
  __typename?: 'MeetingSeries';
  attendees?: Maybe<Array<Attendee>>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  doms: Array<Scalars['Int']>;
  dows: Array<Scalars['Int']>;
  duration: Scalars['Int'];
  endAt: Scalars['DateTime'];
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  instructor?: Maybe<Employee>;
  isPrivateSession: Scalars['Boolean'];
  isSelfEnroll: Scalars['Boolean'];
  isWaitlistEnabled: Scalars['Boolean'];
  location: Location;
  maxOccupancy: Scalars['Int'];
  meetings: Array<Meeting>;
  name: Scalars['String'];
  privateSession?: Maybe<PrivateSessionDuration>;
  room?: Maybe<Room>;
  scheduleFrom: Scalars['DateTime'];
  scheduleTo: Scalars['DateTime'];
  seriesInterval: SeriesInterval;
  service?: Maybe<LocationService>;
  session?: Maybe<PrivateSession>;
  startAt: Scalars['DateTime'];
  updatedDate: Scalars['DateTime'];
  waitlistMax?: Maybe<Scalars['Int']>;
};

export enum MemberStatus {
  Guest = 'Guest',
  Lead = 'Lead',
  Member = 'Member'
}

export type MigrateError = {
  __typename?: 'MigrateError';
  Collision: Array<Scalars['String']>;
  Default: Array<Scalars['String']>;
  Invalid: Array<Scalars['String']>;
  Missing: Array<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTAC: Scalars['Boolean'];
  addAttendeeToMeeting: Scalars['Boolean'];
  addClientToGroup: ClientGroup;
  addTimeClockSession: TimeClockEntry;
  cancelAttendeeToMeeting: Scalars['Boolean'];
  clearCalendarFilters?: Maybe<CalendarFilters>;
  clockIn: TimeClockEntry;
  clockOut: TimeClockEntry;
  createAccessPeriod: AccessPeriod;
  createAgreement: Agreement;
  createAgreementRecipient: AgreementRecipient;
  createAlterAgreementRecord: AlterAgreementRecord;
  createAlterationReason: AlterationReason;
  createAttendance: Attendance;
  createCategoryOption: CategoryOption;
  createCheckIn: CheckIn;
  createClient: Client;
  createClientGroup: ClientGroup;
  createClientPaymentMethod: ClientPaymentMethods;
  createCreditAllotment: CreditAllotment;
  createDiscountCode: DiscountCode;
  createEmployee: Employee;
  createEmployeeRole: EmployeeRole;
  createEmployeeStation: EmployeeStation;
  createInitialCharge: InitialCharge;
  createLocation: Location;
  createLocationMonthlyFee: LocationMonthlyFee;
  createLocationOffering: LocationOffering;
  createLocationPaymentService: LocationPaymentService;
  createLocationService: LocationService;
  createLocationTaxRate: LocationTaxRate;
  createLocationTransactionFee: LocationTransactionFee;
  createMeeting: Meeting;
  createMeetingSeries: MeetingSeries;
  createMemberLogin: Scalars['Boolean'];
  createNotes: Notes;
  createOrganization: Organization;
  createOrganizationPaymentService: OrganizationPaymentService;
  createOrganizationService: OrganizationService;
  createOrganizationTaxRate: OrganizationTaxRate;
  createPackage: Package;
  createPaymentTerminal: PaymentTerminal;
  createPolicy: Policy;
  createPrivateSession: PrivateSession;
  createPrivateSessionDuration: PrivateSessionDuration;
  createPrivateSessionLocationRooms: PrivateSessionLocationRooms;
  createPrivateSessionOverride: PrivateSessionOverride;
  createProduct: Product;
  createProductGroup: ProductGroup;
  createRecurringCharge: RecurringCharge;
  createRoom: Room;
  createScheduledCharges: ScheduledCharges;
  createScheduledTransaction: ScheduledTransaction;
  createServiceAllotment: ServiceAllotment;
  createShoppingCart: ShoppingCart;
  createSignedAgreement: SignedAgreement;
  createSignedDocument: SignedDocumentGroup;
  createSindroPaymentService: SindroPaymentService;
  createSubscription: ClientSubscription;
  createTransaction: Transaction;
  createVariantMetric: VariantMetric;
  createWaitlistee: Waitlistee;
  createsendgridTemplate: SendgridTemplate;
  deleteAccessPeriod: Scalars['Boolean'];
  deleteAgreement: Scalars['Boolean'];
  deleteAlterAgreementRecord: Scalars['Boolean'];
  deleteAlterationReason: Scalars['Boolean'];
  deleteAttendance: Scalars['Boolean'];
  deleteCategoryOption: Scalars['Boolean'];
  deleteCheckIn: Scalars['Boolean'];
  deleteClient: Scalars['Boolean'];
  deleteClientGroup: Scalars['Boolean'];
  deleteClientPaymentMethod: Scalars['Boolean'];
  deleteClientPreferences: Scalars['Boolean'];
  deleteDiscountCode: Scalars['Boolean'];
  deleteEmployee: Scalars['Boolean'];
  deleteEmployeeRole: Scalars['Boolean'];
  deleteEmployeeStation: Scalars['Boolean'];
  deleteInitialCharge: Scalars['Boolean'];
  deleteLocation: Scalars['Boolean'];
  deleteLocationMonthlyFee: Scalars['Boolean'];
  deleteLocationOffering: Scalars['Boolean'];
  deleteLocationPaymentService: Scalars['Boolean'];
  deleteLocationService: Scalars['Boolean'];
  deleteLocationTaxRate: Scalars['Boolean'];
  deleteLocationTransactionFee: Scalars['Boolean'];
  deleteMeeting: Scalars['Boolean'];
  deleteMeetingSeries: Scalars['Boolean'];
  deleteNotes: Scalars['Boolean'];
  deleteOrganization: Scalars['Boolean'];
  deleteOrganizationPaymentService: Scalars['Boolean'];
  deleteOrganizationService: Scalars['Boolean'];
  deleteOrganizationSettings: Scalars['Boolean'];
  deleteOrganizationTaxRate: Scalars['Boolean'];
  deletePackage: Scalars['Boolean'];
  deletePaymentTerminal: Scalars['Boolean'];
  deletePolicy: Scalars['Boolean'];
  deletePrivateSession: Scalars['Boolean'];
  deletePrivateSessionDuration: Scalars['Boolean'];
  deletePrivateSessionLocationRooms: Scalars['Boolean'];
  deletePrivateSessionOverride: Scalars['Boolean'];
  deleteProduct: Scalars['Boolean'];
  deleteProductGroup: Scalars['Boolean'];
  deleteRecurringCharge: Scalars['Boolean'];
  deleteRoom: Scalars['Boolean'];
  deleteScheduledCharges: Scalars['Boolean'];
  deleteScheduledTransaction: Scalars['Boolean'];
  deleteServiceAllotment: Scalars['Boolean'];
  deleteShoppingCart: Scalars['Boolean'];
  deleteSignedAgreement: Scalars['Boolean'];
  deleteSignedDocument: Scalars['Boolean'];
  deleteSindroPaymentService: Scalars['Boolean'];
  deleteSubscription: Scalars['Boolean'];
  deleteTimeClockEntry: Scalars['Boolean'];
  deleteTransaction: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  deleteVariantMetric: Scalars['Boolean'];
  deleteWaitlistee: Scalars['Boolean'];
  deletesendgridTemplate: Scalars['Boolean'];
  downloadAgreementCSV: Scalars['String'];
  downloadPosCSV: Scalars['String'];
  downloadRevenueCSV: Scalars['String'];
  employeeSetActiveLocation: Employee;
  enrollToMeeting: Scalars['Boolean'];
  generateClientLogin: Scalars['String'];
  migrateClientNotes: MutationResult;
  migrateClients: MutationResult;
  migratePaymentMethods: MutationResult;
  migratePaymentRecords: MutationResult;
  migrateSubscription: MutationResult;
  pullFromMeeting: Scalars['Boolean'];
  pushToMeeting: Scalars['Boolean'];
  removeClientFromGroup: Scalars['Boolean'];
  saveCalendarFilters?: Maybe<CalendarFilters>;
  signDocument: SignedDocumentGroup;
  updateAccessPeriod: AccessPeriod;
  updateAdmin: Admin;
  updateAgreement: Agreement;
  updateAlterAgreementRecord: AlterAgreementRecord;
  updateAlterationReason: AlterationReason;
  updateAttendance: Attendance;
  updateCategoryOption: CategoryOption;
  updateCheckIn: CheckIn;
  updateClient: Client;
  updateClientGroup: ClientGroup;
  updateClientOrg: Client;
  updateClientPaymentMethod: ClientPaymentMethods;
  updateClientPreferences: ClientPreferences;
  updateCreditAllotment: CreditAllotment;
  updateDiscountCode: DiscountCode;
  updateEmployee: Employee;
  updateEmployeeRole: EmployeeRole;
  updateEmployeeStation?: Maybe<EmployeeStation>;
  updateInitialCharge: InitialCharge;
  updateLocation: Location;
  updateLocationMonthlyFee: LocationMonthlyFee;
  updateLocationOffering: LocationOffering;
  updateLocationPaymentService?: Maybe<LocationPaymentService>;
  updateLocationRevenue: LocationRevenue;
  updateLocationService: LocationService;
  updateLocationTaxRate: LocationTaxRate;
  updateLocationTransactionFee: LocationTransactionFee;
  updateMeeting: Meeting;
  updateMeetingSeries: MeetingSeries;
  updateNotes: Notes;
  updateOrganization: Organization;
  updateOrganizationBranding: OrganizationBranding;
  updateOrganizationPaymentService?: Maybe<OrganizationPaymentService>;
  updateOrganizationService: OrganizationService;
  updateOrganizationSettings: OrganizationSettings;
  updateOrganizationTaxRate: OrganizationTaxRate;
  updatePackage: Package;
  updatePaymentTerminal: PaymentTerminal;
  updatePolicy: Policy;
  updatePrivateSession: PrivateSession;
  updatePrivateSessionDuration: PrivateSessionDuration;
  updatePrivateSessionLocationRooms: PrivateSessionLocationRooms;
  updatePrivateSessionOverride: PrivateSessionOverride;
  updateProduct: Product;
  updateProductGroup: ProductGroup;
  updateRecurringCharge: RecurringCharge;
  updateRoleAssignment: Scalars['Boolean'];
  updateRoom: Room;
  updateScheduledCharges: ScheduledCharges;
  updateScheduledTransaction: ScheduledTransaction;
  updateServiceAllotment: ServiceAllotment;
  updateShoppingCart: ShoppingCart;
  updateSignedAgreement: SignedAgreement;
  updateSignedDocument: SignedDocumentGroup;
  updateSindroPaymentService: SindroPaymentService;
  updateSubscription: ClientSubscription;
  updateTimeClockEntry: TimeClockEntry;
  updateTransaction: Transaction;
  updateUser: User;
  updateVariantMetric: VariantMetric;
  updateWaitlistee: Waitlistee;
  updatesendgridTemplate: SendgridTemplate;
};


export type MutationAddAttendeeToMeetingArgs = {
  attendeeId: Scalars['String'];
  meetingId: Scalars['String'];
};


export type MutationAddClientToGroupArgs = {
  clientGroupId: Scalars['String'];
  clientId: Scalars['String'];
};


export type MutationAddTimeClockSessionArgs = {
  employeeId: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  station?: InputMaybe<Scalars['String']>;
};


export type MutationCancelAttendeeToMeetingArgs = {
  attendeeId: Scalars['String'];
  meetingId: Scalars['String'];
};


export type MutationClearCalendarFiltersArgs = {
  locationId: Scalars['String'];
};


export type MutationClockInArgs = {
  data: CreateTimeClockEntryInput;
  station?: InputMaybe<Scalars['String']>;
};


export type MutationClockOutArgs = {
  data: ClockOutInput;
  station?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAccessPeriodArgs = {
  data: CreateAccessPeriodInput;
};


export type MutationCreateAgreementArgs = {
  data: CreateAgreementInput;
};


export type MutationCreateAgreementRecipientArgs = {
  data: CreateAgreementRecipientInput;
};


export type MutationCreateAlterAgreementRecordArgs = {
  data: CreateAlterAgreementRecordInput;
};


export type MutationCreateAlterationReasonArgs = {
  data: CreateAlterationReasonInput;
};


export type MutationCreateAttendanceArgs = {
  data: CreateAttendanceInput;
};


export type MutationCreateCategoryOptionArgs = {
  data: CreateCategoryOptionInput;
};


export type MutationCreateCheckInArgs = {
  data: CreateCheckInInput;
};


export type MutationCreateClientArgs = {
  data: CreateClientInput;
};


export type MutationCreateClientGroupArgs = {
  data: CreateClientGroupInput;
};


export type MutationCreateClientPaymentMethodArgs = {
  clientId: Scalars['String'];
  data: CreateClientPaymentMethodInput;
};


export type MutationCreateCreditAllotmentArgs = {
  data: CreateCreditAllotmentInput;
};


export type MutationCreateDiscountCodeArgs = {
  data: CreateDiscountCodeInput;
};


export type MutationCreateEmployeeArgs = {
  data: CreateEmployeeInput;
};


export type MutationCreateEmployeeRoleArgs = {
  data: CreateEmployeeRoleInput;
};


export type MutationCreateEmployeeStationArgs = {
  data: CreateEmployeeStationInput;
};


export type MutationCreateInitialChargeArgs = {
  data: CreateInitialChargeInput;
};


export type MutationCreateLocationArgs = {
  data: CreateLocationInput;
};


export type MutationCreateLocationMonthlyFeeArgs = {
  data: CreateLocationMonthlyFeeInput;
};


export type MutationCreateLocationOfferingArgs = {
  data: CreateLocationOfferingInput;
};


export type MutationCreateLocationPaymentServiceArgs = {
  data: CreateLocationPaymentServiceInput;
};


export type MutationCreateLocationServiceArgs = {
  data: CreateLocationServiceInput;
};


export type MutationCreateLocationTaxRateArgs = {
  data: CreateLocationTaxRateInput;
};


export type MutationCreateLocationTransactionFeeArgs = {
  data: CreateLocationTransactionFeeInput;
};


export type MutationCreateMeetingArgs = {
  data: CreateMeetingInput;
};


export type MutationCreateMeetingSeriesArgs = {
  data: CreateMeetingSeriesInput;
};


export type MutationCreateMemberLoginArgs = {
  clientId: Scalars['String'];
  username: Scalars['String'];
};


export type MutationCreateNotesArgs = {
  data: CreateNotesInput;
};


export type MutationCreateOrganizationArgs = {
  data: CreateOrganizationInput;
};


export type MutationCreateOrganizationPaymentServiceArgs = {
  data: CreateOrganizationPaymentServiceInput;
};


export type MutationCreateOrganizationServiceArgs = {
  data: CreateOrganizationServiceInput;
};


export type MutationCreateOrganizationTaxRateArgs = {
  data: CreateOrganizationTaxRateInput;
};


export type MutationCreatePackageArgs = {
  data: CreatePackageInput;
};


export type MutationCreatePaymentTerminalArgs = {
  data: CreatePaymentTerminalInput;
};


export type MutationCreatePolicyArgs = {
  data: CreatePolicyInput;
};


export type MutationCreatePrivateSessionArgs = {
  data: CreatePrivateSessionInput;
};


export type MutationCreatePrivateSessionDurationArgs = {
  data: CreatePrivateSessionDurationInput;
};


export type MutationCreatePrivateSessionLocationRoomsArgs = {
  data: CreatePrivateSessionLocationRoomsInput;
};


export type MutationCreatePrivateSessionOverrideArgs = {
  data: CreatePrivateSessionOverrideInput;
};


export type MutationCreateProductArgs = {
  data: CreateProductInput;
};


export type MutationCreateProductGroupArgs = {
  data: CreateProductGroupInput;
};


export type MutationCreateRecurringChargeArgs = {
  data: CreateRecurringChargeInput;
};


export type MutationCreateRoomArgs = {
  data: CreateRoomInput;
};


export type MutationCreateScheduledChargesArgs = {
  data: CreateScheduledChargesInput;
};


export type MutationCreateScheduledTransactionArgs = {
  data: CreateScheduledTransactionInput;
};


export type MutationCreateServiceAllotmentArgs = {
  data: CreateServiceAllotmentInput;
};


export type MutationCreateShoppingCartArgs = {
  data: CreateShoppingCartInput;
};


export type MutationCreateSignedAgreementArgs = {
  data: CreateSignedAgreementInput;
};


export type MutationCreateSignedDocumentArgs = {
  data: CreateSignedDocumentInput;
};


export type MutationCreateSindroPaymentServiceArgs = {
  data: CreateSindroPaymentInput;
};


export type MutationCreateSubscriptionArgs = {
  data: CreateClientSubscriptionInput;
};


export type MutationCreateTransactionArgs = {
  data: CreateTransactionInput;
};


export type MutationCreateVariantMetricArgs = {
  data: CreateVariantMetricInput;
};


export type MutationCreateWaitlisteeArgs = {
  data: CreateWaitlisteeInput;
};


export type MutationCreatesendgridTemplateArgs = {
  data: CreateSendgridTemplateInput;
};


export type MutationDeleteAccessPeriodArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAgreementArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAlterAgreementRecordArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAlterationReasonArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAttendanceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCategoryOptionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCheckInArgs = {
  id: Scalars['String'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['String'];
};


export type MutationDeleteClientGroupArgs = {
  id: Scalars['String'];
};


export type MutationDeleteClientPaymentMethodArgs = {
  id: Scalars['String'];
};


export type MutationDeleteClientPreferencesArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDiscountCodeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEmployeeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEmployeeRoleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEmployeeStationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInitialChargeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLocationMonthlyFeeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLocationOfferingArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLocationPaymentServiceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLocationServiceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLocationTaxRateArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLocationTransactionFeeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMeetingArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMeetingSeriesArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNotesArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrganizationPaymentServiceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrganizationServiceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrganizationSettingsArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrganizationTaxRateArgs = {
  id: Scalars['String'];
};


export type MutationDeletePackageArgs = {
  id: Scalars['String'];
};


export type MutationDeletePaymentTerminalArgs = {
  id: Scalars['String'];
};


export type MutationDeletePolicyArgs = {
  id: Scalars['Float'];
};


export type MutationDeletePrivateSessionArgs = {
  id: Scalars['String'];
};


export type MutationDeletePrivateSessionDurationArgs = {
  id: Scalars['String'];
};


export type MutationDeletePrivateSessionLocationRoomsArgs = {
  id: Scalars['String'];
};


export type MutationDeletePrivateSessionOverrideArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProductGroupArgs = {
  id: Scalars['String'];
};


export type MutationDeleteRecurringChargeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteRoomArgs = {
  id: Scalars['String'];
};


export type MutationDeleteScheduledChargesArgs = {
  id: Scalars['String'];
};


export type MutationDeleteScheduledTransactionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteServiceAllotmentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteShoppingCartArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSignedAgreementArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSignedDocumentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSindroPaymentServiceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSubscriptionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTimeClockEntryArgs = {
  timeClockEntryId: Scalars['String'];
};


export type MutationDeleteTransactionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String'];
};


export type MutationDeleteVariantMetricArgs = {
  id: Scalars['String'];
};


export type MutationDeleteWaitlisteeArgs = {
  id: Scalars['String'];
};


export type MutationDeletesendgridTemplateArgs = {
  id: Scalars['String'];
};


export type MutationDownloadAgreementCsvArgs = {
  data: DashboardInput;
  pagination: PaginationInput;
};


export type MutationDownloadPosCsvArgs = {
  data: DashboardInput;
  pagination: PaginationInput;
};


export type MutationDownloadRevenueCsvArgs = {
  data: DashboardInput;
  pagination: PaginationInput;
};


export type MutationEmployeeSetActiveLocationArgs = {
  id: Scalars['String'];
  locationId: Scalars['String'];
};


export type MutationEnrollToMeetingArgs = {
  clientId: Scalars['String'];
  creditAllotmentId?: InputMaybe<Scalars['String']>;
  meetingId: Scalars['String'];
};


export type MutationGenerateClientLoginArgs = {
  id: Scalars['String'];
  username: Scalars['String'];
};


export type MutationMigrateClientNotesArgs = {
  data: NotesJsonArrInput;
};


export type MutationMigrateClientsArgs = {
  data: ClientsJsonArrInput;
  locationId: Scalars['String'];
};


export type MutationMigratePaymentMethodsArgs = {
  data: PaymentMethodJsonArrInput;
  locationId: Scalars['String'];
};


export type MutationMigratePaymentRecordsArgs = {
  data: PaymentRecordJsonArrInput;
  locationId: Scalars['String'];
};


export type MutationMigrateSubscriptionArgs = {
  data: SubscriptionJsonArrInput;
  locationId: Scalars['String'];
};


export type MutationPullFromMeetingArgs = {
  cancelEnrollment?: InputMaybe<Scalars['Boolean']>;
  clientId: Scalars['String'];
  meetingId: Scalars['String'];
};


export type MutationPushToMeetingArgs = {
  clientId: Scalars['String'];
  meetingId: Scalars['String'];
};


export type MutationRemoveClientFromGroupArgs = {
  clientGroupId: Scalars['String'];
  clientId: Scalars['String'];
};


export type MutationSaveCalendarFiltersArgs = {
  data: UpdateCalendarFiltersInput;
};


export type MutationSignDocumentArgs = {
  data: SignSignedDocumentInput;
  id: Scalars['String'];
};


export type MutationUpdateAccessPeriodArgs = {
  data: UpdateAccessPeriodInput;
  id: Scalars['String'];
};


export type MutationUpdateAdminArgs = {
  data: UpdateAdminInput;
  id: Scalars['String'];
};


export type MutationUpdateAgreementArgs = {
  data: UpdateAgreementInput;
  id: Scalars['String'];
  isForceUpdate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateAlterAgreementRecordArgs = {
  data: UpdateAlterAgreementRecordInput;
  id: Scalars['String'];
};


export type MutationUpdateAlterationReasonArgs = {
  data: UpdateAlterationReasonInput;
  id: Scalars['String'];
};


export type MutationUpdateAttendanceArgs = {
  attendeeId: Scalars['String'];
  data: UpdateAttendanceInput;
  feeWaived?: InputMaybe<Scalars['Boolean']>;
  meetingId: Scalars['String'];
};


export type MutationUpdateCategoryOptionArgs = {
  data: UpdateCategoryOptionInput;
  id: Scalars['String'];
};


export type MutationUpdateCheckInArgs = {
  data: UpdateCheckInInput;
  id: Scalars['String'];
};


export type MutationUpdateClientArgs = {
  data: UpdateClientInput;
  id: Scalars['String'];
};


export type MutationUpdateClientGroupArgs = {
  data: UpdateClientGroupInput;
  id: Scalars['String'];
};


export type MutationUpdateClientOrgArgs = {
  id: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type MutationUpdateClientPaymentMethodArgs = {
  data: UpdateClientPaymentMethodInput;
  id: Scalars['String'];
};


export type MutationUpdateClientPreferencesArgs = {
  data: UpdateClientPreferencesInput;
  id: Scalars['String'];
};


export type MutationUpdateCreditAllotmentArgs = {
  data: UpdateCreditAllotmentInput;
  id: Scalars['String'];
};


export type MutationUpdateDiscountCodeArgs = {
  data: UpdateDiscountCodeInput;
  id: Scalars['String'];
};


export type MutationUpdateEmployeeArgs = {
  data: UpdateEmployeeInput;
  id: Scalars['String'];
};


export type MutationUpdateEmployeeRoleArgs = {
  data: UpdateEmployeeRoleInput;
  id: Scalars['String'];
};


export type MutationUpdateEmployeeStationArgs = {
  data: UpdateEmployeeStationInput;
  id: Scalars['String'];
};


export type MutationUpdateInitialChargeArgs = {
  data: UpdateInitialChargeInput;
  id: Scalars['String'];
};


export type MutationUpdateLocationArgs = {
  data: UpdateLocationInput;
  id: Scalars['String'];
};


export type MutationUpdateLocationMonthlyFeeArgs = {
  data: UpdateLocationMonthlyFeeInput;
  id: Scalars['String'];
};


export type MutationUpdateLocationOfferingArgs = {
  data: UpdateLocationOfferingInput;
  id: Scalars['String'];
};


export type MutationUpdateLocationPaymentServiceArgs = {
  data: UpdateLocationPaymentServiceInput;
  id: Scalars['String'];
};


export type MutationUpdateLocationRevenueArgs = {
  data: UpdateLocationRevenueInput;
  id: Scalars['String'];
};


export type MutationUpdateLocationServiceArgs = {
  data: UpdateLocationServiceInput;
  id: Scalars['String'];
};


export type MutationUpdateLocationTaxRateArgs = {
  data: UpdateLocationTaxRateInput;
  id: Scalars['String'];
};


export type MutationUpdateLocationTransactionFeeArgs = {
  data: UpdateLocationTransactionFeeInput;
  id: Scalars['String'];
};


export type MutationUpdateMeetingArgs = {
  data: UpdateMeetingInput;
  id: Scalars['String'];
};


export type MutationUpdateMeetingSeriesArgs = {
  data: UpdateMeetingSeriesInput;
  id: Scalars['String'];
};


export type MutationUpdateNotesArgs = {
  data: UpdateNotesInput;
  id: Scalars['String'];
};


export type MutationUpdateOrganizationArgs = {
  data: UpdateOrganizationInput;
  id: Scalars['String'];
};


export type MutationUpdateOrganizationBrandingArgs = {
  data: OrganizationBrandingInput;
  id: Scalars['String'];
};


export type MutationUpdateOrganizationPaymentServiceArgs = {
  data: UpdateOrganizationPaymentServiceInput;
  id: Scalars['String'];
};


export type MutationUpdateOrganizationServiceArgs = {
  data: UpdateOrganizationServiceInput;
  id: Scalars['String'];
};


export type MutationUpdateOrganizationSettingsArgs = {
  data: OrganizationSettingsInput;
  id: Scalars['String'];
};


export type MutationUpdateOrganizationTaxRateArgs = {
  data: UpdateOrganizationTaxRateInput;
  id: Scalars['String'];
};


export type MutationUpdatePackageArgs = {
  data: UpdatePackageInput;
  id: Scalars['String'];
};


export type MutationUpdatePaymentTerminalArgs = {
  data: UpdatePaymentTerminalInput;
  id: Scalars['String'];
};


export type MutationUpdatePolicyArgs = {
  data: UpdatePolicyInput;
  id: Scalars['String'];
};


export type MutationUpdatePrivateSessionArgs = {
  data: UpdatePrivateSessionInput;
  id: Scalars['String'];
};


export type MutationUpdatePrivateSessionDurationArgs = {
  data: UpdatePrivateSessionDurationInput;
  id: Scalars['String'];
};


export type MutationUpdatePrivateSessionLocationRoomsArgs = {
  data: UpdatePrivateSessionLocationRoomsInput;
  id: Scalars['String'];
};


export type MutationUpdatePrivateSessionOverrideArgs = {
  data: UpdatePrivateSessionOverrideInput;
  id: Scalars['String'];
};


export type MutationUpdateProductArgs = {
  data: UpdateProductInput;
  id: Scalars['String'];
};


export type MutationUpdateProductGroupArgs = {
  data: UpdateProductGroupInput;
  id: Scalars['String'];
};


export type MutationUpdateRecurringChargeArgs = {
  data: UpdateRecurringChargeInput;
  id: Scalars['String'];
};


export type MutationUpdateRoleAssignmentArgs = {
  newRoleId: Scalars['String'];
  roleId: Scalars['String'];
};


export type MutationUpdateRoomArgs = {
  data: UpdateRoomInput;
  id: Scalars['String'];
};


export type MutationUpdateScheduledChargesArgs = {
  data: UpdateScheduledChargesInput;
  id: Scalars['String'];
};


export type MutationUpdateScheduledTransactionArgs = {
  data: UpdateScheduledTransactionInput;
  id: Scalars['String'];
};


export type MutationUpdateServiceAllotmentArgs = {
  data: UpdateServiceAllotmentInput;
  id: Scalars['String'];
};


export type MutationUpdateShoppingCartArgs = {
  data: UpdateShoppingCartInput;
  id: Scalars['String'];
};


export type MutationUpdateSignedAgreementArgs = {
  data: UpdateSignedAgreementInput;
  id: Scalars['String'];
};


export type MutationUpdateSignedDocumentArgs = {
  data: UpdateSignedDocumentInput;
  id: Scalars['String'];
};


export type MutationUpdateSindroPaymentServiceArgs = {
  data: UpdateSindroPaymentInput;
  id: Scalars['String'];
};


export type MutationUpdateSubscriptionArgs = {
  data: UpdateClientSubscriptionInput;
  id: Scalars['String'];
};


export type MutationUpdateTimeClockEntryArgs = {
  data: UpdateTimeClockEntryInput;
  timeClockEntryId: Scalars['String'];
};


export type MutationUpdateTransactionArgs = {
  data: UpdateTransactionInput;
  id: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
  id: Scalars['String'];
};


export type MutationUpdateVariantMetricArgs = {
  data: UpdateVariantMetricInput;
  id: Scalars['String'];
};


export type MutationUpdateWaitlisteeArgs = {
  data: UpdateWaitlisteeInput;
  id: Scalars['String'];
};


export type MutationUpdatesendgridTemplateArgs = {
  data: UpdateSendgridTemplateInput;
  id: Scalars['String'];
};

export type MutationResult = {
  __typename?: 'MutationResult';
  errors: MigrateError;
};

export type Notes = {
  __typename?: 'Notes';
  author?: Maybe<Employee>;
  client: Client;
  content: Scalars['String'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isMigrated: Scalars['Boolean'];
  updatedDate: Scalars['DateTime'];
};

export type NotesJsonArrInput = {
  data: Array<InternalNotesInput>;
};

export enum NotificationType {
  Both = 'Both',
  Email = 'Email',
  None = 'None',
  Sms = 'SMS'
}

export type OrderBy = {
  direction: Scalars['String'];
  field: Scalars['String'];
  parentRelationField?: InputMaybe<Scalars['String']>;
};

export type Organization = {
  __typename?: 'Organization';
  categoryOptions: Array<CategoryOption>;
  city?: Maybe<Scalars['String']>;
  clients: Array<Client>;
  country?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  employees: Array<Employee>;
  id: Scalars['ID'];
  locations: Array<Location>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationBranding?: Maybe<OrganizationBranding>;
  organizationServices: Array<OrganizationService>;
  policies: Array<Policy>;
  settings?: Maybe<OrganizationSettings>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
  zipCode?: Maybe<Scalars['String']>;
};

export type OrganizationBranding = {
  __typename?: 'OrganizationBranding';
  brandingLogoImg?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  signNowBrandId?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
};

export type OrganizationBrandingInput = {
  brandingLogoImg?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  signNowBrandId?: InputMaybe<Scalars['String']>;
};

export type OrganizationPaymentService = {
  __typename?: 'OrganizationPaymentService';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  locations: Array<LocationPaymentService>;
  name: Scalars['String'];
  paymentService: SindroPaymentService;
  paymentType: PaymentType;
  updatedDate: Scalars['DateTime'];
};

export type OrganizationService = {
  __typename?: 'OrganizationService';
  categoryOptions: Array<CategoryOption>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  isIndivdual: Scalars['Boolean'];
  isSelfEnroll: Scalars['Boolean'];
  isWaitlistEnabled: Scalars['Boolean'];
  locationServices: Array<LocationService>;
  name: Scalars['String'];
  organization: Organization;
  policies: Array<Policy>;
  revenueCategory?: Maybe<CategoryOption>;
  serviceType?: Maybe<CategoryOption>;
  updatedDate: Scalars['DateTime'];
  waitlistMax: Scalars['Int'];
};

export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  freezeExtendsTerm?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  seriesGenInterval: SeriesGenInterval;
  seriesGenRange: Scalars['Float'];
  updatedDate: Scalars['DateTime'];
};

export type OrganizationSettingsInput = {
  freezeExtendsTerm?: InputMaybe<Scalars['Boolean']>;
  seriesGenInterval: SeriesGenInterval;
  seriesGenRange?: InputMaybe<Scalars['Float']>;
};

export type OrganizationTaxRate = {
  __typename?: 'OrganizationTaxRate';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: Organization;
  taxRate?: Maybe<Scalars['Float']>;
  updatedDate: Scalars['DateTime'];
};

export type Package = {
  __typename?: 'Package';
  additionalPolicies: Array<Policy>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initialAllotments?: Maybe<Array<ServiceAllotment>>;
  initialCharges?: Maybe<Array<InitialCharge>>;
  isActive: Scalars['Boolean'];
  isGeneric: Scalars['Boolean'];
  isOrg: Scalars['Boolean'];
  locations?: Maybe<Array<Location>>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  product?: Maybe<Product>;
  updatedDate: Scalars['DateTime'];
};

export type PaginatedAgreementResponse = {
  __typename?: 'PaginatedAgreementResponse';
  items: Array<Agreement>;
  totalRows: Scalars['Int'];
};

export type PaginatedAlterAgreementRecordResponse = {
  __typename?: 'PaginatedAlterAgreementRecordResponse';
  items: Array<AlterAgreementRecord>;
  totalRows: Scalars['Int'];
};

export type PaginatedAttendanceResponse = {
  __typename?: 'PaginatedAttendanceResponse';
  items: Array<Attendance>;
  totalRows: Scalars['Int'];
};

export type PaginatedAttendeeResponse = {
  __typename?: 'PaginatedAttendeeResponse';
  items: Array<Attendee>;
  totalRows: Scalars['Int'];
};

export type PaginatedClientGroupResponse = {
  __typename?: 'PaginatedClientGroupResponse';
  items: Array<ClientGroup>;
  totalRows: Scalars['Int'];
};

export type PaginatedClientResponse = {
  __typename?: 'PaginatedClientResponse';
  items: Array<Client>;
  totalRows: Scalars['Int'];
};

export type PaginatedClientSubscriptionResponse = {
  __typename?: 'PaginatedClientSubscriptionResponse';
  items: Array<ClientSubscription>;
  totalRows: Scalars['Int'];
};

export type PaginatedDiscountCodeResponse = {
  __typename?: 'PaginatedDiscountCodeResponse';
  items: Array<DiscountCode>;
  totalRows: Scalars['Int'];
};

export type PaginatedEmployeeResponse = {
  __typename?: 'PaginatedEmployeeResponse';
  items: Array<Employee>;
  totalRows: Scalars['Int'];
};

export type PaginatedEmployeeRoleResponse = {
  __typename?: 'PaginatedEmployeeRoleResponse';
  items: Array<EmployeeRole>;
  totalRows: Scalars['Int'];
};

export type PaginatedEmployeeStationResponse = {
  __typename?: 'PaginatedEmployeeStationResponse';
  items: Array<EmployeeStation>;
  totalRows: Scalars['Int'];
};

export type PaginatedLocationResponse = {
  __typename?: 'PaginatedLocationResponse';
  items: Array<Location>;
  totalRows: Scalars['Int'];
};

export type PaginatedMeetingResponse = {
  __typename?: 'PaginatedMeetingResponse';
  items: Array<Meeting>;
  totalRows: Scalars['Int'];
};

export type PaginatedMeetingSeriesResponse = {
  __typename?: 'PaginatedMeetingSeriesResponse';
  items: Array<MeetingSeries>;
  totalRows: Scalars['Int'];
};

export type PaginatedOrganizationResponse = {
  __typename?: 'PaginatedOrganizationResponse';
  items: Array<Organization>;
  totalRows: Scalars['Int'];
};

export type PaginatedOrganizationServiceResponse = {
  __typename?: 'PaginatedOrganizationServiceResponse';
  items: Array<OrganizationService>;
  totalRows: Scalars['Int'];
};

export type PaginatedPackageResponse = {
  __typename?: 'PaginatedPackageResponse';
  items: Array<Package>;
  totalRows: Scalars['Int'];
};

export type PaginatedPolicyResponse = {
  __typename?: 'PaginatedPolicyResponse';
  items: Array<Policy>;
  totalRows: Scalars['Int'];
};

export type PaginatedPrivateSessionOverrideResponse = {
  __typename?: 'PaginatedPrivateSessionOverrideResponse';
  items: Array<PrivateSessionOverride>;
  totalRows: Scalars['Int'];
};

export type PaginatedPrivateSessionResponse = {
  __typename?: 'PaginatedPrivateSessionResponse';
  items: Array<PrivateSession>;
  totalRows: Scalars['Int'];
};

export type PaginatedProductGroupResponse = {
  __typename?: 'PaginatedProductGroupResponse';
  items: Array<ProductGroup>;
  totalRows: Scalars['Int'];
};

export type PaginatedProductResponse = {
  __typename?: 'PaginatedProductResponse';
  items: Array<Product>;
  totalRows: Scalars['Int'];
};

export type PaginatedProductSaleResponse = {
  __typename?: 'PaginatedProductSaleResponse';
  items: Array<ProductSale>;
  totalRows: Scalars['Int'];
};

export type PaginatedRevenueRecordResponse = {
  __typename?: 'PaginatedRevenueRecordResponse';
  items: Array<RevenueRecord>;
  totalRows: Scalars['Int'];
};

export type PaginatedRoomResponse = {
  __typename?: 'PaginatedRoomResponse';
  items: Array<Room>;
  totalRows: Scalars['Int'];
};

export type PaginatedSendgridTemplateResponse = {
  __typename?: 'PaginatedSendgridTemplateResponse';
  items: Array<SendgridTemplate>;
  totalRows: Scalars['Int'];
};

export type PaginatedSindroPaymentServiceResponse = {
  __typename?: 'PaginatedSindroPaymentServiceResponse';
  items: Array<SindroPaymentService>;
  totalRows: Scalars['Int'];
};

export type PaginatedTimeClockEntryResponse = {
  __typename?: 'PaginatedTimeClockEntryResponse';
  items: Array<TimeClockEntry>;
  totalRows: Scalars['Int'];
};

export type PaginatedTransactionResponse = {
  __typename?: 'PaginatedTransactionResponse';
  items: Array<Transaction>;
  totalRows: Scalars['Int'];
};

export type PaginatedUserResponse = {
  __typename?: 'PaginatedUserResponse';
  items: Array<User>;
  totalRows: Scalars['Int'];
};

export type PaginationInput = {
  count?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<FilterBy>>;
  orderBy?: InputMaybe<OrderBy>;
  page?: InputMaybe<Scalars['Int']>;
};

export enum PaymentFrequency {
  BiWeekly = 'BiWeekly',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
  Yearly = 'Yearly'
}

export type PaymentMethodJsonArrInput = {
  data: Array<InternalPaymentMethodInput>;
};

export type PaymentMethodSubscription = {
  __typename?: 'PaymentMethodSubscription';
  newPaymentMethod: ClientPaymentMethods;
};

export enum PaymentMethodType {
  Ach = 'ACH',
  Card = 'Card'
}

export type PaymentRecordJsonArrInput = {
  data: Array<InternalPaymentRecordInput>;
};

export enum PaymentStatus {
  Due = 'Due',
  Paid = 'Paid',
  Past = 'Past'
}

export type PaymentTerminal = {
  __typename?: 'PaymentTerminal';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  location: Location;
  name: Scalars['String'];
  physicalId?: Maybe<Scalars['String']>;
  transactions: Array<Transaction>;
  updatedDate: Scalars['DateTime'];
};

export enum PaymentType {
  Payroc = 'Payroc',
  Stripe = 'Stripe',
  Tilled = 'Tilled'
}

export type PayrocAccount = {
  __typename?: 'PayrocAccount';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  fundingAccountId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  merchantId?: Maybe<Scalars['String']>;
  payrocEmbeddedSecret?: Maybe<Scalars['String']>;
  payrocVirtualTerminalId?: Maybe<Scalars['String']>;
  updatedDate: Scalars['DateTime'];
};

export type PayrocAccountInput = {
  merchantId?: InputMaybe<Scalars['String']>;
  payrocEmbeddedSecret?: InputMaybe<Scalars['String']>;
  payrocVirtualTerminalId?: InputMaybe<Scalars['String']>;
};

export type Policy = {
  __typename?: 'Policy';
  createdDate: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  deletedDate?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['String']>;
  documentTemplateId?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isPdf: Scalars['Boolean'];
  isSignable: Scalars['Boolean'];
  location?: Maybe<Location>;
  name: Scalars['String'];
  organization: Organization;
  organizationServices: Array<OrganizationService>;
  policyRecords: Array<PolicyRecord>;
  updatedDate: Scalars['DateTime'];
};

export type PolicyRecord = {
  __typename?: 'PolicyRecord';
  createdDate: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  deletedDate?: Maybe<Scalars['DateTime']>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPdf: Scalars['Boolean'];
  name: Scalars['String'];
  policy: Policy;
  updatedDate: Scalars['DateTime'];
};

export type PrivateSession = {
  __typename?: 'PrivateSession';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durations: Array<PrivateSessionDuration>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  intervalDuration: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isEmployeeRequired: Scalars['Boolean'];
  isOrg: Scalars['Boolean'];
  isPostTax: Scalars['Boolean'];
  isRoomRequired: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  maxDuration?: Maybe<Scalars['Int']>;
  minDuration?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  organization: Organization;
  overrides: Array<PrivateSessionOverride>;
  policies: Array<Policy>;
  revenueCategory: CategoryOption;
  rooms: Array<PrivateSessionLocationRooms>;
  serviceType: CategoryOption;
  updatedDate: Scalars['DateTime'];
};

export type PrivateSessionDuration = {
  __typename?: 'PrivateSessionDuration';
  cost: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  duration: Scalars['Int'];
  id: Scalars['ID'];
  product?: Maybe<Product>;
  session: PrivateSession;
  updatedDate: Scalars['DateTime'];
};

export type PrivateSessionLocationRooms = {
  __typename?: 'PrivateSessionLocationRooms';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location: Location;
  rooms: Array<Room>;
  session: PrivateSession;
  taxRates: Array<LocationTaxRate>;
  updatedDate: Scalars['DateTime'];
};

export type PrivateSessionOverride = {
  __typename?: 'PrivateSessionOverride';
  commission: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  employee: Employee;
  id: Scalars['ID'];
  isPercent: Scalars['Boolean'];
  locations: Array<Location>;
  maxDuration?: Maybe<Scalars['Int']>;
  minDuration?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  session: PrivateSession;
  updatedDate: Scalars['DateTime'];
};

export type Product = {
  __typename?: 'Product';
  barcode?: Maybe<Scalars['String']>;
  commissionValue?: Maybe<Scalars['Float']>;
  cost: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isCommissionPercent: Scalars['Boolean'];
  isCommissionable: Scalars['Boolean'];
  isPostTax: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  location?: Maybe<Location>;
  metricValues: Array<VariantValue>;
  name: Scalars['String'];
  package?: Maybe<Package>;
  privateSession?: Maybe<PrivateSessionDuration>;
  productGroup: ProductGroup;
  productSales: ProductSale;
  revenue?: Maybe<CategoryOption>;
  service?: Maybe<LocationService>;
  sku?: Maybe<Scalars['String']>;
  stock: Scalars['Int'];
  tags: Array<CategoryOption>;
  taxRates?: Maybe<Array<LocationTaxRate>>;
  updatedDate: Scalars['DateTime'];
};

export type ProductGroup = {
  __typename?: 'ProductGroup';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isVirtual: Scalars['Boolean'];
  location: Location;
  metrics?: Maybe<Array<VariantMetric>>;
  name: Scalars['String'];
  products: Array<Product>;
  revenueCategory?: Maybe<CategoryOption>;
  updatedDate: Scalars['DateTime'];
};

export type ProductSale = {
  __typename?: 'ProductSale';
  commissionValue: Scalars['Float'];
  count: Scalars['Int'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  discount: Scalars['Float'];
  id: Scalars['ID'];
  isPackage: Scalars['Boolean'];
  location: Location;
  product: Product;
  productType: ProductType;
  revenue: Scalars['Float'];
  tax: Scalars['Float'];
  transaction: Transaction;
  updatedDate: Scalars['DateTime'];
};

export enum ProductType {
  Package = 'Package',
  PrivateSession = 'PrivateSession',
  Retail = 'Retail',
  Service = 'Service'
}

export type Query = {
  __typename?: 'Query';
  PackagePage: PaginatedPackageResponse;
  accessPeriodMany?: Maybe<Array<AccessPeriod>>;
  accessPeriodOne?: Maybe<AccessPeriod>;
  accountDetailReport: Array<Client>;
  adminOne?: Maybe<Admin>;
  agreementDashboard: Array<DashboardObject>;
  agreementMany: Array<Agreement>;
  agreementOne?: Maybe<Agreement>;
  agreementPage: PaginatedAgreementResponse;
  agreementRecipientMany: Array<AgreementRecipient>;
  agreementRecipientOne?: Maybe<AgreementRecipient>;
  agreementReport: Array<SignedAgreement>;
  agreementReportPage: PaginatedTransactionResponse;
  agreementRequests?: Maybe<Array<AlterAgreementRecord>>;
  alterAgreementRecordOne?: Maybe<AlterAgreementRecord>;
  alterAgreementRecordPage: PaginatedAlterAgreementRecordResponse;
  alterAgreementRecordsByType?: Maybe<Array<AlterAgreementRecord>>;
  alterAgreementRecordsMany?: Maybe<Array<AlterAgreementRecord>>;
  alterationReasonByType?: Maybe<Array<AlterationReason>>;
  alterationReasonMany?: Maybe<Array<AlterationReason>>;
  alterationReasonOne?: Maybe<AlterationReason>;
  attendanceByClient: Array<Attendance>;
  attendanceByClientUpcoming: Array<Attendance>;
  attendanceMany: Array<Attendance>;
  attendanceOne?: Maybe<Attendance>;
  attendancePage: PaginatedAttendanceResponse;
  attendeeMany: Array<Attendee>;
  attendeePage: PaginatedAttendeeResponse;
  calendarFilterLocation?: Maybe<CalendarFilters>;
  calendarFiltersOne?: Maybe<CalendarFilters>;
  cardsExpirationReport: Array<ClientSubscription>;
  categoryOptionMany: Array<CategoryOption>;
  categoryOptionOne?: Maybe<CategoryOption>;
  checkEmployeePin: Scalars['Boolean'];
  checkForSignedAgreement?: Maybe<SignedAgreement>;
  checkInMany: Array<CheckIn>;
  checkInOne?: Maybe<CheckIn>;
  checkUsernameAvailability: Scalars['Boolean'];
  clientChangeRecordsMany: Array<ClientChangeRecord>;
  clientChangeRecordsOlderMany: Array<ClientChangeRecord>;
  clientGroupMany: Array<ClientGroup>;
  clientGroupOne?: Maybe<ClientGroup>;
  clientGroupPage: PaginatedClientGroupResponse;
  clientMany: Array<Client>;
  clientOne?: Maybe<Client>;
  clientPage: PaginatedClientResponse;
  clientPaymentMethodOne?: Maybe<ClientPaymentMethods>;
  clientPaymentMethodsMany: Array<ClientPaymentMethods>;
  clientPreferencesMany: Array<ClientPreferences>;
  clientPreferencesOne?: Maybe<ClientPreferences>;
  clientSampleCSV: Scalars['String'];
  creditAllotmentMany: Array<CreditAllotment>;
  creditAllotmentOne?: Maybe<CreditAllotment>;
  dicountCodePage: PaginatedDiscountCodeResponse;
  discountByCode: DiscountCode;
  discountCodeAgreementsOrProducts: DiscountCode;
  discountCodeMany: Array<DiscountCode>;
  discountCodeOne: DiscountCode;
  downloadAccountDetailReport: Scalars['String'];
  downloadAgreementReport: Scalars['String'];
  downloadCardsExpirationReport: Scalars['String'];
  downloadPosReport: Scalars['String'];
  employeeMany: Array<Employee>;
  employeeOne?: Maybe<Employee>;
  employeePage: PaginatedEmployeeResponse;
  employeeRoleMany: Array<EmployeeRole>;
  employeeRoleOne?: Maybe<EmployeeRole>;
  employeeRolePage: PaginatedEmployeeRoleResponse;
  employeeRolesPossible: Array<EmployeeRole>;
  employeeStationMany?: Maybe<Array<EmployeeStation>>;
  employeeStationOne?: Maybe<EmployeeStation>;
  employeeStationPage: PaginatedEmployeeStationResponse;
  getEditorLink: Scalars['String'];
  getEmbeddedLink: Scalars['String'];
  getValidCreditAllotmemts: Array<CreditAllotment>;
  initialChargeOne?: Maybe<InitialCharge>;
  isRoleAssigned: Scalars['Boolean'];
  locationMany: Array<Location>;
  locationMonthlyFeeMany: Array<LocationMonthlyFee>;
  locationMonthlyFeeOne: LocationMonthlyFee;
  locationOfferingByPromoCode?: Maybe<Array<LocationOffering>>;
  locationOfferingMany?: Maybe<Array<LocationOffering>>;
  locationOfferingOne?: Maybe<LocationOffering>;
  locationOne?: Maybe<Location>;
  locationPage: PaginatedLocationResponse;
  locationPaymentServiceMany: Array<LocationPaymentService>;
  locationPaymentServiceOne?: Maybe<LocationPaymentService>;
  locationRevenueByLocation: LocationRevenue;
  locationRevenueMany: Array<LocationRevenue>;
  locationRevenueOne: LocationRevenue;
  locationServiceMany: Array<LocationService>;
  locationServiceOne?: Maybe<LocationService>;
  locationTaxRateMany: Array<LocationTaxRate>;
  locationTaxRateOne?: Maybe<LocationTaxRate>;
  locationTransactionFeeMany: Array<LocationTransactionFee>;
  locationTransactionFeeOne: LocationTransactionFee;
  meetingMany: Array<Meeting>;
  meetingOne?: Maybe<Meeting>;
  meetingPage: PaginatedMeetingResponse;
  meetingSeriesMany: Array<MeetingSeries>;
  meetingSeriesOne?: Maybe<MeetingSeries>;
  meetingSeriesPage: PaginatedMeetingSeriesResponse;
  notesMany: Array<Notes>;
  notesOne?: Maybe<Notes>;
  notesSampleCSV: Scalars['String'];
  organizationBrandingOne: OrganizationBranding;
  organizationMany: Array<Organization>;
  organizationOne?: Maybe<Organization>;
  organizationPage: PaginatedOrganizationResponse;
  organizationPaymentServiceMany: Array<OrganizationPaymentService>;
  organizationPaymentServiceOne?: Maybe<OrganizationPaymentService>;
  organizationServiceMany: Array<OrganizationService>;
  organizationServiceOne?: Maybe<OrganizationService>;
  organizationServicePage: PaginatedOrganizationServiceResponse;
  organizationSettingsOne?: Maybe<OrganizationSettings>;
  organizationTaxRateMany: Array<OrganizationTaxRate>;
  organizationTaxRateOne?: Maybe<OrganizationTaxRate>;
  packageDashboard: Array<DashboardObject>;
  packageMany: Array<Package>;
  packageOne: Package;
  paymentMethodSampleCSV: Scalars['String'];
  paymentRecordSampleCSV: Scalars['String'];
  paymentTerminalMany: Array<PaymentTerminal>;
  paymentTerminalOne: PaymentTerminal;
  policyMany: Array<Policy>;
  policyOne: Policy;
  policyPage: PaginatedPolicyResponse;
  posDashboard: DashboardOrRevenueItem;
  posReport: Array<Transaction>;
  posReportPage: PaginatedProductSaleResponse;
  privateSessionDurationMany: Array<PrivateSessionDuration>;
  privateSessionDurationOne: PrivateSessionDuration;
  privateSessionLocationRoomsMany?: Maybe<Array<PrivateSessionLocationRooms>>;
  privateSessionLocationRoomsOne?: Maybe<PrivateSessionLocationRooms>;
  privateSessionMany?: Maybe<Array<PrivateSession>>;
  privateSessionOne?: Maybe<PrivateSession>;
  privateSessionOverrideMany?: Maybe<Array<PrivateSessionOverride>>;
  privateSessionOverrideOne?: Maybe<PrivateSessionOverride>;
  privateSessionOverridePage: PaginatedPrivateSessionOverrideResponse;
  privateSessionPage: PaginatedPrivateSessionResponse;
  productGroupMany: Array<ProductGroup>;
  productGroupOne: ProductGroup;
  productGroupPage: PaginatedProductGroupResponse;
  productMany: Array<Product>;
  productOne: Product;
  productPage: PaginatedProductResponse;
  projectedIncome: Array<AggregatedRevenue>;
  recurringChargeOne?: Maybe<RecurringCharge>;
  revenueDashboard: RevenueObject;
  revenueRecordMany: Array<RevenueRecord>;
  revenueRecordOne: RevenueRecord;
  revenueReportPage: PaginatedRevenueRecordResponse;
  roomMany: Array<Room>;
  roomOne?: Maybe<Room>;
  roomPage: PaginatedRoomResponse;
  scheduledChargesByTransactionId: Array<ScheduledCharges>;
  scheduledChargesMany: Array<ScheduledCharges>;
  scheduledChargesOne: ScheduledCharges;
  scheduledTransactionMany: Array<ScheduledTransaction>;
  scheduledTransactionOne: ScheduledTransaction;
  scheduledTransactionsByClientId?: Maybe<Array<ScheduledTransaction>>;
  sendgridDynamicFieldMany?: Maybe<Array<SendgridDynamicField>>;
  sendgridDynamicFieldOne?: Maybe<SendgridDynamicField>;
  sendgridTemplateMany?: Maybe<Array<SendgridTemplate>>;
  sendgridTemplateOne?: Maybe<SendgridTemplate>;
  sendgridTemplatePage: PaginatedSendgridTemplateResponse;
  serviceAllotmentMany: Array<ServiceAllotment>;
  serviceAllotmentOne: ServiceAllotment;
  shoppingCartMany: Array<ShoppingCart>;
  shoppingCartOne: ShoppingCart;
  signedAgreementMany: Array<SignedAgreement>;
  signedAgreementOne?: Maybe<SignedAgreement>;
  signedDocumentMany: Array<SignedDocumentGroup>;
  signedDocumentOne: SignedDocumentGroup;
  sindroPaymentServiceMany: Array<SindroPaymentService>;
  sindroPaymentServiceOne?: Maybe<SindroPaymentService>;
  sindroPaymentServicePage: PaginatedSindroPaymentServiceResponse;
  subscriptionMany: Array<ClientSubscription>;
  subscriptionOne: ClientSubscription;
  subscriptionPage: PaginatedClientSubscriptionResponse;
  subscriptionSampleCSV: Scalars['String'];
  suggestedUserName: Scalars['String'];
  timeClockEntryMany: Array<TimeClockEntry>;
  timeClockEntryOne?: Maybe<TimeClockEntry>;
  timeClockEntryPage: PaginatedTimeClockEntryResponse;
  transactionByClient: Array<Transaction>;
  transactionMany: Array<Transaction>;
  transactionOne?: Maybe<Transaction>;
  transactionPage: PaginatedTransactionResponse;
  userMany: Array<User>;
  userOne?: Maybe<User>;
  userPage: PaginatedUserResponse;
  variantMetricOne?: Maybe<VariantMetric>;
  waitlisteeMany: Array<Waitlistee>;
  waitlisteeOne?: Maybe<Waitlistee>;
};


export type QueryPackagePageArgs = {
  locationIds?: InputMaybe<Array<GenericConnectInput>>;
  pagination: PaginationInput;
};


export type QueryAccessPeriodManyArgs = {
  agreementId?: InputMaybe<Scalars['String']>;
};


export type QueryAccessPeriodOneArgs = {
  id: Scalars['String'];
};


export type QueryAccountDetailReportArgs = {
  data: AccountReportInput;
};


export type QueryAdminOneArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryAgreementDashboardArgs = {
  data: DashboardInput;
};


export type QueryAgreementManyArgs = {
  locationIds?: InputMaybe<Array<GenericConnectInput>>;
};


export type QueryAgreementOneArgs = {
  id?: InputMaybe<Scalars['String']>;
  viid?: InputMaybe<Scalars['String']>;
};


export type QueryAgreementPageArgs = {
  locationIds?: InputMaybe<Array<GenericConnectInput>>;
  pagination: PaginationInput;
};


export type QueryAgreementRecipientManyArgs = {
  clientId: Scalars['String'];
};


export type QueryAgreementRecipientOneArgs = {
  id: Scalars['String'];
};


export type QueryAgreementReportArgs = {
  data: CustomReportInput;
};


export type QueryAgreementReportPageArgs = {
  data: DashboardInput;
  pagination: PaginationInput;
};


export type QueryAgreementRequestsArgs = {
  clientId: Scalars['String'];
};


export type QueryAlterAgreementRecordOneArgs = {
  id: Scalars['String'];
};


export type QueryAlterAgreementRecordPageArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryAlterAgreementRecordsByTypeArgs = {
  type: Scalars['String'];
};


export type QueryAlterationReasonByTypeArgs = {
  type: Scalars['String'];
};


export type QueryAlterationReasonManyArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryAlterationReasonOneArgs = {
  id: Scalars['String'];
};


export type QueryAttendanceByClientArgs = {
  clientId: Scalars['String'];
};


export type QueryAttendanceByClientUpcomingArgs = {
  clientId: Scalars['String'];
};


export type QueryAttendanceOneArgs = {
  id: Scalars['String'];
};


export type QueryAttendancePageArgs = {
  pagination: PaginationInput;
};


export type QueryAttendeeManyArgs = {
  orgId?: InputMaybe<Scalars['String']>;
};


export type QueryAttendeePageArgs = {
  pagination: PaginationInput;
};


export type QueryCalendarFilterLocationArgs = {
  locationId: Scalars['String'];
};


export type QueryCalendarFiltersOneArgs = {
  id: Scalars['String'];
};


export type QueryCardsExpirationReportArgs = {
  data: CustomReportInput;
};


export type QueryCategoryOptionManyArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryCategoryOptionOneArgs = {
  id: Scalars['String'];
};


export type QueryCheckEmployeePinArgs = {
  pin: Scalars['String'];
};


export type QueryCheckForSignedAgreementArgs = {
  agreementId: Scalars['String'];
  clientId: Scalars['String'];
  locationId: Scalars['String'];
};


export type QueryCheckInManyArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  todayRecords?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCheckInOneArgs = {
  id: Scalars['String'];
};


export type QueryCheckUsernameAvailabilityArgs = {
  username: Scalars['String'];
};


export type QueryClientChangeRecordsManyArgs = {
  clientId: Scalars['String'];
};


export type QueryClientChangeRecordsOlderManyArgs = {
  clientId: Scalars['String'];
  filter: Scalars['Float'];
};


export type QueryClientGroupManyArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryClientGroupOneArgs = {
  id: Scalars['String'];
};


export type QueryClientGroupPageArgs = {
  pagination: PaginationInput;
};


export type QueryClientOneArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryClientPageArgs = {
  pagination: PaginationInput;
};


export type QueryClientPaymentMethodOneArgs = {
  id: Scalars['String'];
};


export type QueryClientPaymentMethodsManyArgs = {
  clientId: Scalars['String'];
};


export type QueryClientPreferencesOneArgs = {
  id: Scalars['String'];
};


export type QueryCreditAllotmentManyArgs = {
  clientId: Scalars['String'];
};


export type QueryCreditAllotmentOneArgs = {
  id: Scalars['String'];
};


export type QueryDicountCodePageArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryDiscountByCodeArgs = {
  code: Scalars['String'];
  locationId: Scalars['String'];
};


export type QueryDiscountCodeAgreementsOrProductsArgs = {
  id: Scalars['String'];
  isAgreement: Scalars['Boolean'];
};


export type QueryDiscountCodeOneArgs = {
  id: Scalars['String'];
};


export type QueryDownloadAccountDetailReportArgs = {
  data: AccountReportInput;
};


export type QueryDownloadAgreementReportArgs = {
  data: CustomReportInput;
};


export type QueryDownloadCardsExpirationReportArgs = {
  data: CustomReportInput;
};


export type QueryDownloadPosReportArgs = {
  data: CustomReportInput;
};


export type QueryEmployeeManyArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
};


export type QueryEmployeeOneArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryEmployeePageArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryEmployeeRoleOneArgs = {
  id: Scalars['String'];
};


export type QueryEmployeeRolePageArgs = {
  pagination: PaginationInput;
};


export type QueryEmployeeStationManyArgs = {
  employeeId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryEmployeeStationOneArgs = {
  id: Scalars['String'];
};


export type QueryEmployeeStationPageArgs = {
  pagination: PaginationInput;
};


export type QueryGetEditorLinkArgs = {
  id: Scalars['String'];
};


export type QueryGetEmbeddedLinkArgs = {
  signedAgreementId: Scalars['String'];
};


export type QueryGetValidCreditAllotmemtsArgs = {
  clientId: Scalars['String'];
  locationServiceId?: InputMaybe<Scalars['String']>;
  privateSessionId?: InputMaybe<Scalars['String']>;
};


export type QueryInitialChargeOneArgs = {
  id: Scalars['String'];
};


export type QueryIsRoleAssignedArgs = {
  roleId: Scalars['String'];
};


export type QueryLocationMonthlyFeeManyArgs = {
  locationRevenueId?: InputMaybe<Scalars['String']>;
};


export type QueryLocationMonthlyFeeOneArgs = {
  id: Scalars['String'];
};


export type QueryLocationOfferingByPromoCodeArgs = {
  promoCode: Scalars['String'];
};


export type QueryLocationOfferingManyArgs = {
  isPromoCode?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryLocationOfferingOneArgs = {
  id: Scalars['String'];
};


export type QueryLocationOneArgs = {
  id: Scalars['String'];
};


export type QueryLocationPageArgs = {
  pagination: PaginationInput;
};


export type QueryLocationPaymentServiceOneArgs = {
  id: Scalars['String'];
};


export type QueryLocationRevenueByLocationArgs = {
  locationId: Scalars['String'];
};


export type QueryLocationRevenueOneArgs = {
  id: Scalars['String'];
};


export type QueryLocationServiceManyArgs = {
  locationId: Scalars['String'];
};


export type QueryLocationServiceOneArgs = {
  id: Scalars['String'];
};


export type QueryLocationTaxRateManyArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryLocationTaxRateOneArgs = {
  id: Scalars['String'];
};


export type QueryLocationTransactionFeeManyArgs = {
  locationRevenueId?: InputMaybe<Scalars['String']>;
};


export type QueryLocationTransactionFeeOneArgs = {
  id: Scalars['String'];
};


export type QueryMeetingManyArgs = {
  endAt?: InputMaybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  startAt?: InputMaybe<Scalars['DateTime']>;
};


export type QueryMeetingOneArgs = {
  id: Scalars['String'];
};


export type QueryMeetingPageArgs = {
  endAt?: InputMaybe<Scalars['DateTime']>;
  pagination: PaginationInput;
  startAt?: InputMaybe<Scalars['DateTime']>;
};


export type QueryMeetingSeriesManyArgs = {
  endAt?: InputMaybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  startAt?: InputMaybe<Scalars['DateTime']>;
};


export type QueryMeetingSeriesOneArgs = {
  id: Scalars['String'];
};


export type QueryMeetingSeriesPageArgs = {
  endAt?: InputMaybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  pagination: PaginationInput;
  startAt?: InputMaybe<Scalars['DateTime']>;
};


export type QueryNotesManyArgs = {
  clientId?: InputMaybe<Scalars['String']>;
};


export type QueryNotesOneArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationBrandingOneArgs = {
  id?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
};


export type QueryOrganizationOneArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationPageArgs = {
  pagination: PaginationInput;
};


export type QueryOrganizationPaymentServiceOneArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationServiceManyArgs = {
  orgId: Scalars['String'];
};


export type QueryOrganizationServiceOneArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationServicePageArgs = {
  pagination: PaginationInput;
};


export type QueryOrganizationSettingsOneArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationTaxRateManyArgs = {
  organizationId?: InputMaybe<Scalars['String']>;
};


export type QueryOrganizationTaxRateOneArgs = {
  id: Scalars['String'];
};


export type QueryPackageDashboardArgs = {
  data: DashboardInput;
};


export type QueryPackageManyArgs = {
  locationIds?: InputMaybe<Array<GenericConnectInput>>;
};


export type QueryPackageOneArgs = {
  id: Scalars['String'];
};


export type QueryPaymentTerminalManyArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentTerminalOneArgs = {
  id: Scalars['String'];
};


export type QueryPolicyOneArgs = {
  id: Scalars['String'];
};


export type QueryPolicyPageArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryPosDashboardArgs = {
  data: DashboardInput;
  sortType: SortType;
};


export type QueryPosReportArgs = {
  data: CustomReportInput;
};


export type QueryPosReportPageArgs = {
  data: DashboardInput;
  pagination: PaginationInput;
};


export type QueryPrivateSessionDurationManyArgs = {
  privateSessionId?: InputMaybe<Scalars['String']>;
};


export type QueryPrivateSessionDurationOneArgs = {
  id: Scalars['String'];
};


export type QueryPrivateSessionLocationRoomsManyArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryPrivateSessionLocationRoomsOneArgs = {
  id: Scalars['String'];
};


export type QueryPrivateSessionManyArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryPrivateSessionOneArgs = {
  id: Scalars['String'];
};


export type QueryPrivateSessionOverrideOneArgs = {
  id: Scalars['String'];
};


export type QueryPrivateSessionOverridePageArgs = {
  pagination: PaginationInput;
};


export type QueryPrivateSessionPageArgs = {
  pagination: PaginationInput;
};


export type QueryProductGroupOneArgs = {
  id: Scalars['String'];
};


export type QueryProductGroupPageArgs = {
  getByProductsCount?: InputMaybe<Scalars['Boolean']>;
  includeVirtual?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryProductManyArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryProductOneArgs = {
  id: Scalars['String'];
};


export type QueryProductPageArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryProjectedIncomeArgs = {
  data: DashboardInput;
};


export type QueryRecurringChargeOneArgs = {
  id: Scalars['String'];
};


export type QueryRevenueDashboardArgs = {
  data: DashboardInput;
};


export type QueryRevenueRecordOneArgs = {
  id: Scalars['String'];
};


export type QueryRevenueReportPageArgs = {
  data: DashboardInput;
  pagination: PaginationInput;
};


export type QueryRoomManyArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryRoomOneArgs = {
  id: Scalars['String'];
};


export type QueryRoomPageArgs = {
  activeLocationId?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryScheduledChargesByTransactionIdArgs = {
  id: Scalars['String'];
};


export type QueryScheduledChargesOneArgs = {
  id: Scalars['String'];
};


export type QueryScheduledTransactionOneArgs = {
  id: Scalars['String'];
};


export type QueryScheduledTransactionsByClientIdArgs = {
  clientId: Scalars['String'];
};


export type QuerySendgridDynamicFieldOneArgs = {
  id: Scalars['String'];
};


export type QuerySendgridTemplateManyArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
};


export type QuerySendgridTemplateOneArgs = {
  id: Scalars['String'];
};


export type QuerySendgridTemplatePageArgs = {
  pagination: PaginationInput;
};


export type QueryServiceAllotmentOneArgs = {
  id: Scalars['String'];
};


export type QueryShoppingCartOneArgs = {
  id: Scalars['String'];
};


export type QuerySignedAgreementManyArgs = {
  clientId: Scalars['String'];
};


export type QuerySignedAgreementOneArgs = {
  id: Scalars['String'];
};


export type QuerySignedDocumentOneArgs = {
  id: Scalars['String'];
};


export type QuerySindroPaymentServiceOneArgs = {
  id: Scalars['String'];
};


export type QuerySindroPaymentServicePageArgs = {
  pagination: PaginationInput;
};


export type QuerySubscriptionOneArgs = {
  id: Scalars['String'];
};


export type QuerySubscriptionPageArgs = {
  pagination: PaginationInput;
};


export type QuerySuggestedUserNameArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type QueryTimeClockEntryManyArgs = {
  employeeId?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
};


export type QueryTimeClockEntryOneArgs = {
  id: Scalars['String'];
};


export type QueryTimeClockEntryPageArgs = {
  employeeId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
};


export type QueryTransactionByClientArgs = {
  clientId: Scalars['String'];
};


export type QueryTransactionManyArgs = {
  clientId?: InputMaybe<Scalars['String']>;
};


export type QueryTransactionOneArgs = {
  id: Scalars['String'];
};


export type QueryTransactionPageArgs = {
  pagination: PaginationInput;
};


export type QueryUserOneArgs = {
  id?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
};


export type QueryUserPageArgs = {
  pagination: PaginationInput;
};


export type QueryVariantMetricOneArgs = {
  id: Scalars['String'];
};


export type QueryWaitlisteeOneArgs = {
  id: Scalars['String'];
};

export type RecurringCharge = {
  __typename?: 'RecurringCharge';
  agreement?: Maybe<Agreement>;
  categoryOption: CategoryOption;
  cost: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isPostTax: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  subscription?: Maybe<ClientSubscription>;
  taxRates: Array<LocationTaxRate>;
  updatedDate: Scalars['DateTime'];
};

export type RevenueItem = {
  __typename?: 'RevenueItem';
  category: Scalars['String'];
  revenue: Scalars['Float'];
};

export type RevenueObject = {
  __typename?: 'RevenueObject';
  initial: Array<RevenueItem>;
  recurring: Array<RevenueItem>;
};

export type RevenueRecord = {
  __typename?: 'RevenueRecord';
  amount: Scalars['Float'];
  client?: Maybe<Client>;
  completedAt: Scalars['DateTime'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  externalTransaction?: Maybe<ExternalTransaction>;
  id: Scalars['ID'];
  location: Location;
  note: Scalars['String'];
  revenueCat?: Maybe<CategoryOption>;
  tax: Scalars['Float'];
  transaction?: Maybe<Transaction>;
  updatedDate: Scalars['DateTime'];
};

export enum RolePermissionType {
  None = 'None',
  Read = 'Read',
  Write = 'Write'
}

export type Room = {
  __typename?: 'Room';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  location: Location;
  meetings: Array<Meeting>;
  name: Scalars['String'];
  services: Array<LocationService>;
  totalCapacity: Scalars['Int'];
  updatedDate: Scalars['DateTime'];
};

export type ScheduledCharges = {
  __typename?: 'ScheduledCharges';
  cost: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isPostTax: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  name: Scalars['String'];
  recurringCharge?: Maybe<RecurringCharge>;
  revenueCategory: CategoryOption;
  scheduledCharges: ScheduledTransaction;
  scheduledTransaction: ScheduledTransaction;
  subscription?: Maybe<ClientSubscription>;
  taxRates?: Maybe<Array<LocationTaxRate>>;
  transaction?: Maybe<Transaction>;
  updatedDate: Scalars['DateTime'];
};

export type ScheduledTransaction = {
  __typename?: 'ScheduledTransaction';
  charges?: Maybe<Array<ScheduledCharges>>;
  client: Client;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location: Location;
  processAt: Scalars['DateTime'];
  status: ScheduledTransactionStatus;
  subscription?: Maybe<ClientSubscription>;
  transaction?: Maybe<Transaction>;
  updatedDate: Scalars['DateTime'];
};

export enum ScheduledTransactionStatus {
  Complete = 'Complete',
  InProgress = 'InProgress',
  New = 'New'
}

export type SchedulingDetailsInput = {
  doms?: InputMaybe<Array<Scalars['Float']>>;
  dows?: InputMaybe<Array<Scalars['Float']>>;
  duration?: InputMaybe<Scalars['Int']>;
  scheduleFrom?: InputMaybe<Scalars['DateTime']>;
  scheduleTo?: InputMaybe<Scalars['DateTime']>;
  seriesInterval?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
};

export type SendgridDynamicField = {
  __typename?: 'SendgridDynamicField';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  entity: Scalars['String'];
  field: Scalars['String'];
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  templates: Array<SendgridTemplate>;
  testValue: Scalars['String'];
  triggers: Array<TriggerListType>;
  type: DynamicFieldType;
  updatedDate: Scalars['DateTime'];
};

export type SendgridTemplate = {
  __typename?: 'SendgridTemplate';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dynamicFields?: Maybe<Array<SendgridDynamicField>>;
  fromEmail?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  location: Location;
  name: Scalars['String'];
  organization: Organization;
  sendGridTemplateId: Scalars['String'];
  sendGridVersionId?: Maybe<Scalars['String']>;
  subjectLine?: Maybe<Scalars['String']>;
  trigger_?: Maybe<TriggerListType>;
  type: TemplateType;
  updatedDate: Scalars['DateTime'];
};

export enum SeriesGenInterval {
  Days = 'Days',
  Months = 'Months',
  Weeks = 'Weeks'
}

export enum SeriesInterval {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type ServiceAllotment = {
  __typename?: 'ServiceAllotment';
  agreement?: Maybe<Agreement>;
  createdDate: Scalars['DateTime'];
  credits: Scalars['Float'];
  dailyLimit: Scalars['Float'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiration: Expiration;
  id: Scalars['ID'];
  initialAgreement?: Maybe<Agreement>;
  locations: Array<Location>;
  name: Scalars['String'];
  package?: Maybe<Package>;
  privateSessions: Array<PrivateSessionDuration>;
  recurringAgreement?: Maybe<Agreement>;
  serviceFrequency: ServiceFrequency;
  services?: Maybe<Array<OrganizationService>>;
  startAt?: Maybe<Scalars['DateTime']>;
  startMode: StartMode;
  updatedDate: Scalars['DateTime'];
  version?: Maybe<Scalars['Float']>;
  viid?: Maybe<Scalars['Float']>;
};

export enum ServiceFrequency {
  Monthly = 'Monthly',
  Weekly = 'Weekly',
  Yearly = 'Yearly'
}

export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  client?: Maybe<Client>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<Scalars['Float']>;
  discountCodes: Array<DiscountCode>;
  discounts?: Maybe<Scalars['String']>;
  employee?: Maybe<Employee>;
  id: Scalars['ID'];
  lineItems: Array<CheckoutLineItem>;
  location?: Maybe<Location>;
  notes?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  products?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  taxes?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  transactions: Array<Transaction>;
  updatedDate: Scalars['DateTime'];
};

export type SignSignedDocumentInput = {
  signee: GenericConnectInput;
};

export type SignedAgreement = {
  __typename?: 'SignedAgreement';
  agreement: Agreement;
  client: Client;
  clientGroup?: Maybe<ClientGroup>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isAutoRenew: Scalars['Boolean'];
  location: Location;
  paymentMethod?: Maybe<ClientPaymentMethods>;
  recipients: Array<AgreementRecipient>;
  sessionLink?: Maybe<Scalars['String']>;
  signedDocGroup?: Maybe<SignedDocumentGroup>;
  status: SignedAgreementStatus;
  subscription: ClientSubscription;
  termEnd?: Maybe<Scalars['DateTime']>;
  termStart?: Maybe<Scalars['DateTime']>;
  updatedDate: Scalars['DateTime'];
};

export enum SignedAgreementStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  Frozen = 'Frozen',
  NoPaymentMethod = 'NoPaymentMethod',
  Unsigned = 'Unsigned'
}

export type SignedDocumentGroup = {
  __typename?: 'SignedDocumentGroup';
  agreementRecipient?: Maybe<AgreementRecipient>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  documentInvitedId: Scalars['String'];
  id: Scalars['ID'];
  isComplete: Scalars['Boolean'];
  isMinor: Scalars['Boolean'];
  signedAt?: Maybe<Scalars['DateTime']>;
  signee?: Maybe<Client>;
  subject: Client;
  updatedDate: Scalars['DateTime'];
};

export type SindroPaymentService = {
  __typename?: 'SindroPaymentService';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  orgs: Array<OrganizationPaymentService>;
  paymentType: PaymentType;
  updatedDate: Scalars['DateTime'];
};

export enum SortType {
  Product = 'Product',
  RevenueGroup = 'RevenueGroup'
}

export enum StartMode {
  Booking = 'Booking',
  Date = 'Date',
  Now = 'Now'
}

export type Subscription = {
  __typename?: 'Subscription';
  createCheckInSubscription: CheckInSubscriptionPayload;
  newPaymentMethodSubscription: PaymentMethodSubscription;
  resolveTransactionSubscription: TransactionSubscriptionPayload;
};


export type SubscriptionCreateCheckInSubscriptionArgs = {
  locationId: Scalars['String'];
};


export type SubscriptionNewPaymentMethodSubscriptionArgs = {
  paymentMethodId: Scalars['String'];
};


export type SubscriptionResolveTransactionSubscriptionArgs = {
  id: Scalars['String'];
};

export type SubscriptionJsonArrInput = {
  data: Array<InternalSubscriptionsInput>;
};

export enum SubscriptionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  PastDue = 'PastDue',
  PaymentFailed = 'PaymentFailed'
}

export enum TemplateType {
  Email = 'Email',
  Sms = 'SMS'
}

export type TimeClockEntry = {
  __typename?: 'TimeClockEntry';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  editedAt?: Maybe<Scalars['DateTime']>;
  editedBy?: Maybe<Employee>;
  employee: Employee;
  endedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location: Location;
  startedAt: Scalars['DateTime'];
  station?: Maybe<EmployeeStation>;
  updatedDate: Scalars['DateTime'];
};

export type Transaction = {
  __typename?: 'Transaction';
  agreement?: Maybe<Agreement>;
  agreementId?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  chargedTo?: Maybe<Client>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  discount: Scalars['Float'];
  discountCode?: Maybe<Array<DiscountCode>>;
  externalId: Scalars['String'];
  fundingRecord?: Maybe<FundingRecord>;
  fundingRecordId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRecurring: Scalars['Boolean'];
  isRefund: Scalars['Boolean'];
  location: Location;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<ClientPaymentMethods>;
  paymentTerminal?: Maybe<PaymentTerminal>;
  paymentType?: Maybe<TransactionType>;
  performedBy?: Maybe<Employee>;
  productSales: ProductSale;
  shoppingCart?: Maybe<ShoppingCart>;
  subscription?: Maybe<ClientSubscription>;
  subtotal: Scalars['Float'];
  targetClient?: Maybe<Client>;
  tax: Scalars['Float'];
  transactionStatus: TransactionStatus;
  updatedDate: Scalars['DateTime'];
};

export enum TransactionFeeType {
  Ach = 'ACH',
  DiscAmex = 'Disc_AMEX',
  Terminal = 'Terminal',
  VisaMc = 'Visa_MC'
}

export enum TransactionStatus {
  Accepted = 'Accepted',
  Declined = 'Declined',
  Pending = 'Pending',
  Refunded = 'Refunded'
}

export type TransactionSubscriptionPayload = {
  __typename?: 'TransactionSubscriptionPayload';
  transaction: Transaction;
};

export enum TransactionType {
  Ach = 'ACH',
  Amex = 'Amex',
  Cash = 'Cash',
  Disc = 'Disc',
  Mc = 'MC',
  Terminal = 'Terminal',
  Visa = 'Visa'
}

export enum TriggerListType {
  AttendanceCancel = 'attendanceCancel',
  AttendanceCreated = 'attendanceCreated',
  AttendanceNoShow = 'attendanceNoShow',
  CancelAccept = 'cancelAccept',
  CancelReject = 'cancelReject',
  CognitoCreated = 'cognitoCreated',
  ConfirmationCode = 'confirmationCode',
  FreezeAccept = 'freezeAccept',
  FreezeReject = 'freezeReject',
  MeetingTimeChange = 'meetingTimeChange',
  PasswordReset = 'passwordReset',
  PaymentMethodChange = 'paymentMethodChange',
  TransactionReject = 'transactionReject',
  TransactionSuccess = 'transactionSuccess'
}

export enum Unit {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type UpdateAccessPeriodInput = {
  agreement?: InputMaybe<GenericConnectInput>;
  end: Scalars['DateTime'];
  location?: InputMaybe<GenericConnectInput>;
  start: Scalars['DateTime'];
};

export type UpdateAdminInput = {
  organization: GenericConnectInput;
};

export type UpdateAgreementInput = {
  Unit?: InputMaybe<Unit>;
  additionalPolicies?: InputMaybe<Array<GenericConnectInput>>;
  description?: InputMaybe<Scalars['String']>;
  draftMode?: InputMaybe<DraftMode>;
  draftValue?: InputMaybe<Scalars['Float']>;
  groupPricingType?: InputMaybe<GroupPricingType>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAutoRenew?: InputMaybe<Scalars['Boolean']>;
  isGeneric?: InputMaybe<Scalars['Boolean']>;
  isGroup?: InputMaybe<Scalars['Boolean']>;
  isMembership?: InputMaybe<Scalars['Boolean']>;
  isOrg?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  name?: InputMaybe<Scalars['String']>;
  paymentFrequency?: InputMaybe<PaymentFrequency>;
  postponeUntil?: InputMaybe<Scalars['DateTime']>;
  scalingPrice?: InputMaybe<Scalars['Int']>;
  termValue?: InputMaybe<Scalars['Int']>;
};

export type UpdateAlterAgreementRecordInput = {
  alterationAgreementStatus?: InputMaybe<AlterationAgreementStatus>;
  alterationAgreementType?: InputMaybe<AlterationAgreementType>;
  endFreezeAt?: InputMaybe<Scalars['DateTime']>;
  intervals?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<GenericConnectInput>;
  notes?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<GenericConnectInput>;
  reviewedAt?: InputMaybe<Scalars['DateTime']>;
  reviewedBy?: InputMaybe<GenericConnectInput>;
  signedAgreement?: InputMaybe<GenericConnectInput>;
  startFreezeAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateAlterationReasonInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GenericConnectInput>;
  reason?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AlterationAgreementType>;
};

export type UpdateAttendanceInput = {
  attendanceStatus?: InputMaybe<AttendanceStatus>;
  attendanceType?: InputMaybe<AttendanceType>;
  attendee?: InputMaybe<GenericConnectInput>;
  checkInAt?: InputMaybe<Scalars['DateTime']>;
  creditAllotment?: InputMaybe<GenericConnectInput>;
  meeting?: InputMaybe<GenericConnectInput>;
  transaction?: InputMaybe<GenericConnectInput>;
};

export type UpdateCalendarFiltersInput = {
  instructors?: InputMaybe<Array<GenericConnectInput>>;
  location: GenericConnectInput;
  rooms?: InputMaybe<Array<GenericConnectInput>>;
  services?: InputMaybe<Array<GenericConnectInput>>;
};

export type UpdateCategoryOptionInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCheckInInput = {
  isAccepted: Scalars['Boolean'];
};

export type UpdateClientGroupInput = {
  clientGroupType?: InputMaybe<ClientGroupType>;
  clients?: InputMaybe<GenericConnectInput>;
  name: Scalars['String'];
  primaryClient?: InputMaybe<GenericConnectInput>;
};

export type UpdateClientInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  defaultLocation?: InputMaybe<GenericConnectInput>;
  dob?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emergencyName?: InputMaybe<Scalars['String']>;
  emergencyPhone?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  groups?: InputMaybe<Array<GenericConnectInput>>;
  homePhone?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  leadStatus?: InputMaybe<LeadStatus>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  memberStatus?: InputMaybe<MemberStatus>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<UpdateClientPreferencesInput>;
  profilePicUrl?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  workPhone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateClientPaymentMethodInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  mask?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sharedClients?: InputMaybe<Array<GenericConnectInput>>;
  vendor?: InputMaybe<PaymentType>;
};

export type UpdateClientPreferencesInput = {
  minimumNotice?: InputMaybe<Scalars['Float']>;
  notificationType?: InputMaybe<NotificationType>;
};

export type UpdateClientSubscriptionInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GenericConnectInput>;
  nextDraftDate?: InputMaybe<Scalars['DateTime']>;
  paymentFrequency?: InputMaybe<PaymentFrequency>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  signedAgreement?: InputMaybe<GenericConnectInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  subscriptionStatus?: InputMaybe<SubscriptionStatus>;
  vendor?: InputMaybe<PaymentType>;
};

export type UpdateCreditAllotmentInput = {
  agreement?: InputMaybe<GenericConnectInput>;
  client?: InputMaybe<GenericConnectInput>;
  count?: InputMaybe<Scalars['Float']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  package?: InputMaybe<GenericConnectInput>;
  privateSessions?: InputMaybe<Array<GenericConnectInput>>;
  serviceAllotment?: InputMaybe<GenericConnectInput>;
  services?: InputMaybe<Array<GenericConnectInput>>;
  transaction?: InputMaybe<GenericConnectInput>;
};

export type UpdateDiscountCodeInput = {
  agreements?: InputMaybe<Array<GenericConnectInput>>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCodeType?: InputMaybe<DiscountCodeType>;
  expirationUnit?: InputMaybe<Unit>;
  expirationValue?: InputMaybe<Scalars['Int']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  isPercent?: InputMaybe<Scalars['Boolean']>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  isStaffOnly?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  mode?: InputMaybe<ExpirationMode>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<GenericConnectInput>>;
  recurring?: InputMaybe<Scalars['Boolean']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  useLimit?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type UpdateEmployeeInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profilePicUrl?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<GenericConnectInput>;
  staffId?: InputMaybe<Scalars['String']>;
  stations?: InputMaybe<Array<GenericConnectInput>>;
};

export type UpdateEmployeeRoleInput = {
  calendar?: InputMaybe<RolePermissionType>;
  catalog?: InputMaybe<RolePermissionType>;
  checkInQueue?: InputMaybe<RolePermissionType>;
  clients?: InputMaybe<RolePermissionType>;
  description?: InputMaybe<Scalars['String']>;
  employeeStations?: InputMaybe<RolePermissionType>;
  locAgreements?: InputMaybe<RolePermissionType>;
  locDashboard?: InputMaybe<RolePermissionType>;
  locDiscounts?: InputMaybe<RolePermissionType>;
  locEmployees?: InputMaybe<RolePermissionType>;
  locPackages?: InputMaybe<RolePermissionType>;
  locPolicies?: InputMaybe<RolePermissionType>;
  locProducts?: InputMaybe<RolePermissionType>;
  locReports?: InputMaybe<RolePermissionType>;
  locRequests?: InputMaybe<RolePermissionType>;
  locRooms?: InputMaybe<RolePermissionType>;
  locServices?: InputMaybe<RolePermissionType>;
  locSettings?: InputMaybe<RolePermissionType>;
  locTimeclock?: InputMaybe<RolePermissionType>;
  name?: InputMaybe<Scalars['String']>;
  orgAgreements?: InputMaybe<RolePermissionType>;
  orgDiscounts?: InputMaybe<RolePermissionType>;
  orgLocations?: InputMaybe<RolePermissionType>;
  orgPackages?: InputMaybe<RolePermissionType>;
  orgPolicies?: InputMaybe<RolePermissionType>;
  orgRoles?: InputMaybe<RolePermissionType>;
  orgService?: InputMaybe<RolePermissionType>;
  orgSettings?: InputMaybe<RolePermissionType>;
  personalTimeClock?: InputMaybe<RolePermissionType>;
};

export type UpdateEmployeeStationInput = {
  description?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<Array<GenericConnectInput>>;
  location?: InputMaybe<GenericConnectInput>;
  maxShift?: InputMaybe<Scalars['Float']>;
  minShift?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  payRate?: InputMaybe<Scalars['Float']>;
};

export type UpdateInitialChargeInput = {
  cost?: InputMaybe<Scalars['Float']>;
  fee?: InputMaybe<GenericConnectInput>;
  isDiscountable?: InputMaybe<Scalars['Boolean']>;
  isPostTax?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  revenueCategory?: InputMaybe<GenericConnectInput>;
  taxRates?: InputMaybe<Array<GenericConnectInput>>;
};

export type UpdateLocationInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  logoImage?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationSenderNumber?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<ContactInfoInput>;
  state?: InputMaybe<Scalars['String']>;
  stationsEnabled?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  transactionProcessTime?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateLocationMonthlyFeeInput = {
  amount?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<GenericConnectInput>;
  locationRevenue?: InputMaybe<GenericConnectInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateLocationOfferingInput = {
  agreement?: InputMaybe<GenericConnectInput>;
  details?: InputMaybe<Array<Scalars['String']>>;
  header?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GenericConnectInput>;
  name?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  subtext?: InputMaybe<Scalars['String']>;
};

export type UpdateLocationPaymentServiceInput = {
  externalId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<GenericConnectInput>;
  name?: InputMaybe<Scalars['String']>;
  orgPaymentService?: InputMaybe<GenericConnectInput>;
  paymentType?: InputMaybe<PaymentType>;
};

export type UpdateLocationRevenueInput = {
  declineFeeAmount?: InputMaybe<Scalars['Float']>;
  declineFeeDays?: InputMaybe<Scalars['Int']>;
  declineFeeSindroShare?: InputMaybe<Scalars['Float']>;
  lateFeeAmount?: InputMaybe<Scalars['Float']>;
  lateFeeDays?: InputMaybe<Scalars['Int']>;
  lateFeeSindroShare?: InputMaybe<Scalars['Float']>;
  payrocAccount?: InputMaybe<PayrocAccountInput>;
  retryIntervals?: InputMaybe<Array<Scalars['Float']>>;
};

export type UpdateLocationServiceInput = {
  cost?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPrepay?: InputMaybe<Scalars['Boolean']>;
  rooms?: InputMaybe<Array<GenericConnectInput>>;
};

export type UpdateLocationTaxRateInput = {
  location?: InputMaybe<GenericConnectInput>;
  organizationTaxRate?: InputMaybe<GenericConnectInput>;
  taxRate?: InputMaybe<Scalars['Float']>;
};

export type UpdateLocationTransactionFeeInput = {
  flatRate?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<GenericConnectInput>;
  locationRevenue?: InputMaybe<GenericConnectInput>;
  percentage?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<TransactionFeeType>;
};

export type UpdateMeetingInput = {
  additionalPolicies?: InputMaybe<Array<GenericConnectInput>>;
  attendees?: InputMaybe<Array<GenericConnectInput>>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  instructor?: InputMaybe<GenericConnectInput>;
  isPrivateSession?: InputMaybe<Scalars['Boolean']>;
  isSelfEnroll?: InputMaybe<Scalars['Boolean']>;
  isWaitlistEnabled?: InputMaybe<Scalars['Boolean']>;
  maxOccupancy?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  privateSession?: InputMaybe<GenericConnectInput>;
  room?: InputMaybe<GenericConnectInput>;
  service?: InputMaybe<GenericConnectInput>;
  session?: InputMaybe<GenericConnectInput>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  waitlistMax?: InputMaybe<Scalars['Int']>;
};

export type UpdateMeetingSeriesInput = {
  meetingDetails?: InputMaybe<MeetingDetailsInput>;
  schedulingDetails?: InputMaybe<SchedulingDetailsInput>;
};

export type UpdateNotesInput = {
  author?: InputMaybe<GenericConnectInput>;
  client?: InputMaybe<GenericConnectInput>;
  content?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  logoImage?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationBranding?: InputMaybe<OrganizationBrandingInput>;
  settings?: InputMaybe<OrganizationSettingsInput>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationPaymentServiceInput = {
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  paymentService: GenericConnectInput;
  paymentType?: InputMaybe<PaymentType>;
};

export type UpdateOrganizationServiceInput = {
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  isIndivdual?: InputMaybe<Scalars['Boolean']>;
  isSelfEnroll?: InputMaybe<Scalars['Boolean']>;
  isWaitlistEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  policies?: InputMaybe<Array<GenericConnectInput>>;
  revenueCategory?: InputMaybe<GenericConnectInput>;
  serviceType?: InputMaybe<GenericConnectInput>;
  waitlistMax?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrganizationTaxRateInput = {
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<GenericConnectInput>;
  taxRate?: InputMaybe<Scalars['Float']>;
};

export type UpdatePackageInput = {
  additionalPolicies?: InputMaybe<Array<GenericConnectInput>>;
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isGeneric?: InputMaybe<Scalars['Boolean']>;
  isOrg?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentTerminalInput = {
  externalId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<GenericConnectInput>;
  name?: InputMaybe<Scalars['String']>;
  physicalId?: InputMaybe<Scalars['String']>;
};

export type UpdatePolicyInput = {
  data?: InputMaybe<Scalars['String']>;
  fileB64?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GenericConnectInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdatePrivateSessionDurationInput = {
  cost?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Int']>;
  session?: InputMaybe<GenericConnectInput>;
};

export type UpdatePrivateSessionInput = {
  description?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  intervalDuration?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isEmployeeRequired?: InputMaybe<Scalars['Boolean']>;
  isOrg?: InputMaybe<Scalars['Boolean']>;
  isPostTax?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  maxDuration?: InputMaybe<Scalars['Int']>;
  minDuration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<GenericConnectInput>;
  policies?: InputMaybe<Array<GenericConnectInput>>;
  revenueCategory?: InputMaybe<GenericConnectInput>;
  serviceType?: InputMaybe<GenericConnectInput>;
};

export type UpdatePrivateSessionLocationRoomsInput = {
  location?: InputMaybe<GenericConnectInput>;
  rooms?: InputMaybe<Array<GenericConnectInput>>;
  session?: InputMaybe<GenericConnectInput>;
  taxRates?: InputMaybe<Array<GenericConnectInput>>;
};

export type UpdatePrivateSessionOverrideInput = {
  commission?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<GenericConnectInput>;
  isPercent?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  maxDuration?: InputMaybe<Scalars['Int']>;
  minDuration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  session?: InputMaybe<GenericConnectInput>;
};

export type UpdateProductGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  revenueCategory?: InputMaybe<GenericConnectInput>;
};

export type UpdateProductInput = {
  barcode?: InputMaybe<Scalars['String']>;
  commissionValue?: InputMaybe<Scalars['Float']>;
  cost?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isCommissionPercent?: InputMaybe<Scalars['Boolean']>;
  isCommissionable?: InputMaybe<Scalars['Boolean']>;
  isPostTax?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GenericConnectInput>;
  metricValues?: InputMaybe<Array<GenericConnectInput>>;
  name?: InputMaybe<Scalars['String']>;
  revenueCategory?: InputMaybe<GenericConnectInput>;
  service?: InputMaybe<GenericConnectInput>;
  sku?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['Float']>;
  tags?: InputMaybe<Array<GenericConnectInput>>;
  taxRates?: InputMaybe<Array<GenericConnectInput>>;
};

export type UpdateRecurringChargeInput = {
  categoryOption?: InputMaybe<GenericConnectInput>;
  cost?: InputMaybe<Scalars['Float']>;
  isPostTax?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<GenericConnectInput>;
  taxRates?: InputMaybe<Array<GenericConnectInput>>;
};

export type UpdateRoomInput = {
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Array<GenericConnectInput>>;
  totalCapacity?: InputMaybe<Scalars['Int']>;
};

export type UpdateScheduledChargesInput = {
  cost?: InputMaybe<Scalars['Float']>;
  isPostTax?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  recurringCharge?: InputMaybe<GenericConnectInput>;
  revenueCategory?: InputMaybe<GenericConnectInput>;
  scheduledTransaction?: InputMaybe<GenericConnectInput>;
  subscription?: InputMaybe<GenericConnectInput>;
  taxRates?: InputMaybe<Array<GenericConnectInput>>;
  transaction?: InputMaybe<GenericConnectInput>;
};

export type UpdateScheduledTransactionInput = {
  client?: InputMaybe<GenericConnectInput>;
  location?: InputMaybe<GenericConnectInput>;
  processAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<ScheduledTransactionStatus>;
  subscription?: InputMaybe<GenericConnectInput>;
  transaction?: InputMaybe<GenericConnectInput>;
};

export type UpdateSendgridTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  dynamicFields?: InputMaybe<Array<GenericConnectInput>>;
  fromEmail?: InputMaybe<Scalars['String']>;
  fromName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GenericConnectInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<GenericConnectInput>;
  sendGridTemplateId?: InputMaybe<Scalars['String']>;
  sendGridVersionId?: InputMaybe<Scalars['String']>;
  subjectLine?: InputMaybe<Scalars['String']>;
  trigger_?: InputMaybe<TriggerListType>;
  type?: InputMaybe<TemplateType>;
};

export type UpdateServiceAllotmentInput = {
  credits?: InputMaybe<Scalars['Int']>;
  dailyLimit?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  expirationUnit?: InputMaybe<Unit>;
  expirationValue?: InputMaybe<Scalars['Int']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  locations?: InputMaybe<Array<GenericConnectInput>>;
  mode?: InputMaybe<ExpirationMode>;
  name?: InputMaybe<Scalars['String']>;
  privateSessions?: InputMaybe<Array<GenericConnectInput>>;
  serviceFrequency?: InputMaybe<ServiceFrequency>;
  services?: InputMaybe<Array<GenericConnectInput>>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  startMode?: InputMaybe<StartMode>;
};

export type UpdateShoppingCartInput = {
  client?: InputMaybe<GenericConnectInput>;
  discountCodes?: InputMaybe<Array<GenericConnectInput>>;
  employee?: InputMaybe<GenericConnectInput>;
  location?: InputMaybe<GenericConnectInput>;
  notes?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<GenericConnectInput>;
  products?: InputMaybe<Array<CartProductInput>>;
};

export type UpdateSignedAgreementInput = {
  agreement?: InputMaybe<GenericConnectInput>;
  client?: InputMaybe<GenericConnectInput>;
  clientGroup?: InputMaybe<GenericConnectInput>;
  isAutoRenew?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GenericConnectInput>;
  parent?: InputMaybe<GenericConnectInput>;
  paymentMethod?: InputMaybe<GenericConnectInput>;
  status?: InputMaybe<SignedAgreementStatus>;
  termEnd?: InputMaybe<Scalars['DateTime']>;
  termStart?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateSignedDocumentInput = {
  agreementRecipient?: InputMaybe<GenericConnectInput>;
  externalUrl?: InputMaybe<Scalars['String']>;
  isMinor?: InputMaybe<Scalars['Boolean']>;
  signedAgreementId?: InputMaybe<GenericConnectInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signee?: InputMaybe<GenericConnectInput>;
  subject?: InputMaybe<GenericConnectInput>;
};

export type UpdateSindroPaymentInput = {
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<PaymentType>;
};

export type UpdateTimeClockEntryInput = {
  endedAt?: InputMaybe<Scalars['DateTime']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  station?: InputMaybe<GenericConnectInput>;
};

export type UpdateTransactionInput = {
  agreement?: InputMaybe<GenericConnectInput>;
  amount?: InputMaybe<Scalars['Float']>;
  chargedTo?: InputMaybe<GenericConnectInput>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  discount?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  isRecurring?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<GenericConnectInput>;
  packageId?: InputMaybe<GenericConnectInput>;
  paymentTerminal?: InputMaybe<GenericConnectInput>;
  performedBy?: InputMaybe<GenericConnectInput>;
  shoppingCart?: InputMaybe<GenericConnectInput>;
  subscription?: InputMaybe<GenericConnectInput>;
  subtotal?: InputMaybe<Scalars['Float']>;
  targetClient?: InputMaybe<GenericConnectInput>;
  tax?: InputMaybe<Scalars['Float']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
};

export type UpdateUserClientInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  emergencyName?: InputMaybe<Scalars['String']>;
  emergencyPhone?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  homePhone?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  workPhone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  clientData?: InputMaybe<UpdateUserClientInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<UpdateClientPreferencesInput>;
  profilePic?: InputMaybe<Scalars['String']>;
  smsConsent?: InputMaybe<Scalars['Boolean']>;
  staffId?: InputMaybe<Scalars['String']>;
};

export type UpdateVariantMetricInput = {
  name?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<IMetricOption>>;
};

export type UpdateWaitlisteeInput = {
  client?: InputMaybe<GenericConnectInput>;
  meeting?: InputMaybe<GenericConnectInput>;
  notes?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  acceptedTAC: Scalars['Boolean'];
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  middleName: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicUrl?: Maybe<Scalars['String']>;
  role: UserRole;
  smsConsent: Scalars['Boolean'];
  updatedDate: Scalars['DateTime'];
  username?: Maybe<Scalars['String']>;
};

export enum UserRole {
  Admin = 'Admin',
  Client = 'Client',
  Employee = 'Employee'
}

export type VariantMetric = {
  __typename?: 'VariantMetric';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productGroup: ProductGroup;
  updatedDate: Scalars['DateTime'];
  values?: Maybe<Array<VariantValue>>;
};

export type VariantValue = {
  __typename?: 'VariantValue';
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  metric?: Maybe<VariantMetric>;
  name: Scalars['String'];
  updatedDate: Scalars['DateTime'];
};

export type Waitlistee = {
  __typename?: 'Waitlistee';
  client: Client;
  createdDate: Scalars['DateTime'];
  deletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  meeting: Meeting;
  notes?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  updatedDate: Scalars['DateTime'];
};

export type CreateAccessPeriodMutationVariables = Exact<{
  data: CreateAccessPeriodInput;
}>;


export type CreateAccessPeriodMutation = { __typename?: 'Mutation', createAccessPeriod: { __typename?: 'AccessPeriod', id: string } };

export type UpdateAccessPeriodMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateAccessPeriodInput;
}>;


export type UpdateAccessPeriodMutation = { __typename?: 'Mutation', updateAccessPeriod: { __typename?: 'AccessPeriod', id: string } };

export type DeleteAccessPeriodMutationVariables = Exact<{
  deleteAccessPeriodId: Scalars['String'];
}>;


export type DeleteAccessPeriodMutation = { __typename?: 'Mutation', deleteAccessPeriod: boolean };

export type UpdateAdminMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateAdminInput;
}>;


export type UpdateAdminMutation = { __typename?: 'Mutation', updateAdmin: { __typename?: 'Admin', id: string, organization: { __typename?: 'Organization', id: string, name: string } } };

export type CreateAgreementMutationVariables = Exact<{
  data: CreateAgreementInput;
}>;


export type CreateAgreementMutation = { __typename?: 'Mutation', createAgreement: { __typename?: 'Agreement', id: string } };

export type UpdateAgreementMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateAgreementInput;
  isForceUpdate?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateAgreementMutation = { __typename?: 'Mutation', updateAgreement: { __typename?: 'Agreement', id: string } };

export type CreateAgreementRecipientMutationVariables = Exact<{
  data: CreateAgreementRecipientInput;
}>;


export type CreateAgreementRecipientMutation = { __typename?: 'Mutation', createAgreementRecipient: { __typename?: 'AgreementRecipient', id: string } };

export type CreateAlterAgreementRecordMutationVariables = Exact<{
  data: CreateAlterAgreementRecordInput;
}>;


export type CreateAlterAgreementRecordMutation = { __typename?: 'Mutation', createAlterAgreementRecord: { __typename?: 'AlterAgreementRecord', id: string } };

export type UpdateAlterAgreementRecordMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateAlterAgreementRecordInput;
}>;


export type UpdateAlterAgreementRecordMutation = { __typename?: 'Mutation', updateAlterAgreementRecord: { __typename?: 'AlterAgreementRecord', id: string } };

export type CreateAlterationReasonMutationVariables = Exact<{
  data: CreateAlterationReasonInput;
}>;


export type CreateAlterationReasonMutation = { __typename?: 'Mutation', createAlterationReason: { __typename?: 'AlterationReason', id: string } };

export type UpdateAlterationReasonMutationVariables = Exact<{
  data: UpdateAlterationReasonInput;
  updateAlterationReasonId: Scalars['String'];
}>;


export type UpdateAlterationReasonMutation = { __typename?: 'Mutation', updateAlterationReason: { __typename?: 'AlterationReason', id: string } };

export type DeleteAlterationReasonMutationVariables = Exact<{
  deleteAlterationReasonId: Scalars['String'];
}>;


export type DeleteAlterationReasonMutation = { __typename?: 'Mutation', deleteAlterationReason: boolean };

export type UpdateAttendanceMutationVariables = Exact<{
  attendeeId: Scalars['String'];
  meetingId: Scalars['String'];
  feeWaived?: InputMaybe<Scalars['Boolean']>;
  data: UpdateAttendanceInput;
}>;


export type UpdateAttendanceMutation = { __typename?: 'Mutation', updateAttendance: { __typename?: 'Attendance', id: string } };

export type AddAttendeeToMeetingMutationVariables = Exact<{
  meetingId: Scalars['String'];
  attendeeId: Scalars['String'];
}>;


export type AddAttendeeToMeetingMutation = { __typename?: 'Mutation', addAttendeeToMeeting: boolean };

export type CancelAttendeeToMeetingMutationVariables = Exact<{
  meetingId: Scalars['String'];
  attendeeId: Scalars['String'];
}>;


export type CancelAttendeeToMeetingMutation = { __typename?: 'Mutation', cancelAttendeeToMeeting: boolean };

export type CreateCategoryOptionMutationVariables = Exact<{
  data: CreateCategoryOptionInput;
}>;


export type CreateCategoryOptionMutation = { __typename?: 'Mutation', createCategoryOption: { __typename?: 'CategoryOption', name: string, type: CategoryOptionType, organization: { __typename?: 'Organization', id: string } } };

export type DeleteCategoryOptionMutationVariables = Exact<{
  deleteCategoryOptionId: Scalars['String'];
}>;


export type DeleteCategoryOptionMutation = { __typename?: 'Mutation', deleteCategoryOption: boolean };

export type UpdateCategoryOptionMutationVariables = Exact<{
  data: UpdateCategoryOptionInput;
  updateCategoryOptionId: Scalars['String'];
}>;


export type UpdateCategoryOptionMutation = { __typename?: 'Mutation', updateCategoryOption: { __typename?: 'CategoryOption', id: string } };

export type CreateCheckInMutationVariables = Exact<{
  data: CreateCheckInInput;
}>;


export type CreateCheckInMutation = { __typename?: 'Mutation', createCheckIn: { __typename?: 'CheckIn', id: string } };

export type UpdateCheckInMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateCheckInInput;
}>;


export type UpdateCheckInMutation = { __typename?: 'Mutation', updateCheckIn: { __typename?: 'CheckIn', id: string } };

export type CreateClientMutationVariables = Exact<{
  data: CreateClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string, attendee?: { __typename?: 'Attendee', id: string } | null } };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string } };

export type UpdateClientOrgMutationVariables = Exact<{
  id: Scalars['String'];
  organizationId: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateClientOrgMutation = { __typename?: 'Mutation', updateClientOrg: { __typename?: 'Client', id: string } };

export type CreateClientGroupMutationVariables = Exact<{
  data: CreateClientGroupInput;
}>;


export type CreateClientGroupMutation = { __typename?: 'Mutation', createClientGroup: { __typename?: 'ClientGroup', id: string } };

export type UpdateClientGroupMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateClientGroupInput;
}>;


export type UpdateClientGroupMutation = { __typename?: 'Mutation', updateClientGroup: { __typename?: 'ClientGroup', id: string } };

export type AddClientToGroupMutationVariables = Exact<{
  clientId: Scalars['String'];
  clientGroupId: Scalars['String'];
}>;


export type AddClientToGroupMutation = { __typename?: 'Mutation', addClientToGroup: { __typename?: 'ClientGroup', id: string } };

export type RemoveClientFromGroupMutationVariables = Exact<{
  clientId: Scalars['String'];
  clientGroupId: Scalars['String'];
}>;


export type RemoveClientFromGroupMutation = { __typename?: 'Mutation', removeClientFromGroup: boolean };

export type CreateMemberLoginMutationVariables = Exact<{
  clientId: Scalars['String'];
  username: Scalars['String'];
}>;


export type CreateMemberLoginMutation = { __typename?: 'Mutation', createMemberLogin: boolean };

export type MigrateClientsMutationVariables = Exact<{
  data: ClientsJsonArrInput;
  locationId: Scalars['String'];
}>;


export type MigrateClientsMutation = { __typename?: 'Mutation', migrateClients: { __typename?: 'MutationResult', errors: { __typename?: 'MigrateError', Missing: Array<string>, Invalid: Array<string>, Collision: Array<string>, Default: Array<string> } } };

export type CreateClientPaymentMethodMutationVariables = Exact<{
  clientId: Scalars['String'];
  data: CreateClientPaymentMethodInput;
}>;


export type CreateClientPaymentMethodMutation = { __typename?: 'Mutation', createClientPaymentMethod: { __typename?: 'ClientPaymentMethods', id: string } };

export type UpdateClientPaymentMethodMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateClientPaymentMethodInput;
}>;


export type UpdateClientPaymentMethodMutation = { __typename?: 'Mutation', updateClientPaymentMethod: { __typename?: 'ClientPaymentMethods', id: string } };

export type DeleteClientPaymentMethodMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteClientPaymentMethodMutation = { __typename?: 'Mutation', deleteClientPaymentMethod: boolean };

export type MigratePaymentMethodsMutationVariables = Exact<{
  data: PaymentMethodJsonArrInput;
  locationId: Scalars['String'];
}>;


export type MigratePaymentMethodsMutation = { __typename?: 'Mutation', migratePaymentMethods: { __typename?: 'MutationResult', errors: { __typename?: 'MigrateError', Missing: Array<string>, Invalid: Array<string>, Collision: Array<string>, Default: Array<string> } } };

export type ClockInMutationVariables = Exact<{
  data: CreateTimeClockEntryInput;
}>;


export type ClockInMutation = { __typename?: 'Mutation', clockIn: { __typename?: 'TimeClockEntry', id: string } };

export type ClockOutMutationVariables = Exact<{
  data: ClockOutInput;
}>;


export type ClockOutMutation = { __typename?: 'Mutation', clockOut: { __typename?: 'TimeClockEntry', id: string } };

export type AddTimeClockSessionMutationVariables = Exact<{
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  employeeId: Scalars['String'];
  station?: InputMaybe<Scalars['String']>;
}>;


export type AddTimeClockSessionMutation = { __typename?: 'Mutation', addTimeClockSession: { __typename?: 'TimeClockEntry', id: string } };

export type UpdateTimeClockEntryMutationVariables = Exact<{
  timeClockEntryId: Scalars['String'];
  data: UpdateTimeClockEntryInput;
}>;


export type UpdateTimeClockEntryMutation = { __typename?: 'Mutation', updateTimeClockEntry: { __typename?: 'TimeClockEntry', id: string } };

export type DeleteTimeClockEntryMutationVariables = Exact<{
  timeClockEntryId: Scalars['String'];
}>;


export type DeleteTimeClockEntryMutation = { __typename?: 'Mutation', deleteTimeClockEntry: boolean };

export type DownloadRevenueCsvMutationVariables = Exact<{
  data: DashboardInput;
  pagination: PaginationInput;
}>;


export type DownloadRevenueCsvMutation = { __typename?: 'Mutation', downloadRevenueCSV: string };

export type DownloadAgreementCsvMutationVariables = Exact<{
  data: DashboardInput;
  pagination: PaginationInput;
}>;


export type DownloadAgreementCsvMutation = { __typename?: 'Mutation', downloadAgreementCSV: string };

export type DownloadPoStCsvMutationVariables = Exact<{
  data: DashboardInput;
  pagination: PaginationInput;
}>;


export type DownloadPoStCsvMutation = { __typename?: 'Mutation', downloadPosCSV: string };

export type CreateDiscountCodeMutationVariables = Exact<{
  data: CreateDiscountCodeInput;
}>;


export type CreateDiscountCodeMutation = { __typename?: 'Mutation', createDiscountCode: { __typename?: 'DiscountCode', id: string, name: string } };

export type UpdateDiscountCodeMutationVariables = Exact<{
  data: UpdateDiscountCodeInput;
  updateDiscountCodeId: Scalars['String'];
}>;


export type UpdateDiscountCodeMutation = { __typename?: 'Mutation', updateDiscountCode: { __typename?: 'DiscountCode', id: string } };

export type DeleteDiscountCodeMutationVariables = Exact<{
  deleteDiscountCodeId: Scalars['String'];
}>;


export type DeleteDiscountCodeMutation = { __typename?: 'Mutation', deleteDiscountCode: boolean };

export type CreateEmployeeMutationVariables = Exact<{
  data: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', id: string, staffId?: string | null, user: { __typename?: 'User', id: string, username?: string | null, role: UserRole, firstName: string, lastName: string, email: string, phoneNumber?: string | null, profilePicUrl?: string | null } } };

export type UpdateEmployeeMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateEmployeeInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'Employee', id: string } };

export type UpdateRoleAssignmentMutationVariables = Exact<{
  roleId: Scalars['String'];
  newRoleId: Scalars['String'];
}>;


export type UpdateRoleAssignmentMutation = { __typename?: 'Mutation', updateRoleAssignment: boolean };

export type CreateEmployeeRoleMutationVariables = Exact<{
  data: CreateEmployeeRoleInput;
}>;


export type CreateEmployeeRoleMutation = { __typename?: 'Mutation', createEmployeeRole: { __typename?: 'EmployeeRole', id: string } };

export type UpdateEmployeeRoleMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateEmployeeRoleInput;
}>;


export type UpdateEmployeeRoleMutation = { __typename?: 'Mutation', updateEmployeeRole: { __typename?: 'EmployeeRole', id: string } };

export type DeleteEmployeeRoleMutationVariables = Exact<{
  deleteEmployeeRoleId: Scalars['String'];
}>;


export type DeleteEmployeeRoleMutation = { __typename?: 'Mutation', deleteEmployeeRole: boolean };

export type CreateEmployeeStationMutationVariables = Exact<{
  data: CreateEmployeeStationInput;
}>;


export type CreateEmployeeStationMutation = { __typename?: 'Mutation', createEmployeeStation: { __typename?: 'EmployeeStation', id: string } };

export type UpdateEmployeeStationMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateEmployeeStationInput;
}>;


export type UpdateEmployeeStationMutation = { __typename?: 'Mutation', updateEmployeeStation?: { __typename?: 'EmployeeStation', id: string } | null };

export type DeleteEmployeeStationMutationVariables = Exact<{
  employeeStationId: Scalars['String'];
}>;


export type DeleteEmployeeStationMutation = { __typename?: 'Mutation', deleteEmployeeStation: boolean };

export type CreateInitialChargeMutationVariables = Exact<{
  data: CreateInitialChargeInput;
}>;


export type CreateInitialChargeMutation = { __typename?: 'Mutation', createInitialCharge: { __typename?: 'InitialCharge', id: string, cost: number, createdDate: any, isDiscountable: boolean, revenue?: { __typename?: 'CategoryOption', name: string, id: string } | null, fee?: { __typename?: 'CategoryOption', name: string, id: string } | null, package?: { __typename?: 'Package', id: string, name: string } | null } };

export type UpdateInitialChargeMutationVariables = Exact<{
  data: UpdateInitialChargeInput;
  updateInitialChargeId: Scalars['String'];
}>;


export type UpdateInitialChargeMutation = { __typename?: 'Mutation', updateInitialCharge: { __typename?: 'InitialCharge', cost: number, createdDate: any, id: string, isDiscountable: boolean, agreement?: { __typename?: 'Agreement', id: string, name: string } | null, fee?: { __typename?: 'CategoryOption', id: string, name: string } | null, package?: { __typename?: 'Package', id: string, name: string } | null, revenue?: { __typename?: 'CategoryOption', id: string, name: string } | null } };

export type DeleteInitialChargeMutationVariables = Exact<{
  deleteInitialChargeId: Scalars['String'];
}>;


export type DeleteInitialChargeMutation = { __typename?: 'Mutation', deleteInitialCharge: boolean };

export type CreateLocationMutationVariables = Exact<{
  data: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'Location', id: string, name: string } };

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'Location', id: string, name: string, stationsEnabled?: boolean | null } };

export type CreateLocationMonthlyFeeMutationVariables = Exact<{
  data: CreateLocationMonthlyFeeInput;
}>;


export type CreateLocationMonthlyFeeMutation = { __typename?: 'Mutation', createLocationMonthlyFee: { __typename?: 'LocationMonthlyFee', id: string } };

export type UpdateLocationMonthlyFeeMutationVariables = Exact<{
  data: UpdateLocationMonthlyFeeInput;
  id: Scalars['String'];
}>;


export type UpdateLocationMonthlyFeeMutation = { __typename?: 'Mutation', updateLocationMonthlyFee: { __typename?: 'LocationMonthlyFee', id: string } };

export type DeleteLocationMonthlyFeeMutationVariables = Exact<{
  deleteLocationMonthlyFeeId: Scalars['String'];
}>;


export type DeleteLocationMonthlyFeeMutation = { __typename?: 'Mutation', deleteLocationMonthlyFee: boolean };

export type CreateLocationOfferingMutationVariables = Exact<{
  data: CreateLocationOfferingInput;
}>;


export type CreateLocationOfferingMutation = { __typename?: 'Mutation', createLocationOffering: { __typename?: 'LocationOffering', id: string } };

export type UpdateLocationOfferingMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateLocationOfferingInput;
}>;


export type UpdateLocationOfferingMutation = { __typename?: 'Mutation', updateLocationOffering: { __typename?: 'LocationOffering', id: string } };

export type DeleteLocationOfferingMutationVariables = Exact<{
  deleteLocationOfferingId: Scalars['String'];
}>;


export type DeleteLocationOfferingMutation = { __typename?: 'Mutation', deleteLocationOffering: boolean };

export type UpdateLocationRevenueMutationVariables = Exact<{
  data: UpdateLocationRevenueInput;
  updateLocationRevenueId: Scalars['String'];
}>;


export type UpdateLocationRevenueMutation = { __typename?: 'Mutation', updateLocationRevenue: { __typename?: 'LocationRevenue', id: string } };

export type CreateLocationTaxRateMutationVariables = Exact<{
  data: CreateLocationTaxRateInput;
}>;


export type CreateLocationTaxRateMutation = { __typename?: 'Mutation', createLocationTaxRate: { __typename?: 'LocationTaxRate', id: string } };

export type UpdateLocationTaxRateMutationVariables = Exact<{
  data: UpdateLocationTaxRateInput;
  id: Scalars['String'];
}>;


export type UpdateLocationTaxRateMutation = { __typename?: 'Mutation', updateLocationTaxRate: { __typename?: 'LocationTaxRate', id: string } };

export type DeleteLocationTaxRateMutationVariables = Exact<{
  deleteLocationTaxRateId: Scalars['String'];
}>;


export type DeleteLocationTaxRateMutation = { __typename?: 'Mutation', deleteLocationTaxRate: boolean };

export type CreateLocationTransactionFeeMutationVariables = Exact<{
  data: CreateLocationTransactionFeeInput;
}>;


export type CreateLocationTransactionFeeMutation = { __typename?: 'Mutation', createLocationTransactionFee: { __typename?: 'LocationTransactionFee', id: string } };

export type UpdateLocationTransactionFeeMutationVariables = Exact<{
  data: UpdateLocationTransactionFeeInput;
  id: Scalars['String'];
}>;


export type UpdateLocationTransactionFeeMutation = { __typename?: 'Mutation', updateLocationTransactionFee: { __typename?: 'LocationTransactionFee', id: string } };

export type DeleteLocationTransactionFeeMutationVariables = Exact<{
  deleteLocationTransactionFeeId: Scalars['String'];
}>;


export type DeleteLocationTransactionFeeMutation = { __typename?: 'Mutation', deleteLocationTransactionFee: boolean };

export type CreateMeetingMutationVariables = Exact<{
  data: CreateMeetingInput;
}>;


export type CreateMeetingMutation = { __typename?: 'Mutation', createMeeting: { __typename?: 'Meeting', id: string } };

export type UpdateMeetingMutationVariables = Exact<{
  data: UpdateMeetingInput;
  id: Scalars['String'];
}>;


export type UpdateMeetingMutation = { __typename?: 'Mutation', updateMeeting: { __typename?: 'Meeting', id: string } };

export type DeleteMeetingMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMeetingMutation = { __typename?: 'Mutation', deleteMeeting: boolean };

export type SaveCalendarFiltersMutationVariables = Exact<{
  data: UpdateCalendarFiltersInput;
}>;


export type SaveCalendarFiltersMutation = { __typename?: 'Mutation', saveCalendarFilters?: { __typename?: 'CalendarFilters', id: string } | null };

export type ClearCalendarFiltersMutationVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type ClearCalendarFiltersMutation = { __typename?: 'Mutation', clearCalendarFilters?: { __typename?: 'CalendarFilters', id: string } | null };

export type EnrollToMeetingMutationVariables = Exact<{
  meetingId: Scalars['String'];
  clientId: Scalars['String'];
  creditAllotmentId?: InputMaybe<Scalars['String']>;
}>;


export type EnrollToMeetingMutation = { __typename?: 'Mutation', enrollToMeeting: boolean };

export type CreateMeetingSeriesMutationVariables = Exact<{
  data: CreateMeetingSeriesInput;
}>;


export type CreateMeetingSeriesMutation = { __typename?: 'Mutation', createMeetingSeries: { __typename?: 'MeetingSeries', id: string } };

export type UpdateMeetingSeriesMutationVariables = Exact<{
  data: UpdateMeetingSeriesInput;
  id: Scalars['String'];
}>;


export type UpdateMeetingSeriesMutation = { __typename?: 'Mutation', updateMeetingSeries: { __typename?: 'MeetingSeries', id: string } };

export type DeleteMeetingSeriesMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMeetingSeriesMutation = { __typename?: 'Mutation', deleteMeetingSeries: boolean };

export type CreateNotesMutationVariables = Exact<{
  data: CreateNotesInput;
}>;


export type CreateNotesMutation = { __typename?: 'Mutation', createNotes: { __typename?: 'Notes', id: string } };

export type UpdateNotesMutationVariables = Exact<{
  data: UpdateNotesInput;
  updateNotesId: Scalars['String'];
}>;


export type UpdateNotesMutation = { __typename?: 'Mutation', updateNotes: { __typename?: 'Notes', id: string } };

export type DeleteNotesMutationVariables = Exact<{
  deleteNotesId: Scalars['String'];
}>;


export type DeleteNotesMutation = { __typename?: 'Mutation', deleteNotes: boolean };

export type MigrateClientNotesMutationVariables = Exact<{
  data: NotesJsonArrInput;
}>;


export type MigrateClientNotesMutation = { __typename?: 'Mutation', migrateClientNotes: { __typename?: 'MutationResult', errors: { __typename?: 'MigrateError', Missing: Array<string>, Invalid: Array<string>, Collision: Array<string>, Default: Array<string> } } };

export type CreateOrganizationMutationVariables = Exact<{
  data: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', name: string, id: string, logoUrl?: string | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  data: UpdateOrganizationInput;
  id: Scalars['String'];
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', name: string, id: string, logoUrl?: string | null } };

export type UpdateOrganizationBrandingMutationVariables = Exact<{
  data: OrganizationBrandingInput;
  updateOrganizationBrandingId: Scalars['String'];
}>;


export type UpdateOrganizationBrandingMutation = { __typename?: 'Mutation', updateOrganizationBranding: { __typename?: 'OrganizationBranding', id: string } };

export type UpdateOrganizationSettingsMutationVariables = Exact<{
  id: Scalars['String'];
  data: OrganizationSettingsInput;
}>;


export type UpdateOrganizationSettingsMutation = { __typename?: 'Mutation', updateOrganizationSettings: { __typename?: 'OrganizationSettings', id: string } };

export type CreateOrganizationTaxRateMutationVariables = Exact<{
  data: CreateOrganizationTaxRateInput;
}>;


export type CreateOrganizationTaxRateMutation = { __typename?: 'Mutation', createOrganizationTaxRate: { __typename?: 'OrganizationTaxRate', id: string } };

export type UpdateOrganizationTaxRateMutationVariables = Exact<{
  data: UpdateOrganizationTaxRateInput;
  id: Scalars['String'];
}>;


export type UpdateOrganizationTaxRateMutation = { __typename?: 'Mutation', updateOrganizationTaxRate: { __typename?: 'OrganizationTaxRate', id: string } };

export type DeleteOrganizationTaxRateMutationVariables = Exact<{
  deleteOrganizationTaxRateId: Scalars['String'];
}>;


export type DeleteOrganizationTaxRateMutation = { __typename?: 'Mutation', deleteOrganizationTaxRate: boolean };

export type CreatePackageMutationVariables = Exact<{
  data: CreatePackageInput;
}>;


export type CreatePackageMutation = { __typename?: 'Mutation', createPackage: { __typename?: 'Package', id: string } };

export type UpdatePackageMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdatePackageInput;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', updatePackage: { __typename?: 'Package', id: string } };

export type CreatePaymentTerminalMutationVariables = Exact<{
  data: CreatePaymentTerminalInput;
}>;


export type CreatePaymentTerminalMutation = { __typename?: 'Mutation', createPaymentTerminal: { __typename?: 'PaymentTerminal', id: string, externalId: string, physicalId?: string | null, name: string, location: { __typename?: 'Location', id: string } } };

export type UpdatePaymentTerminalMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdatePaymentTerminalInput;
}>;


export type UpdatePaymentTerminalMutation = { __typename?: 'Mutation', updatePaymentTerminal: { __typename?: 'PaymentTerminal', id: string, externalId: string, physicalId?: string | null, name: string, location: { __typename?: 'Location', id: string } } };

export type DeletePaymentTerminalMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePaymentTerminalMutation = { __typename?: 'Mutation', deletePaymentTerminal: boolean };

export type CreatePolicyMutationVariables = Exact<{
  data: CreatePolicyInput;
}>;


export type CreatePolicyMutation = { __typename?: 'Mutation', createPolicy: { __typename?: 'Policy', id: string, documentId?: string | null } };

export type UpdatePolicyMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdatePolicyInput;
}>;


export type UpdatePolicyMutation = { __typename?: 'Mutation', updatePolicy: { __typename?: 'Policy', id: string } };

export type CreatePrivateSessionMutationVariables = Exact<{
  data: CreatePrivateSessionInput;
}>;


export type CreatePrivateSessionMutation = { __typename?: 'Mutation', createPrivateSession: { __typename?: 'PrivateSession', id: string } };

export type UpdatePrivateSessionMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdatePrivateSessionInput;
}>;


export type UpdatePrivateSessionMutation = { __typename?: 'Mutation', updatePrivateSession: { __typename?: 'PrivateSession', id: string } };

export type CreatePrivateSessionDurationMutationVariables = Exact<{
  data: CreatePrivateSessionDurationInput;
}>;


export type CreatePrivateSessionDurationMutation = { __typename?: 'Mutation', createPrivateSessionDuration: { __typename?: 'PrivateSessionDuration', id: string } };

export type UpdatePrivateSessionDurationMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdatePrivateSessionDurationInput;
}>;


export type UpdatePrivateSessionDurationMutation = { __typename?: 'Mutation', updatePrivateSessionDuration: { __typename?: 'PrivateSessionDuration', id: string } };

export type DeletePrivateSessionDurationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePrivateSessionDurationMutation = { __typename?: 'Mutation', deletePrivateSessionDuration: boolean };

export type CreatePrivateSessionLocationRoomsMutationVariables = Exact<{
  data: CreatePrivateSessionLocationRoomsInput;
}>;


export type CreatePrivateSessionLocationRoomsMutation = { __typename?: 'Mutation', createPrivateSessionLocationRooms: { __typename?: 'PrivateSessionLocationRooms', id: string } };

export type UpdatePrivateSessionLocationRoomsMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdatePrivateSessionLocationRoomsInput;
}>;


export type UpdatePrivateSessionLocationRoomsMutation = { __typename?: 'Mutation', updatePrivateSessionLocationRooms: { __typename?: 'PrivateSessionLocationRooms', id: string } };

export type DeletePrivateSessionLocationRoomsMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePrivateSessionLocationRoomsMutation = { __typename?: 'Mutation', deletePrivateSessionLocationRooms: boolean };

export type CreatePrivateSessionOverrideMutationVariables = Exact<{
  data: CreatePrivateSessionOverrideInput;
}>;


export type CreatePrivateSessionOverrideMutation = { __typename?: 'Mutation', createPrivateSessionOverride: { __typename?: 'PrivateSessionOverride', id: string } };

export type UpdatePrivateSessionOverrideMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdatePrivateSessionOverrideInput;
}>;


export type UpdatePrivateSessionOverrideMutation = { __typename?: 'Mutation', updatePrivateSessionOverride: { __typename?: 'PrivateSessionOverride', id: string } };

export type DeletePrivateSessionOverrideMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePrivateSessionOverrideMutation = { __typename?: 'Mutation', deletePrivateSessionOverride: boolean };

export type CreateProductMutationVariables = Exact<{
  data: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string } };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string } };

export type DeleteProductMutationVariables = Exact<{
  deleteProductId: Scalars['String'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct: boolean };

export type CreateProductGroupMutationVariables = Exact<{
  data: CreateProductGroupInput;
}>;


export type CreateProductGroupMutation = { __typename?: 'Mutation', createProductGroup: { __typename?: 'ProductGroup', id: string } };

export type UpdateProductGroupMutationVariables = Exact<{
  updateProductGroupId: Scalars['String'];
  data: UpdateProductGroupInput;
}>;


export type UpdateProductGroupMutation = { __typename?: 'Mutation', updateProductGroup: { __typename?: 'ProductGroup', id: string } };

export type CreateVariantMetricMutationVariables = Exact<{
  data: CreateVariantMetricInput;
}>;


export type CreateVariantMetricMutation = { __typename?: 'Mutation', createVariantMetric: { __typename?: 'VariantMetric', id: string } };

export type UpdateVariantMetricMutationVariables = Exact<{
  data: UpdateVariantMetricInput;
  id: Scalars['String'];
}>;


export type UpdateVariantMetricMutation = { __typename?: 'Mutation', updateVariantMetric: { __typename?: 'VariantMetric', id: string } };

export type DeleteVariantMetricMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteVariantMetricMutation = { __typename?: 'Mutation', deleteVariantMetric: boolean };

export type CreateRecurringChargeMutationVariables = Exact<{
  data: CreateRecurringChargeInput;
}>;


export type CreateRecurringChargeMutation = { __typename?: 'Mutation', createRecurringCharge: { __typename?: 'RecurringCharge', id: string } };

export type UpdateRecurringChargeMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateRecurringChargeInput;
}>;


export type UpdateRecurringChargeMutation = { __typename?: 'Mutation', updateRecurringCharge: { __typename?: 'RecurringCharge', id: string } };

export type DeleteRecurringChargeMutationVariables = Exact<{
  deleteRecurringChargeId: Scalars['String'];
}>;


export type DeleteRecurringChargeMutation = { __typename?: 'Mutation', deleteRecurringCharge: boolean };

export type MigratePaymentRecordsMutationVariables = Exact<{
  data: PaymentRecordJsonArrInput;
  locationId: Scalars['String'];
}>;


export type MigratePaymentRecordsMutation = { __typename?: 'Mutation', migratePaymentRecords: { __typename?: 'MutationResult', errors: { __typename?: 'MigrateError', Missing: Array<string>, Invalid: Array<string>, Collision: Array<string>, Default: Array<string> } } };

export type CreateRoomMutationVariables = Exact<{
  data: CreateRoomInput;
}>;


export type CreateRoomMutation = { __typename?: 'Mutation', createRoom: { __typename?: 'Room', id: string, name: string } };

export type UpdateRoomMutationVariables = Exact<{
  data: UpdateRoomInput;
  updateRoomId: Scalars['String'];
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom: { __typename?: 'Room', id: string, name: string } };

export type DeleteRoomMutationVariables = Exact<{
  deleteRoomId: Scalars['String'];
}>;


export type DeleteRoomMutation = { __typename?: 'Mutation', deleteRoom: boolean };

export type CreateScheduledTransactionMutationVariables = Exact<{
  data: CreateScheduledTransactionInput;
}>;


export type CreateScheduledTransactionMutation = { __typename?: 'Mutation', createScheduledTransaction: { __typename?: 'ScheduledTransaction', id: string } };

export type UpdateScheduledTransactionMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateScheduledTransactionInput;
}>;


export type UpdateScheduledTransactionMutation = { __typename?: 'Mutation', updateScheduledTransaction: { __typename?: 'ScheduledTransaction', id: string } };

export type DeleteScheduledTransactionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteScheduledTransactionMutation = { __typename?: 'Mutation', deleteScheduledTransaction: boolean };

export type CreateScheduledChargesMutationVariables = Exact<{
  data: CreateScheduledChargesInput;
}>;


export type CreateScheduledChargesMutation = { __typename?: 'Mutation', createScheduledCharges: { __typename?: 'ScheduledCharges', id: string } };

export type UpdateScheduledChargesMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateScheduledChargesInput;
}>;


export type UpdateScheduledChargesMutation = { __typename?: 'Mutation', updateScheduledCharges: { __typename?: 'ScheduledCharges', id: string } };

export type DeleteScheduledChargesMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteScheduledChargesMutation = { __typename?: 'Mutation', deleteScheduledCharges: boolean };

export type CreateSendgridTemplateMutationVariables = Exact<{
  data: CreateSendgridTemplateInput;
}>;


export type CreateSendgridTemplateMutation = { __typename?: 'Mutation', createsendgridTemplate: { __typename?: 'SendgridTemplate', id: string } };

export type UpdateSendgridTemplateMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateSendgridTemplateInput;
}>;


export type UpdateSendgridTemplateMutation = { __typename?: 'Mutation', updatesendgridTemplate: { __typename?: 'SendgridTemplate', id: string } };

export type DeleteSendgridTemplateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSendgridTemplateMutation = { __typename?: 'Mutation', deletesendgridTemplate: boolean };

export type CreateOrganizationServiceMutationVariables = Exact<{
  data: CreateOrganizationServiceInput;
}>;


export type CreateOrganizationServiceMutation = { __typename?: 'Mutation', createOrganizationService: { __typename?: 'OrganizationService', id: string } };

export type UpdateOrganizationServiceMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateOrganizationServiceInput;
}>;


export type UpdateOrganizationServiceMutation = { __typename?: 'Mutation', updateOrganizationService: { __typename?: 'OrganizationService', id: string } };

export type CreateLocationServiceMutationVariables = Exact<{
  data: CreateLocationServiceInput;
}>;


export type CreateLocationServiceMutation = { __typename?: 'Mutation', createLocationService: { __typename?: 'LocationService', id: string } };

export type UpdateLocationServiceMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateLocationServiceInput;
}>;


export type UpdateLocationServiceMutation = { __typename?: 'Mutation', updateLocationService: { __typename?: 'LocationService', id: string } };

export type DeleteLocationServiceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteLocationServiceMutation = { __typename?: 'Mutation', deleteLocationService: boolean };

export type CreateServiceAllotmentMutationVariables = Exact<{
  data: CreateServiceAllotmentInput;
}>;


export type CreateServiceAllotmentMutation = { __typename?: 'Mutation', createServiceAllotment: { __typename?: 'ServiceAllotment', id: string, name: string } };

export type UpdateServiceAllotmentMutationVariables = Exact<{
  data: UpdateServiceAllotmentInput;
  updateServiceAllotmentId: Scalars['String'];
}>;


export type UpdateServiceAllotmentMutation = { __typename?: 'Mutation', updateServiceAllotment: { __typename?: 'ServiceAllotment', id: string, name: string } };

export type DeleteServiceAllotmentMutationVariables = Exact<{
  deleteServiceAllotmentId: Scalars['String'];
}>;


export type DeleteServiceAllotmentMutation = { __typename?: 'Mutation', deleteServiceAllotment: boolean };

export type CreateShoppingCartMutationVariables = Exact<{
  data: CreateShoppingCartInput;
}>;


export type CreateShoppingCartMutation = { __typename?: 'Mutation', createShoppingCart: { __typename?: 'ShoppingCart', id: string, subtotal?: number | null, discount?: number | null, tax?: number | null, total?: number | null, discounts?: string | null, taxes?: string | null, products?: string | null, lineItems: Array<{ __typename?: 'CheckoutLineItem', id: string, count?: number | null, subtotal?: number | null, discount?: number | null, discounts?: string | null, product?: { __typename?: 'Product', id: string, name: string } | null }> } };

export type UpdateShoppingCartMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateShoppingCartInput;
}>;


export type UpdateShoppingCartMutation = { __typename?: 'Mutation', updateShoppingCart: { __typename?: 'ShoppingCart', id: string, subtotal?: number | null, total?: number | null, discount?: number | null, discounts?: string | null, tax?: number | null, taxes?: string | null, products?: string | null, lineItems: Array<{ __typename?: 'CheckoutLineItem', id: string, count?: number | null, subtotal?: number | null, discount?: number | null, discounts?: string | null, product?: { __typename?: 'Product', id: string, name: string } | null }> } };

export type DeleteShoppingCartMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteShoppingCartMutation = { __typename?: 'Mutation', deleteShoppingCart: boolean };

export type CreateSignedAgreementMutationVariables = Exact<{
  data: CreateSignedAgreementInput;
}>;


export type CreateSignedAgreementMutation = { __typename?: 'Mutation', createSignedAgreement: { __typename?: 'SignedAgreement', id: string } };

export type UpdateSignedAgreementMutationVariables = Exact<{
  data: UpdateSignedAgreementInput;
  id: Scalars['String'];
}>;


export type UpdateSignedAgreementMutation = { __typename?: 'Mutation', updateSignedAgreement: { __typename?: 'SignedAgreement', id: string } };

export type SignDocumentMutationVariables = Exact<{
  signDocumentId: Scalars['String'];
  data: SignSignedDocumentInput;
}>;


export type SignDocumentMutation = { __typename?: 'Mutation', signDocument: { __typename?: 'SignedDocumentGroup', id: string } };

export type UpdateSubscriptionMutationVariables = Exact<{
  data: UpdateClientSubscriptionInput;
  id: Scalars['String'];
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: { __typename?: 'ClientSubscription', id: string } };

export type MigrateSubscriptionMutationVariables = Exact<{
  data: SubscriptionJsonArrInput;
  locationId: Scalars['String'];
}>;


export type MigrateSubscriptionMutation = { __typename?: 'Mutation', migrateSubscription: { __typename?: 'MutationResult', errors: { __typename?: 'MigrateError', Missing: Array<string>, Invalid: Array<string>, Collision: Array<string>, Default: Array<string> } } };

export type CreateTransactionMutationVariables = Exact<{
  data: CreateTransactionInput;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction: { __typename?: 'Transaction', id: string, externalId: string, amount: number, subtotal: number, tax: number, discount: number, transactionStatus: TransactionStatus, completedAt?: any | null } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, username?: string | null, role: UserRole, firstName: string, middleName: string, lastName: string, email: string, phoneNumber?: string | null, smsConsent: boolean, profilePicUrl?: string | null } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type AcceptTacMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptTacMutation = { __typename?: 'Mutation', acceptTAC: boolean };

export type CreateWaitlisteeMutationVariables = Exact<{
  data: CreateWaitlisteeInput;
}>;


export type CreateWaitlisteeMutation = { __typename?: 'Mutation', createWaitlistee: { __typename?: 'Waitlistee', id: string } };

export type DeleteWaitlisteeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteWaitlisteeMutation = { __typename?: 'Mutation', deleteWaitlistee: boolean };

export type PullFromMeetingMutationVariables = Exact<{
  meetingId: Scalars['String'];
  clientId: Scalars['String'];
  cancelEnrollment?: InputMaybe<Scalars['Boolean']>;
}>;


export type PullFromMeetingMutation = { __typename?: 'Mutation', pullFromMeeting: boolean };

export type PushToMeetingMutationVariables = Exact<{
  meetingId: Scalars['String'];
  clientId: Scalars['String'];
}>;


export type PushToMeetingMutation = { __typename?: 'Mutation', pushToMeeting: boolean };

export type GetAdminQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetAdminQuery = { __typename?: 'Query', adminOne?: { __typename?: 'Admin', id: string, organization: { __typename?: 'Organization', id: string, name: string }, user: { __typename?: 'User', id: string, firstName: string, middleName: string, lastName: string, email: string, phoneNumber?: string | null, createdDate: any, smsConsent: boolean, profilePicUrl?: string | null } } | null };

export type GetAgreementQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAgreementQuery = { __typename?: 'Query', agreementOne?: { __typename?: 'Agreement', isAutoRenew: boolean, isMembership: boolean, isGeneric: boolean, isOrg: boolean, name: string, Unit: Unit, termValue: number, paymentFrequency: PaymentFrequency, draftMode: DraftMode, draftValue?: number | null, isGroup: boolean, scalingPrice?: number | null, groupPricingType?: GroupPricingType | null, limit?: number | null, description?: string | null, postponeUntil?: any | null, locations?: Array<{ __typename?: 'Location', id: string, name: string }> | null, additionalPolicies: Array<{ __typename?: 'Policy', id: string, name: string }>, recurringCharges: Array<{ __typename?: 'RecurringCharge', id: string, cost: number, name?: string | null, isTaxable: boolean, isPostTax: boolean, taxRates: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', name: string } }>, categoryOption: { __typename?: 'CategoryOption', id: string, name: string } }>, initialCharges: Array<{ __typename?: 'InitialCharge', id: string, cost: number, isTaxable: boolean, isPostTax: boolean, isDiscountable: boolean, taxRates: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', name: string } }>, revenue?: { __typename?: 'CategoryOption', id: string, name: string } | null, fee?: { __typename?: 'CategoryOption', id: string, name: string } | null }>, initialAllotments: Array<{ __typename?: 'ServiceAllotment', id: string, name: string, credits: number }>, recurringAllotments: Array<{ __typename?: 'ServiceAllotment', id: string, name: string, credits: number }>, accessPeriods?: Array<{ __typename?: 'AccessPeriod', id: string, start: any, end: any, location: { __typename?: 'Location', id: string, name: string } }> | null } | null };

export type GetAgreementManyQueryVariables = Exact<{
  locationIds?: InputMaybe<Array<GenericConnectInput> | GenericConnectInput>;
}>;


export type GetAgreementManyQuery = { __typename?: 'Query', agreementMany: Array<{ __typename?: 'Agreement', id: string, isAutoRenew: boolean, isMembership: boolean, isGeneric: boolean, isOrg: boolean, name: string, Unit: Unit, termValue: number, description?: string | null, postponeUntil?: any | null, paymentFrequency: PaymentFrequency, groupPricingType?: GroupPricingType | null, isGroup: boolean, limit?: number | null, scalingPrice?: number | null, additionalPolicies: Array<{ __typename?: 'Policy', id: string, name: string }>, recurringCharges: Array<{ __typename?: 'RecurringCharge', id: string, cost: number, categoryOption: { __typename?: 'CategoryOption', id: string, name: string } }>, initialCharges: Array<{ __typename?: 'InitialCharge', id: string, cost: number, isDiscountable: boolean, revenue?: { __typename?: 'CategoryOption', id: string, name: string } | null, fee?: { __typename?: 'CategoryOption', id: string, name: string } | null }>, initialAllotments: Array<{ __typename?: 'ServiceAllotment', id: string, name: string, credits: number }>, recurringAllotments: Array<{ __typename?: 'ServiceAllotment', id: string, name: string, credits: number }> }> };

export type GetAgreementPageQueryVariables = Exact<{
  pagination: PaginationInput;
  locationIds?: InputMaybe<Array<GenericConnectInput> | GenericConnectInput>;
}>;


export type GetAgreementPageQuery = { __typename?: 'Query', agreementPage: { __typename?: 'PaginatedAgreementResponse', totalRows: number, items: Array<{ __typename?: 'Agreement', id: string, viid: string, version: number, isMembership: boolean, isAutoRenew: boolean, isGeneric: boolean, isOrg: boolean, termValue: number, Unit: Unit, name: string, isActive: boolean }> } };

export type GetAgreementNamesQueryVariables = Exact<{
  locationIds?: InputMaybe<Array<GenericConnectInput> | GenericConnectInput>;
}>;


export type GetAgreementNamesQuery = { __typename?: 'Query', agreementMany: Array<{ __typename?: 'Agreement', id: string, name: string }> };

export type GetAlterAgreementRecordPageQueryVariables = Exact<{
  pagination: PaginationInput;
  locationId: Scalars['String'];
}>;


export type GetAlterAgreementRecordPageQuery = { __typename?: 'Query', alterAgreementRecordPage: { __typename?: 'PaginatedAlterAgreementRecordResponse', totalRows: number, items: Array<{ __typename?: 'AlterAgreementRecord', id: string, alterationAgreementStatus?: AlterationAgreementStatus | null, alterationAgreementType?: AlterationAgreementType | null, notes?: string | null, startFreezeAt?: any | null, intervals: number, reviewedAt?: any | null, createdDate: any, signedAgreement: { __typename?: 'SignedAgreement', id: string, status: SignedAgreementStatus, agreement: { __typename?: 'Agreement', id: string, name: string, paymentFrequency: PaymentFrequency }, client: { __typename?: 'Client', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } }, reason?: { __typename?: 'AlterationReason', id: string, reason?: string | null } | null, reviewedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } };

export type GetAgreementRequestsQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type GetAgreementRequestsQuery = { __typename?: 'Query', agreementRequests?: Array<{ __typename?: 'AlterAgreementRecord', id: string, alterationAgreementStatus?: AlterationAgreementStatus | null, signedAgreement: { __typename?: 'SignedAgreement', id: string } }> | null };

export type GetAlterationReasonsQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  includeAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAlterationReasonsQuery = { __typename?: 'Query', alterationReasonMany?: Array<{ __typename?: 'AlterationReason', id: string, reason?: string | null, type?: AlterationAgreementType | null, isActive: boolean, location: { __typename?: 'Location', id: string, name: string } }> | null };

export type GetAlterationReasonNamesQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type GetAlterationReasonNamesQuery = { __typename?: 'Query', alterationReasonMany?: Array<{ __typename?: 'AlterationReason', id: string, reason?: string | null }> | null };

export type GetAttendanceByClientQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type GetAttendanceByClientQuery = { __typename?: 'Query', attendanceByClient: Array<{ __typename?: 'Attendance', attendanceStatus: AttendanceStatus, createdDate: any, meeting: { __typename?: 'Meeting', startAt: any, name: string, location: { __typename?: 'Location', name: string } } }> };

export type GetAttendanceRecordsQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type GetAttendanceRecordsQuery = { __typename?: 'Query', attendanceByClient: Array<{ __typename?: 'Attendance', attendanceStatus: AttendanceStatus, createdDate: any, meeting: { __typename?: 'Meeting', startAt: any, name: string, location: { __typename?: 'Location', name: string } }, creditAllotment?: { __typename?: 'CreditAllotment', count: number, serviceAllotment?: { __typename?: 'ServiceAllotment', name: string, credits: number } | null } | null }> };

export type GetAttendancePageClientGuestQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetAttendancePageClientGuestQuery = { __typename?: 'Query', attendancePage: { __typename?: 'PaginatedAttendanceResponse', totalRows: number, items: Array<{ __typename?: 'Attendance', attendanceStatus: AttendanceStatus, createdDate: any, meeting: { __typename?: 'Meeting', startAt: any, name: string, location: { __typename?: 'Location', name: string } } }> } };

export type AttendanceByClientQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type AttendanceByClientQuery = { __typename?: 'Query', attendanceByClientUpcoming: Array<{ __typename?: 'Attendance', id: string, meeting: { __typename?: 'Meeting', id: string, name: string, endAt: any, startAt: any, location: { __typename?: 'Location', name: string }, room?: { __typename?: 'Room', name: string } | null } }> };

export type GetAttendeePageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetAttendeePageQuery = { __typename?: 'Query', attendeePage: { __typename?: 'PaginatedAttendeeResponse', totalRows: number, items: Array<{ __typename?: 'Attendee', id: string, attendeeType: AttendeeType, client: { __typename?: 'Client', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } }> } };

export type GetAttendeePageCustomerQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetAttendeePageCustomerQuery = { __typename?: 'Query', attendeePage: { __typename?: 'PaginatedAttendeeResponse', totalRows: number, items: Array<{ __typename?: 'Attendee', id: string, attendeeType: AttendeeType, client: { __typename?: 'Client', id: string, leadStatus?: LeadStatus | null, memberStatus: MemberStatus, user: { __typename?: 'User', firstName: string, lastName: string, profilePicUrl?: string | null } } }> } };

export type GetAttendeeNamesQueryVariables = Exact<{
  orgId?: InputMaybe<Scalars['String']>;
}>;


export type GetAttendeeNamesQuery = { __typename?: 'Query', attendeeMany: Array<{ __typename?: 'Attendee', id: string, client: { __typename?: 'Client', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } }> };

export type GetCategoryOptionManyQueryVariables = Exact<{
  orgId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
}>;


export type GetCategoryOptionManyQuery = { __typename?: 'Query', categoryOptionMany: Array<{ __typename?: 'CategoryOption', id: string, name: string, type: CategoryOptionType }> };

export type CheckInManyQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
  todayRecords?: InputMaybe<Scalars['Boolean']>;
}>;


export type CheckInManyQuery = { __typename?: 'Query', checkInMany: Array<{ __typename?: 'CheckIn', id: string, createdDate: any, isAccepted: boolean, client: { __typename?: 'Client', memberStatus: MemberStatus, leadStatus?: LeadStatus | null, memberships: Array<{ __typename?: 'SignedAgreement', id: string, status: SignedAgreementStatus, termStart?: any | null, termEnd?: any | null, subscription: { __typename?: 'ClientSubscription', paymentStatus: PaymentStatus }, location: { __typename?: 'Location', id: string } }>, user: { __typename?: 'User', firstName: string, lastName: string, profilePicUrl?: string | null } } }> };

export type GetnewCheckInSubscriptionVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetnewCheckInSubscription = { __typename?: 'Subscription', createCheckInSubscription: { __typename?: 'CheckInSubscriptionPayload', newCheckIn: { __typename?: 'CheckIn', id: string, createdDate: any, isAccepted: boolean, client: { __typename?: 'Client', memberStatus: MemberStatus, leadStatus?: LeadStatus | null, memberships: Array<{ __typename?: 'SignedAgreement', id: string, status: SignedAgreementStatus, termStart?: any | null, termEnd?: any | null, subscription: { __typename?: 'ClientSubscription', paymentStatus: PaymentStatus }, location: { __typename?: 'Location', id: string } }>, user: { __typename?: 'User', firstName: string, lastName: string, profilePicUrl?: string | null } } } } };

export type GetCheckInOneQueryVariables = Exact<{
  checkInOneId: Scalars['String'];
}>;


export type GetCheckInOneQuery = { __typename?: 'Query', checkInOne?: { __typename?: 'CheckIn', id: string, isAccepted: boolean, isOverride: boolean, createdDate: any, client: { __typename?: 'Client', id: string, dob?: string | null, memberStatus: MemberStatus, leadStatus?: LeadStatus | null, user: { __typename?: 'User', firstName: string, lastName: string, profilePicUrl?: string | null }, memberships: Array<{ __typename?: 'SignedAgreement', id: string, status: SignedAgreementStatus, isAutoRenew: boolean, termStart?: any | null, termEnd?: any | null, subscription: { __typename?: 'ClientSubscription', paymentStatus: PaymentStatus }, location: { __typename?: 'Location', id: string }, agreement: { __typename?: 'Agreement', id: string, name: string } }> } } | null };

export type GetClientPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetClientPageQuery = { __typename?: 'Query', clientPage: { __typename?: 'PaginatedClientResponse', totalRows: number, items: Array<{ __typename?: 'Client', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, createdDate: any, profilePicUrl?: string | null } }> } };

export type GetClientQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetClientQuery = { __typename?: 'Query', clientOne?: { __typename?: 'Client', id: string, dob?: string | null, memberStatus: MemberStatus, memberCode?: string | null, homePhone?: string | null, workPhone?: string | null, address?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, idNumber?: string | null, employer?: string | null, gender?: Gender | null, emergencyName?: string | null, emergencyPhone?: string | null, relationship?: string | null, attendee?: { __typename?: 'Attendee', id: string } | null, preferences?: { __typename?: 'ClientPreferences', minimumNotice: number, notificationType: NotificationType } | null, user: { __typename?: 'User', id: string, firstName: string, middleName: string, lastName: string, email: string, phoneNumber?: string | null, createdDate: any, smsConsent: boolean, profilePicUrl?: string | null, role: UserRole, acceptedTAC: boolean, lastLoginAt?: any | null, username?: string | null }, notes: Array<{ __typename?: 'Notes', id: string, content: string, isMigrated: boolean, updatedDate: any, author?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, profilePicUrl?: string | null } } | null }>, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl?: string | null, organizationBranding?: { __typename?: 'OrganizationBranding', primaryColor?: string | null, secondaryColor?: string | null, id: string, brandingLogoImg?: string | null } | null } | null, paymentMethods?: Array<{ __typename?: 'ClientPaymentMethods', id: string, name?: string | null, mask?: string | null, vendor: PaymentType, expiresAt?: any | null, merchant?: string | null, isPrimary: boolean, isComplete: boolean }> | null, groups?: Array<{ __typename?: 'ClientGroup', id: string, name: string, clientGroupType: ClientGroupType, clients: Array<{ __typename?: 'Client', id: string, user: { __typename?: 'User', firstName: string, lastName: string } }> }> | null, locations?: Array<{ __typename?: 'Location', address?: string | null, city?: string | null, name: string, state?: string | null, zip?: string | null, id: string }> | null, defaultLocation?: { __typename?: 'Location', id: string, name: string } | null } | null };

export type GetClientGroupManyQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetClientGroupManyQuery = { __typename?: 'Query', clientGroupMany: Array<{ __typename?: 'ClientGroup', id: string, name: string, clientGroupType: ClientGroupType, primaryClient: { __typename?: 'Client', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }, clients: Array<{ __typename?: 'Client', id: string, user: { __typename?: 'User', firstName: string, lastName: string } }>, signedAgreement?: { __typename?: 'SignedAgreement', agreement: { __typename?: 'Agreement', id: string, name: string, description?: string | null } } | null }> };

export type GetClientGroupPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetClientGroupPageQuery = { __typename?: 'Query', clientGroupPage: { __typename?: 'PaginatedClientGroupResponse', totalRows: number, items: Array<{ __typename?: 'ClientGroup', id: string, name: string }> } };

export type GetClientCheckInPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetClientCheckInPageQuery = { __typename?: 'Query', clientPage: { __typename?: 'PaginatedClientResponse', totalRows: number, items: Array<{ __typename?: 'Client', id: string, memberStatus: MemberStatus, leadStatus?: LeadStatus | null, user: { __typename?: 'User', firstName: string, lastName: string, profilePicUrl?: string | null } }> } };

export type GetClientGuestLeadQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetClientGuestLeadQuery = { __typename?: 'Query', clientOne?: { __typename?: 'Client', id: string, dob?: string | null, homePhone?: string | null, workPhone?: string | null, address?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, idNumber?: string | null, employer?: string | null, gender?: Gender | null, emergencyName?: string | null, emergencyPhone?: string | null, relationship?: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, profilePicUrl?: string | null, username?: string | null }, notes: Array<{ __typename?: 'Notes', id: string, content: string, isMigrated: boolean, updatedDate: any, author?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, profilePicUrl?: string | null } } | null }> } | null };

export type GetSuggestedUserNameQueryVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type GetSuggestedUserNameQuery = { __typename?: 'Query', suggestedUserName: string };

export type ClientSampleCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientSampleCsvQuery = { __typename?: 'Query', clientSampleCSV: string };

export type GetAccountDetailReportQueryVariables = Exact<{
  data: AccountReportInput;
}>;


export type GetAccountDetailReportQuery = { __typename?: 'Query', accountDetailReport: Array<{ __typename?: 'Client', id: string, memberStatus: MemberStatus, standing?: AccountStatus | null, city?: string | null, country?: string | null, dob?: string | null, idNumber?: string | null, leadStatus?: LeadStatus | null, state?: string | null, employer?: string | null, gender?: Gender | null, zipCode?: string | null, address?: string | null, locations?: Array<{ __typename?: 'Location', id: string, name: string }> | null, agreements: Array<{ __typename?: 'SignedAgreement', id: string, subscription: { __typename?: 'ClientSubscription', isActive: boolean } }>, preferences?: { __typename?: 'ClientPreferences', notificationType: NotificationType } | null, user: { __typename?: 'User', firstName: string, lastName: string, email: string, phoneNumber?: string | null } }> };

export type DownloadAccountDetailReportQueryVariables = Exact<{
  data: AccountReportInput;
}>;


export type DownloadAccountDetailReportQuery = { __typename?: 'Query', downloadAccountDetailReport: string };

export type ClientChangeRecordsQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type ClientChangeRecordsQuery = { __typename?: 'Query', clientChangeRecordsMany: Array<{ __typename?: 'ClientChangeRecord', id: string, author: string, modalName: string, description: string, isJSON: boolean, oldValues?: string | null, newValues?: string | null, createdDate: any }> };

export type ClientChangeOlderRecordsQueryVariables = Exact<{
  clientId: Scalars['String'];
  filter: Scalars['Float'];
}>;


export type ClientChangeOlderRecordsQuery = { __typename?: 'Query', clientChangeRecordsOlderMany: Array<{ __typename?: 'ClientChangeRecord', id: string, author: string, modalName: string, description: string, isJSON: boolean, oldValues?: string | null, newValues?: string | null, createdDate: any }> };

export type GetClientPaymentMethodQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetClientPaymentMethodQuery = { __typename?: 'Query', clientPaymentMethodOne?: { __typename?: 'ClientPaymentMethods', id: string, externalId?: string | null, name?: string | null, mask?: string | null, expiresAt?: any | null, isPrimary: boolean, isComplete: boolean, vendor: PaymentType, merchant?: string | null, type: PaymentMethodType, accountType?: BankAccountType | null, routingNumber?: string | null } | null };

export type GetClientPaymentMethodsManyQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type GetClientPaymentMethodsManyQuery = { __typename?: 'Query', clientPaymentMethodsMany: Array<{ __typename?: 'ClientPaymentMethods', id: string, externalId?: string | null, name?: string | null, mask?: string | null, expiresAt?: any | null, isPrimary: boolean, isComplete: boolean, vendor: PaymentType, merchant?: string | null, type: PaymentMethodType, accountType?: BankAccountType | null, routingNumber?: string | null }> };

export type GetNewPaymentMethodSubscriptionVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;


export type GetNewPaymentMethodSubscription = { __typename?: 'Subscription', newPaymentMethodSubscription: { __typename?: 'PaymentMethodSubscription', newPaymentMethod: { __typename?: 'ClientPaymentMethods', id: string, externalId?: string | null, name?: string | null, mask?: string | null, expiresAt?: any | null, isPrimary: boolean, isComplete: boolean, vendor: PaymentType, merchant?: string | null, type: PaymentMethodType, accountType?: BankAccountType | null, routingNumber?: string | null } } };

export type PaymentMethodSampleCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodSampleCsvQuery = { __typename?: 'Query', paymentMethodSampleCSV: string };

export type GetCardsExpirationReportQueryVariables = Exact<{
  data: CustomReportInput;
}>;


export type GetCardsExpirationReportQuery = { __typename?: 'Query', cardsExpirationReport: Array<{ __typename?: 'ClientSubscription', id: string, signedAgreement: { __typename?: 'SignedAgreement', client: { __typename?: 'Client', migrationId?: string | null, lastVisitDate?: any | null, user: { __typename?: 'User', firstName: string, lastName: string, phoneNumber?: string | null, email: string } }, paymentMethod?: { __typename?: 'ClientPaymentMethods', merchant?: string | null, mask?: string | null, name?: string | null, expiresAt?: any | null, isPrimary: boolean } | null }, location: { __typename?: 'Location', name: string } }> };

export type DownloadCardsExpirationReportQueryVariables = Exact<{
  data: CustomReportInput;
}>;


export type DownloadCardsExpirationReportQuery = { __typename?: 'Query', downloadCardsExpirationReport: string };

export type GetTimeClockEntriesPageQueryVariables = Exact<{
  pagination: PaginationInput;
  locationId: Scalars['String'];
  employeeId?: InputMaybe<Scalars['String']>;
}>;


export type GetTimeClockEntriesPageQuery = { __typename?: 'Query', timeClockEntryPage: { __typename?: 'PaginatedTimeClockEntryResponse', totalRows: number, items: Array<{ __typename?: 'TimeClockEntry', id: string, editedAt?: any | null, updatedDate: any, startedAt: any, endedAt?: any | null, createdDate: any, employee: { __typename?: 'Employee', user: { __typename?: 'User', firstName: string, lastName: string } }, editedBy?: { __typename?: 'Employee', user: { __typename?: 'User', firstName: string, lastName: string } } | null }> } };

export type GetTimeClockEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTimeClockEntryQuery = { __typename?: 'Query', timeClockEntryOne?: { __typename?: 'TimeClockEntry', id: string, startedAt: any, endedAt?: any | null, station?: { __typename?: 'EmployeeStation', id: string } | null, employee: { __typename?: 'Employee', id: string } } | null };

export type GetValidCreditAllotmemtsQueryVariables = Exact<{
  locationServiceId?: InputMaybe<Scalars['String']>;
  privateSessionId?: InputMaybe<Scalars['String']>;
  clientId: Scalars['String'];
}>;


export type GetValidCreditAllotmemtsQuery = { __typename?: 'Query', getValidCreditAllotmemts: Array<{ __typename?: 'CreditAllotment', id: string, expiresAt?: any | null, count: number, name: string, agreement?: { __typename?: 'Agreement', name: string } | null }> };

export type GetCreditAllotmentManyQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type GetCreditAllotmentManyQuery = { __typename?: 'Query', creditAllotmentMany: Array<{ __typename?: 'CreditAllotment', id: string, name: string, count: number, expiresAt?: any | null, services: Array<{ __typename?: 'OrganizationService', name: string }>, privateSessions: Array<{ __typename?: 'PrivateSessionDuration', id: string, duration: number, session: { __typename?: 'PrivateSession', name: string } }>, agreement?: { __typename?: 'Agreement', id: string, name: string } | null, package?: { __typename?: 'Package', id: string, name: string } | null }> };

export type GetRevenueDashboardQueryVariables = Exact<{
  data: DashboardInput;
}>;


export type GetRevenueDashboardQuery = { __typename?: 'Query', revenueDashboard: { __typename?: 'RevenueObject', initial: Array<{ __typename?: 'RevenueItem', revenue: number, category: string }>, recurring: Array<{ __typename?: 'RevenueItem', category: string, revenue: number }> } };

export type GetRevenueReportPageQueryVariables = Exact<{
  pagination: PaginationInput;
  data: DashboardInput;
}>;


export type GetRevenueReportPageQuery = { __typename?: 'Query', revenueReportPage: { __typename?: 'PaginatedRevenueRecordResponse', totalRows: number, items: Array<{ __typename?: 'RevenueRecord', id: string, completedAt: any, amount: number, revenueCat?: { __typename?: 'CategoryOption', name: string } | null, client?: { __typename?: 'Client', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } | null, transaction?: { __typename?: 'Transaction', id: string, transactionStatus: TransactionStatus, isRecurring: boolean, agreement?: { __typename?: 'Agreement', name: string } | null } | null }> } };

export type GetAgreementDashboardQueryVariables = Exact<{
  data: DashboardInput;
}>;


export type GetAgreementDashboardQuery = { __typename?: 'Query', agreementDashboard: Array<{ __typename?: 'DashboardObject', name: string, totalRevenue: number, totalSales: number }> };

export type GetAgreementReportPageQueryVariables = Exact<{
  pagination: PaginationInput;
  data: DashboardInput;
}>;


export type GetAgreementReportPageQuery = { __typename?: 'Query', agreementReportPage: { __typename?: 'PaginatedTransactionResponse', totalRows: number, items: Array<{ __typename?: 'Transaction', id: string, transactionStatus: TransactionStatus, agreementId?: string | null, completedAt?: any | null, createdDate: any, isRecurring: boolean, agreement?: { __typename?: 'Agreement', id: string, name: string, isMembership: boolean, isAutoRenew: boolean } | null, subscription?: { __typename?: 'ClientSubscription', subscriptionStatus?: SubscriptionStatus | null, nextDraftDate?: any | null, startDate?: any | null, endDate?: any | null, signedAgreement: { __typename?: 'SignedAgreement', termEnd?: any | null, termStart?: any | null, client: { __typename?: 'Client', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } } } | null }> } };

export type GetPackageDashboardQueryVariables = Exact<{
  data: DashboardInput;
}>;


export type GetPackageDashboardQuery = { __typename?: 'Query', packageDashboard: Array<{ __typename?: 'DashboardObject', name: string, totalRevenue: number, totalSales: number }> };

export type GetPosDashboardQueryVariables = Exact<{
  sortType: SortType;
  data: DashboardInput;
}>;


export type GetPosDashboardQuery = { __typename?: 'Query', posDashboard: { __typename?: 'DashboardOrRevenueItem', productObject?: Array<{ __typename?: 'DashboardObject', totalSales: number, totalRevenue: number, name: string }> | null, revenueItem?: Array<{ __typename?: 'RevenueItem', revenue: number, category: string }> | null } };

export type GetPosReportPageQueryVariables = Exact<{
  data: DashboardInput;
  pagination: PaginationInput;
}>;


export type GetPosReportPageQuery = { __typename?: 'Query', posReportPage: { __typename?: 'PaginatedProductSaleResponse', totalRows: number, items: Array<{ __typename?: 'ProductSale', id: string, count: number, discount: number, tax: number, commissionValue: number, productType: ProductType, product: { __typename?: 'Product', id: string, name: string, sku?: string | null }, location: { __typename?: 'Location', name: string }, transaction: { __typename?: 'Transaction', id: string, subtotal: number, isRefund: boolean, performedBy?: { __typename?: 'Employee', user: { __typename?: 'User', firstName: string, lastName: string } } | null, chargedTo?: { __typename?: 'Client', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } | null, discountCode?: Array<{ __typename?: 'DiscountCode', name: string, code: string }> | null } }> } };

export type GetProjectedIncomeDashboardQueryVariables = Exact<{
  data: DashboardInput;
}>;


export type GetProjectedIncomeDashboardQuery = { __typename?: 'Query', projectedIncome: Array<{ __typename?: 'AggregatedRevenue', revenueGroup: string, totalAmount: number }> };

export type DicountCodePageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type DicountCodePageQuery = { __typename?: 'Query', dicountCodePage: { __typename?: 'PaginatedDiscountCodeResponse', totalRows: number, items: Array<{ __typename?: 'DiscountCode', code: string, createdDate: any, discountCodeType: DiscountCodeType, id: string, isPercent: boolean, isRestricted: boolean, description?: string | null, name: string, recurring: boolean, startAt: any, useLimit?: number | null, value: number }> } };

export type DiscountCodeOneQueryVariables = Exact<{
  discountCodeOneId: Scalars['String'];
}>;


export type DiscountCodeOneQuery = { __typename?: 'Query', discountCodeOne: { __typename?: 'DiscountCode', id: string, createdDate: any, updatedDate: any, deletedDate?: any | null, name: string, description?: string | null, startAt: any, isPercent: boolean, value: number, code: string, discountCodeType: DiscountCodeType, recurring: boolean, useLimit?: number | null, isStaffOnly: boolean, isRestricted: boolean, locations: Array<{ __typename?: 'Location', name: string, id: string }>, expiration: { __typename?: 'Expiration', id: string, unit: Unit, expirationMode: ExpirationMode, isExpired: boolean, expiresAt?: any | null, value?: number | null } } };

export type DiscountCodeAgreementsQueryVariables = Exact<{
  discountCodeOneId: Scalars['String'];
  isAgreement: Scalars['Boolean'];
}>;


export type DiscountCodeAgreementsQuery = { __typename?: 'Query', discountCodeAgreementsOrProducts: { __typename?: 'DiscountCode', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, name: string }> } };

export type DiscountCodeProductsQueryVariables = Exact<{
  discountCodeOneId: Scalars['String'];
  isAgreement: Scalars['Boolean'];
}>;


export type DiscountCodeProductsQuery = { __typename?: 'Query', discountCodeAgreementsOrProducts: { __typename?: 'DiscountCode', id: string, products: Array<{ __typename?: 'Product', name: string, id: string }> } };

export type DiscountByCodeQueryVariables = Exact<{
  locationId: Scalars['String'];
  code: Scalars['String'];
}>;


export type DiscountByCodeQuery = { __typename?: 'Query', discountByCode: { __typename?: 'DiscountCode', name: string, id: string, value: number, useLimit?: number | null, isPercent: boolean, products: Array<{ __typename?: 'Product', id: string, name: string, cost: number }> } };

export type GetEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeesQuery = { __typename?: 'Query', employeeMany: Array<{ __typename?: 'Employee', id: string, user: { __typename?: 'User', id: string, username?: string | null, role: UserRole, firstName: string, middleName: string, lastName: string, email: string, phoneNumber?: string | null, createdDate: any, profilePicUrl?: string | null }, organization: { __typename?: 'Organization', id: string, name: string } }> };

export type GetEmployeesNameQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployeesNameQuery = { __typename?: 'Query', employeeMany: Array<{ __typename?: 'Employee', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> };

export type GetEmployeeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployeeQuery = { __typename?: 'Query', employeeOne?: { __typename?: 'Employee', id: string, staffId?: string | null, pin?: string | null, clockedIn: boolean, user: { __typename?: 'User', id: string, username?: string | null, role: UserRole, firstName: string, middleName: string, lastName: string, email: string, phoneNumber?: string | null, createdDate: any, profilePicUrl?: string | null }, organization: { __typename?: 'Organization', id: string, name: string }, locations: Array<{ __typename?: 'Location', id: string, name: string, description?: string | null, logoUrl?: string | null, stationsEnabled?: boolean | null }>, activeLocation: { __typename?: 'Location', id: string, name: string, stationsEnabled?: boolean | null }, activeSession?: { __typename?: 'TimeClockEntry', location: { __typename?: 'Location', id: string, name: string }, station?: { __typename?: 'EmployeeStation', id: string, name: string } | null } | null, role?: { __typename?: 'EmployeeRole', id: string, name: string, description?: string | null, orgRoles: RolePermissionType, orgPolicies: RolePermissionType, orgAgreements: RolePermissionType, orgPackages: RolePermissionType, orgLocations: RolePermissionType, orgDiscounts: RolePermissionType, orgSettings: RolePermissionType, orgService: RolePermissionType, locPolicies: RolePermissionType, locAgreements: RolePermissionType, locPackages: RolePermissionType, locServices: RolePermissionType, locDiscounts: RolePermissionType, locSettings: RolePermissionType, locRooms: RolePermissionType, locEmployees: RolePermissionType, locProducts: RolePermissionType, locRequests: RolePermissionType, locTimeclock: RolePermissionType, locDashboard: RolePermissionType, locReports: RolePermissionType, clients: RolePermissionType, calendar: RolePermissionType, catalog: RolePermissionType, checkInQueue: RolePermissionType, personalTimeClock: RolePermissionType, employeeStations: RolePermissionType } | null } | null };

export type GetEmployeePageQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
}>;


export type GetEmployeePageQuery = { __typename?: 'Query', employeePage: { __typename?: 'PaginatedEmployeeResponse', totalRows: number, items: Array<{ __typename?: 'Employee', id: string, isActive: boolean, user: { __typename?: 'User', id: string, firstName: string, middleName: string, lastName: string, email: string, phoneNumber?: string | null, createdDate: any, profilePicUrl?: string | null }, organization: { __typename?: 'Organization', id: string, name: string } }> } };

export type GetEmployeeInfoQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployeeInfoQuery = { __typename?: 'Query', employeeOne?: { __typename?: 'Employee', id: string, staffId?: string | null, pin?: string | null, role?: { __typename?: 'EmployeeRole', id: string, name: string } | null, user: { __typename?: 'User', id: string, firstName: string, middleName: string, lastName: string, email: string, phoneNumber?: string | null, profilePicUrl?: string | null }, locations: Array<{ __typename?: 'Location', id: string, name: string, description?: string | null, logoUrl?: string | null, stationsEnabled?: boolean | null }>, stations: Array<{ __typename?: 'EmployeeStation', id: string, name: string }> } | null };

export type CheckEmployeePinQueryVariables = Exact<{
  pin: Scalars['String'];
}>;


export type CheckEmployeePinQuery = { __typename?: 'Query', checkEmployeePin: boolean };

export type GetEmployeesNameLocQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployeesNameLocQuery = { __typename?: 'Query', employeeMany: Array<{ __typename?: 'Employee', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string }, locations: Array<{ __typename?: 'Location', id: string, name: string, stationsEnabled?: boolean | null }> }> };

export type IsRoleAssignedQueryVariables = Exact<{
  roleId: Scalars['String'];
}>;


export type IsRoleAssignedQuery = { __typename?: 'Query', isRoleAssigned: boolean };

export type GetEmployeeRoleNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeeRoleNamesQuery = { __typename?: 'Query', employeeRoleMany: Array<{ __typename?: 'EmployeeRole', id: string, name: string }> };

export type GetEmployeeRolePageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetEmployeeRolePageQuery = { __typename?: 'Query', employeeRolePage: { __typename?: 'PaginatedEmployeeRoleResponse', totalRows: number, items: Array<{ __typename?: 'EmployeeRole', id: string, name: string, seedId?: string | null }> } };

export type GetEmployeeRoleQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEmployeeRoleQuery = { __typename?: 'Query', employeeRoleOne?: { __typename?: 'EmployeeRole', id: string, name: string, description?: string | null, orgRoles: RolePermissionType, orgPolicies: RolePermissionType, orgAgreements: RolePermissionType, orgPackages: RolePermissionType, orgLocations: RolePermissionType, orgService: RolePermissionType, orgDiscounts: RolePermissionType, orgSettings: RolePermissionType, locPolicies: RolePermissionType, locAgreements: RolePermissionType, locPackages: RolePermissionType, locServices: RolePermissionType, locDiscounts: RolePermissionType, locSettings: RolePermissionType, locRooms: RolePermissionType, locEmployees: RolePermissionType, locProducts: RolePermissionType, locRequests: RolePermissionType, locTimeclock: RolePermissionType, locDashboard: RolePermissionType, locReports: RolePermissionType, clients: RolePermissionType, calendar: RolePermissionType, catalog: RolePermissionType, checkInQueue: RolePermissionType, personalTimeClock: RolePermissionType, employeeStations: RolePermissionType } | null };

export type GetEmployeeRoleNamesPossibleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeeRoleNamesPossibleQuery = { __typename?: 'Query', employeeRolesPossible: Array<{ __typename?: 'EmployeeRole', id: string, name: string }> };

export type GetEmployeesStationNameManyQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployeesStationNameManyQuery = { __typename?: 'Query', employeeStationMany?: Array<{ __typename?: 'EmployeeStation', id: string, name: string }> | null };

export type GetEmployeesStationManyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeesStationManyQuery = { __typename?: 'Query', employeeStationMany?: Array<{ __typename?: 'EmployeeStation', id: string, name: string, description?: string | null, payRate: number, minShift?: number | null, maxShift?: number | null }> | null };

export type GetEmployeeStationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEmployeeStationQuery = { __typename?: 'Query', employeeStationOne?: { __typename?: 'EmployeeStation', id: string, name: string, description?: string | null, payRate: number, minShift?: number | null, maxShift?: number | null } | null };

export type GetEmployeeStationPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetEmployeeStationPageQuery = { __typename?: 'Query', employeeStationPage: { __typename?: 'PaginatedEmployeeStationResponse', totalRows: number, items: Array<{ __typename?: 'EmployeeStation', id: string, name: string, description?: string | null, payRate: number, minShift?: number | null, maxShift?: number | null }> } };

export type InitialChargeOneQueryVariables = Exact<{
  initialChargeOneId: Scalars['String'];
}>;


export type InitialChargeOneQuery = { __typename?: 'Query', initialChargeOne?: { __typename?: 'InitialCharge', id: string, createdDate: any, updatedDate: any, deletedDate?: any | null, cost: number, isDiscountable: boolean, agreement?: { __typename?: 'Agreement', id: string, name: string } | null, package?: { __typename?: 'Package', id: string, name: string } | null, fee?: { __typename?: 'CategoryOption', id: string, name: string } | null, revenue?: { __typename?: 'CategoryOption', name: string, id: string } | null } | null };

export type GetLocationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLocationQuery = { __typename?: 'Query', locationOne?: { __typename?: 'Location', address?: string | null, city?: string | null, createdDate: any, id: string, description?: string | null, stationsEnabled?: boolean | null, notificationSenderNumber?: string | null, transactionProcessTime: string, logoUrl?: string | null, name: string, zip?: string | null, timezone: string, state?: string | null, passportLocCode?: number | null, locationServices: Array<{ __typename?: 'LocationService', id: string, organizationService: { __typename?: 'OrganizationService', name: string } }>, organization: { __typename?: 'Organization', id: string, name: string }, primaryContact?: { __typename?: 'ContactInfo', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null } | null };

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = { __typename?: 'Query', locationMany: Array<{ __typename?: 'Location', id: string, name: string }> };

export type GetLocationPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetLocationPageQuery = { __typename?: 'Query', locationPage: { __typename?: 'PaginatedLocationResponse', totalRows: number, items: Array<{ __typename?: 'Location', id: string, name: string, logoUrl?: string | null, address?: string | null, createdDate: any }> } };

export type GetLocationDetailCalendarQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLocationDetailCalendarQuery = { __typename?: 'Query', locationOne?: { __typename?: 'Location', id: string, employees: Array<{ __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string } }>, rooms: Array<{ __typename?: 'Room', id: string, name: string }>, locationServices: Array<{ __typename?: 'LocationService', id: string, organizationService: { __typename?: 'OrganizationService', name: string } }> } | null };

export type GetLocationRevenueQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLocationRevenueQuery = { __typename?: 'Query', locationOne?: { __typename?: 'Location', id: string, locationRevenue?: { __typename?: 'LocationRevenue', id: string, payrocAccount?: { __typename?: 'PayrocAccount', id: string, merchantId?: string | null, payrocVirtualTerminalId?: string | null, payrocEmbeddedSecret?: string | null } | null } | null } | null };

export type GetLocationRoomsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationRoomsQuery = { __typename?: 'Query', locationMany: Array<{ __typename?: 'Location', id: string, name: string, rooms: Array<{ __typename?: 'Room', id: string, name: string }> }> };

export type GetLocationMonthlyFeesQueryVariables = Exact<{
  locationRevenueId?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationMonthlyFeesQuery = { __typename?: 'Query', locationMonthlyFeeMany: Array<{ __typename?: 'LocationMonthlyFee', name: string, amount: number, id: string }> };

export type LocationOfferingManyQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
  isPromoCode?: InputMaybe<Scalars['Boolean']>;
}>;


export type LocationOfferingManyQuery = { __typename?: 'Query', locationOfferingMany?: Array<{ __typename?: 'LocationOffering', header: string, details: Array<string>, id: string, isActive: boolean, promoCode?: string | null, name?: string | null, subtext?: string | null, location: { __typename?: 'Location', name: string, organization: { __typename?: 'Organization', id: string } }, agreement: { __typename?: 'Agreement', name: string } }> | null };

export type LocationOfferingOneQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type LocationOfferingOneQuery = { __typename?: 'Query', locationOfferingOne?: { __typename?: 'LocationOffering', location: { __typename?: 'Location', id: string }, agreement: { __typename?: 'Agreement', id: string, name: string, description?: string | null, locations?: Array<{ __typename?: 'Location', id: string, name: string, address?: string | null, primaryContact?: { __typename?: 'ContactInfo', phoneNumber?: string | null } | null }> | null, recurringCharges: Array<{ __typename?: 'RecurringCharge', id: string, name?: string | null, cost: number }>, initialCharges: Array<{ __typename?: 'InitialCharge', id: string, cost: number, revenue?: { __typename?: 'CategoryOption', name: string } | null }>, additionalPolicies: Array<{ __typename?: 'Policy', id: string, name: string }> } } | null };

export type GetLocationOfferingListQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
  isPromoCode?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetLocationOfferingListQuery = { __typename?: 'Query', locationOfferingMany?: Array<{ __typename?: 'LocationOffering', id: string, isActive: boolean, name?: string | null, agreement: { __typename?: 'Agreement', id: string, name: string } }> | null };

export type GetLocationOfferingDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLocationOfferingDetailQuery = { __typename?: 'Query', locationOfferingOne?: { __typename?: 'LocationOffering', header: string, details: Array<string>, name?: string | null, subtext?: string | null, promoCode?: string | null, agreement: { __typename?: 'Agreement', id: string } } | null };

export type LocationOfferingByPromoCodeQueryVariables = Exact<{
  promoCode: Scalars['String'];
}>;


export type LocationOfferingByPromoCodeQuery = { __typename?: 'Query', locationOfferingByPromoCode?: Array<{ __typename?: 'LocationOffering', header: string, details: Array<string>, id: string, isActive: boolean, promoCode?: string | null, name?: string | null, subtext?: string | null, location: { __typename?: 'Location', name: string, organization: { __typename?: 'Organization', id: string } }, agreement: { __typename?: 'Agreement', name: string } }> | null };

export type GetRevenueByLocationQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetRevenueByLocationQuery = { __typename?: 'Query', locationRevenueByLocation: { __typename?: 'LocationRevenue', id: string, payrocAccount?: { __typename?: 'PayrocAccount', id: string, merchantId?: string | null, payrocVirtualTerminalId?: string | null, payrocEmbeddedSecret?: string | null } | null } };

export type GetLocationTaxRatesQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationTaxRatesQuery = { __typename?: 'Query', locationTaxRateMany: Array<{ __typename?: 'LocationTaxRate', taxRate: number, id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', id: string, name: string } }> };

export type GetLocationTaxRateNamesQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationTaxRateNamesQuery = { __typename?: 'Query', locationTaxRateMany: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', name: string } }> };

export type GetLocationTransactionFeesQueryVariables = Exact<{
  locationRevenueId?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationTransactionFeesQuery = { __typename?: 'Query', locationTransactionFeeMany: Array<{ __typename?: 'LocationTransactionFee', percentage: number, type: TransactionFeeType, flatRate: number, id: string }> };

export type GetMeetingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMeetingQuery = { __typename?: 'Query', meetingOne?: { __typename?: 'Meeting', id: string, imgUrl?: string | null, name: string, duration: number, isSelfEnroll: boolean, description?: string | null, waitlistMax?: number | null, isWaitlistEnabled: boolean, maxOccupancy?: number | null, startAt: any, endAt: any, isPrivateSession: boolean, series?: { __typename?: 'MeetingSeries', id: string, dows: Array<number>, doms: Array<number>, seriesInterval: SeriesInterval, scheduleTo: any, scheduleFrom: any } | null, session?: { __typename?: 'PrivateSession', id: string, name: string } | null, privateSession?: { __typename?: 'PrivateSessionDuration', id: string, duration: number } | null, attendees?: Array<{ __typename?: 'Attendee', id: string, client: { __typename?: 'Client', user: { __typename?: 'User', firstName: string, lastName: string } } }> | null, service?: { __typename?: 'LocationService', id: string, organizationService: { __typename?: 'OrganizationService', name: string } } | null, instructor?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } | null, room?: { __typename?: 'Room', id: string, name: string } | null, location: { __typename?: 'Location', id: string, name: string }, attendances: Array<{ __typename?: 'Attendance', id: string, attendanceStatus: AttendanceStatus, isPaid: boolean, attendee: { __typename?: 'Attendee', id: string, attendeeType: AttendeeType, client: { __typename?: 'Client', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } } }>, waitlistees: Array<{ __typename?: 'Waitlistee', id: string, client: { __typename?: 'Client', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } }> } | null };

export type GetMeetingsQueryVariables = Exact<{
  locationId: Scalars['String'];
  endAt?: InputMaybe<Scalars['DateTime']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetMeetingsQuery = { __typename?: 'Query', meetingMany: Array<{ __typename?: 'Meeting', id: string, name: string, startAt: any, endAt: any, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'LocationService', id: string } | null, instructor?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } | null }> };

export type GetCalendarFilterLocQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetCalendarFilterLocQuery = { __typename?: 'Query', calendarFilterLocation?: { __typename?: 'CalendarFilters', id: string, services?: Array<{ __typename?: 'LocationService', id: string }> | null, location: { __typename?: 'Location', id: string, name: string }, instructors?: Array<{ __typename?: 'Employee', id: string }> | null, rooms?: Array<{ __typename?: 'Room', id: string }> | null } | null };

export type GetEventDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEventDetailQuery = { __typename?: 'Query', meetingOne?: { __typename?: 'Meeting', id: string, name: string, isSelfEnroll: boolean, description?: string | null, waitlistMax?: number | null, isWaitlistEnabled: boolean, maxOccupancy?: number | null, startAt: any, endAt: any, instructor?: { __typename?: 'Employee', user: { __typename?: 'User', profilePicUrl?: string | null, firstName: string, lastName: string } } | null, room?: { __typename?: 'Room', name: string } | null, location: { __typename?: 'Location', name: string }, attendees?: Array<{ __typename?: 'Attendee', id: string }> | null, waitlistees: Array<{ __typename?: 'Waitlistee', id: string }>, service?: { __typename?: 'LocationService', id: string, imgUrl?: string | null, cost: number, organizationService: { __typename?: 'OrganizationService', name: string }, product?: { __typename?: 'Product', id: string } | null, location: { __typename?: 'Location', id: string } } | null, privateSession?: { __typename?: 'PrivateSessionDuration', id: string, cost: number, session: { __typename?: 'PrivateSession', imageUrl?: string | null, name: string }, product?: { __typename?: 'Product', id: string, isTaxable: boolean, taxRates?: Array<{ __typename?: 'LocationTaxRate', id: string, taxRate: number }> | null } | null } | null } | null };

export type GetMeetingPageQueryVariables = Exact<{
  pagination: PaginationInput;
  startAt?: InputMaybe<Scalars['DateTime']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetMeetingPageQuery = { __typename?: 'Query', meetingPage: { __typename?: 'PaginatedMeetingResponse', totalRows: number, items: Array<{ __typename?: 'Meeting', maxOccupancy?: number | null, startAt: any, id: string, name: string, imgUrl?: string | null, attendees?: Array<{ __typename?: 'Attendee', id: string }> | null }> } };

export type GetMeetingSeriesDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMeetingSeriesDetailsQuery = { __typename?: 'Query', meetingSeriesOne?: { __typename?: 'MeetingSeries', id: string, name: string, description?: string | null, duration: number, startAt: any, endAt: any, isSelfEnroll: boolean, isWaitlistEnabled: boolean, isPrivateSession: boolean, seriesInterval: SeriesInterval, maxOccupancy: number, waitlistMax?: number | null, scheduleFrom: any, scheduleTo: any, dows: Array<number>, doms: Array<number>, room?: { __typename?: 'Room', id: string, name: string } | null, session?: { __typename?: 'PrivateSession', id: string, name: string } | null, privateSession?: { __typename?: 'PrivateSessionDuration', id: string, duration: number } | null, attendees?: Array<{ __typename?: 'Attendee', id: string, client: { __typename?: 'Client', user: { __typename?: 'User', firstName: string, lastName: string } } }> | null, service?: { __typename?: 'LocationService', id: string } | null, instructor?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } | null, location: { __typename?: 'Location', id: string, name: string } } | null };

export type GetMeetingSeriesPageQueryVariables = Exact<{
  pagination: PaginationInput;
  locationId: Scalars['String'];
  startAt?: InputMaybe<Scalars['DateTime']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetMeetingSeriesPageQuery = { __typename?: 'Query', meetingSeriesPage: { __typename?: 'PaginatedMeetingSeriesResponse', totalRows: number, items: Array<{ __typename?: 'MeetingSeries', id: string, name: string, description?: string | null, startAt: any, endAt: any, scheduleFrom: any, scheduleTo: any, dows: Array<number>, doms: Array<number>, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'LocationService', id: string } | null, instructor?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } | null, location: { __typename?: 'Location', id: string, name: string } }> } };

export type GetNotesQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']>;
}>;


export type GetNotesQuery = { __typename?: 'Query', notesMany: Array<{ __typename?: 'Notes', id: string, content: string, isMigrated: boolean, updatedDate: any, author?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, profilePicUrl?: string | null } } | null }> };

export type NotesSampleCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type NotesSampleCsvQuery = { __typename?: 'Query', notesSampleCSV: string };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organizationOne?: { __typename?: 'Organization', id: string, name: string, description?: string | null, logoUrl?: string | null, street?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, state?: string | null, categoryOptions: Array<{ __typename?: 'CategoryOption', id: string, name: string, type: CategoryOptionType, isActive: boolean }>, locations: Array<{ __typename?: 'Location', id: string, name: string, description?: string | null, logoUrl?: string | null, stationsEnabled?: boolean | null }>, organizationBranding?: { __typename?: 'OrganizationBranding', brandingLogoImg?: string | null, id: string, primaryColor?: string | null, secondaryColor?: string | null } | null } | null };

export type GetOrganizationPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetOrganizationPageQuery = { __typename?: 'Query', organizationPage: { __typename?: 'PaginatedOrganizationResponse', totalRows: number, items: Array<{ __typename?: 'Organization', id: string, name: string, description?: string | null, logoUrl?: string | null, createdDate: any }> } };

export type GetOrganizationRevenueFeeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrganizationRevenueFeeQuery = { __typename?: 'Query', organizationOne?: { __typename?: 'Organization', id: string, locations: Array<{ __typename?: 'Location', id: string, name: string, logoUrl?: string | null, locationRevenue?: { __typename?: 'LocationRevenue', id: string, payrocAccount?: { __typename?: 'PayrocAccount', id: string, merchantId?: string | null, payrocVirtualTerminalId?: string | null, payrocEmbeddedSecret?: string | null } | null } | null }> } | null };

export type GetOrganizationBrandingQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationBrandingQuery = { __typename?: 'Query', organizationBrandingOne: { __typename?: 'OrganizationBranding', brandingLogoImg?: string | null, id: string, primaryColor?: string | null, secondaryColor?: string | null } };

export type GetOrganizationSettingsQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetOrganizationSettingsQuery = { __typename?: 'Query', organizationSettingsOne?: { __typename?: 'OrganizationSettings', id: string, freezeExtendsTerm?: boolean | null, seriesGenInterval: SeriesGenInterval, seriesGenRange: number } | null };

export type GetOrganizationTaxRatesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationTaxRatesQuery = { __typename?: 'Query', organizationTaxRateMany: Array<{ __typename?: 'OrganizationTaxRate', name: string, taxRate?: number | null, id: string }> };

export type GetPackageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPackageQuery = { __typename?: 'Query', packageOne: { __typename?: 'Package', name: string, description?: string | null, isOrg: boolean, isGeneric: boolean, locations?: Array<{ __typename?: 'Location', id: string, name: string }> | null, additionalPolicies: Array<{ __typename?: 'Policy', id: string, name: string }>, initialCharges?: Array<{ __typename?: 'InitialCharge', id: string, cost: number, isTaxable: boolean, isPostTax: boolean, isDiscountable: boolean, taxRates: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', name: string } }>, revenue?: { __typename?: 'CategoryOption', id: string, name: string } | null, fee?: { __typename?: 'CategoryOption', id: string, name: string } | null }> | null, initialAllotments?: Array<{ __typename?: 'ServiceAllotment', id: string, name: string, credits: number }> | null, product?: { __typename?: 'Product', id: string, imgUrl?: string | null, isActive: boolean, tags: Array<{ __typename?: 'CategoryOption', id: string, name: string }>, revenue?: { __typename?: 'CategoryOption', id: string, name: string } | null } | null } };

export type GetPackagePageQueryVariables = Exact<{
  pagination: PaginationInput;
  locationIds?: InputMaybe<Array<GenericConnectInput> | GenericConnectInput>;
}>;


export type GetPackagePageQuery = { __typename?: 'Query', PackagePage: { __typename?: 'PaginatedPackageResponse', totalRows: number, items: Array<{ __typename?: 'Package', id: string, name: string, description?: string | null, createdDate: any, isActive: boolean, isOrg: boolean }> } };

export type GetTerminalsByLocationQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type GetTerminalsByLocationQuery = { __typename?: 'Query', paymentTerminalMany: Array<{ __typename?: 'PaymentTerminal', id: string, externalId: string, physicalId?: string | null, name: string, location: { __typename?: 'Location', id: string } }> };

export type GetPolicyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPolicyQuery = { __typename?: 'Query', policyOne: { __typename?: 'Policy', name: string, isPdf: boolean, fileUrl?: string | null, data?: string | null, documentId?: string | null } };

export type GetPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPoliciesQuery = { __typename?: 'Query', policyMany: Array<{ __typename?: 'Policy', id: string, name: string }> };

export type GetPolicyPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetPolicyPageQuery = { __typename?: 'Query', policyPage: { __typename?: 'PaginatedPolicyResponse', totalRows: number, items: Array<{ __typename?: 'Policy', id: string, name: string, createdDate: any, fileUrl?: string | null, data?: string | null, isActive: boolean }> } };

export type GetEditorLinkQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEditorLinkQuery = { __typename?: 'Query', getEditorLink: string };

export type GetPrivateSessionPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetPrivateSessionPageQuery = { __typename?: 'Query', privateSessionPage: { __typename?: 'PaginatedPrivateSessionResponse', totalRows: number, items: Array<{ __typename?: 'PrivateSession', id: string, name: string, minDuration?: number | null, maxDuration?: number | null, isActive: boolean, serviceType: { __typename?: 'CategoryOption', name: string }, revenueCategory: { __typename?: 'CategoryOption', name: string } }> } };

export type GetPrivateSessionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPrivateSessionQuery = { __typename?: 'Query', privateSessionOne?: { __typename?: 'PrivateSession', id: string, name: string, description?: string | null, intervalDuration: number, isTaxable: boolean, isPostTax: boolean, isOrg: boolean, isRoomRequired: boolean, isEmployeeRequired: boolean, minDuration?: number | null, maxDuration?: number | null, imageUrl?: string | null, serviceType: { __typename?: 'CategoryOption', id: string, name: string }, revenueCategory: { __typename?: 'CategoryOption', id: string, name: string }, organization: { __typename?: 'Organization', id: string }, policies: Array<{ __typename?: 'Policy', id: string, name: string }>, rooms: Array<{ __typename?: 'PrivateSessionLocationRooms', id: string, location: { __typename?: 'Location', id: string, name: string }, taxRates: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', name: string } }> }>, durations: Array<{ __typename?: 'PrivateSessionDuration', id: string, duration: number }>, overrides: Array<{ __typename?: 'PrivateSessionOverride', id: string, employee: { __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string }, locations: Array<{ __typename?: 'Location', id: string }> } }> } | null };

export type GetPrivateSessionsDetailQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type GetPrivateSessionsDetailQuery = { __typename?: 'Query', privateSessionMany?: Array<{ __typename?: 'PrivateSession', id: string, name: string, isRoomRequired: boolean, isEmployeeRequired: boolean, minDuration?: number | null, maxDuration?: number | null, durations: Array<{ __typename?: 'PrivateSessionDuration', id: string, duration: number }>, rooms: Array<{ __typename?: 'PrivateSessionLocationRooms', rooms: Array<{ __typename?: 'Room', id: string, name: string, totalCapacity: number }> }>, overrides: Array<{ __typename?: 'PrivateSessionOverride', minDuration?: number | null, maxDuration?: number | null, employee: { __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } }> }> | null };

export type GetPrivateSessionDurationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPrivateSessionDurationQuery = { __typename?: 'Query', privateSessionDurationOne: { __typename?: 'PrivateSessionDuration', duration: number, cost: number, session: { __typename?: 'PrivateSession', id: string } } };

export type GetPrivateSessionDurationsNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrivateSessionDurationsNameQuery = { __typename?: 'Query', privateSessionDurationMany: Array<{ __typename?: 'PrivateSessionDuration', duration: number, id: string, session: { __typename?: 'PrivateSession', name: string } }> };

export type GetPrivateSessionLocationRoomsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPrivateSessionLocationRoomsQuery = { __typename?: 'Query', privateSessionLocationRoomsOne?: { __typename?: 'PrivateSessionLocationRooms', rooms: Array<{ __typename?: 'Room', id: string, name: string }>, session: { __typename?: 'PrivateSession', id: string }, location: { __typename?: 'Location', id: string, name: string }, taxRates: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', name: string } }> } | null };

export type GetPrivateSessionOverrideQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPrivateSessionOverrideQuery = { __typename?: 'Query', privateSessionOverrideOne?: { __typename?: 'PrivateSessionOverride', id: string, name?: string | null, description?: string | null, commission: number, isPercent: boolean, minDuration?: number | null, maxDuration?: number | null, employee: { __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string } }, session: { __typename?: 'PrivateSession', id: string }, locations: Array<{ __typename?: 'Location', id: string, name: string }> } | null };

export type GetProductQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProductQuery = { __typename?: 'Query', productOne: { __typename?: 'Product', name: string, cost: number, description?: string | null, isActive: boolean, isCommissionable: boolean, isCommissionPercent: boolean, commissionValue?: number | null, isTaxable: boolean, isPostTax: boolean, stock: number, imgUrl?: string | null, barcode?: string | null, sku?: string | null, metricValues: Array<{ __typename?: 'VariantValue', id: string, name: string, metric?: { __typename?: 'VariantMetric', name: string, id: string } | null }>, tags: Array<{ __typename?: 'CategoryOption', id: string, name: string }>, revenue?: { __typename?: 'CategoryOption', id: string, name: string } | null, taxRates?: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', name: string } }> | null } };

export type ProductPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type ProductPageQuery = { __typename?: 'Query', productPage: { __typename?: 'PaginatedProductResponse', totalRows: number, items: Array<{ __typename?: 'Product', id: string, name: string, cost: number, sku?: string | null, barcode?: string | null, description?: string | null, imgUrl?: string | null, location?: { __typename?: 'Location', id: string, name: string } | null }> } };

export type GetProductGroupQueryVariables = Exact<{
  productGroupOneId: Scalars['String'];
}>;


export type GetProductGroupQuery = { __typename?: 'Query', productGroupOne: { __typename?: 'ProductGroup', name: string, description?: string | null, imgUrl?: string | null, location: { __typename?: 'Location', id: string }, revenueCategory?: { __typename?: 'CategoryOption', id: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, name: string, stock: number, imgUrl?: string | null, metricValues: Array<{ __typename?: 'VariantValue', id: string }> }>, metrics?: Array<{ __typename?: 'VariantMetric', id: string, name: string, values?: Array<{ __typename?: 'VariantValue', id: string, name: string }> | null }> | null } };

export type GetProductGroupPageQueryVariables = Exact<{
  pagination: PaginationInput;
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type GetProductGroupPageQuery = { __typename?: 'Query', productGroupPage: { __typename?: 'PaginatedProductGroupResponse', totalRows: number, items: Array<{ __typename?: 'ProductGroup', id: string, name: string, description?: string | null, imgUrl?: string | null, createdDate: any }> } };

export type GetProductGroupPageDetailQueryVariables = Exact<{
  pagination: PaginationInput;
  locationId?: InputMaybe<Scalars['String']>;
  getByProductsCount?: InputMaybe<Scalars['Boolean']>;
  includeVirtual?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProductGroupPageDetailQuery = { __typename?: 'Query', productGroupPage: { __typename?: 'PaginatedProductGroupResponse', totalRows: number, items: Array<{ __typename?: 'ProductGroup', id: string, name: string, description?: string | null, imgUrl?: string | null, createdDate: any, products: Array<{ __typename?: 'Product', id: string, name: string, cost: number, stock: number, imgUrl?: string | null, description?: string | null, isTaxable: boolean, isPostTax: boolean, isActive: boolean, taxRates?: Array<{ __typename?: 'LocationTaxRate', taxRate: number, organizationTaxRate: { __typename?: 'OrganizationTaxRate', name: string } }> | null, productGroup: { __typename?: 'ProductGroup', id: string }, metricValues: Array<{ __typename?: 'VariantValue', id: string }> }>, metrics?: Array<{ __typename?: 'VariantMetric', id: string, name: string, values?: Array<{ __typename?: 'VariantValue', id: string, name: string }> | null }> | null }> } };

export type GetRecurringChargeOneQueryVariables = Exact<{
  recurringChargeOneId: Scalars['String'];
}>;


export type GetRecurringChargeOneQuery = { __typename?: 'Query', recurringChargeOne?: { __typename?: 'RecurringCharge', id: string, cost: number, name?: string | null, isTaxable: boolean, isPostTax: boolean, taxRates: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', name: string } }>, categoryOption: { __typename?: 'CategoryOption', id: string, name: string } } | null };

export type PaymentRecordSampleCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentRecordSampleCsvQuery = { __typename?: 'Query', paymentRecordSampleCSV: string };

export type RoomManyQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type RoomManyQuery = { __typename?: 'Query', roomMany: Array<{ __typename?: 'Room', id: string, name: string, totalCapacity: number, description?: string | null, services: Array<{ __typename?: 'LocationService', id: string, imgUrl?: string | null, organizationService: { __typename?: 'OrganizationService', id: string, name: string } }> }> };

export type RoomPageQueryVariables = Exact<{
  pagination: PaginationInput;
  activeLocationId?: InputMaybe<Scalars['String']>;
}>;


export type RoomPageQuery = { __typename?: 'Query', roomPage: { __typename?: 'PaginatedRoomResponse', totalRows: number, items: Array<{ __typename?: 'Room', createdDate: any, id: string, name: string, description?: string | null, totalCapacity: number, isActive: boolean, location: { __typename?: 'Location', id: string, logoUrl?: string | null, name: string }, services: Array<{ __typename?: 'LocationService', id: string, organizationService: { __typename?: 'OrganizationService', name: string } }> }> } };

export type GetRoomNamesQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetRoomNamesQuery = { __typename?: 'Query', roomMany: Array<{ __typename?: 'Room', id: string, name: string }> };

export type ScheduledChargesOneQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ScheduledChargesOneQuery = { __typename?: 'Query', scheduledChargesOne: { __typename?: 'ScheduledCharges', id: string, cost: number, isTaxable: boolean, isPostTax: boolean, subscription?: { __typename?: 'ClientSubscription', id: string } | null, taxRates?: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', id: string, name: string } }> | null, revenueCategory: { __typename?: 'CategoryOption', id: string, name: string } } };

export type ScheduledChargesByTransactionIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ScheduledChargesByTransactionIdQuery = { __typename?: 'Query', scheduledChargesByTransactionId: Array<{ __typename?: 'ScheduledCharges', id: string, name: string, cost: number, isTaxable: boolean, isPostTax: boolean, taxRates?: Array<{ __typename?: 'LocationTaxRate', id: string, organizationTaxRate: { __typename?: 'OrganizationTaxRate', id: string, name: string } }> | null, revenueCategory: { __typename?: 'CategoryOption', id: string, name: string } }> };

export type ScheduledTransactionsByClientIdQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type ScheduledTransactionsByClientIdQuery = { __typename?: 'Query', scheduledTransactionsByClientId?: Array<{ __typename?: 'ScheduledTransaction', id: string, processAt: any, location: { __typename?: 'Location', id: string, name: string }, charges?: Array<{ __typename?: 'ScheduledCharges', id: string, name: string, cost: number }> | null, transaction?: { __typename?: 'Transaction', paymentMethod?: { __typename?: 'ClientPaymentMethods', mask?: string | null, merchant?: string | null, type: PaymentMethodType } | null } | null }> | null };

export type GetSendgridTemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSendgridTemplateQuery = { __typename?: 'Query', sendgridTemplateOne?: { __typename?: 'SendgridTemplate', id: string, name: string, type: TemplateType, description?: string | null, isActive: boolean, trigger_?: TriggerListType | null, fromEmail?: string | null, fromName?: string | null, subjectLine?: string | null, location: { __typename?: 'Location', id: string, name: string }, organization: { __typename?: 'Organization', id: string, name: string }, dynamicFields?: Array<{ __typename?: 'SendgridDynamicField', id: string, field: string, keyword: string, entity: string, type: DynamicFieldType, isDefault?: boolean | null }> | null } | null };

export type GetSendgridTemplateManyQueryVariables = Exact<{
  id: Scalars['String'];
  includeAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSendgridTemplateManyQuery = { __typename?: 'Query', sendgridTemplateMany?: Array<{ __typename?: 'SendgridTemplate', id: string, name: string, type: TemplateType, isActive: boolean, trigger_?: TriggerListType | null }> | null };

export type GetSendgridDynamicFieldManyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSendgridDynamicFieldManyQuery = { __typename?: 'Query', sendgridDynamicFieldMany?: Array<{ __typename?: 'SendgridDynamicField', keyword: string, triggers: Array<TriggerListType> }> | null };

export type GetOrganizationServiceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrganizationServiceQuery = { __typename?: 'Query', organizationServiceOne?: { __typename?: 'OrganizationService', description?: string | null, duration: number, isIndivdual: boolean, isSelfEnroll: boolean, isWaitlistEnabled: boolean, name: string, waitlistMax: number, imgUrl?: string | null, serviceType?: { __typename?: 'CategoryOption', id: string, name: string } | null, policies: Array<{ __typename?: 'Policy', id: string, name: string }>, revenueCategory?: { __typename?: 'CategoryOption', id: string, name: string } | null, locationServices: Array<{ __typename?: 'LocationService', id: string, cost: number, isPrepay: boolean, isActive: boolean, description?: string | null, imgUrl?: string | null, location: { __typename?: 'Location', id: string, name: string }, rooms: Array<{ __typename?: 'Room', id: string, name: string }> }> } | null };

export type GetOrganizationServicesQueryVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type GetOrganizationServicesQuery = { __typename?: 'Query', organizationServiceMany: Array<{ __typename?: 'OrganizationService', id: string, name: string }> };

export type GetOrganizationServicePageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetOrganizationServicePageQuery = { __typename?: 'Query', organizationServicePage: { __typename?: 'PaginatedOrganizationServiceResponse', totalRows: number, items: Array<{ __typename?: 'OrganizationService', id: string, name: string, createdDate: any, duration: number, imgUrl?: string | null, serviceType?: { __typename?: 'CategoryOption', name: string } | null, revenueCategory?: { __typename?: 'CategoryOption', name: string } | null, locationServices: Array<{ __typename?: 'LocationService', id: string, location: { __typename?: 'Location', id: string } }> }> } };

export type GetLocationServicesQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetLocationServicesQuery = { __typename?: 'Query', locationServiceMany: Array<{ __typename?: 'LocationService', id: string, rooms: Array<{ __typename?: 'Room', id: string, name: string, totalCapacity: number }>, organizationService: { __typename?: 'OrganizationService', imgUrl?: string | null, waitlistMax: number, duration: number, description?: string | null, name: string, isWaitlistEnabled: boolean, isSelfEnroll: boolean } }> };

export type GetLocationServiceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLocationServiceQuery = { __typename?: 'Query', locationServiceOne?: { __typename?: 'LocationService', id: string, rooms: Array<{ __typename?: 'Room', id: string, name: string, totalCapacity: number }>, location: { __typename?: 'Location', id: string, name: string, employees: Array<{ __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string } }>, meetings: Array<{ __typename?: 'Meeting', id: string, startAt: any, endAt: any, duration: number, room?: { __typename?: 'Room', id: string } | null, instructor?: { __typename?: 'Employee', id: string } | null, location: { __typename?: 'Location', id: string } }> }, organizationService: { __typename?: 'OrganizationService', imgUrl?: string | null, waitlistMax: number, duration: number, description?: string | null, name: string, isWaitlistEnabled: boolean, isSelfEnroll: boolean } } | null };

export type GetLocationServicesNameQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetLocationServicesNameQuery = { __typename?: 'Query', locationServiceMany: Array<{ __typename?: 'LocationService', id: string, organizationService: { __typename?: 'OrganizationService', name: string } }> };

export type GetLocationServicesNameGroupQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetLocationServicesNameGroupQuery = { __typename?: 'Query', locationServiceMany: Array<{ __typename?: 'LocationService', id: string, organizationService: { __typename?: 'OrganizationService', name: string, isIndivdual: boolean } }> };

export type GetLocationServiceDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLocationServiceDetailQuery = { __typename?: 'Query', locationServiceOne?: { __typename?: 'LocationService', id: string, imgUrl?: string | null, description?: string | null, isPrepay: boolean, isActive: boolean, cost: number, rooms: Array<{ __typename?: 'Room', id: string, name: string }>, organizationService: { __typename?: 'OrganizationService', id: string, duration: number, name: string, isSelfEnroll: boolean, waitlistMax: number, revenueCategory?: { __typename?: 'CategoryOption', id: string, name: string } | null, serviceType?: { __typename?: 'CategoryOption', id: string, name: string } | null, policies: Array<{ __typename?: 'Policy', id: string, name: string }> } } | null };

export type GetServiceAllotmentQueryVariables = Exact<{
  serviceAllotmentOneId: Scalars['String'];
}>;


export type GetServiceAllotmentQuery = { __typename?: 'Query', serviceAllotmentOne: { __typename?: 'ServiceAllotment', credits: number, dailyLimit: number, description?: string | null, serviceFrequency: ServiceFrequency, id: string, name: string, startAt?: any | null, startMode: StartMode, expiration: { __typename?: 'Expiration', id: string, isExpired: boolean, expiresAt?: any | null, expirationMode: ExpirationMode, unit: Unit, value?: number | null }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, services?: Array<{ __typename?: 'OrganizationService', id: string, name: string }> | null, privateSessions: Array<{ __typename?: 'PrivateSessionDuration', id: string, duration: number }> } };

export type ServiceAllotmentManyQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceAllotmentManyQuery = { __typename?: 'Query', serviceAllotmentMany: Array<{ __typename?: 'ServiceAllotment', createdDate: any, credits: number, dailyLimit: number, description?: string | null, id: string, name: string, startAt?: any | null, version?: number | null, viid?: number | null, startMode: StartMode, agreement?: { __typename?: 'Agreement', id: string, name: string } | null, expiration: { __typename?: 'Expiration', id: string, isExpired: boolean, expiresAt?: any | null, expirationMode: ExpirationMode, unit: Unit, value?: number | null }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, package?: { __typename?: 'Package', id: string, name: string } | null, services?: Array<{ __typename?: 'OrganizationService', id: string, name: string }> | null }> };

export type GetShoppingCartQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetShoppingCartQuery = { __typename?: 'Query', shoppingCartOne: { __typename?: 'ShoppingCart', id: string, subtotal?: number | null, discount?: number | null, tax?: number | null, total?: number | null, discounts?: string | null, taxes?: string | null, products?: string | null, lineItems: Array<{ __typename?: 'CheckoutLineItem', id: string, count?: number | null, subtotal?: number | null, discount?: number | null, discounts?: string | null, product?: { __typename?: 'Product', id: string, name: string } | null }> } };

export type GetSignedAgreementsQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type GetSignedAgreementsQuery = { __typename?: 'Query', signedAgreementMany: Array<{ __typename?: 'SignedAgreement', id: string, termStart?: any | null, termEnd?: any | null, status: SignedAgreementStatus, agreement: { __typename?: 'Agreement', id: string, name: string, isOrg: boolean, isAutoRenew: boolean, description?: string | null, isMembership: boolean, termValue: number, Unit: Unit, postponeUntil?: any | null, paymentFrequency: PaymentFrequency, draftMode: DraftMode, additionalPolicies: Array<{ __typename?: 'Policy', name: string }>, initialCharges: Array<{ __typename?: 'InitialCharge', id: string, cost: number }>, recurringCharges: Array<{ __typename?: 'RecurringCharge', id: string, name?: string | null, cost: number, categoryOption: { __typename?: 'CategoryOption', name: string } }> }, subscription: { __typename?: 'ClientSubscription', id: string, subscriptionStatus?: SubscriptionStatus | null, nextDraftDate?: any | null, paymentStatus: PaymentStatus, paymentFrequency: PaymentFrequency, recurringCharges: Array<{ __typename?: 'RecurringCharge', id: string, name?: string | null, cost: number, categoryOption: { __typename?: 'CategoryOption', id: string, name: string } }>, scheduledTransaction?: Array<{ __typename?: 'ScheduledTransaction', id: string, processAt: any, location: { __typename?: 'Location', id: string, name: string }, charges?: Array<{ __typename?: 'ScheduledCharges', id: string, name: string, cost: number }> | null }> | null }, location: { __typename?: 'Location', id: string, name: string }, paymentMethod?: { __typename?: 'ClientPaymentMethods', id: string, mask?: string | null, expiresAt?: any | null, merchant?: string | null, type: PaymentMethodType } | null }> };

export type GetSignedAgreementQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSignedAgreementQuery = { __typename?: 'Query', signedAgreementOne?: { __typename?: 'SignedAgreement', id: string, termStart?: any | null, termEnd?: any | null, status: SignedAgreementStatus, agreement: { __typename?: 'Agreement', id: string, name: string, isAutoRenew: boolean, description?: string | null, isMembership: boolean, termValue: number, Unit: Unit, postponeUntil?: any | null, paymentFrequency: PaymentFrequency, draftMode: DraftMode, additionalPolicies: Array<{ __typename?: 'Policy', name: string }>, initialCharges: Array<{ __typename?: 'InitialCharge', id: string, cost: number }> }, subscription: { __typename?: 'ClientSubscription', id: string, subscriptionStatus?: SubscriptionStatus | null, nextDraftDate?: any | null, paymentStatus: PaymentStatus, paymentFrequency: PaymentFrequency, recurringCharges: Array<{ __typename?: 'RecurringCharge', id: string, name?: string | null, cost: number, categoryOption: { __typename?: 'CategoryOption', id: string, name: string } }> }, paymentMethod?: { __typename?: 'ClientPaymentMethods', id: string, mask?: string | null, expiresAt?: any | null, merchant?: string | null, type: PaymentMethodType } | null } | null };

export type GetSignedAgreementCheckoutQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSignedAgreementCheckoutQuery = { __typename?: 'Query', signedAgreementOne?: { __typename?: 'SignedAgreement', id: string, agreement: { __typename?: 'Agreement', id: string, name: string, initialCharges: Array<{ __typename?: 'InitialCharge', id: string, cost: number }>, recurringCharges: Array<{ __typename?: 'RecurringCharge', id: string, cost: number }> } } | null };

export type CheckForSignedAgreementQueryVariables = Exact<{
  clientId: Scalars['String'];
  locationId: Scalars['String'];
  agreementId: Scalars['String'];
}>;


export type CheckForSignedAgreementQuery = { __typename?: 'Query', checkForSignedAgreement?: { __typename?: 'SignedAgreement', id: string } | null };

export type GetSignedAgreementDocumentsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSignedAgreementDocumentsQuery = { __typename?: 'Query', signedAgreementOne?: { __typename?: 'SignedAgreement', id: string, status: SignedAgreementStatus, signedDocGroup?: { __typename?: 'SignedDocumentGroup', id: string } | null } | null };

export type GetSignedAgreementOnPaymentQueryVariables = Exact<{
  clientId: Scalars['String'];
  locationId: Scalars['String'];
  agreementId: Scalars['String'];
}>;


export type GetSignedAgreementOnPaymentQuery = { __typename?: 'Query', checkForSignedAgreement?: { __typename?: 'SignedAgreement', id: string, agreement: { __typename?: 'Agreement', id: string, name: string, isAutoRenew: boolean, description?: string | null, isMembership: boolean, termValue: number, Unit: Unit, postponeUntil?: any | null, paymentFrequency: PaymentFrequency, draftMode: DraftMode, additionalPolicies: Array<{ __typename?: 'Policy', name: string }>, initialCharges: Array<{ __typename?: 'InitialCharge', id: string, cost: number }>, recurringCharges: Array<{ __typename?: 'RecurringCharge', id: string, cost: number }> } } | null };

export type GetEmbeddedLinkQueryVariables = Exact<{
  signedAgreementId: Scalars['String'];
}>;


export type GetEmbeddedLinkQuery = { __typename?: 'Query', getEmbeddedLink: string };

export type GetAgreementReportQueryVariables = Exact<{
  data: CustomReportInput;
}>;


export type GetAgreementReportQuery = { __typename?: 'Query', agreementReport: Array<{ __typename?: 'SignedAgreement', id: string, termEnd?: any | null, termStart?: any | null, isAutoRenew: boolean, client: { __typename?: 'Client', memberStatus: MemberStatus, lastVisitDate?: any | null, user: { __typename?: 'User', firstName: string, lastName: string } }, location: { __typename?: 'Location', name: string }, agreement: { __typename?: 'Agreement', version: number, name: string, paymentFrequency: PaymentFrequency, termValue: number, isMembership: boolean } }> };

export type DownloadAgreementReportQueryVariables = Exact<{
  data: CustomReportInput;
}>;


export type DownloadAgreementReportQuery = { __typename?: 'Query', downloadAgreementReport: string };

export type SubscriptionSampleCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionSampleCsvQuery = { __typename?: 'Query', subscriptionSampleCSV: string };

export type GetTransactionsManyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionsManyQuery = { __typename?: 'Query', transactionMany: Array<{ __typename?: 'Transaction', id: string, createdDate: any, updatedDate: any, externalId: string, amount: number, subtotal: number, tax: number, discount: number, transactionStatus: TransactionStatus, completedAt?: any | null, performedBy?: { __typename?: 'Employee', id: string, user: { __typename?: 'User', firstName: string, lastName: string } } | null, location: { __typename?: 'Location', name: string, state?: string | null, city?: string | null } }> };

export type GetTransactionByClientQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type GetTransactionByClientQuery = { __typename?: 'Query', transactionByClient: Array<{ __typename?: 'Transaction', id: string, createdDate: any, amount: number, transactionStatus: TransactionStatus, location: { __typename?: 'Location', name: string }, paymentMethod?: { __typename?: 'ClientPaymentMethods', mask?: string | null, type: PaymentMethodType, merchant?: string | null } | null, paymentTerminal?: { __typename?: 'PaymentTerminal', id: string, name: string } | null }> };

export type GetTransactionRecordQueryVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type GetTransactionRecordQuery = { __typename?: 'Query', transactionByClient: Array<{ __typename?: 'Transaction', id: string, createdDate: any, amount: number, transactionStatus: TransactionStatus, location: { __typename?: 'Location', name: string }, agreement?: { __typename?: 'Agreement', name: string } | null, shoppingCart?: { __typename?: 'ShoppingCart', products?: string | null } | null, package?: { __typename?: 'Package', name: string } | null }> };

export type GetTransactionPageClientGuestQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetTransactionPageClientGuestQuery = { __typename?: 'Query', transactionPage: { __typename?: 'PaginatedTransactionResponse', totalRows: number, items: Array<{ __typename?: 'Transaction', id: string, createdDate: any, amount: number, transactionStatus: TransactionStatus, location: { __typename?: 'Location', name: string }, paymentMethod?: { __typename?: 'ClientPaymentMethods', mask?: string | null, type: PaymentMethodType, merchant?: string | null } | null, paymentTerminal?: { __typename?: 'PaymentTerminal', id: string, name: string } | null }> } };

export type SubscribeToTransactionSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type SubscribeToTransactionSubscription = { __typename?: 'Subscription', resolveTransactionSubscription: { __typename?: 'TransactionSubscriptionPayload', transaction: { __typename?: 'Transaction', id: string, completedAt?: any | null, transactionStatus: TransactionStatus } } };

export type GetPosReportQueryVariables = Exact<{
  data: CustomReportInput;
}>;


export type GetPosReportQuery = { __typename?: 'Query', posReport: Array<{ __typename?: 'Transaction', id: string, createdDate: any, updatedDate: any, externalId: string, amount: number, subtotal: number, tax: number, discount: number, transactionStatus: TransactionStatus, completedAt?: any | null, isRefund: boolean, chargedTo?: { __typename?: 'Client', user: { __typename?: 'User', firstName: string, lastName: string } } | null, performedBy?: { __typename?: 'Employee', user: { __typename?: 'User', firstName: string, lastName: string } } | null, paymentMethod?: { __typename?: 'ClientPaymentMethods', id: string, name?: string | null, mask?: string | null, vendor: PaymentType, type: PaymentMethodType } | null }> };

export type DownloadPosReportQueryVariables = Exact<{
  data: CustomReportInput;
}>;


export type DownloadPosReportQuery = { __typename?: 'Query', downloadPosReport: string };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', userMany: Array<{ __typename?: 'User', id: string, username?: string | null, role: UserRole, firstName: string, middleName: string, lastName: string, email: string, phoneNumber?: string | null, createdDate: any, profilePicUrl?: string | null }> };

export type GetUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
}>;


export type GetUserQuery = { __typename?: 'Query', userOne?: { __typename?: 'User', id: string, username?: string | null, role: UserRole, firstName: string, middleName: string, lastName: string, email: string, phoneNumber?: string | null, createdDate: any, acceptedTAC: boolean, smsConsent: boolean, profilePicUrl?: string | null } | null };

export type GetUserPageQueryVariables = Exact<{
  pagination: PaginationInput;
}>;


export type GetUserPageQuery = { __typename?: 'Query', userPage: { __typename?: 'PaginatedUserResponse', totalRows: number, items: Array<{ __typename?: 'User', id: string, username?: string | null, role: UserRole, firstName: string, lastName: string, email: string, phoneNumber?: string | null, createdDate: any, profilePicUrl?: string | null }> } };

export type GetIsUsernameAvailableQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetIsUsernameAvailableQuery = { __typename?: 'Query', checkUsernameAvailability: boolean };


export const CreateAccessPeriodDocument = gql`
    mutation CreateAccessPeriod($data: CreateAccessPeriodInput!) {
  createAccessPeriod(data: $data) {
    id
  }
}
    `;
export type CreateAccessPeriodMutationFn = Apollo.MutationFunction<CreateAccessPeriodMutation, CreateAccessPeriodMutationVariables>;

/**
 * __useCreateAccessPeriodMutation__
 *
 * To run a mutation, you first call `useCreateAccessPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessPeriodMutation, { data, loading, error }] = useCreateAccessPeriodMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAccessPeriodMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccessPeriodMutation, CreateAccessPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccessPeriodMutation, CreateAccessPeriodMutationVariables>(CreateAccessPeriodDocument, options);
      }
export type CreateAccessPeriodMutationHookResult = ReturnType<typeof useCreateAccessPeriodMutation>;
export type CreateAccessPeriodMutationResult = Apollo.MutationResult<CreateAccessPeriodMutation>;
export type CreateAccessPeriodMutationOptions = Apollo.BaseMutationOptions<CreateAccessPeriodMutation, CreateAccessPeriodMutationVariables>;
export const UpdateAccessPeriodDocument = gql`
    mutation UpdateAccessPeriod($id: String!, $data: UpdateAccessPeriodInput!) {
  updateAccessPeriod(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateAccessPeriodMutationFn = Apollo.MutationFunction<UpdateAccessPeriodMutation, UpdateAccessPeriodMutationVariables>;

/**
 * __useUpdateAccessPeriodMutation__
 *
 * To run a mutation, you first call `useUpdateAccessPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessPeriodMutation, { data, loading, error }] = useUpdateAccessPeriodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAccessPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccessPeriodMutation, UpdateAccessPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccessPeriodMutation, UpdateAccessPeriodMutationVariables>(UpdateAccessPeriodDocument, options);
      }
export type UpdateAccessPeriodMutationHookResult = ReturnType<typeof useUpdateAccessPeriodMutation>;
export type UpdateAccessPeriodMutationResult = Apollo.MutationResult<UpdateAccessPeriodMutation>;
export type UpdateAccessPeriodMutationOptions = Apollo.BaseMutationOptions<UpdateAccessPeriodMutation, UpdateAccessPeriodMutationVariables>;
export const DeleteAccessPeriodDocument = gql`
    mutation DeleteAccessPeriod($deleteAccessPeriodId: String!) {
  deleteAccessPeriod(id: $deleteAccessPeriodId)
}
    `;
export type DeleteAccessPeriodMutationFn = Apollo.MutationFunction<DeleteAccessPeriodMutation, DeleteAccessPeriodMutationVariables>;

/**
 * __useDeleteAccessPeriodMutation__
 *
 * To run a mutation, you first call `useDeleteAccessPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccessPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccessPeriodMutation, { data, loading, error }] = useDeleteAccessPeriodMutation({
 *   variables: {
 *      deleteAccessPeriodId: // value for 'deleteAccessPeriodId'
 *   },
 * });
 */
export function useDeleteAccessPeriodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccessPeriodMutation, DeleteAccessPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccessPeriodMutation, DeleteAccessPeriodMutationVariables>(DeleteAccessPeriodDocument, options);
      }
export type DeleteAccessPeriodMutationHookResult = ReturnType<typeof useDeleteAccessPeriodMutation>;
export type DeleteAccessPeriodMutationResult = Apollo.MutationResult<DeleteAccessPeriodMutation>;
export type DeleteAccessPeriodMutationOptions = Apollo.BaseMutationOptions<DeleteAccessPeriodMutation, DeleteAccessPeriodMutationVariables>;
export const UpdateAdminDocument = gql`
    mutation UpdateAdmin($id: String!, $data: UpdateAdminInput!) {
  updateAdmin(id: $id, data: $data) {
    id
    organization {
      id
      name
    }
  }
}
    `;
export type UpdateAdminMutationFn = Apollo.MutationFunction<UpdateAdminMutation, UpdateAdminMutationVariables>;

/**
 * __useUpdateAdminMutation__
 *
 * To run a mutation, you first call `useUpdateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminMutation, { data, loading, error }] = useUpdateAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminMutation, UpdateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminMutation, UpdateAdminMutationVariables>(UpdateAdminDocument, options);
      }
export type UpdateAdminMutationHookResult = ReturnType<typeof useUpdateAdminMutation>;
export type UpdateAdminMutationResult = Apollo.MutationResult<UpdateAdminMutation>;
export type UpdateAdminMutationOptions = Apollo.BaseMutationOptions<UpdateAdminMutation, UpdateAdminMutationVariables>;
export const CreateAgreementDocument = gql`
    mutation CreateAgreement($data: CreateAgreementInput!) {
  createAgreement(data: $data) {
    id
  }
}
    `;
export type CreateAgreementMutationFn = Apollo.MutationFunction<CreateAgreementMutation, CreateAgreementMutationVariables>;

/**
 * __useCreateAgreementMutation__
 *
 * To run a mutation, you first call `useCreateAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgreementMutation, { data, loading, error }] = useCreateAgreementMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgreementMutation, CreateAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgreementMutation, CreateAgreementMutationVariables>(CreateAgreementDocument, options);
      }
export type CreateAgreementMutationHookResult = ReturnType<typeof useCreateAgreementMutation>;
export type CreateAgreementMutationResult = Apollo.MutationResult<CreateAgreementMutation>;
export type CreateAgreementMutationOptions = Apollo.BaseMutationOptions<CreateAgreementMutation, CreateAgreementMutationVariables>;
export const UpdateAgreementDocument = gql`
    mutation UpdateAgreement($id: String!, $data: UpdateAgreementInput!, $isForceUpdate: Boolean) {
  updateAgreement(id: $id, data: $data, isForceUpdate: $isForceUpdate) {
    id
  }
}
    `;
export type UpdateAgreementMutationFn = Apollo.MutationFunction<UpdateAgreementMutation, UpdateAgreementMutationVariables>;

/**
 * __useUpdateAgreementMutation__
 *
 * To run a mutation, you first call `useUpdateAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgreementMutation, { data, loading, error }] = useUpdateAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *      isForceUpdate: // value for 'isForceUpdate'
 *   },
 * });
 */
export function useUpdateAgreementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgreementMutation, UpdateAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgreementMutation, UpdateAgreementMutationVariables>(UpdateAgreementDocument, options);
      }
export type UpdateAgreementMutationHookResult = ReturnType<typeof useUpdateAgreementMutation>;
export type UpdateAgreementMutationResult = Apollo.MutationResult<UpdateAgreementMutation>;
export type UpdateAgreementMutationOptions = Apollo.BaseMutationOptions<UpdateAgreementMutation, UpdateAgreementMutationVariables>;
export const CreateAgreementRecipientDocument = gql`
    mutation CreateAgreementRecipient($data: CreateAgreementRecipientInput!) {
  createAgreementRecipient(data: $data) {
    id
  }
}
    `;
export type CreateAgreementRecipientMutationFn = Apollo.MutationFunction<CreateAgreementRecipientMutation, CreateAgreementRecipientMutationVariables>;

/**
 * __useCreateAgreementRecipientMutation__
 *
 * To run a mutation, you first call `useCreateAgreementRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgreementRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgreementRecipientMutation, { data, loading, error }] = useCreateAgreementRecipientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAgreementRecipientMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgreementRecipientMutation, CreateAgreementRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgreementRecipientMutation, CreateAgreementRecipientMutationVariables>(CreateAgreementRecipientDocument, options);
      }
export type CreateAgreementRecipientMutationHookResult = ReturnType<typeof useCreateAgreementRecipientMutation>;
export type CreateAgreementRecipientMutationResult = Apollo.MutationResult<CreateAgreementRecipientMutation>;
export type CreateAgreementRecipientMutationOptions = Apollo.BaseMutationOptions<CreateAgreementRecipientMutation, CreateAgreementRecipientMutationVariables>;
export const CreateAlterAgreementRecordDocument = gql`
    mutation CreateAlterAgreementRecord($data: CreateAlterAgreementRecordInput!) {
  createAlterAgreementRecord(data: $data) {
    id
  }
}
    `;
export type CreateAlterAgreementRecordMutationFn = Apollo.MutationFunction<CreateAlterAgreementRecordMutation, CreateAlterAgreementRecordMutationVariables>;

/**
 * __useCreateAlterAgreementRecordMutation__
 *
 * To run a mutation, you first call `useCreateAlterAgreementRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlterAgreementRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlterAgreementRecordMutation, { data, loading, error }] = useCreateAlterAgreementRecordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAlterAgreementRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlterAgreementRecordMutation, CreateAlterAgreementRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlterAgreementRecordMutation, CreateAlterAgreementRecordMutationVariables>(CreateAlterAgreementRecordDocument, options);
      }
export type CreateAlterAgreementRecordMutationHookResult = ReturnType<typeof useCreateAlterAgreementRecordMutation>;
export type CreateAlterAgreementRecordMutationResult = Apollo.MutationResult<CreateAlterAgreementRecordMutation>;
export type CreateAlterAgreementRecordMutationOptions = Apollo.BaseMutationOptions<CreateAlterAgreementRecordMutation, CreateAlterAgreementRecordMutationVariables>;
export const UpdateAlterAgreementRecordDocument = gql`
    mutation UpdateAlterAgreementRecord($id: String!, $data: UpdateAlterAgreementRecordInput!) {
  updateAlterAgreementRecord(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateAlterAgreementRecordMutationFn = Apollo.MutationFunction<UpdateAlterAgreementRecordMutation, UpdateAlterAgreementRecordMutationVariables>;

/**
 * __useUpdateAlterAgreementRecordMutation__
 *
 * To run a mutation, you first call `useUpdateAlterAgreementRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlterAgreementRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlterAgreementRecordMutation, { data, loading, error }] = useUpdateAlterAgreementRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAlterAgreementRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlterAgreementRecordMutation, UpdateAlterAgreementRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlterAgreementRecordMutation, UpdateAlterAgreementRecordMutationVariables>(UpdateAlterAgreementRecordDocument, options);
      }
export type UpdateAlterAgreementRecordMutationHookResult = ReturnType<typeof useUpdateAlterAgreementRecordMutation>;
export type UpdateAlterAgreementRecordMutationResult = Apollo.MutationResult<UpdateAlterAgreementRecordMutation>;
export type UpdateAlterAgreementRecordMutationOptions = Apollo.BaseMutationOptions<UpdateAlterAgreementRecordMutation, UpdateAlterAgreementRecordMutationVariables>;
export const CreateAlterationReasonDocument = gql`
    mutation CreateAlterationReason($data: CreateAlterationReasonInput!) {
  createAlterationReason(data: $data) {
    id
  }
}
    `;
export type CreateAlterationReasonMutationFn = Apollo.MutationFunction<CreateAlterationReasonMutation, CreateAlterationReasonMutationVariables>;

/**
 * __useCreateAlterationReasonMutation__
 *
 * To run a mutation, you first call `useCreateAlterationReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlterationReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlterationReasonMutation, { data, loading, error }] = useCreateAlterationReasonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAlterationReasonMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlterationReasonMutation, CreateAlterationReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlterationReasonMutation, CreateAlterationReasonMutationVariables>(CreateAlterationReasonDocument, options);
      }
export type CreateAlterationReasonMutationHookResult = ReturnType<typeof useCreateAlterationReasonMutation>;
export type CreateAlterationReasonMutationResult = Apollo.MutationResult<CreateAlterationReasonMutation>;
export type CreateAlterationReasonMutationOptions = Apollo.BaseMutationOptions<CreateAlterationReasonMutation, CreateAlterationReasonMutationVariables>;
export const UpdateAlterationReasonDocument = gql`
    mutation UpdateAlterationReason($data: UpdateAlterationReasonInput!, $updateAlterationReasonId: String!) {
  updateAlterationReason(data: $data, id: $updateAlterationReasonId) {
    id
  }
}
    `;
export type UpdateAlterationReasonMutationFn = Apollo.MutationFunction<UpdateAlterationReasonMutation, UpdateAlterationReasonMutationVariables>;

/**
 * __useUpdateAlterationReasonMutation__
 *
 * To run a mutation, you first call `useUpdateAlterationReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlterationReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlterationReasonMutation, { data, loading, error }] = useUpdateAlterationReasonMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateAlterationReasonId: // value for 'updateAlterationReasonId'
 *   },
 * });
 */
export function useUpdateAlterationReasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlterationReasonMutation, UpdateAlterationReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlterationReasonMutation, UpdateAlterationReasonMutationVariables>(UpdateAlterationReasonDocument, options);
      }
export type UpdateAlterationReasonMutationHookResult = ReturnType<typeof useUpdateAlterationReasonMutation>;
export type UpdateAlterationReasonMutationResult = Apollo.MutationResult<UpdateAlterationReasonMutation>;
export type UpdateAlterationReasonMutationOptions = Apollo.BaseMutationOptions<UpdateAlterationReasonMutation, UpdateAlterationReasonMutationVariables>;
export const DeleteAlterationReasonDocument = gql`
    mutation DeleteAlterationReason($deleteAlterationReasonId: String!) {
  deleteAlterationReason(id: $deleteAlterationReasonId)
}
    `;
export type DeleteAlterationReasonMutationFn = Apollo.MutationFunction<DeleteAlterationReasonMutation, DeleteAlterationReasonMutationVariables>;

/**
 * __useDeleteAlterationReasonMutation__
 *
 * To run a mutation, you first call `useDeleteAlterationReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlterationReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlterationReasonMutation, { data, loading, error }] = useDeleteAlterationReasonMutation({
 *   variables: {
 *      deleteAlterationReasonId: // value for 'deleteAlterationReasonId'
 *   },
 * });
 */
export function useDeleteAlterationReasonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlterationReasonMutation, DeleteAlterationReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlterationReasonMutation, DeleteAlterationReasonMutationVariables>(DeleteAlterationReasonDocument, options);
      }
export type DeleteAlterationReasonMutationHookResult = ReturnType<typeof useDeleteAlterationReasonMutation>;
export type DeleteAlterationReasonMutationResult = Apollo.MutationResult<DeleteAlterationReasonMutation>;
export type DeleteAlterationReasonMutationOptions = Apollo.BaseMutationOptions<DeleteAlterationReasonMutation, DeleteAlterationReasonMutationVariables>;
export const UpdateAttendanceDocument = gql`
    mutation UpdateAttendance($attendeeId: String!, $meetingId: String!, $feeWaived: Boolean, $data: UpdateAttendanceInput!) {
  updateAttendance(
    attendeeId: $attendeeId
    meetingId: $meetingId
    feeWaived: $feeWaived
    data: $data
  ) {
    id
  }
}
    `;
export type UpdateAttendanceMutationFn = Apollo.MutationFunction<UpdateAttendanceMutation, UpdateAttendanceMutationVariables>;

/**
 * __useUpdateAttendanceMutation__
 *
 * To run a mutation, you first call `useUpdateAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttendanceMutation, { data, loading, error }] = useUpdateAttendanceMutation({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      meetingId: // value for 'meetingId'
 *      feeWaived: // value for 'feeWaived'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAttendanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttendanceMutation, UpdateAttendanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttendanceMutation, UpdateAttendanceMutationVariables>(UpdateAttendanceDocument, options);
      }
export type UpdateAttendanceMutationHookResult = ReturnType<typeof useUpdateAttendanceMutation>;
export type UpdateAttendanceMutationResult = Apollo.MutationResult<UpdateAttendanceMutation>;
export type UpdateAttendanceMutationOptions = Apollo.BaseMutationOptions<UpdateAttendanceMutation, UpdateAttendanceMutationVariables>;
export const AddAttendeeToMeetingDocument = gql`
    mutation addAttendeeToMeeting($meetingId: String!, $attendeeId: String!) {
  addAttendeeToMeeting(meetingId: $meetingId, attendeeId: $attendeeId)
}
    `;
export type AddAttendeeToMeetingMutationFn = Apollo.MutationFunction<AddAttendeeToMeetingMutation, AddAttendeeToMeetingMutationVariables>;

/**
 * __useAddAttendeeToMeetingMutation__
 *
 * To run a mutation, you first call `useAddAttendeeToMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttendeeToMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttendeeToMeetingMutation, { data, loading, error }] = useAddAttendeeToMeetingMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useAddAttendeeToMeetingMutation(baseOptions?: Apollo.MutationHookOptions<AddAttendeeToMeetingMutation, AddAttendeeToMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttendeeToMeetingMutation, AddAttendeeToMeetingMutationVariables>(AddAttendeeToMeetingDocument, options);
      }
export type AddAttendeeToMeetingMutationHookResult = ReturnType<typeof useAddAttendeeToMeetingMutation>;
export type AddAttendeeToMeetingMutationResult = Apollo.MutationResult<AddAttendeeToMeetingMutation>;
export type AddAttendeeToMeetingMutationOptions = Apollo.BaseMutationOptions<AddAttendeeToMeetingMutation, AddAttendeeToMeetingMutationVariables>;
export const CancelAttendeeToMeetingDocument = gql`
    mutation cancelAttendeeToMeeting($meetingId: String!, $attendeeId: String!) {
  cancelAttendeeToMeeting(meetingId: $meetingId, attendeeId: $attendeeId)
}
    `;
export type CancelAttendeeToMeetingMutationFn = Apollo.MutationFunction<CancelAttendeeToMeetingMutation, CancelAttendeeToMeetingMutationVariables>;

/**
 * __useCancelAttendeeToMeetingMutation__
 *
 * To run a mutation, you first call `useCancelAttendeeToMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAttendeeToMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAttendeeToMeetingMutation, { data, loading, error }] = useCancelAttendeeToMeetingMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useCancelAttendeeToMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CancelAttendeeToMeetingMutation, CancelAttendeeToMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAttendeeToMeetingMutation, CancelAttendeeToMeetingMutationVariables>(CancelAttendeeToMeetingDocument, options);
      }
export type CancelAttendeeToMeetingMutationHookResult = ReturnType<typeof useCancelAttendeeToMeetingMutation>;
export type CancelAttendeeToMeetingMutationResult = Apollo.MutationResult<CancelAttendeeToMeetingMutation>;
export type CancelAttendeeToMeetingMutationOptions = Apollo.BaseMutationOptions<CancelAttendeeToMeetingMutation, CancelAttendeeToMeetingMutationVariables>;
export const CreateCategoryOptionDocument = gql`
    mutation CreateCategoryOption($data: CreateCategoryOptionInput!) {
  createCategoryOption(data: $data) {
    name
    organization {
      id
    }
    type
  }
}
    `;
export type CreateCategoryOptionMutationFn = Apollo.MutationFunction<CreateCategoryOptionMutation, CreateCategoryOptionMutationVariables>;

/**
 * __useCreateCategoryOptionMutation__
 *
 * To run a mutation, you first call `useCreateCategoryOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryOptionMutation, { data, loading, error }] = useCreateCategoryOptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCategoryOptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryOptionMutation, CreateCategoryOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryOptionMutation, CreateCategoryOptionMutationVariables>(CreateCategoryOptionDocument, options);
      }
export type CreateCategoryOptionMutationHookResult = ReturnType<typeof useCreateCategoryOptionMutation>;
export type CreateCategoryOptionMutationResult = Apollo.MutationResult<CreateCategoryOptionMutation>;
export type CreateCategoryOptionMutationOptions = Apollo.BaseMutationOptions<CreateCategoryOptionMutation, CreateCategoryOptionMutationVariables>;
export const DeleteCategoryOptionDocument = gql`
    mutation DeleteCategoryOption($deleteCategoryOptionId: String!) {
  deleteCategoryOption(id: $deleteCategoryOptionId)
}
    `;
export type DeleteCategoryOptionMutationFn = Apollo.MutationFunction<DeleteCategoryOptionMutation, DeleteCategoryOptionMutationVariables>;

/**
 * __useDeleteCategoryOptionMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryOptionMutation, { data, loading, error }] = useDeleteCategoryOptionMutation({
 *   variables: {
 *      deleteCategoryOptionId: // value for 'deleteCategoryOptionId'
 *   },
 * });
 */
export function useDeleteCategoryOptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryOptionMutation, DeleteCategoryOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryOptionMutation, DeleteCategoryOptionMutationVariables>(DeleteCategoryOptionDocument, options);
      }
export type DeleteCategoryOptionMutationHookResult = ReturnType<typeof useDeleteCategoryOptionMutation>;
export type DeleteCategoryOptionMutationResult = Apollo.MutationResult<DeleteCategoryOptionMutation>;
export type DeleteCategoryOptionMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryOptionMutation, DeleteCategoryOptionMutationVariables>;
export const UpdateCategoryOptionDocument = gql`
    mutation UpdateCategoryOption($data: UpdateCategoryOptionInput!, $updateCategoryOptionId: String!) {
  updateCategoryOption(data: $data, id: $updateCategoryOptionId) {
    id
  }
}
    `;
export type UpdateCategoryOptionMutationFn = Apollo.MutationFunction<UpdateCategoryOptionMutation, UpdateCategoryOptionMutationVariables>;

/**
 * __useUpdateCategoryOptionMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryOptionMutation, { data, loading, error }] = useUpdateCategoryOptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateCategoryOptionId: // value for 'updateCategoryOptionId'
 *   },
 * });
 */
export function useUpdateCategoryOptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryOptionMutation, UpdateCategoryOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryOptionMutation, UpdateCategoryOptionMutationVariables>(UpdateCategoryOptionDocument, options);
      }
export type UpdateCategoryOptionMutationHookResult = ReturnType<typeof useUpdateCategoryOptionMutation>;
export type UpdateCategoryOptionMutationResult = Apollo.MutationResult<UpdateCategoryOptionMutation>;
export type UpdateCategoryOptionMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryOptionMutation, UpdateCategoryOptionMutationVariables>;
export const CreateCheckInDocument = gql`
    mutation CreateCheckIn($data: CreateCheckInInput!) {
  createCheckIn(data: $data) {
    id
  }
}
    `;
export type CreateCheckInMutationFn = Apollo.MutationFunction<CreateCheckInMutation, CreateCheckInMutationVariables>;

/**
 * __useCreateCheckInMutation__
 *
 * To run a mutation, you first call `useCreateCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckInMutation, { data, loading, error }] = useCreateCheckInMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCheckInMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckInMutation, CreateCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckInMutation, CreateCheckInMutationVariables>(CreateCheckInDocument, options);
      }
export type CreateCheckInMutationHookResult = ReturnType<typeof useCreateCheckInMutation>;
export type CreateCheckInMutationResult = Apollo.MutationResult<CreateCheckInMutation>;
export type CreateCheckInMutationOptions = Apollo.BaseMutationOptions<CreateCheckInMutation, CreateCheckInMutationVariables>;
export const UpdateCheckInDocument = gql`
    mutation UpdateCheckIn($id: String!, $data: UpdateCheckInInput!) {
  updateCheckIn(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateCheckInMutationFn = Apollo.MutationFunction<UpdateCheckInMutation, UpdateCheckInMutationVariables>;

/**
 * __useUpdateCheckInMutation__
 *
 * To run a mutation, you first call `useUpdateCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckInMutation, { data, loading, error }] = useUpdateCheckInMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCheckInMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckInMutation, UpdateCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckInMutation, UpdateCheckInMutationVariables>(UpdateCheckInDocument, options);
      }
export type UpdateCheckInMutationHookResult = ReturnType<typeof useUpdateCheckInMutation>;
export type UpdateCheckInMutationResult = Apollo.MutationResult<UpdateCheckInMutation>;
export type UpdateCheckInMutationOptions = Apollo.BaseMutationOptions<UpdateCheckInMutation, UpdateCheckInMutationVariables>;
export const CreateClientDocument = gql`
    mutation CreateClient($data: CreateClientInput!) {
  createClient(data: $data) {
    id
    attendee {
      id
    }
  }
}
    `;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($id: String!, $data: UpdateClientInput!) {
  updateClient(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateClientOrgDocument = gql`
    mutation UpdateClientOrg($id: String!, $organizationId: String!, $locationId: String) {
  updateClientOrg(
    id: $id
    organizationId: $organizationId
    locationId: $locationId
  ) {
    id
  }
}
    `;
export type UpdateClientOrgMutationFn = Apollo.MutationFunction<UpdateClientOrgMutation, UpdateClientOrgMutationVariables>;

/**
 * __useUpdateClientOrgMutation__
 *
 * To run a mutation, you first call `useUpdateClientOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientOrgMutation, { data, loading, error }] = useUpdateClientOrgMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organizationId: // value for 'organizationId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useUpdateClientOrgMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientOrgMutation, UpdateClientOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientOrgMutation, UpdateClientOrgMutationVariables>(UpdateClientOrgDocument, options);
      }
export type UpdateClientOrgMutationHookResult = ReturnType<typeof useUpdateClientOrgMutation>;
export type UpdateClientOrgMutationResult = Apollo.MutationResult<UpdateClientOrgMutation>;
export type UpdateClientOrgMutationOptions = Apollo.BaseMutationOptions<UpdateClientOrgMutation, UpdateClientOrgMutationVariables>;
export const CreateClientGroupDocument = gql`
    mutation CreateClientGroup($data: CreateClientGroupInput!) {
  createClientGroup(data: $data) {
    id
  }
}
    `;
export type CreateClientGroupMutationFn = Apollo.MutationFunction<CreateClientGroupMutation, CreateClientGroupMutationVariables>;

/**
 * __useCreateClientGroupMutation__
 *
 * To run a mutation, you first call `useCreateClientGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientGroupMutation, { data, loading, error }] = useCreateClientGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientGroupMutation, CreateClientGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientGroupMutation, CreateClientGroupMutationVariables>(CreateClientGroupDocument, options);
      }
export type CreateClientGroupMutationHookResult = ReturnType<typeof useCreateClientGroupMutation>;
export type CreateClientGroupMutationResult = Apollo.MutationResult<CreateClientGroupMutation>;
export type CreateClientGroupMutationOptions = Apollo.BaseMutationOptions<CreateClientGroupMutation, CreateClientGroupMutationVariables>;
export const UpdateClientGroupDocument = gql`
    mutation UpdateClientGroup($id: String!, $data: UpdateClientGroupInput!) {
  updateClientGroup(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateClientGroupMutationFn = Apollo.MutationFunction<UpdateClientGroupMutation, UpdateClientGroupMutationVariables>;

/**
 * __useUpdateClientGroupMutation__
 *
 * To run a mutation, you first call `useUpdateClientGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientGroupMutation, { data, loading, error }] = useUpdateClientGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientGroupMutation, UpdateClientGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientGroupMutation, UpdateClientGroupMutationVariables>(UpdateClientGroupDocument, options);
      }
export type UpdateClientGroupMutationHookResult = ReturnType<typeof useUpdateClientGroupMutation>;
export type UpdateClientGroupMutationResult = Apollo.MutationResult<UpdateClientGroupMutation>;
export type UpdateClientGroupMutationOptions = Apollo.BaseMutationOptions<UpdateClientGroupMutation, UpdateClientGroupMutationVariables>;
export const AddClientToGroupDocument = gql`
    mutation AddClientToGroup($clientId: String!, $clientGroupId: String!) {
  addClientToGroup(clientId: $clientId, clientGroupId: $clientGroupId) {
    id
  }
}
    `;
export type AddClientToGroupMutationFn = Apollo.MutationFunction<AddClientToGroupMutation, AddClientToGroupMutationVariables>;

/**
 * __useAddClientToGroupMutation__
 *
 * To run a mutation, you first call `useAddClientToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientToGroupMutation, { data, loading, error }] = useAddClientToGroupMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      clientGroupId: // value for 'clientGroupId'
 *   },
 * });
 */
export function useAddClientToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddClientToGroupMutation, AddClientToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientToGroupMutation, AddClientToGroupMutationVariables>(AddClientToGroupDocument, options);
      }
export type AddClientToGroupMutationHookResult = ReturnType<typeof useAddClientToGroupMutation>;
export type AddClientToGroupMutationResult = Apollo.MutationResult<AddClientToGroupMutation>;
export type AddClientToGroupMutationOptions = Apollo.BaseMutationOptions<AddClientToGroupMutation, AddClientToGroupMutationVariables>;
export const RemoveClientFromGroupDocument = gql`
    mutation RemoveClientFromGroup($clientId: String!, $clientGroupId: String!) {
  removeClientFromGroup(clientId: $clientId, clientGroupId: $clientGroupId)
}
    `;
export type RemoveClientFromGroupMutationFn = Apollo.MutationFunction<RemoveClientFromGroupMutation, RemoveClientFromGroupMutationVariables>;

/**
 * __useRemoveClientFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveClientFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClientFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClientFromGroupMutation, { data, loading, error }] = useRemoveClientFromGroupMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      clientGroupId: // value for 'clientGroupId'
 *   },
 * });
 */
export function useRemoveClientFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClientFromGroupMutation, RemoveClientFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClientFromGroupMutation, RemoveClientFromGroupMutationVariables>(RemoveClientFromGroupDocument, options);
      }
export type RemoveClientFromGroupMutationHookResult = ReturnType<typeof useRemoveClientFromGroupMutation>;
export type RemoveClientFromGroupMutationResult = Apollo.MutationResult<RemoveClientFromGroupMutation>;
export type RemoveClientFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveClientFromGroupMutation, RemoveClientFromGroupMutationVariables>;
export const CreateMemberLoginDocument = gql`
    mutation createMemberLogin($clientId: String!, $username: String!) {
  createMemberLogin(clientId: $clientId, username: $username)
}
    `;
export type CreateMemberLoginMutationFn = Apollo.MutationFunction<CreateMemberLoginMutation, CreateMemberLoginMutationVariables>;

/**
 * __useCreateMemberLoginMutation__
 *
 * To run a mutation, you first call `useCreateMemberLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMemberLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMemberLoginMutation, { data, loading, error }] = useCreateMemberLoginMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useCreateMemberLoginMutation(baseOptions?: Apollo.MutationHookOptions<CreateMemberLoginMutation, CreateMemberLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMemberLoginMutation, CreateMemberLoginMutationVariables>(CreateMemberLoginDocument, options);
      }
export type CreateMemberLoginMutationHookResult = ReturnType<typeof useCreateMemberLoginMutation>;
export type CreateMemberLoginMutationResult = Apollo.MutationResult<CreateMemberLoginMutation>;
export type CreateMemberLoginMutationOptions = Apollo.BaseMutationOptions<CreateMemberLoginMutation, CreateMemberLoginMutationVariables>;
export const MigrateClientsDocument = gql`
    mutation migrateClients($data: ClientsJsonArrInput!, $locationId: String!) {
  migrateClients(data: $data, locationId: $locationId) {
    errors {
      Missing
      Invalid
      Collision
      Default
    }
  }
}
    `;
export type MigrateClientsMutationFn = Apollo.MutationFunction<MigrateClientsMutation, MigrateClientsMutationVariables>;

/**
 * __useMigrateClientsMutation__
 *
 * To run a mutation, you first call `useMigrateClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateClientsMutation, { data, loading, error }] = useMigrateClientsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useMigrateClientsMutation(baseOptions?: Apollo.MutationHookOptions<MigrateClientsMutation, MigrateClientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateClientsMutation, MigrateClientsMutationVariables>(MigrateClientsDocument, options);
      }
export type MigrateClientsMutationHookResult = ReturnType<typeof useMigrateClientsMutation>;
export type MigrateClientsMutationResult = Apollo.MutationResult<MigrateClientsMutation>;
export type MigrateClientsMutationOptions = Apollo.BaseMutationOptions<MigrateClientsMutation, MigrateClientsMutationVariables>;
export const CreateClientPaymentMethodDocument = gql`
    mutation CreateClientPaymentMethod($clientId: String!, $data: CreateClientPaymentMethodInput!) {
  createClientPaymentMethod(clientId: $clientId, data: $data) {
    id
  }
}
    `;
export type CreateClientPaymentMethodMutationFn = Apollo.MutationFunction<CreateClientPaymentMethodMutation, CreateClientPaymentMethodMutationVariables>;

/**
 * __useCreateClientPaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreateClientPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientPaymentMethodMutation, { data, loading, error }] = useCreateClientPaymentMethodMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientPaymentMethodMutation, CreateClientPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientPaymentMethodMutation, CreateClientPaymentMethodMutationVariables>(CreateClientPaymentMethodDocument, options);
      }
export type CreateClientPaymentMethodMutationHookResult = ReturnType<typeof useCreateClientPaymentMethodMutation>;
export type CreateClientPaymentMethodMutationResult = Apollo.MutationResult<CreateClientPaymentMethodMutation>;
export type CreateClientPaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreateClientPaymentMethodMutation, CreateClientPaymentMethodMutationVariables>;
export const UpdateClientPaymentMethodDocument = gql`
    mutation UpdateClientPaymentMethod($id: String!, $data: UpdateClientPaymentMethodInput!) {
  updateClientPaymentMethod(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateClientPaymentMethodMutationFn = Apollo.MutationFunction<UpdateClientPaymentMethodMutation, UpdateClientPaymentMethodMutationVariables>;

/**
 * __useUpdateClientPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateClientPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientPaymentMethodMutation, { data, loading, error }] = useUpdateClientPaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientPaymentMethodMutation, UpdateClientPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientPaymentMethodMutation, UpdateClientPaymentMethodMutationVariables>(UpdateClientPaymentMethodDocument, options);
      }
export type UpdateClientPaymentMethodMutationHookResult = ReturnType<typeof useUpdateClientPaymentMethodMutation>;
export type UpdateClientPaymentMethodMutationResult = Apollo.MutationResult<UpdateClientPaymentMethodMutation>;
export type UpdateClientPaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdateClientPaymentMethodMutation, UpdateClientPaymentMethodMutationVariables>;
export const DeleteClientPaymentMethodDocument = gql`
    mutation DeleteClientPaymentMethod($id: String!) {
  deleteClientPaymentMethod(id: $id)
}
    `;
export type DeleteClientPaymentMethodMutationFn = Apollo.MutationFunction<DeleteClientPaymentMethodMutation, DeleteClientPaymentMethodMutationVariables>;

/**
 * __useDeleteClientPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeleteClientPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientPaymentMethodMutation, { data, loading, error }] = useDeleteClientPaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientPaymentMethodMutation, DeleteClientPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientPaymentMethodMutation, DeleteClientPaymentMethodMutationVariables>(DeleteClientPaymentMethodDocument, options);
      }
export type DeleteClientPaymentMethodMutationHookResult = ReturnType<typeof useDeleteClientPaymentMethodMutation>;
export type DeleteClientPaymentMethodMutationResult = Apollo.MutationResult<DeleteClientPaymentMethodMutation>;
export type DeleteClientPaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeleteClientPaymentMethodMutation, DeleteClientPaymentMethodMutationVariables>;
export const MigratePaymentMethodsDocument = gql`
    mutation migratePaymentMethods($data: PaymentMethodJsonArrInput!, $locationId: String!) {
  migratePaymentMethods(data: $data, locationId: $locationId) {
    errors {
      Missing
      Invalid
      Collision
      Default
    }
  }
}
    `;
export type MigratePaymentMethodsMutationFn = Apollo.MutationFunction<MigratePaymentMethodsMutation, MigratePaymentMethodsMutationVariables>;

/**
 * __useMigratePaymentMethodsMutation__
 *
 * To run a mutation, you first call `useMigratePaymentMethodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigratePaymentMethodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migratePaymentMethodsMutation, { data, loading, error }] = useMigratePaymentMethodsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useMigratePaymentMethodsMutation(baseOptions?: Apollo.MutationHookOptions<MigratePaymentMethodsMutation, MigratePaymentMethodsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigratePaymentMethodsMutation, MigratePaymentMethodsMutationVariables>(MigratePaymentMethodsDocument, options);
      }
export type MigratePaymentMethodsMutationHookResult = ReturnType<typeof useMigratePaymentMethodsMutation>;
export type MigratePaymentMethodsMutationResult = Apollo.MutationResult<MigratePaymentMethodsMutation>;
export type MigratePaymentMethodsMutationOptions = Apollo.BaseMutationOptions<MigratePaymentMethodsMutation, MigratePaymentMethodsMutationVariables>;
export const ClockInDocument = gql`
    mutation ClockIn($data: CreateTimeClockEntryInput!) {
  clockIn(data: $data) {
    id
  }
}
    `;
export type ClockInMutationFn = Apollo.MutationFunction<ClockInMutation, ClockInMutationVariables>;

/**
 * __useClockInMutation__
 *
 * To run a mutation, you first call `useClockInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClockInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clockInMutation, { data, loading, error }] = useClockInMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClockInMutation(baseOptions?: Apollo.MutationHookOptions<ClockInMutation, ClockInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClockInMutation, ClockInMutationVariables>(ClockInDocument, options);
      }
export type ClockInMutationHookResult = ReturnType<typeof useClockInMutation>;
export type ClockInMutationResult = Apollo.MutationResult<ClockInMutation>;
export type ClockInMutationOptions = Apollo.BaseMutationOptions<ClockInMutation, ClockInMutationVariables>;
export const ClockOutDocument = gql`
    mutation ClockOut($data: ClockOutInput!) {
  clockOut(data: $data) {
    id
  }
}
    `;
export type ClockOutMutationFn = Apollo.MutationFunction<ClockOutMutation, ClockOutMutationVariables>;

/**
 * __useClockOutMutation__
 *
 * To run a mutation, you first call `useClockOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClockOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clockOutMutation, { data, loading, error }] = useClockOutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClockOutMutation(baseOptions?: Apollo.MutationHookOptions<ClockOutMutation, ClockOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClockOutMutation, ClockOutMutationVariables>(ClockOutDocument, options);
      }
export type ClockOutMutationHookResult = ReturnType<typeof useClockOutMutation>;
export type ClockOutMutationResult = Apollo.MutationResult<ClockOutMutation>;
export type ClockOutMutationOptions = Apollo.BaseMutationOptions<ClockOutMutation, ClockOutMutationVariables>;
export const AddTimeClockSessionDocument = gql`
    mutation addTimeClockSession($endDate: DateTime, $startDate: DateTime!, $employeeId: String!, $station: String) {
  addTimeClockSession(
    endDate: $endDate
    startDate: $startDate
    employeeId: $employeeId
    station: $station
  ) {
    id
  }
}
    `;
export type AddTimeClockSessionMutationFn = Apollo.MutationFunction<AddTimeClockSessionMutation, AddTimeClockSessionMutationVariables>;

/**
 * __useAddTimeClockSessionMutation__
 *
 * To run a mutation, you first call `useAddTimeClockSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTimeClockSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTimeClockSessionMutation, { data, loading, error }] = useAddTimeClockSessionMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      employeeId: // value for 'employeeId'
 *      station: // value for 'station'
 *   },
 * });
 */
export function useAddTimeClockSessionMutation(baseOptions?: Apollo.MutationHookOptions<AddTimeClockSessionMutation, AddTimeClockSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTimeClockSessionMutation, AddTimeClockSessionMutationVariables>(AddTimeClockSessionDocument, options);
      }
export type AddTimeClockSessionMutationHookResult = ReturnType<typeof useAddTimeClockSessionMutation>;
export type AddTimeClockSessionMutationResult = Apollo.MutationResult<AddTimeClockSessionMutation>;
export type AddTimeClockSessionMutationOptions = Apollo.BaseMutationOptions<AddTimeClockSessionMutation, AddTimeClockSessionMutationVariables>;
export const UpdateTimeClockEntryDocument = gql`
    mutation UpdateTimeClockEntry($timeClockEntryId: String!, $data: UpdateTimeClockEntryInput!) {
  updateTimeClockEntry(timeClockEntryId: $timeClockEntryId, data: $data) {
    id
  }
}
    `;
export type UpdateTimeClockEntryMutationFn = Apollo.MutationFunction<UpdateTimeClockEntryMutation, UpdateTimeClockEntryMutationVariables>;

/**
 * __useUpdateTimeClockEntryMutation__
 *
 * To run a mutation, you first call `useUpdateTimeClockEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeClockEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeClockEntryMutation, { data, loading, error }] = useUpdateTimeClockEntryMutation({
 *   variables: {
 *      timeClockEntryId: // value for 'timeClockEntryId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTimeClockEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeClockEntryMutation, UpdateTimeClockEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeClockEntryMutation, UpdateTimeClockEntryMutationVariables>(UpdateTimeClockEntryDocument, options);
      }
export type UpdateTimeClockEntryMutationHookResult = ReturnType<typeof useUpdateTimeClockEntryMutation>;
export type UpdateTimeClockEntryMutationResult = Apollo.MutationResult<UpdateTimeClockEntryMutation>;
export type UpdateTimeClockEntryMutationOptions = Apollo.BaseMutationOptions<UpdateTimeClockEntryMutation, UpdateTimeClockEntryMutationVariables>;
export const DeleteTimeClockEntryDocument = gql`
    mutation DeleteTimeClockEntry($timeClockEntryId: String!) {
  deleteTimeClockEntry(timeClockEntryId: $timeClockEntryId)
}
    `;
export type DeleteTimeClockEntryMutationFn = Apollo.MutationFunction<DeleteTimeClockEntryMutation, DeleteTimeClockEntryMutationVariables>;

/**
 * __useDeleteTimeClockEntryMutation__
 *
 * To run a mutation, you first call `useDeleteTimeClockEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeClockEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeClockEntryMutation, { data, loading, error }] = useDeleteTimeClockEntryMutation({
 *   variables: {
 *      timeClockEntryId: // value for 'timeClockEntryId'
 *   },
 * });
 */
export function useDeleteTimeClockEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeClockEntryMutation, DeleteTimeClockEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeClockEntryMutation, DeleteTimeClockEntryMutationVariables>(DeleteTimeClockEntryDocument, options);
      }
export type DeleteTimeClockEntryMutationHookResult = ReturnType<typeof useDeleteTimeClockEntryMutation>;
export type DeleteTimeClockEntryMutationResult = Apollo.MutationResult<DeleteTimeClockEntryMutation>;
export type DeleteTimeClockEntryMutationOptions = Apollo.BaseMutationOptions<DeleteTimeClockEntryMutation, DeleteTimeClockEntryMutationVariables>;
export const DownloadRevenueCsvDocument = gql`
    mutation DownloadRevenueCSV($data: DashboardInput!, $pagination: PaginationInput!) {
  downloadRevenueCSV(data: $data, pagination: $pagination)
}
    `;
export type DownloadRevenueCsvMutationFn = Apollo.MutationFunction<DownloadRevenueCsvMutation, DownloadRevenueCsvMutationVariables>;

/**
 * __useDownloadRevenueCsvMutation__
 *
 * To run a mutation, you first call `useDownloadRevenueCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadRevenueCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadRevenueCsvMutation, { data, loading, error }] = useDownloadRevenueCsvMutation({
 *   variables: {
 *      data: // value for 'data'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDownloadRevenueCsvMutation(baseOptions?: Apollo.MutationHookOptions<DownloadRevenueCsvMutation, DownloadRevenueCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadRevenueCsvMutation, DownloadRevenueCsvMutationVariables>(DownloadRevenueCsvDocument, options);
      }
export type DownloadRevenueCsvMutationHookResult = ReturnType<typeof useDownloadRevenueCsvMutation>;
export type DownloadRevenueCsvMutationResult = Apollo.MutationResult<DownloadRevenueCsvMutation>;
export type DownloadRevenueCsvMutationOptions = Apollo.BaseMutationOptions<DownloadRevenueCsvMutation, DownloadRevenueCsvMutationVariables>;
export const DownloadAgreementCsvDocument = gql`
    mutation DownloadAgreementCSV($data: DashboardInput!, $pagination: PaginationInput!) {
  downloadAgreementCSV(data: $data, pagination: $pagination)
}
    `;
export type DownloadAgreementCsvMutationFn = Apollo.MutationFunction<DownloadAgreementCsvMutation, DownloadAgreementCsvMutationVariables>;

/**
 * __useDownloadAgreementCsvMutation__
 *
 * To run a mutation, you first call `useDownloadAgreementCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAgreementCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAgreementCsvMutation, { data, loading, error }] = useDownloadAgreementCsvMutation({
 *   variables: {
 *      data: // value for 'data'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDownloadAgreementCsvMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAgreementCsvMutation, DownloadAgreementCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAgreementCsvMutation, DownloadAgreementCsvMutationVariables>(DownloadAgreementCsvDocument, options);
      }
export type DownloadAgreementCsvMutationHookResult = ReturnType<typeof useDownloadAgreementCsvMutation>;
export type DownloadAgreementCsvMutationResult = Apollo.MutationResult<DownloadAgreementCsvMutation>;
export type DownloadAgreementCsvMutationOptions = Apollo.BaseMutationOptions<DownloadAgreementCsvMutation, DownloadAgreementCsvMutationVariables>;
export const DownloadPoStCsvDocument = gql`
    mutation DownloadPOStCSV($data: DashboardInput!, $pagination: PaginationInput!) {
  downloadPosCSV(data: $data, pagination: $pagination)
}
    `;
export type DownloadPoStCsvMutationFn = Apollo.MutationFunction<DownloadPoStCsvMutation, DownloadPoStCsvMutationVariables>;

/**
 * __useDownloadPoStCsvMutation__
 *
 * To run a mutation, you first call `useDownloadPoStCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadPoStCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadPoStCsvMutation, { data, loading, error }] = useDownloadPoStCsvMutation({
 *   variables: {
 *      data: // value for 'data'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDownloadPoStCsvMutation(baseOptions?: Apollo.MutationHookOptions<DownloadPoStCsvMutation, DownloadPoStCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadPoStCsvMutation, DownloadPoStCsvMutationVariables>(DownloadPoStCsvDocument, options);
      }
export type DownloadPoStCsvMutationHookResult = ReturnType<typeof useDownloadPoStCsvMutation>;
export type DownloadPoStCsvMutationResult = Apollo.MutationResult<DownloadPoStCsvMutation>;
export type DownloadPoStCsvMutationOptions = Apollo.BaseMutationOptions<DownloadPoStCsvMutation, DownloadPoStCsvMutationVariables>;
export const CreateDiscountCodeDocument = gql`
    mutation CreateDiscountCode($data: CreateDiscountCodeInput!) {
  createDiscountCode(data: $data) {
    id
    name
  }
}
    `;
export type CreateDiscountCodeMutationFn = Apollo.MutationFunction<CreateDiscountCodeMutation, CreateDiscountCodeMutationVariables>;

/**
 * __useCreateDiscountCodeMutation__
 *
 * To run a mutation, you first call `useCreateDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountCodeMutation, { data, loading, error }] = useCreateDiscountCodeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDiscountCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscountCodeMutation, CreateDiscountCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscountCodeMutation, CreateDiscountCodeMutationVariables>(CreateDiscountCodeDocument, options);
      }
export type CreateDiscountCodeMutationHookResult = ReturnType<typeof useCreateDiscountCodeMutation>;
export type CreateDiscountCodeMutationResult = Apollo.MutationResult<CreateDiscountCodeMutation>;
export type CreateDiscountCodeMutationOptions = Apollo.BaseMutationOptions<CreateDiscountCodeMutation, CreateDiscountCodeMutationVariables>;
export const UpdateDiscountCodeDocument = gql`
    mutation UpdateDiscountCode($data: UpdateDiscountCodeInput!, $updateDiscountCodeId: String!) {
  updateDiscountCode(data: $data, id: $updateDiscountCodeId) {
    id
  }
}
    `;
export type UpdateDiscountCodeMutationFn = Apollo.MutationFunction<UpdateDiscountCodeMutation, UpdateDiscountCodeMutationVariables>;

/**
 * __useUpdateDiscountCodeMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountCodeMutation, { data, loading, error }] = useUpdateDiscountCodeMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateDiscountCodeId: // value for 'updateDiscountCodeId'
 *   },
 * });
 */
export function useUpdateDiscountCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountCodeMutation, UpdateDiscountCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountCodeMutation, UpdateDiscountCodeMutationVariables>(UpdateDiscountCodeDocument, options);
      }
export type UpdateDiscountCodeMutationHookResult = ReturnType<typeof useUpdateDiscountCodeMutation>;
export type UpdateDiscountCodeMutationResult = Apollo.MutationResult<UpdateDiscountCodeMutation>;
export type UpdateDiscountCodeMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountCodeMutation, UpdateDiscountCodeMutationVariables>;
export const DeleteDiscountCodeDocument = gql`
    mutation DeleteDiscountCode($deleteDiscountCodeId: String!) {
  deleteDiscountCode(id: $deleteDiscountCodeId)
}
    `;
export type DeleteDiscountCodeMutationFn = Apollo.MutationFunction<DeleteDiscountCodeMutation, DeleteDiscountCodeMutationVariables>;

/**
 * __useDeleteDiscountCodeMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscountCodeMutation, { data, loading, error }] = useDeleteDiscountCodeMutation({
 *   variables: {
 *      deleteDiscountCodeId: // value for 'deleteDiscountCodeId'
 *   },
 * });
 */
export function useDeleteDiscountCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscountCodeMutation, DeleteDiscountCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscountCodeMutation, DeleteDiscountCodeMutationVariables>(DeleteDiscountCodeDocument, options);
      }
export type DeleteDiscountCodeMutationHookResult = ReturnType<typeof useDeleteDiscountCodeMutation>;
export type DeleteDiscountCodeMutationResult = Apollo.MutationResult<DeleteDiscountCodeMutation>;
export type DeleteDiscountCodeMutationOptions = Apollo.BaseMutationOptions<DeleteDiscountCodeMutation, DeleteDiscountCodeMutationVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($data: CreateEmployeeInput!) {
  createEmployee(data: $data) {
    id
    staffId
    user {
      id
      username
      role
      firstName
      lastName
      email
      phoneNumber
      profilePicUrl
    }
  }
}
    `;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($id: String!, $data: UpdateEmployeeInput!) {
  updateEmployee(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const UpdateRoleAssignmentDocument = gql`
    mutation updateRoleAssignment($roleId: String!, $newRoleId: String!) {
  updateRoleAssignment(roleId: $roleId, newRoleId: $newRoleId)
}
    `;
export type UpdateRoleAssignmentMutationFn = Apollo.MutationFunction<UpdateRoleAssignmentMutation, UpdateRoleAssignmentMutationVariables>;

/**
 * __useUpdateRoleAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateRoleAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleAssignmentMutation, { data, loading, error }] = useUpdateRoleAssignmentMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      newRoleId: // value for 'newRoleId'
 *   },
 * });
 */
export function useUpdateRoleAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleAssignmentMutation, UpdateRoleAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleAssignmentMutation, UpdateRoleAssignmentMutationVariables>(UpdateRoleAssignmentDocument, options);
      }
export type UpdateRoleAssignmentMutationHookResult = ReturnType<typeof useUpdateRoleAssignmentMutation>;
export type UpdateRoleAssignmentMutationResult = Apollo.MutationResult<UpdateRoleAssignmentMutation>;
export type UpdateRoleAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdateRoleAssignmentMutation, UpdateRoleAssignmentMutationVariables>;
export const CreateEmployeeRoleDocument = gql`
    mutation CreateEmployeeRole($data: CreateEmployeeRoleInput!) {
  createEmployeeRole(data: $data) {
    id
  }
}
    `;
export type CreateEmployeeRoleMutationFn = Apollo.MutationFunction<CreateEmployeeRoleMutation, CreateEmployeeRoleMutationVariables>;

/**
 * __useCreateEmployeeRoleMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeRoleMutation, { data, loading, error }] = useCreateEmployeeRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmployeeRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeRoleMutation, CreateEmployeeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeRoleMutation, CreateEmployeeRoleMutationVariables>(CreateEmployeeRoleDocument, options);
      }
export type CreateEmployeeRoleMutationHookResult = ReturnType<typeof useCreateEmployeeRoleMutation>;
export type CreateEmployeeRoleMutationResult = Apollo.MutationResult<CreateEmployeeRoleMutation>;
export type CreateEmployeeRoleMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeRoleMutation, CreateEmployeeRoleMutationVariables>;
export const UpdateEmployeeRoleDocument = gql`
    mutation UpdateEmployeeRole($id: String!, $data: UpdateEmployeeRoleInput!) {
  updateEmployeeRole(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateEmployeeRoleMutationFn = Apollo.MutationFunction<UpdateEmployeeRoleMutation, UpdateEmployeeRoleMutationVariables>;

/**
 * __useUpdateEmployeeRoleMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeRoleMutation, { data, loading, error }] = useUpdateEmployeeRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmployeeRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeRoleMutation, UpdateEmployeeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeRoleMutation, UpdateEmployeeRoleMutationVariables>(UpdateEmployeeRoleDocument, options);
      }
export type UpdateEmployeeRoleMutationHookResult = ReturnType<typeof useUpdateEmployeeRoleMutation>;
export type UpdateEmployeeRoleMutationResult = Apollo.MutationResult<UpdateEmployeeRoleMutation>;
export type UpdateEmployeeRoleMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeRoleMutation, UpdateEmployeeRoleMutationVariables>;
export const DeleteEmployeeRoleDocument = gql`
    mutation DeleteEmployeeRole($deleteEmployeeRoleId: String!) {
  deleteEmployeeRole(id: $deleteEmployeeRoleId)
}
    `;
export type DeleteEmployeeRoleMutationFn = Apollo.MutationFunction<DeleteEmployeeRoleMutation, DeleteEmployeeRoleMutationVariables>;

/**
 * __useDeleteEmployeeRoleMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeRoleMutation, { data, loading, error }] = useDeleteEmployeeRoleMutation({
 *   variables: {
 *      deleteEmployeeRoleId: // value for 'deleteEmployeeRoleId'
 *   },
 * });
 */
export function useDeleteEmployeeRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeRoleMutation, DeleteEmployeeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeRoleMutation, DeleteEmployeeRoleMutationVariables>(DeleteEmployeeRoleDocument, options);
      }
export type DeleteEmployeeRoleMutationHookResult = ReturnType<typeof useDeleteEmployeeRoleMutation>;
export type DeleteEmployeeRoleMutationResult = Apollo.MutationResult<DeleteEmployeeRoleMutation>;
export type DeleteEmployeeRoleMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeRoleMutation, DeleteEmployeeRoleMutationVariables>;
export const CreateEmployeeStationDocument = gql`
    mutation CreateEmployeeStation($data: CreateEmployeeStationInput!) {
  createEmployeeStation(data: $data) {
    id
  }
}
    `;
export type CreateEmployeeStationMutationFn = Apollo.MutationFunction<CreateEmployeeStationMutation, CreateEmployeeStationMutationVariables>;

/**
 * __useCreateEmployeeStationMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeStationMutation, { data, loading, error }] = useCreateEmployeeStationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmployeeStationMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeStationMutation, CreateEmployeeStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeStationMutation, CreateEmployeeStationMutationVariables>(CreateEmployeeStationDocument, options);
      }
export type CreateEmployeeStationMutationHookResult = ReturnType<typeof useCreateEmployeeStationMutation>;
export type CreateEmployeeStationMutationResult = Apollo.MutationResult<CreateEmployeeStationMutation>;
export type CreateEmployeeStationMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeStationMutation, CreateEmployeeStationMutationVariables>;
export const UpdateEmployeeStationDocument = gql`
    mutation UpdateEmployeeStation($id: String!, $data: UpdateEmployeeStationInput!) {
  updateEmployeeStation(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateEmployeeStationMutationFn = Apollo.MutationFunction<UpdateEmployeeStationMutation, UpdateEmployeeStationMutationVariables>;

/**
 * __useUpdateEmployeeStationMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeStationMutation, { data, loading, error }] = useUpdateEmployeeStationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmployeeStationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeStationMutation, UpdateEmployeeStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeStationMutation, UpdateEmployeeStationMutationVariables>(UpdateEmployeeStationDocument, options);
      }
export type UpdateEmployeeStationMutationHookResult = ReturnType<typeof useUpdateEmployeeStationMutation>;
export type UpdateEmployeeStationMutationResult = Apollo.MutationResult<UpdateEmployeeStationMutation>;
export type UpdateEmployeeStationMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeStationMutation, UpdateEmployeeStationMutationVariables>;
export const DeleteEmployeeStationDocument = gql`
    mutation DeleteEmployeeStation($employeeStationId: String!) {
  deleteEmployeeStation(id: $employeeStationId)
}
    `;
export type DeleteEmployeeStationMutationFn = Apollo.MutationFunction<DeleteEmployeeStationMutation, DeleteEmployeeStationMutationVariables>;

/**
 * __useDeleteEmployeeStationMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeStationMutation, { data, loading, error }] = useDeleteEmployeeStationMutation({
 *   variables: {
 *      employeeStationId: // value for 'employeeStationId'
 *   },
 * });
 */
export function useDeleteEmployeeStationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeStationMutation, DeleteEmployeeStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeStationMutation, DeleteEmployeeStationMutationVariables>(DeleteEmployeeStationDocument, options);
      }
export type DeleteEmployeeStationMutationHookResult = ReturnType<typeof useDeleteEmployeeStationMutation>;
export type DeleteEmployeeStationMutationResult = Apollo.MutationResult<DeleteEmployeeStationMutation>;
export type DeleteEmployeeStationMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeStationMutation, DeleteEmployeeStationMutationVariables>;
export const CreateInitialChargeDocument = gql`
    mutation CreateInitialCharge($data: CreateInitialChargeInput!) {
  createInitialCharge(data: $data) {
    id
    cost
    createdDate
    isDiscountable
    revenue {
      name
      id
    }
    fee {
      name
      id
    }
    package {
      id
      name
    }
  }
}
    `;
export type CreateInitialChargeMutationFn = Apollo.MutationFunction<CreateInitialChargeMutation, CreateInitialChargeMutationVariables>;

/**
 * __useCreateInitialChargeMutation__
 *
 * To run a mutation, you first call `useCreateInitialChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInitialChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInitialChargeMutation, { data, loading, error }] = useCreateInitialChargeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInitialChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateInitialChargeMutation, CreateInitialChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInitialChargeMutation, CreateInitialChargeMutationVariables>(CreateInitialChargeDocument, options);
      }
export type CreateInitialChargeMutationHookResult = ReturnType<typeof useCreateInitialChargeMutation>;
export type CreateInitialChargeMutationResult = Apollo.MutationResult<CreateInitialChargeMutation>;
export type CreateInitialChargeMutationOptions = Apollo.BaseMutationOptions<CreateInitialChargeMutation, CreateInitialChargeMutationVariables>;
export const UpdateInitialChargeDocument = gql`
    mutation UpdateInitialCharge($data: UpdateInitialChargeInput!, $updateInitialChargeId: String!) {
  updateInitialCharge(data: $data, id: $updateInitialChargeId) {
    agreement {
      id
      name
    }
    cost
    createdDate
    fee {
      id
      name
    }
    id
    isDiscountable
    package {
      id
      name
    }
    revenue {
      id
      name
    }
  }
}
    `;
export type UpdateInitialChargeMutationFn = Apollo.MutationFunction<UpdateInitialChargeMutation, UpdateInitialChargeMutationVariables>;

/**
 * __useUpdateInitialChargeMutation__
 *
 * To run a mutation, you first call `useUpdateInitialChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInitialChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInitialChargeMutation, { data, loading, error }] = useUpdateInitialChargeMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateInitialChargeId: // value for 'updateInitialChargeId'
 *   },
 * });
 */
export function useUpdateInitialChargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInitialChargeMutation, UpdateInitialChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInitialChargeMutation, UpdateInitialChargeMutationVariables>(UpdateInitialChargeDocument, options);
      }
export type UpdateInitialChargeMutationHookResult = ReturnType<typeof useUpdateInitialChargeMutation>;
export type UpdateInitialChargeMutationResult = Apollo.MutationResult<UpdateInitialChargeMutation>;
export type UpdateInitialChargeMutationOptions = Apollo.BaseMutationOptions<UpdateInitialChargeMutation, UpdateInitialChargeMutationVariables>;
export const DeleteInitialChargeDocument = gql`
    mutation DeleteInitialCharge($deleteInitialChargeId: String!) {
  deleteInitialCharge(id: $deleteInitialChargeId)
}
    `;
export type DeleteInitialChargeMutationFn = Apollo.MutationFunction<DeleteInitialChargeMutation, DeleteInitialChargeMutationVariables>;

/**
 * __useDeleteInitialChargeMutation__
 *
 * To run a mutation, you first call `useDeleteInitialChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInitialChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInitialChargeMutation, { data, loading, error }] = useDeleteInitialChargeMutation({
 *   variables: {
 *      deleteInitialChargeId: // value for 'deleteInitialChargeId'
 *   },
 * });
 */
export function useDeleteInitialChargeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInitialChargeMutation, DeleteInitialChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInitialChargeMutation, DeleteInitialChargeMutationVariables>(DeleteInitialChargeDocument, options);
      }
export type DeleteInitialChargeMutationHookResult = ReturnType<typeof useDeleteInitialChargeMutation>;
export type DeleteInitialChargeMutationResult = Apollo.MutationResult<DeleteInitialChargeMutation>;
export type DeleteInitialChargeMutationOptions = Apollo.BaseMutationOptions<DeleteInitialChargeMutation, DeleteInitialChargeMutationVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($data: CreateLocationInput!) {
  createLocation(data: $data) {
    id
    name
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($id: String!, $data: UpdateLocationInput!) {
  updateLocation(id: $id, data: $data) {
    id
    name
    stationsEnabled
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const CreateLocationMonthlyFeeDocument = gql`
    mutation CreateLocationMonthlyFee($data: CreateLocationMonthlyFeeInput!) {
  createLocationMonthlyFee(data: $data) {
    id
  }
}
    `;
export type CreateLocationMonthlyFeeMutationFn = Apollo.MutationFunction<CreateLocationMonthlyFeeMutation, CreateLocationMonthlyFeeMutationVariables>;

/**
 * __useCreateLocationMonthlyFeeMutation__
 *
 * To run a mutation, you first call `useCreateLocationMonthlyFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMonthlyFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMonthlyFeeMutation, { data, loading, error }] = useCreateLocationMonthlyFeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLocationMonthlyFeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMonthlyFeeMutation, CreateLocationMonthlyFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMonthlyFeeMutation, CreateLocationMonthlyFeeMutationVariables>(CreateLocationMonthlyFeeDocument, options);
      }
export type CreateLocationMonthlyFeeMutationHookResult = ReturnType<typeof useCreateLocationMonthlyFeeMutation>;
export type CreateLocationMonthlyFeeMutationResult = Apollo.MutationResult<CreateLocationMonthlyFeeMutation>;
export type CreateLocationMonthlyFeeMutationOptions = Apollo.BaseMutationOptions<CreateLocationMonthlyFeeMutation, CreateLocationMonthlyFeeMutationVariables>;
export const UpdateLocationMonthlyFeeDocument = gql`
    mutation UpdateLocationMonthlyFee($data: UpdateLocationMonthlyFeeInput!, $id: String!) {
  updateLocationMonthlyFee(data: $data, id: $id) {
    id
  }
}
    `;
export type UpdateLocationMonthlyFeeMutationFn = Apollo.MutationFunction<UpdateLocationMonthlyFeeMutation, UpdateLocationMonthlyFeeMutationVariables>;

/**
 * __useUpdateLocationMonthlyFeeMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMonthlyFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMonthlyFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMonthlyFeeMutation, { data, loading, error }] = useUpdateLocationMonthlyFeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLocationMonthlyFeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMonthlyFeeMutation, UpdateLocationMonthlyFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMonthlyFeeMutation, UpdateLocationMonthlyFeeMutationVariables>(UpdateLocationMonthlyFeeDocument, options);
      }
export type UpdateLocationMonthlyFeeMutationHookResult = ReturnType<typeof useUpdateLocationMonthlyFeeMutation>;
export type UpdateLocationMonthlyFeeMutationResult = Apollo.MutationResult<UpdateLocationMonthlyFeeMutation>;
export type UpdateLocationMonthlyFeeMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMonthlyFeeMutation, UpdateLocationMonthlyFeeMutationVariables>;
export const DeleteLocationMonthlyFeeDocument = gql`
    mutation DeleteLocationMonthlyFee($deleteLocationMonthlyFeeId: String!) {
  deleteLocationMonthlyFee(id: $deleteLocationMonthlyFeeId)
}
    `;
export type DeleteLocationMonthlyFeeMutationFn = Apollo.MutationFunction<DeleteLocationMonthlyFeeMutation, DeleteLocationMonthlyFeeMutationVariables>;

/**
 * __useDeleteLocationMonthlyFeeMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMonthlyFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMonthlyFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMonthlyFeeMutation, { data, loading, error }] = useDeleteLocationMonthlyFeeMutation({
 *   variables: {
 *      deleteLocationMonthlyFeeId: // value for 'deleteLocationMonthlyFeeId'
 *   },
 * });
 */
export function useDeleteLocationMonthlyFeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMonthlyFeeMutation, DeleteLocationMonthlyFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMonthlyFeeMutation, DeleteLocationMonthlyFeeMutationVariables>(DeleteLocationMonthlyFeeDocument, options);
      }
export type DeleteLocationMonthlyFeeMutationHookResult = ReturnType<typeof useDeleteLocationMonthlyFeeMutation>;
export type DeleteLocationMonthlyFeeMutationResult = Apollo.MutationResult<DeleteLocationMonthlyFeeMutation>;
export type DeleteLocationMonthlyFeeMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMonthlyFeeMutation, DeleteLocationMonthlyFeeMutationVariables>;
export const CreateLocationOfferingDocument = gql`
    mutation CreateLocationOffering($data: CreateLocationOfferingInput!) {
  createLocationOffering(data: $data) {
    id
  }
}
    `;
export type CreateLocationOfferingMutationFn = Apollo.MutationFunction<CreateLocationOfferingMutation, CreateLocationOfferingMutationVariables>;

/**
 * __useCreateLocationOfferingMutation__
 *
 * To run a mutation, you first call `useCreateLocationOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationOfferingMutation, { data, loading, error }] = useCreateLocationOfferingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLocationOfferingMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationOfferingMutation, CreateLocationOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationOfferingMutation, CreateLocationOfferingMutationVariables>(CreateLocationOfferingDocument, options);
      }
export type CreateLocationOfferingMutationHookResult = ReturnType<typeof useCreateLocationOfferingMutation>;
export type CreateLocationOfferingMutationResult = Apollo.MutationResult<CreateLocationOfferingMutation>;
export type CreateLocationOfferingMutationOptions = Apollo.BaseMutationOptions<CreateLocationOfferingMutation, CreateLocationOfferingMutationVariables>;
export const UpdateLocationOfferingDocument = gql`
    mutation UpdateLocationOffering($id: String!, $data: UpdateLocationOfferingInput!) {
  updateLocationOffering(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateLocationOfferingMutationFn = Apollo.MutationFunction<UpdateLocationOfferingMutation, UpdateLocationOfferingMutationVariables>;

/**
 * __useUpdateLocationOfferingMutation__
 *
 * To run a mutation, you first call `useUpdateLocationOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationOfferingMutation, { data, loading, error }] = useUpdateLocationOfferingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLocationOfferingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationOfferingMutation, UpdateLocationOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationOfferingMutation, UpdateLocationOfferingMutationVariables>(UpdateLocationOfferingDocument, options);
      }
export type UpdateLocationOfferingMutationHookResult = ReturnType<typeof useUpdateLocationOfferingMutation>;
export type UpdateLocationOfferingMutationResult = Apollo.MutationResult<UpdateLocationOfferingMutation>;
export type UpdateLocationOfferingMutationOptions = Apollo.BaseMutationOptions<UpdateLocationOfferingMutation, UpdateLocationOfferingMutationVariables>;
export const DeleteLocationOfferingDocument = gql`
    mutation DeleteLocationOffering($deleteLocationOfferingId: String!) {
  deleteLocationOffering(id: $deleteLocationOfferingId)
}
    `;
export type DeleteLocationOfferingMutationFn = Apollo.MutationFunction<DeleteLocationOfferingMutation, DeleteLocationOfferingMutationVariables>;

/**
 * __useDeleteLocationOfferingMutation__
 *
 * To run a mutation, you first call `useDeleteLocationOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationOfferingMutation, { data, loading, error }] = useDeleteLocationOfferingMutation({
 *   variables: {
 *      deleteLocationOfferingId: // value for 'deleteLocationOfferingId'
 *   },
 * });
 */
export function useDeleteLocationOfferingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationOfferingMutation, DeleteLocationOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationOfferingMutation, DeleteLocationOfferingMutationVariables>(DeleteLocationOfferingDocument, options);
      }
export type DeleteLocationOfferingMutationHookResult = ReturnType<typeof useDeleteLocationOfferingMutation>;
export type DeleteLocationOfferingMutationResult = Apollo.MutationResult<DeleteLocationOfferingMutation>;
export type DeleteLocationOfferingMutationOptions = Apollo.BaseMutationOptions<DeleteLocationOfferingMutation, DeleteLocationOfferingMutationVariables>;
export const UpdateLocationRevenueDocument = gql`
    mutation UpdateLocationRevenue($data: UpdateLocationRevenueInput!, $updateLocationRevenueId: String!) {
  updateLocationRevenue(data: $data, id: $updateLocationRevenueId) {
    id
  }
}
    `;
export type UpdateLocationRevenueMutationFn = Apollo.MutationFunction<UpdateLocationRevenueMutation, UpdateLocationRevenueMutationVariables>;

/**
 * __useUpdateLocationRevenueMutation__
 *
 * To run a mutation, you first call `useUpdateLocationRevenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationRevenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationRevenueMutation, { data, loading, error }] = useUpdateLocationRevenueMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateLocationRevenueId: // value for 'updateLocationRevenueId'
 *   },
 * });
 */
export function useUpdateLocationRevenueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationRevenueMutation, UpdateLocationRevenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationRevenueMutation, UpdateLocationRevenueMutationVariables>(UpdateLocationRevenueDocument, options);
      }
export type UpdateLocationRevenueMutationHookResult = ReturnType<typeof useUpdateLocationRevenueMutation>;
export type UpdateLocationRevenueMutationResult = Apollo.MutationResult<UpdateLocationRevenueMutation>;
export type UpdateLocationRevenueMutationOptions = Apollo.BaseMutationOptions<UpdateLocationRevenueMutation, UpdateLocationRevenueMutationVariables>;
export const CreateLocationTaxRateDocument = gql`
    mutation CreateLocationTaxRate($data: CreateLocationTaxRateInput!) {
  createLocationTaxRate(data: $data) {
    id
  }
}
    `;
export type CreateLocationTaxRateMutationFn = Apollo.MutationFunction<CreateLocationTaxRateMutation, CreateLocationTaxRateMutationVariables>;

/**
 * __useCreateLocationTaxRateMutation__
 *
 * To run a mutation, you first call `useCreateLocationTaxRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationTaxRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationTaxRateMutation, { data, loading, error }] = useCreateLocationTaxRateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLocationTaxRateMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationTaxRateMutation, CreateLocationTaxRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationTaxRateMutation, CreateLocationTaxRateMutationVariables>(CreateLocationTaxRateDocument, options);
      }
export type CreateLocationTaxRateMutationHookResult = ReturnType<typeof useCreateLocationTaxRateMutation>;
export type CreateLocationTaxRateMutationResult = Apollo.MutationResult<CreateLocationTaxRateMutation>;
export type CreateLocationTaxRateMutationOptions = Apollo.BaseMutationOptions<CreateLocationTaxRateMutation, CreateLocationTaxRateMutationVariables>;
export const UpdateLocationTaxRateDocument = gql`
    mutation UpdateLocationTaxRate($data: UpdateLocationTaxRateInput!, $id: String!) {
  updateLocationTaxRate(data: $data, id: $id) {
    id
  }
}
    `;
export type UpdateLocationTaxRateMutationFn = Apollo.MutationFunction<UpdateLocationTaxRateMutation, UpdateLocationTaxRateMutationVariables>;

/**
 * __useUpdateLocationTaxRateMutation__
 *
 * To run a mutation, you first call `useUpdateLocationTaxRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationTaxRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationTaxRateMutation, { data, loading, error }] = useUpdateLocationTaxRateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLocationTaxRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationTaxRateMutation, UpdateLocationTaxRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationTaxRateMutation, UpdateLocationTaxRateMutationVariables>(UpdateLocationTaxRateDocument, options);
      }
export type UpdateLocationTaxRateMutationHookResult = ReturnType<typeof useUpdateLocationTaxRateMutation>;
export type UpdateLocationTaxRateMutationResult = Apollo.MutationResult<UpdateLocationTaxRateMutation>;
export type UpdateLocationTaxRateMutationOptions = Apollo.BaseMutationOptions<UpdateLocationTaxRateMutation, UpdateLocationTaxRateMutationVariables>;
export const DeleteLocationTaxRateDocument = gql`
    mutation DeleteLocationTaxRate($deleteLocationTaxRateId: String!) {
  deleteLocationTaxRate(id: $deleteLocationTaxRateId)
}
    `;
export type DeleteLocationTaxRateMutationFn = Apollo.MutationFunction<DeleteLocationTaxRateMutation, DeleteLocationTaxRateMutationVariables>;

/**
 * __useDeleteLocationTaxRateMutation__
 *
 * To run a mutation, you first call `useDeleteLocationTaxRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationTaxRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationTaxRateMutation, { data, loading, error }] = useDeleteLocationTaxRateMutation({
 *   variables: {
 *      deleteLocationTaxRateId: // value for 'deleteLocationTaxRateId'
 *   },
 * });
 */
export function useDeleteLocationTaxRateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationTaxRateMutation, DeleteLocationTaxRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationTaxRateMutation, DeleteLocationTaxRateMutationVariables>(DeleteLocationTaxRateDocument, options);
      }
export type DeleteLocationTaxRateMutationHookResult = ReturnType<typeof useDeleteLocationTaxRateMutation>;
export type DeleteLocationTaxRateMutationResult = Apollo.MutationResult<DeleteLocationTaxRateMutation>;
export type DeleteLocationTaxRateMutationOptions = Apollo.BaseMutationOptions<DeleteLocationTaxRateMutation, DeleteLocationTaxRateMutationVariables>;
export const CreateLocationTransactionFeeDocument = gql`
    mutation CreateLocationTransactionFee($data: CreateLocationTransactionFeeInput!) {
  createLocationTransactionFee(data: $data) {
    id
  }
}
    `;
export type CreateLocationTransactionFeeMutationFn = Apollo.MutationFunction<CreateLocationTransactionFeeMutation, CreateLocationTransactionFeeMutationVariables>;

/**
 * __useCreateLocationTransactionFeeMutation__
 *
 * To run a mutation, you first call `useCreateLocationTransactionFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationTransactionFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationTransactionFeeMutation, { data, loading, error }] = useCreateLocationTransactionFeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLocationTransactionFeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationTransactionFeeMutation, CreateLocationTransactionFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationTransactionFeeMutation, CreateLocationTransactionFeeMutationVariables>(CreateLocationTransactionFeeDocument, options);
      }
export type CreateLocationTransactionFeeMutationHookResult = ReturnType<typeof useCreateLocationTransactionFeeMutation>;
export type CreateLocationTransactionFeeMutationResult = Apollo.MutationResult<CreateLocationTransactionFeeMutation>;
export type CreateLocationTransactionFeeMutationOptions = Apollo.BaseMutationOptions<CreateLocationTransactionFeeMutation, CreateLocationTransactionFeeMutationVariables>;
export const UpdateLocationTransactionFeeDocument = gql`
    mutation UpdateLocationTransactionFee($data: UpdateLocationTransactionFeeInput!, $id: String!) {
  updateLocationTransactionFee(data: $data, id: $id) {
    id
  }
}
    `;
export type UpdateLocationTransactionFeeMutationFn = Apollo.MutationFunction<UpdateLocationTransactionFeeMutation, UpdateLocationTransactionFeeMutationVariables>;

/**
 * __useUpdateLocationTransactionFeeMutation__
 *
 * To run a mutation, you first call `useUpdateLocationTransactionFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationTransactionFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationTransactionFeeMutation, { data, loading, error }] = useUpdateLocationTransactionFeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLocationTransactionFeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationTransactionFeeMutation, UpdateLocationTransactionFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationTransactionFeeMutation, UpdateLocationTransactionFeeMutationVariables>(UpdateLocationTransactionFeeDocument, options);
      }
export type UpdateLocationTransactionFeeMutationHookResult = ReturnType<typeof useUpdateLocationTransactionFeeMutation>;
export type UpdateLocationTransactionFeeMutationResult = Apollo.MutationResult<UpdateLocationTransactionFeeMutation>;
export type UpdateLocationTransactionFeeMutationOptions = Apollo.BaseMutationOptions<UpdateLocationTransactionFeeMutation, UpdateLocationTransactionFeeMutationVariables>;
export const DeleteLocationTransactionFeeDocument = gql`
    mutation DeleteLocationTransactionFee($deleteLocationTransactionFeeId: String!) {
  deleteLocationTransactionFee(id: $deleteLocationTransactionFeeId)
}
    `;
export type DeleteLocationTransactionFeeMutationFn = Apollo.MutationFunction<DeleteLocationTransactionFeeMutation, DeleteLocationTransactionFeeMutationVariables>;

/**
 * __useDeleteLocationTransactionFeeMutation__
 *
 * To run a mutation, you first call `useDeleteLocationTransactionFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationTransactionFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationTransactionFeeMutation, { data, loading, error }] = useDeleteLocationTransactionFeeMutation({
 *   variables: {
 *      deleteLocationTransactionFeeId: // value for 'deleteLocationTransactionFeeId'
 *   },
 * });
 */
export function useDeleteLocationTransactionFeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationTransactionFeeMutation, DeleteLocationTransactionFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationTransactionFeeMutation, DeleteLocationTransactionFeeMutationVariables>(DeleteLocationTransactionFeeDocument, options);
      }
export type DeleteLocationTransactionFeeMutationHookResult = ReturnType<typeof useDeleteLocationTransactionFeeMutation>;
export type DeleteLocationTransactionFeeMutationResult = Apollo.MutationResult<DeleteLocationTransactionFeeMutation>;
export type DeleteLocationTransactionFeeMutationOptions = Apollo.BaseMutationOptions<DeleteLocationTransactionFeeMutation, DeleteLocationTransactionFeeMutationVariables>;
export const CreateMeetingDocument = gql`
    mutation CreateMeeting($data: CreateMeetingInput!) {
  createMeeting(data: $data) {
    id
  }
}
    `;
export type CreateMeetingMutationFn = Apollo.MutationFunction<CreateMeetingMutation, CreateMeetingMutationVariables>;

/**
 * __useCreateMeetingMutation__
 *
 * To run a mutation, you first call `useCreateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingMutation, { data, loading, error }] = useCreateMeetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeetingMutation, CreateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeetingMutation, CreateMeetingMutationVariables>(CreateMeetingDocument, options);
      }
export type CreateMeetingMutationHookResult = ReturnType<typeof useCreateMeetingMutation>;
export type CreateMeetingMutationResult = Apollo.MutationResult<CreateMeetingMutation>;
export type CreateMeetingMutationOptions = Apollo.BaseMutationOptions<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const UpdateMeetingDocument = gql`
    mutation UpdateMeeting($data: UpdateMeetingInput!, $id: String!) {
  updateMeeting(data: $data, id: $id) {
    id
  }
}
    `;
export type UpdateMeetingMutationFn = Apollo.MutationFunction<UpdateMeetingMutation, UpdateMeetingMutationVariables>;

/**
 * __useUpdateMeetingMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingMutation, { data, loading, error }] = useUpdateMeetingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeetingMutation, UpdateMeetingMutationVariables>(UpdateMeetingDocument, options);
      }
export type UpdateMeetingMutationHookResult = ReturnType<typeof useUpdateMeetingMutation>;
export type UpdateMeetingMutationResult = Apollo.MutationResult<UpdateMeetingMutation>;
export type UpdateMeetingMutationOptions = Apollo.BaseMutationOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>;
export const DeleteMeetingDocument = gql`
    mutation DeleteMeeting($id: String!) {
  deleteMeeting(id: $id)
}
    `;
export type DeleteMeetingMutationFn = Apollo.MutationFunction<DeleteMeetingMutation, DeleteMeetingMutationVariables>;

/**
 * __useDeleteMeetingMutation__
 *
 * To run a mutation, you first call `useDeleteMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeetingMutation, { data, loading, error }] = useDeleteMeetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMeetingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMeetingMutation, DeleteMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMeetingMutation, DeleteMeetingMutationVariables>(DeleteMeetingDocument, options);
      }
export type DeleteMeetingMutationHookResult = ReturnType<typeof useDeleteMeetingMutation>;
export type DeleteMeetingMutationResult = Apollo.MutationResult<DeleteMeetingMutation>;
export type DeleteMeetingMutationOptions = Apollo.BaseMutationOptions<DeleteMeetingMutation, DeleteMeetingMutationVariables>;
export const SaveCalendarFiltersDocument = gql`
    mutation saveCalendarFilters($data: UpdateCalendarFiltersInput!) {
  saveCalendarFilters(data: $data) {
    id
  }
}
    `;
export type SaveCalendarFiltersMutationFn = Apollo.MutationFunction<SaveCalendarFiltersMutation, SaveCalendarFiltersMutationVariables>;

/**
 * __useSaveCalendarFiltersMutation__
 *
 * To run a mutation, you first call `useSaveCalendarFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCalendarFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCalendarFiltersMutation, { data, loading, error }] = useSaveCalendarFiltersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveCalendarFiltersMutation(baseOptions?: Apollo.MutationHookOptions<SaveCalendarFiltersMutation, SaveCalendarFiltersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCalendarFiltersMutation, SaveCalendarFiltersMutationVariables>(SaveCalendarFiltersDocument, options);
      }
export type SaveCalendarFiltersMutationHookResult = ReturnType<typeof useSaveCalendarFiltersMutation>;
export type SaveCalendarFiltersMutationResult = Apollo.MutationResult<SaveCalendarFiltersMutation>;
export type SaveCalendarFiltersMutationOptions = Apollo.BaseMutationOptions<SaveCalendarFiltersMutation, SaveCalendarFiltersMutationVariables>;
export const ClearCalendarFiltersDocument = gql`
    mutation clearCalendarFilters($locationId: String!) {
  clearCalendarFilters(locationId: $locationId) {
    id
  }
}
    `;
export type ClearCalendarFiltersMutationFn = Apollo.MutationFunction<ClearCalendarFiltersMutation, ClearCalendarFiltersMutationVariables>;

/**
 * __useClearCalendarFiltersMutation__
 *
 * To run a mutation, you first call `useClearCalendarFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCalendarFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCalendarFiltersMutation, { data, loading, error }] = useClearCalendarFiltersMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useClearCalendarFiltersMutation(baseOptions?: Apollo.MutationHookOptions<ClearCalendarFiltersMutation, ClearCalendarFiltersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearCalendarFiltersMutation, ClearCalendarFiltersMutationVariables>(ClearCalendarFiltersDocument, options);
      }
export type ClearCalendarFiltersMutationHookResult = ReturnType<typeof useClearCalendarFiltersMutation>;
export type ClearCalendarFiltersMutationResult = Apollo.MutationResult<ClearCalendarFiltersMutation>;
export type ClearCalendarFiltersMutationOptions = Apollo.BaseMutationOptions<ClearCalendarFiltersMutation, ClearCalendarFiltersMutationVariables>;
export const EnrollToMeetingDocument = gql`
    mutation enrollToMeeting($meetingId: String!, $clientId: String!, $creditAllotmentId: String) {
  enrollToMeeting(
    meetingId: $meetingId
    clientId: $clientId
    creditAllotmentId: $creditAllotmentId
  )
}
    `;
export type EnrollToMeetingMutationFn = Apollo.MutationFunction<EnrollToMeetingMutation, EnrollToMeetingMutationVariables>;

/**
 * __useEnrollToMeetingMutation__
 *
 * To run a mutation, you first call `useEnrollToMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollToMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollToMeetingMutation, { data, loading, error }] = useEnrollToMeetingMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *      clientId: // value for 'clientId'
 *      creditAllotmentId: // value for 'creditAllotmentId'
 *   },
 * });
 */
export function useEnrollToMeetingMutation(baseOptions?: Apollo.MutationHookOptions<EnrollToMeetingMutation, EnrollToMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollToMeetingMutation, EnrollToMeetingMutationVariables>(EnrollToMeetingDocument, options);
      }
export type EnrollToMeetingMutationHookResult = ReturnType<typeof useEnrollToMeetingMutation>;
export type EnrollToMeetingMutationResult = Apollo.MutationResult<EnrollToMeetingMutation>;
export type EnrollToMeetingMutationOptions = Apollo.BaseMutationOptions<EnrollToMeetingMutation, EnrollToMeetingMutationVariables>;
export const CreateMeetingSeriesDocument = gql`
    mutation CreateMeetingSeries($data: CreateMeetingSeriesInput!) {
  createMeetingSeries(data: $data) {
    id
  }
}
    `;
export type CreateMeetingSeriesMutationFn = Apollo.MutationFunction<CreateMeetingSeriesMutation, CreateMeetingSeriesMutationVariables>;

/**
 * __useCreateMeetingSeriesMutation__
 *
 * To run a mutation, you first call `useCreateMeetingSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingSeriesMutation, { data, loading, error }] = useCreateMeetingSeriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMeetingSeriesMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeetingSeriesMutation, CreateMeetingSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeetingSeriesMutation, CreateMeetingSeriesMutationVariables>(CreateMeetingSeriesDocument, options);
      }
export type CreateMeetingSeriesMutationHookResult = ReturnType<typeof useCreateMeetingSeriesMutation>;
export type CreateMeetingSeriesMutationResult = Apollo.MutationResult<CreateMeetingSeriesMutation>;
export type CreateMeetingSeriesMutationOptions = Apollo.BaseMutationOptions<CreateMeetingSeriesMutation, CreateMeetingSeriesMutationVariables>;
export const UpdateMeetingSeriesDocument = gql`
    mutation UpdateMeetingSeries($data: UpdateMeetingSeriesInput!, $id: String!) {
  updateMeetingSeries(data: $data, id: $id) {
    id
  }
}
    `;
export type UpdateMeetingSeriesMutationFn = Apollo.MutationFunction<UpdateMeetingSeriesMutation, UpdateMeetingSeriesMutationVariables>;

/**
 * __useUpdateMeetingSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingSeriesMutation, { data, loading, error }] = useUpdateMeetingSeriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMeetingSeriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeetingSeriesMutation, UpdateMeetingSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeetingSeriesMutation, UpdateMeetingSeriesMutationVariables>(UpdateMeetingSeriesDocument, options);
      }
export type UpdateMeetingSeriesMutationHookResult = ReturnType<typeof useUpdateMeetingSeriesMutation>;
export type UpdateMeetingSeriesMutationResult = Apollo.MutationResult<UpdateMeetingSeriesMutation>;
export type UpdateMeetingSeriesMutationOptions = Apollo.BaseMutationOptions<UpdateMeetingSeriesMutation, UpdateMeetingSeriesMutationVariables>;
export const DeleteMeetingSeriesDocument = gql`
    mutation DeleteMeetingSeries($id: String!) {
  deleteMeetingSeries(id: $id)
}
    `;
export type DeleteMeetingSeriesMutationFn = Apollo.MutationFunction<DeleteMeetingSeriesMutation, DeleteMeetingSeriesMutationVariables>;

/**
 * __useDeleteMeetingSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteMeetingSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeetingSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeetingSeriesMutation, { data, loading, error }] = useDeleteMeetingSeriesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMeetingSeriesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMeetingSeriesMutation, DeleteMeetingSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMeetingSeriesMutation, DeleteMeetingSeriesMutationVariables>(DeleteMeetingSeriesDocument, options);
      }
export type DeleteMeetingSeriesMutationHookResult = ReturnType<typeof useDeleteMeetingSeriesMutation>;
export type DeleteMeetingSeriesMutationResult = Apollo.MutationResult<DeleteMeetingSeriesMutation>;
export type DeleteMeetingSeriesMutationOptions = Apollo.BaseMutationOptions<DeleteMeetingSeriesMutation, DeleteMeetingSeriesMutationVariables>;
export const CreateNotesDocument = gql`
    mutation CreateNotes($data: CreateNotesInput!) {
  createNotes(data: $data) {
    id
  }
}
    `;
export type CreateNotesMutationFn = Apollo.MutationFunction<CreateNotesMutation, CreateNotesMutationVariables>;

/**
 * __useCreateNotesMutation__
 *
 * To run a mutation, you first call `useCreateNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotesMutation, { data, loading, error }] = useCreateNotesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNotesMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotesMutation, CreateNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotesMutation, CreateNotesMutationVariables>(CreateNotesDocument, options);
      }
export type CreateNotesMutationHookResult = ReturnType<typeof useCreateNotesMutation>;
export type CreateNotesMutationResult = Apollo.MutationResult<CreateNotesMutation>;
export type CreateNotesMutationOptions = Apollo.BaseMutationOptions<CreateNotesMutation, CreateNotesMutationVariables>;
export const UpdateNotesDocument = gql`
    mutation UpdateNotes($data: UpdateNotesInput!, $updateNotesId: String!) {
  updateNotes(data: $data, id: $updateNotesId) {
    id
  }
}
    `;
export type UpdateNotesMutationFn = Apollo.MutationFunction<UpdateNotesMutation, UpdateNotesMutationVariables>;

/**
 * __useUpdateNotesMutation__
 *
 * To run a mutation, you first call `useUpdateNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotesMutation, { data, loading, error }] = useUpdateNotesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateNotesId: // value for 'updateNotesId'
 *   },
 * });
 */
export function useUpdateNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotesMutation, UpdateNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotesMutation, UpdateNotesMutationVariables>(UpdateNotesDocument, options);
      }
export type UpdateNotesMutationHookResult = ReturnType<typeof useUpdateNotesMutation>;
export type UpdateNotesMutationResult = Apollo.MutationResult<UpdateNotesMutation>;
export type UpdateNotesMutationOptions = Apollo.BaseMutationOptions<UpdateNotesMutation, UpdateNotesMutationVariables>;
export const DeleteNotesDocument = gql`
    mutation DeleteNotes($deleteNotesId: String!) {
  deleteNotes(id: $deleteNotesId)
}
    `;
export type DeleteNotesMutationFn = Apollo.MutationFunction<DeleteNotesMutation, DeleteNotesMutationVariables>;

/**
 * __useDeleteNotesMutation__
 *
 * To run a mutation, you first call `useDeleteNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotesMutation, { data, loading, error }] = useDeleteNotesMutation({
 *   variables: {
 *      deleteNotesId: // value for 'deleteNotesId'
 *   },
 * });
 */
export function useDeleteNotesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotesMutation, DeleteNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotesMutation, DeleteNotesMutationVariables>(DeleteNotesDocument, options);
      }
export type DeleteNotesMutationHookResult = ReturnType<typeof useDeleteNotesMutation>;
export type DeleteNotesMutationResult = Apollo.MutationResult<DeleteNotesMutation>;
export type DeleteNotesMutationOptions = Apollo.BaseMutationOptions<DeleteNotesMutation, DeleteNotesMutationVariables>;
export const MigrateClientNotesDocument = gql`
    mutation migrateClientNotes($data: NotesJsonArrInput!) {
  migrateClientNotes(data: $data) {
    errors {
      Missing
      Invalid
      Collision
      Default
    }
  }
}
    `;
export type MigrateClientNotesMutationFn = Apollo.MutationFunction<MigrateClientNotesMutation, MigrateClientNotesMutationVariables>;

/**
 * __useMigrateClientNotesMutation__
 *
 * To run a mutation, you first call `useMigrateClientNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateClientNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateClientNotesMutation, { data, loading, error }] = useMigrateClientNotesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMigrateClientNotesMutation(baseOptions?: Apollo.MutationHookOptions<MigrateClientNotesMutation, MigrateClientNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateClientNotesMutation, MigrateClientNotesMutationVariables>(MigrateClientNotesDocument, options);
      }
export type MigrateClientNotesMutationHookResult = ReturnType<typeof useMigrateClientNotesMutation>;
export type MigrateClientNotesMutationResult = Apollo.MutationResult<MigrateClientNotesMutation>;
export type MigrateClientNotesMutationOptions = Apollo.BaseMutationOptions<MigrateClientNotesMutation, MigrateClientNotesMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($data: CreateOrganizationInput!) {
  createOrganization(data: $data) {
    name
    id
    logoUrl
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($data: UpdateOrganizationInput!, $id: String!) {
  updateOrganization(data: $data, id: $id) {
    name
    id
    logoUrl
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationBrandingDocument = gql`
    mutation UpdateOrganizationBranding($data: OrganizationBrandingInput!, $updateOrganizationBrandingId: String!) {
  updateOrganizationBranding(data: $data, id: $updateOrganizationBrandingId) {
    id
  }
}
    `;
export type UpdateOrganizationBrandingMutationFn = Apollo.MutationFunction<UpdateOrganizationBrandingMutation, UpdateOrganizationBrandingMutationVariables>;

/**
 * __useUpdateOrganizationBrandingMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationBrandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationBrandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationBrandingMutation, { data, loading, error }] = useUpdateOrganizationBrandingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateOrganizationBrandingId: // value for 'updateOrganizationBrandingId'
 *   },
 * });
 */
export function useUpdateOrganizationBrandingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationBrandingMutation, UpdateOrganizationBrandingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationBrandingMutation, UpdateOrganizationBrandingMutationVariables>(UpdateOrganizationBrandingDocument, options);
      }
export type UpdateOrganizationBrandingMutationHookResult = ReturnType<typeof useUpdateOrganizationBrandingMutation>;
export type UpdateOrganizationBrandingMutationResult = Apollo.MutationResult<UpdateOrganizationBrandingMutation>;
export type UpdateOrganizationBrandingMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationBrandingMutation, UpdateOrganizationBrandingMutationVariables>;
export const UpdateOrganizationSettingsDocument = gql`
    mutation UpdateOrganizationSettings($id: String!, $data: OrganizationSettingsInput!) {
  updateOrganizationSettings(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateOrganizationSettingsMutationFn = Apollo.MutationFunction<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;

/**
 * __useUpdateOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingsMutation, { data, loading, error }] = useUpdateOrganizationSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>(UpdateOrganizationSettingsDocument, options);
      }
export type UpdateOrganizationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationResult = Apollo.MutationResult<UpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;
export const CreateOrganizationTaxRateDocument = gql`
    mutation CreateOrganizationTaxRate($data: CreateOrganizationTaxRateInput!) {
  createOrganizationTaxRate(data: $data) {
    id
  }
}
    `;
export type CreateOrganizationTaxRateMutationFn = Apollo.MutationFunction<CreateOrganizationTaxRateMutation, CreateOrganizationTaxRateMutationVariables>;

/**
 * __useCreateOrganizationTaxRateMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationTaxRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationTaxRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationTaxRateMutation, { data, loading, error }] = useCreateOrganizationTaxRateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizationTaxRateMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationTaxRateMutation, CreateOrganizationTaxRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationTaxRateMutation, CreateOrganizationTaxRateMutationVariables>(CreateOrganizationTaxRateDocument, options);
      }
export type CreateOrganizationTaxRateMutationHookResult = ReturnType<typeof useCreateOrganizationTaxRateMutation>;
export type CreateOrganizationTaxRateMutationResult = Apollo.MutationResult<CreateOrganizationTaxRateMutation>;
export type CreateOrganizationTaxRateMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationTaxRateMutation, CreateOrganizationTaxRateMutationVariables>;
export const UpdateOrganizationTaxRateDocument = gql`
    mutation UpdateOrganizationTaxRate($data: UpdateOrganizationTaxRateInput!, $id: String!) {
  updateOrganizationTaxRate(data: $data, id: $id) {
    id
  }
}
    `;
export type UpdateOrganizationTaxRateMutationFn = Apollo.MutationFunction<UpdateOrganizationTaxRateMutation, UpdateOrganizationTaxRateMutationVariables>;

/**
 * __useUpdateOrganizationTaxRateMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationTaxRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationTaxRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationTaxRateMutation, { data, loading, error }] = useUpdateOrganizationTaxRateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOrganizationTaxRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationTaxRateMutation, UpdateOrganizationTaxRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationTaxRateMutation, UpdateOrganizationTaxRateMutationVariables>(UpdateOrganizationTaxRateDocument, options);
      }
export type UpdateOrganizationTaxRateMutationHookResult = ReturnType<typeof useUpdateOrganizationTaxRateMutation>;
export type UpdateOrganizationTaxRateMutationResult = Apollo.MutationResult<UpdateOrganizationTaxRateMutation>;
export type UpdateOrganizationTaxRateMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationTaxRateMutation, UpdateOrganizationTaxRateMutationVariables>;
export const DeleteOrganizationTaxRateDocument = gql`
    mutation DeleteOrganizationTaxRate($deleteOrganizationTaxRateId: String!) {
  deleteOrganizationTaxRate(id: $deleteOrganizationTaxRateId)
}
    `;
export type DeleteOrganizationTaxRateMutationFn = Apollo.MutationFunction<DeleteOrganizationTaxRateMutation, DeleteOrganizationTaxRateMutationVariables>;

/**
 * __useDeleteOrganizationTaxRateMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationTaxRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationTaxRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationTaxRateMutation, { data, loading, error }] = useDeleteOrganizationTaxRateMutation({
 *   variables: {
 *      deleteOrganizationTaxRateId: // value for 'deleteOrganizationTaxRateId'
 *   },
 * });
 */
export function useDeleteOrganizationTaxRateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationTaxRateMutation, DeleteOrganizationTaxRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationTaxRateMutation, DeleteOrganizationTaxRateMutationVariables>(DeleteOrganizationTaxRateDocument, options);
      }
export type DeleteOrganizationTaxRateMutationHookResult = ReturnType<typeof useDeleteOrganizationTaxRateMutation>;
export type DeleteOrganizationTaxRateMutationResult = Apollo.MutationResult<DeleteOrganizationTaxRateMutation>;
export type DeleteOrganizationTaxRateMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationTaxRateMutation, DeleteOrganizationTaxRateMutationVariables>;
export const CreatePackageDocument = gql`
    mutation CreatePackage($data: CreatePackageInput!) {
  createPackage(data: $data) {
    id
  }
}
    `;
export type CreatePackageMutationFn = Apollo.MutationFunction<CreatePackageMutation, CreatePackageMutationVariables>;

/**
 * __useCreatePackageMutation__
 *
 * To run a mutation, you first call `useCreatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageMutation, { data, loading, error }] = useCreatePackageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePackageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageMutation, CreatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageMutation, CreatePackageMutationVariables>(CreatePackageDocument, options);
      }
export type CreatePackageMutationHookResult = ReturnType<typeof useCreatePackageMutation>;
export type CreatePackageMutationResult = Apollo.MutationResult<CreatePackageMutation>;
export type CreatePackageMutationOptions = Apollo.BaseMutationOptions<CreatePackageMutation, CreatePackageMutationVariables>;
export const UpdatePackageDocument = gql`
    mutation UpdatePackage($id: String!, $data: UpdatePackageInput!) {
  updatePackage(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdatePackageMutationFn = Apollo.MutationFunction<UpdatePackageMutation, UpdatePackageMutationVariables>;

/**
 * __useUpdatePackageMutation__
 *
 * To run a mutation, you first call `useUpdatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageMutation, { data, loading, error }] = useUpdatePackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageMutation, UpdatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageMutation, UpdatePackageMutationVariables>(UpdatePackageDocument, options);
      }
export type UpdatePackageMutationHookResult = ReturnType<typeof useUpdatePackageMutation>;
export type UpdatePackageMutationResult = Apollo.MutationResult<UpdatePackageMutation>;
export type UpdatePackageMutationOptions = Apollo.BaseMutationOptions<UpdatePackageMutation, UpdatePackageMutationVariables>;
export const CreatePaymentTerminalDocument = gql`
    mutation CreatePaymentTerminal($data: CreatePaymentTerminalInput!) {
  createPaymentTerminal(data: $data) {
    id
    externalId
    physicalId
    name
    location {
      id
    }
  }
}
    `;
export type CreatePaymentTerminalMutationFn = Apollo.MutationFunction<CreatePaymentTerminalMutation, CreatePaymentTerminalMutationVariables>;

/**
 * __useCreatePaymentTerminalMutation__
 *
 * To run a mutation, you first call `useCreatePaymentTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentTerminalMutation, { data, loading, error }] = useCreatePaymentTerminalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePaymentTerminalMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentTerminalMutation, CreatePaymentTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentTerminalMutation, CreatePaymentTerminalMutationVariables>(CreatePaymentTerminalDocument, options);
      }
export type CreatePaymentTerminalMutationHookResult = ReturnType<typeof useCreatePaymentTerminalMutation>;
export type CreatePaymentTerminalMutationResult = Apollo.MutationResult<CreatePaymentTerminalMutation>;
export type CreatePaymentTerminalMutationOptions = Apollo.BaseMutationOptions<CreatePaymentTerminalMutation, CreatePaymentTerminalMutationVariables>;
export const UpdatePaymentTerminalDocument = gql`
    mutation UpdatePaymentTerminal($id: String!, $data: UpdatePaymentTerminalInput!) {
  updatePaymentTerminal(id: $id, data: $data) {
    id
    externalId
    physicalId
    name
    location {
      id
    }
  }
}
    `;
export type UpdatePaymentTerminalMutationFn = Apollo.MutationFunction<UpdatePaymentTerminalMutation, UpdatePaymentTerminalMutationVariables>;

/**
 * __useUpdatePaymentTerminalMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentTerminalMutation, { data, loading, error }] = useUpdatePaymentTerminalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePaymentTerminalMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentTerminalMutation, UpdatePaymentTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentTerminalMutation, UpdatePaymentTerminalMutationVariables>(UpdatePaymentTerminalDocument, options);
      }
export type UpdatePaymentTerminalMutationHookResult = ReturnType<typeof useUpdatePaymentTerminalMutation>;
export type UpdatePaymentTerminalMutationResult = Apollo.MutationResult<UpdatePaymentTerminalMutation>;
export type UpdatePaymentTerminalMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentTerminalMutation, UpdatePaymentTerminalMutationVariables>;
export const DeletePaymentTerminalDocument = gql`
    mutation DeletePaymentTerminal($id: String!) {
  deletePaymentTerminal(id: $id)
}
    `;
export type DeletePaymentTerminalMutationFn = Apollo.MutationFunction<DeletePaymentTerminalMutation, DeletePaymentTerminalMutationVariables>;

/**
 * __useDeletePaymentTerminalMutation__
 *
 * To run a mutation, you first call `useDeletePaymentTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentTerminalMutation, { data, loading, error }] = useDeletePaymentTerminalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePaymentTerminalMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentTerminalMutation, DeletePaymentTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentTerminalMutation, DeletePaymentTerminalMutationVariables>(DeletePaymentTerminalDocument, options);
      }
export type DeletePaymentTerminalMutationHookResult = ReturnType<typeof useDeletePaymentTerminalMutation>;
export type DeletePaymentTerminalMutationResult = Apollo.MutationResult<DeletePaymentTerminalMutation>;
export type DeletePaymentTerminalMutationOptions = Apollo.BaseMutationOptions<DeletePaymentTerminalMutation, DeletePaymentTerminalMutationVariables>;
export const CreatePolicyDocument = gql`
    mutation CreatePolicy($data: CreatePolicyInput!) {
  createPolicy(data: $data) {
    id
    documentId
  }
}
    `;
export type CreatePolicyMutationFn = Apollo.MutationFunction<CreatePolicyMutation, CreatePolicyMutationVariables>;

/**
 * __useCreatePolicyMutation__
 *
 * To run a mutation, you first call `useCreatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPolicyMutation, { data, loading, error }] = useCreatePolicyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePolicyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePolicyMutation, CreatePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePolicyMutation, CreatePolicyMutationVariables>(CreatePolicyDocument, options);
      }
export type CreatePolicyMutationHookResult = ReturnType<typeof useCreatePolicyMutation>;
export type CreatePolicyMutationResult = Apollo.MutationResult<CreatePolicyMutation>;
export type CreatePolicyMutationOptions = Apollo.BaseMutationOptions<CreatePolicyMutation, CreatePolicyMutationVariables>;
export const UpdatePolicyDocument = gql`
    mutation UpdatePolicy($id: String!, $data: UpdatePolicyInput!) {
  updatePolicy(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdatePolicyMutationFn = Apollo.MutationFunction<UpdatePolicyMutation, UpdatePolicyMutationVariables>;

/**
 * __useUpdatePolicyMutation__
 *
 * To run a mutation, you first call `useUpdatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePolicyMutation, { data, loading, error }] = useUpdatePolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePolicyMutation, UpdatePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePolicyMutation, UpdatePolicyMutationVariables>(UpdatePolicyDocument, options);
      }
export type UpdatePolicyMutationHookResult = ReturnType<typeof useUpdatePolicyMutation>;
export type UpdatePolicyMutationResult = Apollo.MutationResult<UpdatePolicyMutation>;
export type UpdatePolicyMutationOptions = Apollo.BaseMutationOptions<UpdatePolicyMutation, UpdatePolicyMutationVariables>;
export const CreatePrivateSessionDocument = gql`
    mutation CreatePrivateSession($data: CreatePrivateSessionInput!) {
  createPrivateSession(data: $data) {
    id
  }
}
    `;
export type CreatePrivateSessionMutationFn = Apollo.MutationFunction<CreatePrivateSessionMutation, CreatePrivateSessionMutationVariables>;

/**
 * __useCreatePrivateSessionMutation__
 *
 * To run a mutation, you first call `useCreatePrivateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrivateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrivateSessionMutation, { data, loading, error }] = useCreatePrivateSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePrivateSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrivateSessionMutation, CreatePrivateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrivateSessionMutation, CreatePrivateSessionMutationVariables>(CreatePrivateSessionDocument, options);
      }
export type CreatePrivateSessionMutationHookResult = ReturnType<typeof useCreatePrivateSessionMutation>;
export type CreatePrivateSessionMutationResult = Apollo.MutationResult<CreatePrivateSessionMutation>;
export type CreatePrivateSessionMutationOptions = Apollo.BaseMutationOptions<CreatePrivateSessionMutation, CreatePrivateSessionMutationVariables>;
export const UpdatePrivateSessionDocument = gql`
    mutation UpdatePrivateSession($id: String!, $data: UpdatePrivateSessionInput!) {
  updatePrivateSession(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdatePrivateSessionMutationFn = Apollo.MutationFunction<UpdatePrivateSessionMutation, UpdatePrivateSessionMutationVariables>;

/**
 * __useUpdatePrivateSessionMutation__
 *
 * To run a mutation, you first call `useUpdatePrivateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivateSessionMutation, { data, loading, error }] = useUpdatePrivateSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePrivateSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrivateSessionMutation, UpdatePrivateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrivateSessionMutation, UpdatePrivateSessionMutationVariables>(UpdatePrivateSessionDocument, options);
      }
export type UpdatePrivateSessionMutationHookResult = ReturnType<typeof useUpdatePrivateSessionMutation>;
export type UpdatePrivateSessionMutationResult = Apollo.MutationResult<UpdatePrivateSessionMutation>;
export type UpdatePrivateSessionMutationOptions = Apollo.BaseMutationOptions<UpdatePrivateSessionMutation, UpdatePrivateSessionMutationVariables>;
export const CreatePrivateSessionDurationDocument = gql`
    mutation CreatePrivateSessionDuration($data: CreatePrivateSessionDurationInput!) {
  createPrivateSessionDuration(data: $data) {
    id
  }
}
    `;
export type CreatePrivateSessionDurationMutationFn = Apollo.MutationFunction<CreatePrivateSessionDurationMutation, CreatePrivateSessionDurationMutationVariables>;

/**
 * __useCreatePrivateSessionDurationMutation__
 *
 * To run a mutation, you first call `useCreatePrivateSessionDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrivateSessionDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrivateSessionDurationMutation, { data, loading, error }] = useCreatePrivateSessionDurationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePrivateSessionDurationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrivateSessionDurationMutation, CreatePrivateSessionDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrivateSessionDurationMutation, CreatePrivateSessionDurationMutationVariables>(CreatePrivateSessionDurationDocument, options);
      }
export type CreatePrivateSessionDurationMutationHookResult = ReturnType<typeof useCreatePrivateSessionDurationMutation>;
export type CreatePrivateSessionDurationMutationResult = Apollo.MutationResult<CreatePrivateSessionDurationMutation>;
export type CreatePrivateSessionDurationMutationOptions = Apollo.BaseMutationOptions<CreatePrivateSessionDurationMutation, CreatePrivateSessionDurationMutationVariables>;
export const UpdatePrivateSessionDurationDocument = gql`
    mutation UpdatePrivateSessionDuration($id: String!, $data: UpdatePrivateSessionDurationInput!) {
  updatePrivateSessionDuration(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdatePrivateSessionDurationMutationFn = Apollo.MutationFunction<UpdatePrivateSessionDurationMutation, UpdatePrivateSessionDurationMutationVariables>;

/**
 * __useUpdatePrivateSessionDurationMutation__
 *
 * To run a mutation, you first call `useUpdatePrivateSessionDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivateSessionDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivateSessionDurationMutation, { data, loading, error }] = useUpdatePrivateSessionDurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePrivateSessionDurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrivateSessionDurationMutation, UpdatePrivateSessionDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrivateSessionDurationMutation, UpdatePrivateSessionDurationMutationVariables>(UpdatePrivateSessionDurationDocument, options);
      }
export type UpdatePrivateSessionDurationMutationHookResult = ReturnType<typeof useUpdatePrivateSessionDurationMutation>;
export type UpdatePrivateSessionDurationMutationResult = Apollo.MutationResult<UpdatePrivateSessionDurationMutation>;
export type UpdatePrivateSessionDurationMutationOptions = Apollo.BaseMutationOptions<UpdatePrivateSessionDurationMutation, UpdatePrivateSessionDurationMutationVariables>;
export const DeletePrivateSessionDurationDocument = gql`
    mutation DeletePrivateSessionDuration($id: String!) {
  deletePrivateSessionDuration(id: $id)
}
    `;
export type DeletePrivateSessionDurationMutationFn = Apollo.MutationFunction<DeletePrivateSessionDurationMutation, DeletePrivateSessionDurationMutationVariables>;

/**
 * __useDeletePrivateSessionDurationMutation__
 *
 * To run a mutation, you first call `useDeletePrivateSessionDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrivateSessionDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrivateSessionDurationMutation, { data, loading, error }] = useDeletePrivateSessionDurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePrivateSessionDurationMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrivateSessionDurationMutation, DeletePrivateSessionDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrivateSessionDurationMutation, DeletePrivateSessionDurationMutationVariables>(DeletePrivateSessionDurationDocument, options);
      }
export type DeletePrivateSessionDurationMutationHookResult = ReturnType<typeof useDeletePrivateSessionDurationMutation>;
export type DeletePrivateSessionDurationMutationResult = Apollo.MutationResult<DeletePrivateSessionDurationMutation>;
export type DeletePrivateSessionDurationMutationOptions = Apollo.BaseMutationOptions<DeletePrivateSessionDurationMutation, DeletePrivateSessionDurationMutationVariables>;
export const CreatePrivateSessionLocationRoomsDocument = gql`
    mutation CreatePrivateSessionLocationRooms($data: CreatePrivateSessionLocationRoomsInput!) {
  createPrivateSessionLocationRooms(data: $data) {
    id
  }
}
    `;
export type CreatePrivateSessionLocationRoomsMutationFn = Apollo.MutationFunction<CreatePrivateSessionLocationRoomsMutation, CreatePrivateSessionLocationRoomsMutationVariables>;

/**
 * __useCreatePrivateSessionLocationRoomsMutation__
 *
 * To run a mutation, you first call `useCreatePrivateSessionLocationRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrivateSessionLocationRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrivateSessionLocationRoomsMutation, { data, loading, error }] = useCreatePrivateSessionLocationRoomsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePrivateSessionLocationRoomsMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrivateSessionLocationRoomsMutation, CreatePrivateSessionLocationRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrivateSessionLocationRoomsMutation, CreatePrivateSessionLocationRoomsMutationVariables>(CreatePrivateSessionLocationRoomsDocument, options);
      }
export type CreatePrivateSessionLocationRoomsMutationHookResult = ReturnType<typeof useCreatePrivateSessionLocationRoomsMutation>;
export type CreatePrivateSessionLocationRoomsMutationResult = Apollo.MutationResult<CreatePrivateSessionLocationRoomsMutation>;
export type CreatePrivateSessionLocationRoomsMutationOptions = Apollo.BaseMutationOptions<CreatePrivateSessionLocationRoomsMutation, CreatePrivateSessionLocationRoomsMutationVariables>;
export const UpdatePrivateSessionLocationRoomsDocument = gql`
    mutation UpdatePrivateSessionLocationRooms($id: String!, $data: UpdatePrivateSessionLocationRoomsInput!) {
  updatePrivateSessionLocationRooms(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdatePrivateSessionLocationRoomsMutationFn = Apollo.MutationFunction<UpdatePrivateSessionLocationRoomsMutation, UpdatePrivateSessionLocationRoomsMutationVariables>;

/**
 * __useUpdatePrivateSessionLocationRoomsMutation__
 *
 * To run a mutation, you first call `useUpdatePrivateSessionLocationRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivateSessionLocationRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivateSessionLocationRoomsMutation, { data, loading, error }] = useUpdatePrivateSessionLocationRoomsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePrivateSessionLocationRoomsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrivateSessionLocationRoomsMutation, UpdatePrivateSessionLocationRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrivateSessionLocationRoomsMutation, UpdatePrivateSessionLocationRoomsMutationVariables>(UpdatePrivateSessionLocationRoomsDocument, options);
      }
export type UpdatePrivateSessionLocationRoomsMutationHookResult = ReturnType<typeof useUpdatePrivateSessionLocationRoomsMutation>;
export type UpdatePrivateSessionLocationRoomsMutationResult = Apollo.MutationResult<UpdatePrivateSessionLocationRoomsMutation>;
export type UpdatePrivateSessionLocationRoomsMutationOptions = Apollo.BaseMutationOptions<UpdatePrivateSessionLocationRoomsMutation, UpdatePrivateSessionLocationRoomsMutationVariables>;
export const DeletePrivateSessionLocationRoomsDocument = gql`
    mutation DeletePrivateSessionLocationRooms($id: String!) {
  deletePrivateSessionLocationRooms(id: $id)
}
    `;
export type DeletePrivateSessionLocationRoomsMutationFn = Apollo.MutationFunction<DeletePrivateSessionLocationRoomsMutation, DeletePrivateSessionLocationRoomsMutationVariables>;

/**
 * __useDeletePrivateSessionLocationRoomsMutation__
 *
 * To run a mutation, you first call `useDeletePrivateSessionLocationRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrivateSessionLocationRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrivateSessionLocationRoomsMutation, { data, loading, error }] = useDeletePrivateSessionLocationRoomsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePrivateSessionLocationRoomsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrivateSessionLocationRoomsMutation, DeletePrivateSessionLocationRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrivateSessionLocationRoomsMutation, DeletePrivateSessionLocationRoomsMutationVariables>(DeletePrivateSessionLocationRoomsDocument, options);
      }
export type DeletePrivateSessionLocationRoomsMutationHookResult = ReturnType<typeof useDeletePrivateSessionLocationRoomsMutation>;
export type DeletePrivateSessionLocationRoomsMutationResult = Apollo.MutationResult<DeletePrivateSessionLocationRoomsMutation>;
export type DeletePrivateSessionLocationRoomsMutationOptions = Apollo.BaseMutationOptions<DeletePrivateSessionLocationRoomsMutation, DeletePrivateSessionLocationRoomsMutationVariables>;
export const CreatePrivateSessionOverrideDocument = gql`
    mutation CreatePrivateSessionOverride($data: CreatePrivateSessionOverrideInput!) {
  createPrivateSessionOverride(data: $data) {
    id
  }
}
    `;
export type CreatePrivateSessionOverrideMutationFn = Apollo.MutationFunction<CreatePrivateSessionOverrideMutation, CreatePrivateSessionOverrideMutationVariables>;

/**
 * __useCreatePrivateSessionOverrideMutation__
 *
 * To run a mutation, you first call `useCreatePrivateSessionOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrivateSessionOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrivateSessionOverrideMutation, { data, loading, error }] = useCreatePrivateSessionOverrideMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePrivateSessionOverrideMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrivateSessionOverrideMutation, CreatePrivateSessionOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrivateSessionOverrideMutation, CreatePrivateSessionOverrideMutationVariables>(CreatePrivateSessionOverrideDocument, options);
      }
export type CreatePrivateSessionOverrideMutationHookResult = ReturnType<typeof useCreatePrivateSessionOverrideMutation>;
export type CreatePrivateSessionOverrideMutationResult = Apollo.MutationResult<CreatePrivateSessionOverrideMutation>;
export type CreatePrivateSessionOverrideMutationOptions = Apollo.BaseMutationOptions<CreatePrivateSessionOverrideMutation, CreatePrivateSessionOverrideMutationVariables>;
export const UpdatePrivateSessionOverrideDocument = gql`
    mutation UpdatePrivateSessionOverride($id: String!, $data: UpdatePrivateSessionOverrideInput!) {
  updatePrivateSessionOverride(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdatePrivateSessionOverrideMutationFn = Apollo.MutationFunction<UpdatePrivateSessionOverrideMutation, UpdatePrivateSessionOverrideMutationVariables>;

/**
 * __useUpdatePrivateSessionOverrideMutation__
 *
 * To run a mutation, you first call `useUpdatePrivateSessionOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivateSessionOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivateSessionOverrideMutation, { data, loading, error }] = useUpdatePrivateSessionOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePrivateSessionOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrivateSessionOverrideMutation, UpdatePrivateSessionOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrivateSessionOverrideMutation, UpdatePrivateSessionOverrideMutationVariables>(UpdatePrivateSessionOverrideDocument, options);
      }
export type UpdatePrivateSessionOverrideMutationHookResult = ReturnType<typeof useUpdatePrivateSessionOverrideMutation>;
export type UpdatePrivateSessionOverrideMutationResult = Apollo.MutationResult<UpdatePrivateSessionOverrideMutation>;
export type UpdatePrivateSessionOverrideMutationOptions = Apollo.BaseMutationOptions<UpdatePrivateSessionOverrideMutation, UpdatePrivateSessionOverrideMutationVariables>;
export const DeletePrivateSessionOverrideDocument = gql`
    mutation DeletePrivateSessionOverride($id: String!) {
  deletePrivateSessionOverride(id: $id)
}
    `;
export type DeletePrivateSessionOverrideMutationFn = Apollo.MutationFunction<DeletePrivateSessionOverrideMutation, DeletePrivateSessionOverrideMutationVariables>;

/**
 * __useDeletePrivateSessionOverrideMutation__
 *
 * To run a mutation, you first call `useDeletePrivateSessionOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrivateSessionOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrivateSessionOverrideMutation, { data, loading, error }] = useDeletePrivateSessionOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePrivateSessionOverrideMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrivateSessionOverrideMutation, DeletePrivateSessionOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrivateSessionOverrideMutation, DeletePrivateSessionOverrideMutationVariables>(DeletePrivateSessionOverrideDocument, options);
      }
export type DeletePrivateSessionOverrideMutationHookResult = ReturnType<typeof useDeletePrivateSessionOverrideMutation>;
export type DeletePrivateSessionOverrideMutationResult = Apollo.MutationResult<DeletePrivateSessionOverrideMutation>;
export type DeletePrivateSessionOverrideMutationOptions = Apollo.BaseMutationOptions<DeletePrivateSessionOverrideMutation, DeletePrivateSessionOverrideMutationVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($data: CreateProductInput!) {
  createProduct(data: $data) {
    id
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: String!, $data: UpdateProductInput!) {
  updateProduct(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($deleteProductId: String!) {
  deleteProduct(id: $deleteProductId)
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      deleteProductId: // value for 'deleteProductId'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const CreateProductGroupDocument = gql`
    mutation CreateProductGroup($data: CreateProductGroupInput!) {
  createProductGroup(data: $data) {
    id
  }
}
    `;
export type CreateProductGroupMutationFn = Apollo.MutationFunction<CreateProductGroupMutation, CreateProductGroupMutationVariables>;

/**
 * __useCreateProductGroupMutation__
 *
 * To run a mutation, you first call `useCreateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductGroupMutation, { data, loading, error }] = useCreateProductGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductGroupMutation, CreateProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductGroupMutation, CreateProductGroupMutationVariables>(CreateProductGroupDocument, options);
      }
export type CreateProductGroupMutationHookResult = ReturnType<typeof useCreateProductGroupMutation>;
export type CreateProductGroupMutationResult = Apollo.MutationResult<CreateProductGroupMutation>;
export type CreateProductGroupMutationOptions = Apollo.BaseMutationOptions<CreateProductGroupMutation, CreateProductGroupMutationVariables>;
export const UpdateProductGroupDocument = gql`
    mutation UpdateProductGroup($updateProductGroupId: String!, $data: UpdateProductGroupInput!) {
  updateProductGroup(id: $updateProductGroupId, data: $data) {
    id
  }
}
    `;
export type UpdateProductGroupMutationFn = Apollo.MutationFunction<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>;

/**
 * __useUpdateProductGroupMutation__
 *
 * To run a mutation, you first call `useUpdateProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductGroupMutation, { data, loading, error }] = useUpdateProductGroupMutation({
 *   variables: {
 *      updateProductGroupId: // value for 'updateProductGroupId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>(UpdateProductGroupDocument, options);
      }
export type UpdateProductGroupMutationHookResult = ReturnType<typeof useUpdateProductGroupMutation>;
export type UpdateProductGroupMutationResult = Apollo.MutationResult<UpdateProductGroupMutation>;
export type UpdateProductGroupMutationOptions = Apollo.BaseMutationOptions<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>;
export const CreateVariantMetricDocument = gql`
    mutation CreateVariantMetric($data: CreateVariantMetricInput!) {
  createVariantMetric(data: $data) {
    id
  }
}
    `;
export type CreateVariantMetricMutationFn = Apollo.MutationFunction<CreateVariantMetricMutation, CreateVariantMetricMutationVariables>;

/**
 * __useCreateVariantMetricMutation__
 *
 * To run a mutation, you first call `useCreateVariantMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVariantMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVariantMetricMutation, { data, loading, error }] = useCreateVariantMetricMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateVariantMetricMutation(baseOptions?: Apollo.MutationHookOptions<CreateVariantMetricMutation, CreateVariantMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVariantMetricMutation, CreateVariantMetricMutationVariables>(CreateVariantMetricDocument, options);
      }
export type CreateVariantMetricMutationHookResult = ReturnType<typeof useCreateVariantMetricMutation>;
export type CreateVariantMetricMutationResult = Apollo.MutationResult<CreateVariantMetricMutation>;
export type CreateVariantMetricMutationOptions = Apollo.BaseMutationOptions<CreateVariantMetricMutation, CreateVariantMetricMutationVariables>;
export const UpdateVariantMetricDocument = gql`
    mutation UpdateVariantMetric($data: UpdateVariantMetricInput!, $id: String!) {
  updateVariantMetric(data: $data, id: $id) {
    id
  }
}
    `;
export type UpdateVariantMetricMutationFn = Apollo.MutationFunction<UpdateVariantMetricMutation, UpdateVariantMetricMutationVariables>;

/**
 * __useUpdateVariantMetricMutation__
 *
 * To run a mutation, you first call `useUpdateVariantMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVariantMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVariantMetricMutation, { data, loading, error }] = useUpdateVariantMetricMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateVariantMetricMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVariantMetricMutation, UpdateVariantMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVariantMetricMutation, UpdateVariantMetricMutationVariables>(UpdateVariantMetricDocument, options);
      }
export type UpdateVariantMetricMutationHookResult = ReturnType<typeof useUpdateVariantMetricMutation>;
export type UpdateVariantMetricMutationResult = Apollo.MutationResult<UpdateVariantMetricMutation>;
export type UpdateVariantMetricMutationOptions = Apollo.BaseMutationOptions<UpdateVariantMetricMutation, UpdateVariantMetricMutationVariables>;
export const DeleteVariantMetricDocument = gql`
    mutation DeleteVariantMetric($id: String!) {
  deleteVariantMetric(id: $id)
}
    `;
export type DeleteVariantMetricMutationFn = Apollo.MutationFunction<DeleteVariantMetricMutation, DeleteVariantMetricMutationVariables>;

/**
 * __useDeleteVariantMetricMutation__
 *
 * To run a mutation, you first call `useDeleteVariantMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVariantMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVariantMetricMutation, { data, loading, error }] = useDeleteVariantMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVariantMetricMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVariantMetricMutation, DeleteVariantMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVariantMetricMutation, DeleteVariantMetricMutationVariables>(DeleteVariantMetricDocument, options);
      }
export type DeleteVariantMetricMutationHookResult = ReturnType<typeof useDeleteVariantMetricMutation>;
export type DeleteVariantMetricMutationResult = Apollo.MutationResult<DeleteVariantMetricMutation>;
export type DeleteVariantMetricMutationOptions = Apollo.BaseMutationOptions<DeleteVariantMetricMutation, DeleteVariantMetricMutationVariables>;
export const CreateRecurringChargeDocument = gql`
    mutation CreateRecurringCharge($data: CreateRecurringChargeInput!) {
  createRecurringCharge(data: $data) {
    id
  }
}
    `;
export type CreateRecurringChargeMutationFn = Apollo.MutationFunction<CreateRecurringChargeMutation, CreateRecurringChargeMutationVariables>;

/**
 * __useCreateRecurringChargeMutation__
 *
 * To run a mutation, you first call `useCreateRecurringChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringChargeMutation, { data, loading, error }] = useCreateRecurringChargeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRecurringChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringChargeMutation, CreateRecurringChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringChargeMutation, CreateRecurringChargeMutationVariables>(CreateRecurringChargeDocument, options);
      }
export type CreateRecurringChargeMutationHookResult = ReturnType<typeof useCreateRecurringChargeMutation>;
export type CreateRecurringChargeMutationResult = Apollo.MutationResult<CreateRecurringChargeMutation>;
export type CreateRecurringChargeMutationOptions = Apollo.BaseMutationOptions<CreateRecurringChargeMutation, CreateRecurringChargeMutationVariables>;
export const UpdateRecurringChargeDocument = gql`
    mutation UpdateRecurringCharge($id: String!, $data: UpdateRecurringChargeInput!) {
  updateRecurringCharge(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateRecurringChargeMutationFn = Apollo.MutationFunction<UpdateRecurringChargeMutation, UpdateRecurringChargeMutationVariables>;

/**
 * __useUpdateRecurringChargeMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringChargeMutation, { data, loading, error }] = useUpdateRecurringChargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRecurringChargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecurringChargeMutation, UpdateRecurringChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecurringChargeMutation, UpdateRecurringChargeMutationVariables>(UpdateRecurringChargeDocument, options);
      }
export type UpdateRecurringChargeMutationHookResult = ReturnType<typeof useUpdateRecurringChargeMutation>;
export type UpdateRecurringChargeMutationResult = Apollo.MutationResult<UpdateRecurringChargeMutation>;
export type UpdateRecurringChargeMutationOptions = Apollo.BaseMutationOptions<UpdateRecurringChargeMutation, UpdateRecurringChargeMutationVariables>;
export const DeleteRecurringChargeDocument = gql`
    mutation DeleteRecurringCharge($deleteRecurringChargeId: String!) {
  deleteRecurringCharge(id: $deleteRecurringChargeId)
}
    `;
export type DeleteRecurringChargeMutationFn = Apollo.MutationFunction<DeleteRecurringChargeMutation, DeleteRecurringChargeMutationVariables>;

/**
 * __useDeleteRecurringChargeMutation__
 *
 * To run a mutation, you first call `useDeleteRecurringChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecurringChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecurringChargeMutation, { data, loading, error }] = useDeleteRecurringChargeMutation({
 *   variables: {
 *      deleteRecurringChargeId: // value for 'deleteRecurringChargeId'
 *   },
 * });
 */
export function useDeleteRecurringChargeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecurringChargeMutation, DeleteRecurringChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecurringChargeMutation, DeleteRecurringChargeMutationVariables>(DeleteRecurringChargeDocument, options);
      }
export type DeleteRecurringChargeMutationHookResult = ReturnType<typeof useDeleteRecurringChargeMutation>;
export type DeleteRecurringChargeMutationResult = Apollo.MutationResult<DeleteRecurringChargeMutation>;
export type DeleteRecurringChargeMutationOptions = Apollo.BaseMutationOptions<DeleteRecurringChargeMutation, DeleteRecurringChargeMutationVariables>;
export const MigratePaymentRecordsDocument = gql`
    mutation migratePaymentRecords($data: PaymentRecordJsonArrInput!, $locationId: String!) {
  migratePaymentRecords(data: $data, locationId: $locationId) {
    errors {
      Missing
      Invalid
      Collision
      Default
    }
  }
}
    `;
export type MigratePaymentRecordsMutationFn = Apollo.MutationFunction<MigratePaymentRecordsMutation, MigratePaymentRecordsMutationVariables>;

/**
 * __useMigratePaymentRecordsMutation__
 *
 * To run a mutation, you first call `useMigratePaymentRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigratePaymentRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migratePaymentRecordsMutation, { data, loading, error }] = useMigratePaymentRecordsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useMigratePaymentRecordsMutation(baseOptions?: Apollo.MutationHookOptions<MigratePaymentRecordsMutation, MigratePaymentRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigratePaymentRecordsMutation, MigratePaymentRecordsMutationVariables>(MigratePaymentRecordsDocument, options);
      }
export type MigratePaymentRecordsMutationHookResult = ReturnType<typeof useMigratePaymentRecordsMutation>;
export type MigratePaymentRecordsMutationResult = Apollo.MutationResult<MigratePaymentRecordsMutation>;
export type MigratePaymentRecordsMutationOptions = Apollo.BaseMutationOptions<MigratePaymentRecordsMutation, MigratePaymentRecordsMutationVariables>;
export const CreateRoomDocument = gql`
    mutation CreateRoom($data: CreateRoomInput!) {
  createRoom(data: $data) {
    id
    name
  }
}
    `;
export type CreateRoomMutationFn = Apollo.MutationFunction<CreateRoomMutation, CreateRoomMutationVariables>;

/**
 * __useCreateRoomMutation__
 *
 * To run a mutation, you first call `useCreateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomMutation, { data, loading, error }] = useCreateRoomMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRoomMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomMutation, CreateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoomMutation, CreateRoomMutationVariables>(CreateRoomDocument, options);
      }
export type CreateRoomMutationHookResult = ReturnType<typeof useCreateRoomMutation>;
export type CreateRoomMutationResult = Apollo.MutationResult<CreateRoomMutation>;
export type CreateRoomMutationOptions = Apollo.BaseMutationOptions<CreateRoomMutation, CreateRoomMutationVariables>;
export const UpdateRoomDocument = gql`
    mutation UpdateRoom($data: UpdateRoomInput!, $updateRoomId: String!) {
  updateRoom(data: $data, id: $updateRoomId) {
    id
    name
  }
}
    `;
export type UpdateRoomMutationFn = Apollo.MutationFunction<UpdateRoomMutation, UpdateRoomMutationVariables>;

/**
 * __useUpdateRoomMutation__
 *
 * To run a mutation, you first call `useUpdateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomMutation, { data, loading, error }] = useUpdateRoomMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateRoomId: // value for 'updateRoomId'
 *   },
 * });
 */
export function useUpdateRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomMutation, UpdateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomMutation, UpdateRoomMutationVariables>(UpdateRoomDocument, options);
      }
export type UpdateRoomMutationHookResult = ReturnType<typeof useUpdateRoomMutation>;
export type UpdateRoomMutationResult = Apollo.MutationResult<UpdateRoomMutation>;
export type UpdateRoomMutationOptions = Apollo.BaseMutationOptions<UpdateRoomMutation, UpdateRoomMutationVariables>;
export const DeleteRoomDocument = gql`
    mutation DeleteRoom($deleteRoomId: String!) {
  deleteRoom(id: $deleteRoomId)
}
    `;
export type DeleteRoomMutationFn = Apollo.MutationFunction<DeleteRoomMutation, DeleteRoomMutationVariables>;

/**
 * __useDeleteRoomMutation__
 *
 * To run a mutation, you first call `useDeleteRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomMutation, { data, loading, error }] = useDeleteRoomMutation({
 *   variables: {
 *      deleteRoomId: // value for 'deleteRoomId'
 *   },
 * });
 */
export function useDeleteRoomMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomMutation, DeleteRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomMutation, DeleteRoomMutationVariables>(DeleteRoomDocument, options);
      }
export type DeleteRoomMutationHookResult = ReturnType<typeof useDeleteRoomMutation>;
export type DeleteRoomMutationResult = Apollo.MutationResult<DeleteRoomMutation>;
export type DeleteRoomMutationOptions = Apollo.BaseMutationOptions<DeleteRoomMutation, DeleteRoomMutationVariables>;
export const CreateScheduledTransactionDocument = gql`
    mutation CreateScheduledTransaction($data: CreateScheduledTransactionInput!) {
  createScheduledTransaction(data: $data) {
    id
  }
}
    `;
export type CreateScheduledTransactionMutationFn = Apollo.MutationFunction<CreateScheduledTransactionMutation, CreateScheduledTransactionMutationVariables>;

/**
 * __useCreateScheduledTransactionMutation__
 *
 * To run a mutation, you first call `useCreateScheduledTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledTransactionMutation, { data, loading, error }] = useCreateScheduledTransactionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateScheduledTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledTransactionMutation, CreateScheduledTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledTransactionMutation, CreateScheduledTransactionMutationVariables>(CreateScheduledTransactionDocument, options);
      }
export type CreateScheduledTransactionMutationHookResult = ReturnType<typeof useCreateScheduledTransactionMutation>;
export type CreateScheduledTransactionMutationResult = Apollo.MutationResult<CreateScheduledTransactionMutation>;
export type CreateScheduledTransactionMutationOptions = Apollo.BaseMutationOptions<CreateScheduledTransactionMutation, CreateScheduledTransactionMutationVariables>;
export const UpdateScheduledTransactionDocument = gql`
    mutation UpdateScheduledTransaction($id: String!, $data: UpdateScheduledTransactionInput!) {
  updateScheduledTransaction(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateScheduledTransactionMutationFn = Apollo.MutationFunction<UpdateScheduledTransactionMutation, UpdateScheduledTransactionMutationVariables>;

/**
 * __useUpdateScheduledTransactionMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledTransactionMutation, { data, loading, error }] = useUpdateScheduledTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateScheduledTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledTransactionMutation, UpdateScheduledTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledTransactionMutation, UpdateScheduledTransactionMutationVariables>(UpdateScheduledTransactionDocument, options);
      }
export type UpdateScheduledTransactionMutationHookResult = ReturnType<typeof useUpdateScheduledTransactionMutation>;
export type UpdateScheduledTransactionMutationResult = Apollo.MutationResult<UpdateScheduledTransactionMutation>;
export type UpdateScheduledTransactionMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledTransactionMutation, UpdateScheduledTransactionMutationVariables>;
export const DeleteScheduledTransactionDocument = gql`
    mutation DeleteScheduledTransaction($id: String!) {
  deleteScheduledTransaction(id: $id)
}
    `;
export type DeleteScheduledTransactionMutationFn = Apollo.MutationFunction<DeleteScheduledTransactionMutation, DeleteScheduledTransactionMutationVariables>;

/**
 * __useDeleteScheduledTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledTransactionMutation, { data, loading, error }] = useDeleteScheduledTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduledTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledTransactionMutation, DeleteScheduledTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledTransactionMutation, DeleteScheduledTransactionMutationVariables>(DeleteScheduledTransactionDocument, options);
      }
export type DeleteScheduledTransactionMutationHookResult = ReturnType<typeof useDeleteScheduledTransactionMutation>;
export type DeleteScheduledTransactionMutationResult = Apollo.MutationResult<DeleteScheduledTransactionMutation>;
export type DeleteScheduledTransactionMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledTransactionMutation, DeleteScheduledTransactionMutationVariables>;
export const CreateScheduledChargesDocument = gql`
    mutation CreateScheduledCharges($data: CreateScheduledChargesInput!) {
  createScheduledCharges(data: $data) {
    id
  }
}
    `;
export type CreateScheduledChargesMutationFn = Apollo.MutationFunction<CreateScheduledChargesMutation, CreateScheduledChargesMutationVariables>;

/**
 * __useCreateScheduledChargesMutation__
 *
 * To run a mutation, you first call `useCreateScheduledChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledChargesMutation, { data, loading, error }] = useCreateScheduledChargesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateScheduledChargesMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledChargesMutation, CreateScheduledChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledChargesMutation, CreateScheduledChargesMutationVariables>(CreateScheduledChargesDocument, options);
      }
export type CreateScheduledChargesMutationHookResult = ReturnType<typeof useCreateScheduledChargesMutation>;
export type CreateScheduledChargesMutationResult = Apollo.MutationResult<CreateScheduledChargesMutation>;
export type CreateScheduledChargesMutationOptions = Apollo.BaseMutationOptions<CreateScheduledChargesMutation, CreateScheduledChargesMutationVariables>;
export const UpdateScheduledChargesDocument = gql`
    mutation UpdateScheduledCharges($id: String!, $data: UpdateScheduledChargesInput!) {
  updateScheduledCharges(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateScheduledChargesMutationFn = Apollo.MutationFunction<UpdateScheduledChargesMutation, UpdateScheduledChargesMutationVariables>;

/**
 * __useUpdateScheduledChargesMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledChargesMutation, { data, loading, error }] = useUpdateScheduledChargesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateScheduledChargesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledChargesMutation, UpdateScheduledChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledChargesMutation, UpdateScheduledChargesMutationVariables>(UpdateScheduledChargesDocument, options);
      }
export type UpdateScheduledChargesMutationHookResult = ReturnType<typeof useUpdateScheduledChargesMutation>;
export type UpdateScheduledChargesMutationResult = Apollo.MutationResult<UpdateScheduledChargesMutation>;
export type UpdateScheduledChargesMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledChargesMutation, UpdateScheduledChargesMutationVariables>;
export const DeleteScheduledChargesDocument = gql`
    mutation DeleteScheduledCharges($id: String!) {
  deleteScheduledCharges(id: $id)
}
    `;
export type DeleteScheduledChargesMutationFn = Apollo.MutationFunction<DeleteScheduledChargesMutation, DeleteScheduledChargesMutationVariables>;

/**
 * __useDeleteScheduledChargesMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledChargesMutation, { data, loading, error }] = useDeleteScheduledChargesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduledChargesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledChargesMutation, DeleteScheduledChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledChargesMutation, DeleteScheduledChargesMutationVariables>(DeleteScheduledChargesDocument, options);
      }
export type DeleteScheduledChargesMutationHookResult = ReturnType<typeof useDeleteScheduledChargesMutation>;
export type DeleteScheduledChargesMutationResult = Apollo.MutationResult<DeleteScheduledChargesMutation>;
export type DeleteScheduledChargesMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledChargesMutation, DeleteScheduledChargesMutationVariables>;
export const CreateSendgridTemplateDocument = gql`
    mutation CreateSendgridTemplate($data: CreateSendgridTemplateInput!) {
  createsendgridTemplate(data: $data) {
    id
  }
}
    `;
export type CreateSendgridTemplateMutationFn = Apollo.MutationFunction<CreateSendgridTemplateMutation, CreateSendgridTemplateMutationVariables>;

/**
 * __useCreateSendgridTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSendgridTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSendgridTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSendgridTemplateMutation, { data, loading, error }] = useCreateSendgridTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSendgridTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateSendgridTemplateMutation, CreateSendgridTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSendgridTemplateMutation, CreateSendgridTemplateMutationVariables>(CreateSendgridTemplateDocument, options);
      }
export type CreateSendgridTemplateMutationHookResult = ReturnType<typeof useCreateSendgridTemplateMutation>;
export type CreateSendgridTemplateMutationResult = Apollo.MutationResult<CreateSendgridTemplateMutation>;
export type CreateSendgridTemplateMutationOptions = Apollo.BaseMutationOptions<CreateSendgridTemplateMutation, CreateSendgridTemplateMutationVariables>;
export const UpdateSendgridTemplateDocument = gql`
    mutation UpdateSendgridTemplate($id: String!, $data: UpdateSendgridTemplateInput!) {
  updatesendgridTemplate(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateSendgridTemplateMutationFn = Apollo.MutationFunction<UpdateSendgridTemplateMutation, UpdateSendgridTemplateMutationVariables>;

/**
 * __useUpdateSendgridTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSendgridTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSendgridTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSendgridTemplateMutation, { data, loading, error }] = useUpdateSendgridTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSendgridTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSendgridTemplateMutation, UpdateSendgridTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSendgridTemplateMutation, UpdateSendgridTemplateMutationVariables>(UpdateSendgridTemplateDocument, options);
      }
export type UpdateSendgridTemplateMutationHookResult = ReturnType<typeof useUpdateSendgridTemplateMutation>;
export type UpdateSendgridTemplateMutationResult = Apollo.MutationResult<UpdateSendgridTemplateMutation>;
export type UpdateSendgridTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateSendgridTemplateMutation, UpdateSendgridTemplateMutationVariables>;
export const DeleteSendgridTemplateDocument = gql`
    mutation DeleteSendgridTemplate($id: String!) {
  deletesendgridTemplate(id: $id)
}
    `;
export type DeleteSendgridTemplateMutationFn = Apollo.MutationFunction<DeleteSendgridTemplateMutation, DeleteSendgridTemplateMutationVariables>;

/**
 * __useDeleteSendgridTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteSendgridTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSendgridTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSendgridTemplateMutation, { data, loading, error }] = useDeleteSendgridTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSendgridTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSendgridTemplateMutation, DeleteSendgridTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSendgridTemplateMutation, DeleteSendgridTemplateMutationVariables>(DeleteSendgridTemplateDocument, options);
      }
export type DeleteSendgridTemplateMutationHookResult = ReturnType<typeof useDeleteSendgridTemplateMutation>;
export type DeleteSendgridTemplateMutationResult = Apollo.MutationResult<DeleteSendgridTemplateMutation>;
export type DeleteSendgridTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteSendgridTemplateMutation, DeleteSendgridTemplateMutationVariables>;
export const CreateOrganizationServiceDocument = gql`
    mutation CreateOrganizationService($data: CreateOrganizationServiceInput!) {
  createOrganizationService(data: $data) {
    id
  }
}
    `;
export type CreateOrganizationServiceMutationFn = Apollo.MutationFunction<CreateOrganizationServiceMutation, CreateOrganizationServiceMutationVariables>;

/**
 * __useCreateOrganizationServiceMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationServiceMutation, { data, loading, error }] = useCreateOrganizationServiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizationServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationServiceMutation, CreateOrganizationServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationServiceMutation, CreateOrganizationServiceMutationVariables>(CreateOrganizationServiceDocument, options);
      }
export type CreateOrganizationServiceMutationHookResult = ReturnType<typeof useCreateOrganizationServiceMutation>;
export type CreateOrganizationServiceMutationResult = Apollo.MutationResult<CreateOrganizationServiceMutation>;
export type CreateOrganizationServiceMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationServiceMutation, CreateOrganizationServiceMutationVariables>;
export const UpdateOrganizationServiceDocument = gql`
    mutation UpdateOrganizationService($id: String!, $data: UpdateOrganizationServiceInput!) {
  updateOrganizationService(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateOrganizationServiceMutationFn = Apollo.MutationFunction<UpdateOrganizationServiceMutation, UpdateOrganizationServiceMutationVariables>;

/**
 * __useUpdateOrganizationServiceMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationServiceMutation, { data, loading, error }] = useUpdateOrganizationServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationServiceMutation, UpdateOrganizationServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationServiceMutation, UpdateOrganizationServiceMutationVariables>(UpdateOrganizationServiceDocument, options);
      }
export type UpdateOrganizationServiceMutationHookResult = ReturnType<typeof useUpdateOrganizationServiceMutation>;
export type UpdateOrganizationServiceMutationResult = Apollo.MutationResult<UpdateOrganizationServiceMutation>;
export type UpdateOrganizationServiceMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationServiceMutation, UpdateOrganizationServiceMutationVariables>;
export const CreateLocationServiceDocument = gql`
    mutation CreateLocationService($data: CreateLocationServiceInput!) {
  createLocationService(data: $data) {
    id
  }
}
    `;
export type CreateLocationServiceMutationFn = Apollo.MutationFunction<CreateLocationServiceMutation, CreateLocationServiceMutationVariables>;

/**
 * __useCreateLocationServiceMutation__
 *
 * To run a mutation, you first call `useCreateLocationServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationServiceMutation, { data, loading, error }] = useCreateLocationServiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLocationServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationServiceMutation, CreateLocationServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationServiceMutation, CreateLocationServiceMutationVariables>(CreateLocationServiceDocument, options);
      }
export type CreateLocationServiceMutationHookResult = ReturnType<typeof useCreateLocationServiceMutation>;
export type CreateLocationServiceMutationResult = Apollo.MutationResult<CreateLocationServiceMutation>;
export type CreateLocationServiceMutationOptions = Apollo.BaseMutationOptions<CreateLocationServiceMutation, CreateLocationServiceMutationVariables>;
export const UpdateLocationServiceDocument = gql`
    mutation UpdateLocationService($id: String!, $data: UpdateLocationServiceInput!) {
  updateLocationService(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateLocationServiceMutationFn = Apollo.MutationFunction<UpdateLocationServiceMutation, UpdateLocationServiceMutationVariables>;

/**
 * __useUpdateLocationServiceMutation__
 *
 * To run a mutation, you first call `useUpdateLocationServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationServiceMutation, { data, loading, error }] = useUpdateLocationServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLocationServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationServiceMutation, UpdateLocationServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationServiceMutation, UpdateLocationServiceMutationVariables>(UpdateLocationServiceDocument, options);
      }
export type UpdateLocationServiceMutationHookResult = ReturnType<typeof useUpdateLocationServiceMutation>;
export type UpdateLocationServiceMutationResult = Apollo.MutationResult<UpdateLocationServiceMutation>;
export type UpdateLocationServiceMutationOptions = Apollo.BaseMutationOptions<UpdateLocationServiceMutation, UpdateLocationServiceMutationVariables>;
export const DeleteLocationServiceDocument = gql`
    mutation DeleteLocationService($id: String!) {
  deleteLocationService(id: $id)
}
    `;
export type DeleteLocationServiceMutationFn = Apollo.MutationFunction<DeleteLocationServiceMutation, DeleteLocationServiceMutationVariables>;

/**
 * __useDeleteLocationServiceMutation__
 *
 * To run a mutation, you first call `useDeleteLocationServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationServiceMutation, { data, loading, error }] = useDeleteLocationServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationServiceMutation, DeleteLocationServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationServiceMutation, DeleteLocationServiceMutationVariables>(DeleteLocationServiceDocument, options);
      }
export type DeleteLocationServiceMutationHookResult = ReturnType<typeof useDeleteLocationServiceMutation>;
export type DeleteLocationServiceMutationResult = Apollo.MutationResult<DeleteLocationServiceMutation>;
export type DeleteLocationServiceMutationOptions = Apollo.BaseMutationOptions<DeleteLocationServiceMutation, DeleteLocationServiceMutationVariables>;
export const CreateServiceAllotmentDocument = gql`
    mutation CreateServiceAllotment($data: CreateServiceAllotmentInput!) {
  createServiceAllotment(data: $data) {
    id
    name
  }
}
    `;
export type CreateServiceAllotmentMutationFn = Apollo.MutationFunction<CreateServiceAllotmentMutation, CreateServiceAllotmentMutationVariables>;

/**
 * __useCreateServiceAllotmentMutation__
 *
 * To run a mutation, you first call `useCreateServiceAllotmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceAllotmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceAllotmentMutation, { data, loading, error }] = useCreateServiceAllotmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateServiceAllotmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceAllotmentMutation, CreateServiceAllotmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceAllotmentMutation, CreateServiceAllotmentMutationVariables>(CreateServiceAllotmentDocument, options);
      }
export type CreateServiceAllotmentMutationHookResult = ReturnType<typeof useCreateServiceAllotmentMutation>;
export type CreateServiceAllotmentMutationResult = Apollo.MutationResult<CreateServiceAllotmentMutation>;
export type CreateServiceAllotmentMutationOptions = Apollo.BaseMutationOptions<CreateServiceAllotmentMutation, CreateServiceAllotmentMutationVariables>;
export const UpdateServiceAllotmentDocument = gql`
    mutation UpdateServiceAllotment($data: UpdateServiceAllotmentInput!, $updateServiceAllotmentId: String!) {
  updateServiceAllotment(data: $data, id: $updateServiceAllotmentId) {
    id
    name
  }
}
    `;
export type UpdateServiceAllotmentMutationFn = Apollo.MutationFunction<UpdateServiceAllotmentMutation, UpdateServiceAllotmentMutationVariables>;

/**
 * __useUpdateServiceAllotmentMutation__
 *
 * To run a mutation, you first call `useUpdateServiceAllotmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceAllotmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceAllotmentMutation, { data, loading, error }] = useUpdateServiceAllotmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateServiceAllotmentId: // value for 'updateServiceAllotmentId'
 *   },
 * });
 */
export function useUpdateServiceAllotmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceAllotmentMutation, UpdateServiceAllotmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceAllotmentMutation, UpdateServiceAllotmentMutationVariables>(UpdateServiceAllotmentDocument, options);
      }
export type UpdateServiceAllotmentMutationHookResult = ReturnType<typeof useUpdateServiceAllotmentMutation>;
export type UpdateServiceAllotmentMutationResult = Apollo.MutationResult<UpdateServiceAllotmentMutation>;
export type UpdateServiceAllotmentMutationOptions = Apollo.BaseMutationOptions<UpdateServiceAllotmentMutation, UpdateServiceAllotmentMutationVariables>;
export const DeleteServiceAllotmentDocument = gql`
    mutation DeleteServiceAllotment($deleteServiceAllotmentId: String!) {
  deleteServiceAllotment(id: $deleteServiceAllotmentId)
}
    `;
export type DeleteServiceAllotmentMutationFn = Apollo.MutationFunction<DeleteServiceAllotmentMutation, DeleteServiceAllotmentMutationVariables>;

/**
 * __useDeleteServiceAllotmentMutation__
 *
 * To run a mutation, you first call `useDeleteServiceAllotmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceAllotmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceAllotmentMutation, { data, loading, error }] = useDeleteServiceAllotmentMutation({
 *   variables: {
 *      deleteServiceAllotmentId: // value for 'deleteServiceAllotmentId'
 *   },
 * });
 */
export function useDeleteServiceAllotmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceAllotmentMutation, DeleteServiceAllotmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceAllotmentMutation, DeleteServiceAllotmentMutationVariables>(DeleteServiceAllotmentDocument, options);
      }
export type DeleteServiceAllotmentMutationHookResult = ReturnType<typeof useDeleteServiceAllotmentMutation>;
export type DeleteServiceAllotmentMutationResult = Apollo.MutationResult<DeleteServiceAllotmentMutation>;
export type DeleteServiceAllotmentMutationOptions = Apollo.BaseMutationOptions<DeleteServiceAllotmentMutation, DeleteServiceAllotmentMutationVariables>;
export const CreateShoppingCartDocument = gql`
    mutation CreateShoppingCart($data: CreateShoppingCartInput!) {
  createShoppingCart(data: $data) {
    id
    subtotal
    discount
    tax
    total
    discounts
    taxes
    products
    lineItems {
      id
      count
      subtotal
      discount
      discounts
      product {
        id
        name
      }
    }
  }
}
    `;
export type CreateShoppingCartMutationFn = Apollo.MutationFunction<CreateShoppingCartMutation, CreateShoppingCartMutationVariables>;

/**
 * __useCreateShoppingCartMutation__
 *
 * To run a mutation, you first call `useCreateShoppingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShoppingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShoppingCartMutation, { data, loading, error }] = useCreateShoppingCartMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateShoppingCartMutation(baseOptions?: Apollo.MutationHookOptions<CreateShoppingCartMutation, CreateShoppingCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShoppingCartMutation, CreateShoppingCartMutationVariables>(CreateShoppingCartDocument, options);
      }
export type CreateShoppingCartMutationHookResult = ReturnType<typeof useCreateShoppingCartMutation>;
export type CreateShoppingCartMutationResult = Apollo.MutationResult<CreateShoppingCartMutation>;
export type CreateShoppingCartMutationOptions = Apollo.BaseMutationOptions<CreateShoppingCartMutation, CreateShoppingCartMutationVariables>;
export const UpdateShoppingCartDocument = gql`
    mutation UpdateShoppingCart($id: String!, $data: UpdateShoppingCartInput!) {
  updateShoppingCart(id: $id, data: $data) {
    id
    subtotal
    total
    discount
    discounts
    tax
    taxes
    products
    lineItems {
      id
      count
      subtotal
      discount
      discounts
      product {
        id
        name
      }
    }
  }
}
    `;
export type UpdateShoppingCartMutationFn = Apollo.MutationFunction<UpdateShoppingCartMutation, UpdateShoppingCartMutationVariables>;

/**
 * __useUpdateShoppingCartMutation__
 *
 * To run a mutation, you first call `useUpdateShoppingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShoppingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShoppingCartMutation, { data, loading, error }] = useUpdateShoppingCartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateShoppingCartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShoppingCartMutation, UpdateShoppingCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShoppingCartMutation, UpdateShoppingCartMutationVariables>(UpdateShoppingCartDocument, options);
      }
export type UpdateShoppingCartMutationHookResult = ReturnType<typeof useUpdateShoppingCartMutation>;
export type UpdateShoppingCartMutationResult = Apollo.MutationResult<UpdateShoppingCartMutation>;
export type UpdateShoppingCartMutationOptions = Apollo.BaseMutationOptions<UpdateShoppingCartMutation, UpdateShoppingCartMutationVariables>;
export const DeleteShoppingCartDocument = gql`
    mutation DeleteShoppingCart($id: String!) {
  deleteShoppingCart(id: $id)
}
    `;
export type DeleteShoppingCartMutationFn = Apollo.MutationFunction<DeleteShoppingCartMutation, DeleteShoppingCartMutationVariables>;

/**
 * __useDeleteShoppingCartMutation__
 *
 * To run a mutation, you first call `useDeleteShoppingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShoppingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShoppingCartMutation, { data, loading, error }] = useDeleteShoppingCartMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShoppingCartMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShoppingCartMutation, DeleteShoppingCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShoppingCartMutation, DeleteShoppingCartMutationVariables>(DeleteShoppingCartDocument, options);
      }
export type DeleteShoppingCartMutationHookResult = ReturnType<typeof useDeleteShoppingCartMutation>;
export type DeleteShoppingCartMutationResult = Apollo.MutationResult<DeleteShoppingCartMutation>;
export type DeleteShoppingCartMutationOptions = Apollo.BaseMutationOptions<DeleteShoppingCartMutation, DeleteShoppingCartMutationVariables>;
export const CreateSignedAgreementDocument = gql`
    mutation CreateSignedAgreement($data: CreateSignedAgreementInput!) {
  createSignedAgreement(data: $data) {
    id
  }
}
    `;
export type CreateSignedAgreementMutationFn = Apollo.MutationFunction<CreateSignedAgreementMutation, CreateSignedAgreementMutationVariables>;

/**
 * __useCreateSignedAgreementMutation__
 *
 * To run a mutation, you first call `useCreateSignedAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignedAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignedAgreementMutation, { data, loading, error }] = useCreateSignedAgreementMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSignedAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CreateSignedAgreementMutation, CreateSignedAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSignedAgreementMutation, CreateSignedAgreementMutationVariables>(CreateSignedAgreementDocument, options);
      }
export type CreateSignedAgreementMutationHookResult = ReturnType<typeof useCreateSignedAgreementMutation>;
export type CreateSignedAgreementMutationResult = Apollo.MutationResult<CreateSignedAgreementMutation>;
export type CreateSignedAgreementMutationOptions = Apollo.BaseMutationOptions<CreateSignedAgreementMutation, CreateSignedAgreementMutationVariables>;
export const UpdateSignedAgreementDocument = gql`
    mutation UpdateSignedAgreement($data: UpdateSignedAgreementInput!, $id: String!) {
  updateSignedAgreement(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateSignedAgreementMutationFn = Apollo.MutationFunction<UpdateSignedAgreementMutation, UpdateSignedAgreementMutationVariables>;

/**
 * __useUpdateSignedAgreementMutation__
 *
 * To run a mutation, you first call `useUpdateSignedAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignedAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignedAgreementMutation, { data, loading, error }] = useUpdateSignedAgreementMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateSignedAgreementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignedAgreementMutation, UpdateSignedAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSignedAgreementMutation, UpdateSignedAgreementMutationVariables>(UpdateSignedAgreementDocument, options);
      }
export type UpdateSignedAgreementMutationHookResult = ReturnType<typeof useUpdateSignedAgreementMutation>;
export type UpdateSignedAgreementMutationResult = Apollo.MutationResult<UpdateSignedAgreementMutation>;
export type UpdateSignedAgreementMutationOptions = Apollo.BaseMutationOptions<UpdateSignedAgreementMutation, UpdateSignedAgreementMutationVariables>;
export const SignDocumentDocument = gql`
    mutation SignDocument($signDocumentId: String!, $data: SignSignedDocumentInput!) {
  signDocument(id: $signDocumentId, data: $data) {
    id
  }
}
    `;
export type SignDocumentMutationFn = Apollo.MutationFunction<SignDocumentMutation, SignDocumentMutationVariables>;

/**
 * __useSignDocumentMutation__
 *
 * To run a mutation, you first call `useSignDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signDocumentMutation, { data, loading, error }] = useSignDocumentMutation({
 *   variables: {
 *      signDocumentId: // value for 'signDocumentId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSignDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SignDocumentMutation, SignDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignDocumentMutation, SignDocumentMutationVariables>(SignDocumentDocument, options);
      }
export type SignDocumentMutationHookResult = ReturnType<typeof useSignDocumentMutation>;
export type SignDocumentMutationResult = Apollo.MutationResult<SignDocumentMutation>;
export type SignDocumentMutationOptions = Apollo.BaseMutationOptions<SignDocumentMutation, SignDocumentMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($data: UpdateClientSubscriptionInput!, $id: String!) {
  updateSubscription(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const MigrateSubscriptionDocument = gql`
    mutation migrateSubscription($data: SubscriptionJsonArrInput!, $locationId: String!) {
  migrateSubscription(data: $data, locationId: $locationId) {
    errors {
      Missing
      Invalid
      Collision
      Default
    }
  }
}
    `;
export type MigrateSubscriptionMutationFn = Apollo.MutationFunction<MigrateSubscriptionMutation, MigrateSubscriptionMutationVariables>;

/**
 * __useMigrateSubscriptionMutation__
 *
 * To run a mutation, you first call `useMigrateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateSubscriptionMutation, { data, loading, error }] = useMigrateSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useMigrateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<MigrateSubscriptionMutation, MigrateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateSubscriptionMutation, MigrateSubscriptionMutationVariables>(MigrateSubscriptionDocument, options);
      }
export type MigrateSubscriptionMutationHookResult = ReturnType<typeof useMigrateSubscriptionMutation>;
export type MigrateSubscriptionMutationResult = Apollo.MutationResult<MigrateSubscriptionMutation>;
export type MigrateSubscriptionMutationOptions = Apollo.BaseMutationOptions<MigrateSubscriptionMutation, MigrateSubscriptionMutationVariables>;
export const CreateTransactionDocument = gql`
    mutation CreateTransaction($data: CreateTransactionInput!) {
  createTransaction(data: $data) {
    id
    externalId
    amount
    subtotal
    tax
    discount
    transactionStatus
    completedAt
  }
}
    `;
export type CreateTransactionMutationFn = Apollo.MutationFunction<CreateTransactionMutation, CreateTransactionMutationVariables>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, options);
      }
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationResult = Apollo.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationOptions = Apollo.BaseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $data: UpdateUserInput!) {
  updateUser(id: $id, data: $data) {
    id
    username
    role
    firstName
    middleName
    lastName
    email
    phoneNumber
    smsConsent
    profilePicUrl
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: String!) {
  deleteUser(id: $id)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const AcceptTacDocument = gql`
    mutation AcceptTAC {
  acceptTAC
}
    `;
export type AcceptTacMutationFn = Apollo.MutationFunction<AcceptTacMutation, AcceptTacMutationVariables>;

/**
 * __useAcceptTacMutation__
 *
 * To run a mutation, you first call `useAcceptTacMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTacMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTacMutation, { data, loading, error }] = useAcceptTacMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptTacMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTacMutation, AcceptTacMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTacMutation, AcceptTacMutationVariables>(AcceptTacDocument, options);
      }
export type AcceptTacMutationHookResult = ReturnType<typeof useAcceptTacMutation>;
export type AcceptTacMutationResult = Apollo.MutationResult<AcceptTacMutation>;
export type AcceptTacMutationOptions = Apollo.BaseMutationOptions<AcceptTacMutation, AcceptTacMutationVariables>;
export const CreateWaitlisteeDocument = gql`
    mutation CreateWaitlistee($data: CreateWaitlisteeInput!) {
  createWaitlistee(data: $data) {
    id
  }
}
    `;
export type CreateWaitlisteeMutationFn = Apollo.MutationFunction<CreateWaitlisteeMutation, CreateWaitlisteeMutationVariables>;

/**
 * __useCreateWaitlisteeMutation__
 *
 * To run a mutation, you first call `useCreateWaitlisteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWaitlisteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWaitlisteeMutation, { data, loading, error }] = useCreateWaitlisteeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWaitlisteeMutation(baseOptions?: Apollo.MutationHookOptions<CreateWaitlisteeMutation, CreateWaitlisteeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWaitlisteeMutation, CreateWaitlisteeMutationVariables>(CreateWaitlisteeDocument, options);
      }
export type CreateWaitlisteeMutationHookResult = ReturnType<typeof useCreateWaitlisteeMutation>;
export type CreateWaitlisteeMutationResult = Apollo.MutationResult<CreateWaitlisteeMutation>;
export type CreateWaitlisteeMutationOptions = Apollo.BaseMutationOptions<CreateWaitlisteeMutation, CreateWaitlisteeMutationVariables>;
export const DeleteWaitlisteeDocument = gql`
    mutation DeleteWaitlistee($id: String!) {
  deleteWaitlistee(id: $id)
}
    `;
export type DeleteWaitlisteeMutationFn = Apollo.MutationFunction<DeleteWaitlisteeMutation, DeleteWaitlisteeMutationVariables>;

/**
 * __useDeleteWaitlisteeMutation__
 *
 * To run a mutation, you first call `useDeleteWaitlisteeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWaitlisteeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWaitlisteeMutation, { data, loading, error }] = useDeleteWaitlisteeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWaitlisteeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWaitlisteeMutation, DeleteWaitlisteeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWaitlisteeMutation, DeleteWaitlisteeMutationVariables>(DeleteWaitlisteeDocument, options);
      }
export type DeleteWaitlisteeMutationHookResult = ReturnType<typeof useDeleteWaitlisteeMutation>;
export type DeleteWaitlisteeMutationResult = Apollo.MutationResult<DeleteWaitlisteeMutation>;
export type DeleteWaitlisteeMutationOptions = Apollo.BaseMutationOptions<DeleteWaitlisteeMutation, DeleteWaitlisteeMutationVariables>;
export const PullFromMeetingDocument = gql`
    mutation PullFromMeeting($meetingId: String!, $clientId: String!, $cancelEnrollment: Boolean) {
  pullFromMeeting(
    meetingId: $meetingId
    clientId: $clientId
    cancelEnrollment: $cancelEnrollment
  )
}
    `;
export type PullFromMeetingMutationFn = Apollo.MutationFunction<PullFromMeetingMutation, PullFromMeetingMutationVariables>;

/**
 * __usePullFromMeetingMutation__
 *
 * To run a mutation, you first call `usePullFromMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePullFromMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pullFromMeetingMutation, { data, loading, error }] = usePullFromMeetingMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *      clientId: // value for 'clientId'
 *      cancelEnrollment: // value for 'cancelEnrollment'
 *   },
 * });
 */
export function usePullFromMeetingMutation(baseOptions?: Apollo.MutationHookOptions<PullFromMeetingMutation, PullFromMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PullFromMeetingMutation, PullFromMeetingMutationVariables>(PullFromMeetingDocument, options);
      }
export type PullFromMeetingMutationHookResult = ReturnType<typeof usePullFromMeetingMutation>;
export type PullFromMeetingMutationResult = Apollo.MutationResult<PullFromMeetingMutation>;
export type PullFromMeetingMutationOptions = Apollo.BaseMutationOptions<PullFromMeetingMutation, PullFromMeetingMutationVariables>;
export const PushToMeetingDocument = gql`
    mutation PushToMeeting($meetingId: String!, $clientId: String!) {
  pushToMeeting(meetingId: $meetingId, clientId: $clientId)
}
    `;
export type PushToMeetingMutationFn = Apollo.MutationFunction<PushToMeetingMutation, PushToMeetingMutationVariables>;

/**
 * __usePushToMeetingMutation__
 *
 * To run a mutation, you first call `usePushToMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToMeetingMutation, { data, loading, error }] = usePushToMeetingMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function usePushToMeetingMutation(baseOptions?: Apollo.MutationHookOptions<PushToMeetingMutation, PushToMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushToMeetingMutation, PushToMeetingMutationVariables>(PushToMeetingDocument, options);
      }
export type PushToMeetingMutationHookResult = ReturnType<typeof usePushToMeetingMutation>;
export type PushToMeetingMutationResult = Apollo.MutationResult<PushToMeetingMutation>;
export type PushToMeetingMutationOptions = Apollo.BaseMutationOptions<PushToMeetingMutation, PushToMeetingMutationVariables>;
export const GetAdminDocument = gql`
    query GetAdmin($id: String) {
  adminOne(id: $id) {
    id
    organization {
      id
      name
    }
    user {
      id
      firstName
      middleName
      lastName
      email
      phoneNumber
      createdDate
      smsConsent
      profilePicUrl
    }
  }
}
    `;

/**
 * __useGetAdminQuery__
 *
 * To run a query within a React component, call `useGetAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminQuery, GetAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminQuery, GetAdminQueryVariables>(GetAdminDocument, options);
      }
export function useGetAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuery, GetAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminQuery, GetAdminQueryVariables>(GetAdminDocument, options);
        }
export type GetAdminQueryHookResult = ReturnType<typeof useGetAdminQuery>;
export type GetAdminLazyQueryHookResult = ReturnType<typeof useGetAdminLazyQuery>;
export type GetAdminQueryResult = Apollo.QueryResult<GetAdminQuery, GetAdminQueryVariables>;
export const GetAgreementDocument = gql`
    query GetAgreement($id: String!) {
  agreementOne(id: $id) {
    isAutoRenew
    isMembership
    isGeneric
    isOrg
    locations {
      id
      name
    }
    name
    Unit
    termValue
    paymentFrequency
    draftMode
    draftValue
    isGroup
    scalingPrice
    groupPricingType
    limit
    additionalPolicies {
      id
      name
    }
    description
    postponeUntil
    recurringCharges {
      id
      cost
      name
      isTaxable
      isPostTax
      taxRates {
        id
        organizationTaxRate {
          name
        }
      }
      categoryOption {
        id
        name
      }
    }
    initialCharges {
      id
      cost
      isTaxable
      isPostTax
      taxRates {
        id
        organizationTaxRate {
          name
        }
      }
      revenue {
        id
        name
      }
      fee {
        id
        name
      }
      isDiscountable
    }
    initialAllotments {
      id
      name
      credits
    }
    recurringAllotments {
      id
      name
      credits
    }
    accessPeriods {
      id
      location {
        id
        name
      }
      start
      end
    }
  }
}
    `;

/**
 * __useGetAgreementQuery__
 *
 * To run a query within a React component, call `useGetAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgreementQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementQuery, GetAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementQuery, GetAgreementQueryVariables>(GetAgreementDocument, options);
      }
export function useGetAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementQuery, GetAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementQuery, GetAgreementQueryVariables>(GetAgreementDocument, options);
        }
export type GetAgreementQueryHookResult = ReturnType<typeof useGetAgreementQuery>;
export type GetAgreementLazyQueryHookResult = ReturnType<typeof useGetAgreementLazyQuery>;
export type GetAgreementQueryResult = Apollo.QueryResult<GetAgreementQuery, GetAgreementQueryVariables>;
export const GetAgreementManyDocument = gql`
    query GetAgreementMany($locationIds: [GenericConnectInput!]) {
  agreementMany(locationIds: $locationIds) {
    id
    isAutoRenew
    isMembership
    isGeneric
    isOrg
    name
    Unit
    termValue
    additionalPolicies {
      id
      name
    }
    description
    postponeUntil
    recurringCharges {
      id
      cost
      categoryOption {
        id
        name
      }
    }
    initialCharges {
      id
      cost
      revenue {
        id
        name
      }
      fee {
        id
        name
      }
      isDiscountable
    }
    initialAllotments {
      id
      name
      credits
    }
    recurringAllotments {
      id
      name
      credits
    }
    paymentFrequency
    groupPricingType
    isGroup
    limit
    scalingPrice
  }
}
    `;

/**
 * __useGetAgreementManyQuery__
 *
 * To run a query within a React component, call `useGetAgreementManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementManyQuery({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useGetAgreementManyQuery(baseOptions?: Apollo.QueryHookOptions<GetAgreementManyQuery, GetAgreementManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementManyQuery, GetAgreementManyQueryVariables>(GetAgreementManyDocument, options);
      }
export function useGetAgreementManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementManyQuery, GetAgreementManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementManyQuery, GetAgreementManyQueryVariables>(GetAgreementManyDocument, options);
        }
export type GetAgreementManyQueryHookResult = ReturnType<typeof useGetAgreementManyQuery>;
export type GetAgreementManyLazyQueryHookResult = ReturnType<typeof useGetAgreementManyLazyQuery>;
export type GetAgreementManyQueryResult = Apollo.QueryResult<GetAgreementManyQuery, GetAgreementManyQueryVariables>;
export const GetAgreementPageDocument = gql`
    query GetAgreementPage($pagination: PaginationInput!, $locationIds: [GenericConnectInput!]) {
  agreementPage(pagination: $pagination, locationIds: $locationIds) {
    items {
      id
      viid
      version
      isMembership
      isAutoRenew
      isGeneric
      isOrg
      termValue
      Unit
      name
      isActive
    }
    totalRows
  }
}
    `;

/**
 * __useGetAgreementPageQuery__
 *
 * To run a query within a React component, call `useGetAgreementPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useGetAgreementPageQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementPageQuery, GetAgreementPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementPageQuery, GetAgreementPageQueryVariables>(GetAgreementPageDocument, options);
      }
export function useGetAgreementPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementPageQuery, GetAgreementPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementPageQuery, GetAgreementPageQueryVariables>(GetAgreementPageDocument, options);
        }
export type GetAgreementPageQueryHookResult = ReturnType<typeof useGetAgreementPageQuery>;
export type GetAgreementPageLazyQueryHookResult = ReturnType<typeof useGetAgreementPageLazyQuery>;
export type GetAgreementPageQueryResult = Apollo.QueryResult<GetAgreementPageQuery, GetAgreementPageQueryVariables>;
export const GetAgreementNamesDocument = gql`
    query GetAgreementNames($locationIds: [GenericConnectInput!]) {
  agreementMany(locationIds: $locationIds) {
    id
    name
  }
}
    `;

/**
 * __useGetAgreementNamesQuery__
 *
 * To run a query within a React component, call `useGetAgreementNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementNamesQuery({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useGetAgreementNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgreementNamesQuery, GetAgreementNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementNamesQuery, GetAgreementNamesQueryVariables>(GetAgreementNamesDocument, options);
      }
export function useGetAgreementNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementNamesQuery, GetAgreementNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementNamesQuery, GetAgreementNamesQueryVariables>(GetAgreementNamesDocument, options);
        }
export type GetAgreementNamesQueryHookResult = ReturnType<typeof useGetAgreementNamesQuery>;
export type GetAgreementNamesLazyQueryHookResult = ReturnType<typeof useGetAgreementNamesLazyQuery>;
export type GetAgreementNamesQueryResult = Apollo.QueryResult<GetAgreementNamesQuery, GetAgreementNamesQueryVariables>;
export const GetAlterAgreementRecordPageDocument = gql`
    query GetAlterAgreementRecordPage($pagination: PaginationInput!, $locationId: String!) {
  alterAgreementRecordPage(pagination: $pagination, locationId: $locationId) {
    items {
      id
      signedAgreement {
        id
        status
        agreement {
          id
          name
          paymentFrequency
        }
        client {
          id
          user {
            id
            firstName
            lastName
          }
        }
      }
      alterationAgreementStatus
      alterationAgreementType
      notes
      reason {
        id
        reason
      }
      startFreezeAt
      intervals
      reviewedBy {
        id
        firstName
        lastName
      }
      reviewedAt
      createdDate
    }
    totalRows
  }
}
    `;

/**
 * __useGetAlterAgreementRecordPageQuery__
 *
 * To run a query within a React component, call `useGetAlterAgreementRecordPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlterAgreementRecordPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlterAgreementRecordPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetAlterAgreementRecordPageQuery(baseOptions: Apollo.QueryHookOptions<GetAlterAgreementRecordPageQuery, GetAlterAgreementRecordPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlterAgreementRecordPageQuery, GetAlterAgreementRecordPageQueryVariables>(GetAlterAgreementRecordPageDocument, options);
      }
export function useGetAlterAgreementRecordPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlterAgreementRecordPageQuery, GetAlterAgreementRecordPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlterAgreementRecordPageQuery, GetAlterAgreementRecordPageQueryVariables>(GetAlterAgreementRecordPageDocument, options);
        }
export type GetAlterAgreementRecordPageQueryHookResult = ReturnType<typeof useGetAlterAgreementRecordPageQuery>;
export type GetAlterAgreementRecordPageLazyQueryHookResult = ReturnType<typeof useGetAlterAgreementRecordPageLazyQuery>;
export type GetAlterAgreementRecordPageQueryResult = Apollo.QueryResult<GetAlterAgreementRecordPageQuery, GetAlterAgreementRecordPageQueryVariables>;
export const GetAgreementRequestsDocument = gql`
    query GetAgreementRequests($clientId: String!) {
  agreementRequests(clientId: $clientId) {
    id
    signedAgreement {
      id
    }
    alterationAgreementStatus
  }
}
    `;

/**
 * __useGetAgreementRequestsQuery__
 *
 * To run a query within a React component, call `useGetAgreementRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementRequestsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetAgreementRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementRequestsQuery, GetAgreementRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementRequestsQuery, GetAgreementRequestsQueryVariables>(GetAgreementRequestsDocument, options);
      }
export function useGetAgreementRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementRequestsQuery, GetAgreementRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementRequestsQuery, GetAgreementRequestsQueryVariables>(GetAgreementRequestsDocument, options);
        }
export type GetAgreementRequestsQueryHookResult = ReturnType<typeof useGetAgreementRequestsQuery>;
export type GetAgreementRequestsLazyQueryHookResult = ReturnType<typeof useGetAgreementRequestsLazyQuery>;
export type GetAgreementRequestsQueryResult = Apollo.QueryResult<GetAgreementRequestsQuery, GetAgreementRequestsQueryVariables>;
export const GetAlterationReasonsDocument = gql`
    query GetAlterationReasons($type: String, $locationId: String, $includeAll: Boolean) {
  alterationReasonMany(
    type: $type
    locationId: $locationId
    includeAll: $includeAll
  ) {
    id
    reason
    type
    isActive
    location {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAlterationReasonsQuery__
 *
 * To run a query within a React component, call `useGetAlterationReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlterationReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlterationReasonsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      locationId: // value for 'locationId'
 *      includeAll: // value for 'includeAll'
 *   },
 * });
 */
export function useGetAlterationReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetAlterationReasonsQuery, GetAlterationReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlterationReasonsQuery, GetAlterationReasonsQueryVariables>(GetAlterationReasonsDocument, options);
      }
export function useGetAlterationReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlterationReasonsQuery, GetAlterationReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlterationReasonsQuery, GetAlterationReasonsQueryVariables>(GetAlterationReasonsDocument, options);
        }
export type GetAlterationReasonsQueryHookResult = ReturnType<typeof useGetAlterationReasonsQuery>;
export type GetAlterationReasonsLazyQueryHookResult = ReturnType<typeof useGetAlterationReasonsLazyQuery>;
export type GetAlterationReasonsQueryResult = Apollo.QueryResult<GetAlterationReasonsQuery, GetAlterationReasonsQueryVariables>;
export const GetAlterationReasonNamesDocument = gql`
    query GetAlterationReasonNames($locationId: String, $type: String) {
  alterationReasonMany(locationId: $locationId, type: $type) {
    id
    reason
  }
}
    `;

/**
 * __useGetAlterationReasonNamesQuery__
 *
 * To run a query within a React component, call `useGetAlterationReasonNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlterationReasonNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlterationReasonNamesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAlterationReasonNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetAlterationReasonNamesQuery, GetAlterationReasonNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlterationReasonNamesQuery, GetAlterationReasonNamesQueryVariables>(GetAlterationReasonNamesDocument, options);
      }
export function useGetAlterationReasonNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlterationReasonNamesQuery, GetAlterationReasonNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlterationReasonNamesQuery, GetAlterationReasonNamesQueryVariables>(GetAlterationReasonNamesDocument, options);
        }
export type GetAlterationReasonNamesQueryHookResult = ReturnType<typeof useGetAlterationReasonNamesQuery>;
export type GetAlterationReasonNamesLazyQueryHookResult = ReturnType<typeof useGetAlterationReasonNamesLazyQuery>;
export type GetAlterationReasonNamesQueryResult = Apollo.QueryResult<GetAlterationReasonNamesQuery, GetAlterationReasonNamesQueryVariables>;
export const GetAttendanceByClientDocument = gql`
    query GetAttendanceByClient($clientId: String!) {
  attendanceByClient(clientId: $clientId) {
    attendanceStatus
    createdDate
    meeting {
      location {
        name
      }
      startAt
      name
    }
  }
}
    `;

/**
 * __useGetAttendanceByClientQuery__
 *
 * To run a query within a React component, call `useGetAttendanceByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceByClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetAttendanceByClientQuery(baseOptions: Apollo.QueryHookOptions<GetAttendanceByClientQuery, GetAttendanceByClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendanceByClientQuery, GetAttendanceByClientQueryVariables>(GetAttendanceByClientDocument, options);
      }
export function useGetAttendanceByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendanceByClientQuery, GetAttendanceByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendanceByClientQuery, GetAttendanceByClientQueryVariables>(GetAttendanceByClientDocument, options);
        }
export type GetAttendanceByClientQueryHookResult = ReturnType<typeof useGetAttendanceByClientQuery>;
export type GetAttendanceByClientLazyQueryHookResult = ReturnType<typeof useGetAttendanceByClientLazyQuery>;
export type GetAttendanceByClientQueryResult = Apollo.QueryResult<GetAttendanceByClientQuery, GetAttendanceByClientQueryVariables>;
export const GetAttendanceRecordsDocument = gql`
    query GetAttendanceRecords($clientId: String!) {
  attendanceByClient(clientId: $clientId) {
    attendanceStatus
    createdDate
    meeting {
      location {
        name
      }
      startAt
      name
    }
    creditAllotment {
      count
      serviceAllotment {
        name
        credits
      }
    }
  }
}
    `;

/**
 * __useGetAttendanceRecordsQuery__
 *
 * To run a query within a React component, call `useGetAttendanceRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceRecordsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetAttendanceRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetAttendanceRecordsQuery, GetAttendanceRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendanceRecordsQuery, GetAttendanceRecordsQueryVariables>(GetAttendanceRecordsDocument, options);
      }
export function useGetAttendanceRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendanceRecordsQuery, GetAttendanceRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendanceRecordsQuery, GetAttendanceRecordsQueryVariables>(GetAttendanceRecordsDocument, options);
        }
export type GetAttendanceRecordsQueryHookResult = ReturnType<typeof useGetAttendanceRecordsQuery>;
export type GetAttendanceRecordsLazyQueryHookResult = ReturnType<typeof useGetAttendanceRecordsLazyQuery>;
export type GetAttendanceRecordsQueryResult = Apollo.QueryResult<GetAttendanceRecordsQuery, GetAttendanceRecordsQueryVariables>;
export const GetAttendancePageClientGuestDocument = gql`
    query GetAttendancePageClientGuest($pagination: PaginationInput!) {
  attendancePage(pagination: $pagination) {
    items {
      attendanceStatus
      createdDate
      meeting {
        location {
          name
        }
        startAt
        name
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetAttendancePageClientGuestQuery__
 *
 * To run a query within a React component, call `useGetAttendancePageClientGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendancePageClientGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendancePageClientGuestQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAttendancePageClientGuestQuery(baseOptions: Apollo.QueryHookOptions<GetAttendancePageClientGuestQuery, GetAttendancePageClientGuestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendancePageClientGuestQuery, GetAttendancePageClientGuestQueryVariables>(GetAttendancePageClientGuestDocument, options);
      }
export function useGetAttendancePageClientGuestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendancePageClientGuestQuery, GetAttendancePageClientGuestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendancePageClientGuestQuery, GetAttendancePageClientGuestQueryVariables>(GetAttendancePageClientGuestDocument, options);
        }
export type GetAttendancePageClientGuestQueryHookResult = ReturnType<typeof useGetAttendancePageClientGuestQuery>;
export type GetAttendancePageClientGuestLazyQueryHookResult = ReturnType<typeof useGetAttendancePageClientGuestLazyQuery>;
export type GetAttendancePageClientGuestQueryResult = Apollo.QueryResult<GetAttendancePageClientGuestQuery, GetAttendancePageClientGuestQueryVariables>;
export const AttendanceByClientDocument = gql`
    query AttendanceByClient($clientId: String!) {
  attendanceByClientUpcoming(clientId: $clientId) {
    id
    meeting {
      id
      name
      endAt
      startAt
      location {
        name
      }
      room {
        name
      }
    }
  }
}
    `;

/**
 * __useAttendanceByClientQuery__
 *
 * To run a query within a React component, call `useAttendanceByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceByClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAttendanceByClientQuery(baseOptions: Apollo.QueryHookOptions<AttendanceByClientQuery, AttendanceByClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendanceByClientQuery, AttendanceByClientQueryVariables>(AttendanceByClientDocument, options);
      }
export function useAttendanceByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendanceByClientQuery, AttendanceByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendanceByClientQuery, AttendanceByClientQueryVariables>(AttendanceByClientDocument, options);
        }
export type AttendanceByClientQueryHookResult = ReturnType<typeof useAttendanceByClientQuery>;
export type AttendanceByClientLazyQueryHookResult = ReturnType<typeof useAttendanceByClientLazyQuery>;
export type AttendanceByClientQueryResult = Apollo.QueryResult<AttendanceByClientQuery, AttendanceByClientQueryVariables>;
export const GetAttendeePageDocument = gql`
    query GetAttendeePage($pagination: PaginationInput!) {
  attendeePage(pagination: $pagination) {
    items {
      id
      attendeeType
      client {
        id
        user {
          firstName
          lastName
        }
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetAttendeePageQuery__
 *
 * To run a query within a React component, call `useGetAttendeePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeePageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAttendeePageQuery(baseOptions: Apollo.QueryHookOptions<GetAttendeePageQuery, GetAttendeePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendeePageQuery, GetAttendeePageQueryVariables>(GetAttendeePageDocument, options);
      }
export function useGetAttendeePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendeePageQuery, GetAttendeePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendeePageQuery, GetAttendeePageQueryVariables>(GetAttendeePageDocument, options);
        }
export type GetAttendeePageQueryHookResult = ReturnType<typeof useGetAttendeePageQuery>;
export type GetAttendeePageLazyQueryHookResult = ReturnType<typeof useGetAttendeePageLazyQuery>;
export type GetAttendeePageQueryResult = Apollo.QueryResult<GetAttendeePageQuery, GetAttendeePageQueryVariables>;
export const GetAttendeePageCustomerDocument = gql`
    query GetAttendeePageCustomer($pagination: PaginationInput!) {
  attendeePage(pagination: $pagination) {
    items {
      id
      attendeeType
      client {
        id
        user {
          firstName
          lastName
          profilePicUrl
        }
        leadStatus
        memberStatus
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetAttendeePageCustomerQuery__
 *
 * To run a query within a React component, call `useGetAttendeePageCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeePageCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeePageCustomerQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAttendeePageCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetAttendeePageCustomerQuery, GetAttendeePageCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendeePageCustomerQuery, GetAttendeePageCustomerQueryVariables>(GetAttendeePageCustomerDocument, options);
      }
export function useGetAttendeePageCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendeePageCustomerQuery, GetAttendeePageCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendeePageCustomerQuery, GetAttendeePageCustomerQueryVariables>(GetAttendeePageCustomerDocument, options);
        }
export type GetAttendeePageCustomerQueryHookResult = ReturnType<typeof useGetAttendeePageCustomerQuery>;
export type GetAttendeePageCustomerLazyQueryHookResult = ReturnType<typeof useGetAttendeePageCustomerLazyQuery>;
export type GetAttendeePageCustomerQueryResult = Apollo.QueryResult<GetAttendeePageCustomerQuery, GetAttendeePageCustomerQueryVariables>;
export const GetAttendeeNamesDocument = gql`
    query GetAttendeeNames($orgId: String) {
  attendeeMany(orgId: $orgId) {
    id
    client {
      id
      user {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetAttendeeNamesQuery__
 *
 * To run a query within a React component, call `useGetAttendeeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeNamesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAttendeeNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetAttendeeNamesQuery, GetAttendeeNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendeeNamesQuery, GetAttendeeNamesQueryVariables>(GetAttendeeNamesDocument, options);
      }
export function useGetAttendeeNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendeeNamesQuery, GetAttendeeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendeeNamesQuery, GetAttendeeNamesQueryVariables>(GetAttendeeNamesDocument, options);
        }
export type GetAttendeeNamesQueryHookResult = ReturnType<typeof useGetAttendeeNamesQuery>;
export type GetAttendeeNamesLazyQueryHookResult = ReturnType<typeof useGetAttendeeNamesLazyQuery>;
export type GetAttendeeNamesQueryResult = Apollo.QueryResult<GetAttendeeNamesQuery, GetAttendeeNamesQueryVariables>;
export const GetCategoryOptionManyDocument = gql`
    query GetCategoryOptionMany($orgId: String!, $type: String) {
  categoryOptionMany(orgId: $orgId, type: $type) {
    id
    name
    type
  }
}
    `;

/**
 * __useGetCategoryOptionManyQuery__
 *
 * To run a query within a React component, call `useGetCategoryOptionManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryOptionManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryOptionManyQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetCategoryOptionManyQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryOptionManyQuery, GetCategoryOptionManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryOptionManyQuery, GetCategoryOptionManyQueryVariables>(GetCategoryOptionManyDocument, options);
      }
export function useGetCategoryOptionManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryOptionManyQuery, GetCategoryOptionManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryOptionManyQuery, GetCategoryOptionManyQueryVariables>(GetCategoryOptionManyDocument, options);
        }
export type GetCategoryOptionManyQueryHookResult = ReturnType<typeof useGetCategoryOptionManyQuery>;
export type GetCategoryOptionManyLazyQueryHookResult = ReturnType<typeof useGetCategoryOptionManyLazyQuery>;
export type GetCategoryOptionManyQueryResult = Apollo.QueryResult<GetCategoryOptionManyQuery, GetCategoryOptionManyQueryVariables>;
export const CheckInManyDocument = gql`
    query CheckInMany($locationId: String, $todayRecords: Boolean) {
  checkInMany(locationId: $locationId, todayRecords: $todayRecords) {
    id
    createdDate
    isAccepted
    client {
      memberships {
        id
        status
        subscription {
          paymentStatus
        }
        location {
          id
        }
        termStart
        termEnd
      }
      user {
        firstName
        lastName
        profilePicUrl
      }
      memberStatus
      leadStatus
    }
  }
}
    `;

/**
 * __useCheckInManyQuery__
 *
 * To run a query within a React component, call `useCheckInManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInManyQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      todayRecords: // value for 'todayRecords'
 *   },
 * });
 */
export function useCheckInManyQuery(baseOptions?: Apollo.QueryHookOptions<CheckInManyQuery, CheckInManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckInManyQuery, CheckInManyQueryVariables>(CheckInManyDocument, options);
      }
export function useCheckInManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckInManyQuery, CheckInManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckInManyQuery, CheckInManyQueryVariables>(CheckInManyDocument, options);
        }
export type CheckInManyQueryHookResult = ReturnType<typeof useCheckInManyQuery>;
export type CheckInManyLazyQueryHookResult = ReturnType<typeof useCheckInManyLazyQuery>;
export type CheckInManyQueryResult = Apollo.QueryResult<CheckInManyQuery, CheckInManyQueryVariables>;
export const GetnewCheckInDocument = gql`
    subscription GetnewCheckIn($locationId: String!) {
  createCheckInSubscription(locationId: $locationId) {
    newCheckIn {
      id
      createdDate
      isAccepted
      client {
        memberships {
          id
          status
          subscription {
            paymentStatus
          }
          location {
            id
          }
          termStart
          termEnd
        }
        user {
          firstName
          lastName
          profilePicUrl
        }
        memberStatus
        leadStatus
      }
    }
  }
}
    `;

/**
 * __useGetnewCheckInSubscription__
 *
 * To run a query within a React component, call `useGetnewCheckInSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetnewCheckInSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetnewCheckInSubscription({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetnewCheckInSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetnewCheckInSubscription, GetnewCheckInSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetnewCheckInSubscription, GetnewCheckInSubscriptionVariables>(GetnewCheckInDocument, options);
      }
export type GetnewCheckInSubscriptionHookResult = ReturnType<typeof useGetnewCheckInSubscription>;
export type GetnewCheckInSubscriptionResult = Apollo.SubscriptionResult<GetnewCheckInSubscription>;
export const GetCheckInOneDocument = gql`
    query GetCheckInOne($checkInOneId: String!) {
  checkInOne(id: $checkInOneId) {
    id
    isAccepted
    isOverride
    createdDate
    client {
      id
      user {
        firstName
        lastName
        profilePicUrl
      }
      dob
      memberStatus
      leadStatus
      memberships {
        id
        status
        subscription {
          paymentStatus
        }
        location {
          id
        }
        isAutoRenew
        termStart
        termEnd
        agreement {
          id
          name
        }
      }
    }
    isAccepted
    isOverride
  }
}
    `;

/**
 * __useGetCheckInOneQuery__
 *
 * To run a query within a React component, call `useGetCheckInOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckInOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckInOneQuery({
 *   variables: {
 *      checkInOneId: // value for 'checkInOneId'
 *   },
 * });
 */
export function useGetCheckInOneQuery(baseOptions: Apollo.QueryHookOptions<GetCheckInOneQuery, GetCheckInOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckInOneQuery, GetCheckInOneQueryVariables>(GetCheckInOneDocument, options);
      }
export function useGetCheckInOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckInOneQuery, GetCheckInOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckInOneQuery, GetCheckInOneQueryVariables>(GetCheckInOneDocument, options);
        }
export type GetCheckInOneQueryHookResult = ReturnType<typeof useGetCheckInOneQuery>;
export type GetCheckInOneLazyQueryHookResult = ReturnType<typeof useGetCheckInOneLazyQuery>;
export type GetCheckInOneQueryResult = Apollo.QueryResult<GetCheckInOneQuery, GetCheckInOneQueryVariables>;
export const GetClientPageDocument = gql`
    query GetClientPage($pagination: PaginationInput!) {
  clientPage(pagination: $pagination) {
    items {
      id
      user {
        id
        firstName
        lastName
        email
        createdDate
        profilePicUrl
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetClientPageQuery__
 *
 * To run a query within a React component, call `useGetClientPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetClientPageQuery(baseOptions: Apollo.QueryHookOptions<GetClientPageQuery, GetClientPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPageQuery, GetClientPageQueryVariables>(GetClientPageDocument, options);
      }
export function useGetClientPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPageQuery, GetClientPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPageQuery, GetClientPageQueryVariables>(GetClientPageDocument, options);
        }
export type GetClientPageQueryHookResult = ReturnType<typeof useGetClientPageQuery>;
export type GetClientPageLazyQueryHookResult = ReturnType<typeof useGetClientPageLazyQuery>;
export type GetClientPageQueryResult = Apollo.QueryResult<GetClientPageQuery, GetClientPageQueryVariables>;
export const GetClientDocument = gql`
    query GetClient($id: String) {
  clientOne(id: $id) {
    id
    dob
    memberStatus
    memberCode
    homePhone
    workPhone
    address
    city
    state
    zipCode
    country
    idNumber
    employer
    gender
    emergencyName
    emergencyPhone
    relationship
    attendee {
      id
    }
    preferences {
      minimumNotice
      notificationType
    }
    user {
      id
      firstName
      middleName
      lastName
      email
      phoneNumber
      createdDate
      smsConsent
      profilePicUrl
      role
      acceptedTAC
      lastLoginAt
      username
    }
    notes {
      id
      content
      isMigrated
      author {
        id
        user {
          id
          firstName
          lastName
          profilePicUrl
        }
      }
      updatedDate
    }
    organization {
      id
      name
      logoUrl
      organizationBranding {
        primaryColor
        secondaryColor
        id
        brandingLogoImg
      }
    }
    paymentMethods {
      id
      name
      mask
      vendor
      expiresAt
      merchant
      isPrimary
      isComplete
    }
    groups {
      id
      name
      clientGroupType
      clients {
        id
        user {
          firstName
          lastName
        }
      }
    }
    locations {
      address
      city
      name
      state
      zip
      id
    }
    defaultLocation {
      id
      name
    }
  }
}
    `;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions?: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetClientGroupManyDocument = gql`
    query GetClientGroupMany($id: String) {
  clientGroupMany(id: $id) {
    id
    name
    clientGroupType
    primaryClient {
      id
      user {
        id
        firstName
        lastName
      }
    }
    clients {
      id
      user {
        firstName
        lastName
      }
    }
    signedAgreement {
      agreement {
        id
        name
        description
      }
    }
  }
}
    `;

/**
 * __useGetClientGroupManyQuery__
 *
 * To run a query within a React component, call `useGetClientGroupManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientGroupManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientGroupManyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientGroupManyQuery(baseOptions?: Apollo.QueryHookOptions<GetClientGroupManyQuery, GetClientGroupManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientGroupManyQuery, GetClientGroupManyQueryVariables>(GetClientGroupManyDocument, options);
      }
export function useGetClientGroupManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientGroupManyQuery, GetClientGroupManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientGroupManyQuery, GetClientGroupManyQueryVariables>(GetClientGroupManyDocument, options);
        }
export type GetClientGroupManyQueryHookResult = ReturnType<typeof useGetClientGroupManyQuery>;
export type GetClientGroupManyLazyQueryHookResult = ReturnType<typeof useGetClientGroupManyLazyQuery>;
export type GetClientGroupManyQueryResult = Apollo.QueryResult<GetClientGroupManyQuery, GetClientGroupManyQueryVariables>;
export const GetClientGroupPageDocument = gql`
    query GetClientGroupPage($pagination: PaginationInput!) {
  clientGroupPage(pagination: $pagination) {
    items {
      id
      name
    }
    totalRows
  }
}
    `;

/**
 * __useGetClientGroupPageQuery__
 *
 * To run a query within a React component, call `useGetClientGroupPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientGroupPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientGroupPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetClientGroupPageQuery(baseOptions: Apollo.QueryHookOptions<GetClientGroupPageQuery, GetClientGroupPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientGroupPageQuery, GetClientGroupPageQueryVariables>(GetClientGroupPageDocument, options);
      }
export function useGetClientGroupPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientGroupPageQuery, GetClientGroupPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientGroupPageQuery, GetClientGroupPageQueryVariables>(GetClientGroupPageDocument, options);
        }
export type GetClientGroupPageQueryHookResult = ReturnType<typeof useGetClientGroupPageQuery>;
export type GetClientGroupPageLazyQueryHookResult = ReturnType<typeof useGetClientGroupPageLazyQuery>;
export type GetClientGroupPageQueryResult = Apollo.QueryResult<GetClientGroupPageQuery, GetClientGroupPageQueryVariables>;
export const GetClientCheckInPageDocument = gql`
    query GetClientCheckInPage($pagination: PaginationInput!) {
  clientPage(pagination: $pagination) {
    items {
      id
      user {
        firstName
        lastName
        profilePicUrl
      }
      memberStatus
      leadStatus
    }
    totalRows
  }
}
    `;

/**
 * __useGetClientCheckInPageQuery__
 *
 * To run a query within a React component, call `useGetClientCheckInPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCheckInPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCheckInPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetClientCheckInPageQuery(baseOptions: Apollo.QueryHookOptions<GetClientCheckInPageQuery, GetClientCheckInPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCheckInPageQuery, GetClientCheckInPageQueryVariables>(GetClientCheckInPageDocument, options);
      }
export function useGetClientCheckInPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCheckInPageQuery, GetClientCheckInPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCheckInPageQuery, GetClientCheckInPageQueryVariables>(GetClientCheckInPageDocument, options);
        }
export type GetClientCheckInPageQueryHookResult = ReturnType<typeof useGetClientCheckInPageQuery>;
export type GetClientCheckInPageLazyQueryHookResult = ReturnType<typeof useGetClientCheckInPageLazyQuery>;
export type GetClientCheckInPageQueryResult = Apollo.QueryResult<GetClientCheckInPageQuery, GetClientCheckInPageQueryVariables>;
export const GetClientGuestLeadDocument = gql`
    query GetClientGuestLead($id: String!) {
  clientOne(id: $id) {
    id
    dob
    homePhone
    workPhone
    address
    city
    state
    zipCode
    country
    idNumber
    employer
    gender
    emergencyName
    emergencyPhone
    relationship
    user {
      id
      email
      firstName
      lastName
      profilePicUrl
      username
    }
    notes {
      id
      content
      isMigrated
      author {
        id
        user {
          id
          firstName
          lastName
          profilePicUrl
        }
      }
      updatedDate
    }
  }
}
    `;

/**
 * __useGetClientGuestLeadQuery__
 *
 * To run a query within a React component, call `useGetClientGuestLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientGuestLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientGuestLeadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientGuestLeadQuery(baseOptions: Apollo.QueryHookOptions<GetClientGuestLeadQuery, GetClientGuestLeadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientGuestLeadQuery, GetClientGuestLeadQueryVariables>(GetClientGuestLeadDocument, options);
      }
export function useGetClientGuestLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientGuestLeadQuery, GetClientGuestLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientGuestLeadQuery, GetClientGuestLeadQueryVariables>(GetClientGuestLeadDocument, options);
        }
export type GetClientGuestLeadQueryHookResult = ReturnType<typeof useGetClientGuestLeadQuery>;
export type GetClientGuestLeadLazyQueryHookResult = ReturnType<typeof useGetClientGuestLeadLazyQuery>;
export type GetClientGuestLeadQueryResult = Apollo.QueryResult<GetClientGuestLeadQuery, GetClientGuestLeadQueryVariables>;
export const GetSuggestedUserNameDocument = gql`
    query GetSuggestedUserName($firstName: String!, $lastName: String!) {
  suggestedUserName(firstName: $firstName, lastName: $lastName)
}
    `;

/**
 * __useGetSuggestedUserNameQuery__
 *
 * To run a query within a React component, call `useGetSuggestedUserNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedUserNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedUserNameQuery({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useGetSuggestedUserNameQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedUserNameQuery, GetSuggestedUserNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedUserNameQuery, GetSuggestedUserNameQueryVariables>(GetSuggestedUserNameDocument, options);
      }
export function useGetSuggestedUserNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedUserNameQuery, GetSuggestedUserNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedUserNameQuery, GetSuggestedUserNameQueryVariables>(GetSuggestedUserNameDocument, options);
        }
export type GetSuggestedUserNameQueryHookResult = ReturnType<typeof useGetSuggestedUserNameQuery>;
export type GetSuggestedUserNameLazyQueryHookResult = ReturnType<typeof useGetSuggestedUserNameLazyQuery>;
export type GetSuggestedUserNameQueryResult = Apollo.QueryResult<GetSuggestedUserNameQuery, GetSuggestedUserNameQueryVariables>;
export const ClientSampleCsvDocument = gql`
    query clientSampleCSV {
  clientSampleCSV
}
    `;

/**
 * __useClientSampleCsvQuery__
 *
 * To run a query within a React component, call `useClientSampleCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientSampleCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientSampleCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientSampleCsvQuery(baseOptions?: Apollo.QueryHookOptions<ClientSampleCsvQuery, ClientSampleCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientSampleCsvQuery, ClientSampleCsvQueryVariables>(ClientSampleCsvDocument, options);
      }
export function useClientSampleCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientSampleCsvQuery, ClientSampleCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientSampleCsvQuery, ClientSampleCsvQueryVariables>(ClientSampleCsvDocument, options);
        }
export type ClientSampleCsvQueryHookResult = ReturnType<typeof useClientSampleCsvQuery>;
export type ClientSampleCsvLazyQueryHookResult = ReturnType<typeof useClientSampleCsvLazyQuery>;
export type ClientSampleCsvQueryResult = Apollo.QueryResult<ClientSampleCsvQuery, ClientSampleCsvQueryVariables>;
export const GetAccountDetailReportDocument = gql`
    query GetAccountDetailReport($data: AccountReportInput!) {
  accountDetailReport(data: $data) {
    id
    locations {
      id
      name
    }
    agreements {
      id
      subscription {
        isActive
      }
    }
    memberStatus
    preferences {
      notificationType
    }
    standing
    user {
      firstName
      lastName
      email
      phoneNumber
    }
    city
    country
    dob
    idNumber
    leadStatus
    state
    employer
    gender
    zipCode
    address
  }
}
    `;

/**
 * __useGetAccountDetailReportQuery__
 *
 * To run a query within a React component, call `useGetAccountDetailReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountDetailReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountDetailReportQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetAccountDetailReportQuery(baseOptions: Apollo.QueryHookOptions<GetAccountDetailReportQuery, GetAccountDetailReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountDetailReportQuery, GetAccountDetailReportQueryVariables>(GetAccountDetailReportDocument, options);
      }
export function useGetAccountDetailReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountDetailReportQuery, GetAccountDetailReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountDetailReportQuery, GetAccountDetailReportQueryVariables>(GetAccountDetailReportDocument, options);
        }
export type GetAccountDetailReportQueryHookResult = ReturnType<typeof useGetAccountDetailReportQuery>;
export type GetAccountDetailReportLazyQueryHookResult = ReturnType<typeof useGetAccountDetailReportLazyQuery>;
export type GetAccountDetailReportQueryResult = Apollo.QueryResult<GetAccountDetailReportQuery, GetAccountDetailReportQueryVariables>;
export const DownloadAccountDetailReportDocument = gql`
    query DownloadAccountDetailReport($data: AccountReportInput!) {
  downloadAccountDetailReport(data: $data)
}
    `;

/**
 * __useDownloadAccountDetailReportQuery__
 *
 * To run a query within a React component, call `useDownloadAccountDetailReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAccountDetailReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAccountDetailReportQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDownloadAccountDetailReportQuery(baseOptions: Apollo.QueryHookOptions<DownloadAccountDetailReportQuery, DownloadAccountDetailReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadAccountDetailReportQuery, DownloadAccountDetailReportQueryVariables>(DownloadAccountDetailReportDocument, options);
      }
export function useDownloadAccountDetailReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAccountDetailReportQuery, DownloadAccountDetailReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadAccountDetailReportQuery, DownloadAccountDetailReportQueryVariables>(DownloadAccountDetailReportDocument, options);
        }
export type DownloadAccountDetailReportQueryHookResult = ReturnType<typeof useDownloadAccountDetailReportQuery>;
export type DownloadAccountDetailReportLazyQueryHookResult = ReturnType<typeof useDownloadAccountDetailReportLazyQuery>;
export type DownloadAccountDetailReportQueryResult = Apollo.QueryResult<DownloadAccountDetailReportQuery, DownloadAccountDetailReportQueryVariables>;
export const ClientChangeRecordsDocument = gql`
    query clientChangeRecords($clientId: String!) {
  clientChangeRecordsMany(clientId: $clientId) {
    id
    author
    modalName
    description
    isJSON
    oldValues
    newValues
    createdDate
  }
}
    `;

/**
 * __useClientChangeRecordsQuery__
 *
 * To run a query within a React component, call `useClientChangeRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientChangeRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientChangeRecordsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientChangeRecordsQuery(baseOptions: Apollo.QueryHookOptions<ClientChangeRecordsQuery, ClientChangeRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientChangeRecordsQuery, ClientChangeRecordsQueryVariables>(ClientChangeRecordsDocument, options);
      }
export function useClientChangeRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientChangeRecordsQuery, ClientChangeRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientChangeRecordsQuery, ClientChangeRecordsQueryVariables>(ClientChangeRecordsDocument, options);
        }
export type ClientChangeRecordsQueryHookResult = ReturnType<typeof useClientChangeRecordsQuery>;
export type ClientChangeRecordsLazyQueryHookResult = ReturnType<typeof useClientChangeRecordsLazyQuery>;
export type ClientChangeRecordsQueryResult = Apollo.QueryResult<ClientChangeRecordsQuery, ClientChangeRecordsQueryVariables>;
export const ClientChangeOlderRecordsDocument = gql`
    query clientChangeOlderRecords($clientId: String!, $filter: Float!) {
  clientChangeRecordsOlderMany(clientId: $clientId, filter: $filter) {
    id
    author
    modalName
    description
    isJSON
    oldValues
    newValues
    createdDate
  }
}
    `;

/**
 * __useClientChangeOlderRecordsQuery__
 *
 * To run a query within a React component, call `useClientChangeOlderRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientChangeOlderRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientChangeOlderRecordsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientChangeOlderRecordsQuery(baseOptions: Apollo.QueryHookOptions<ClientChangeOlderRecordsQuery, ClientChangeOlderRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientChangeOlderRecordsQuery, ClientChangeOlderRecordsQueryVariables>(ClientChangeOlderRecordsDocument, options);
      }
export function useClientChangeOlderRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientChangeOlderRecordsQuery, ClientChangeOlderRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientChangeOlderRecordsQuery, ClientChangeOlderRecordsQueryVariables>(ClientChangeOlderRecordsDocument, options);
        }
export type ClientChangeOlderRecordsQueryHookResult = ReturnType<typeof useClientChangeOlderRecordsQuery>;
export type ClientChangeOlderRecordsLazyQueryHookResult = ReturnType<typeof useClientChangeOlderRecordsLazyQuery>;
export type ClientChangeOlderRecordsQueryResult = Apollo.QueryResult<ClientChangeOlderRecordsQuery, ClientChangeOlderRecordsQueryVariables>;
export const GetClientPaymentMethodDocument = gql`
    query GetClientPaymentMethod($id: String!) {
  clientPaymentMethodOne(id: $id) {
    id
    externalId
    name
    mask
    expiresAt
    isPrimary
    isComplete
    vendor
    merchant
    type
    accountType
    routingNumber
  }
}
    `;

/**
 * __useGetClientPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetClientPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPaymentMethodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<GetClientPaymentMethodQuery, GetClientPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPaymentMethodQuery, GetClientPaymentMethodQueryVariables>(GetClientPaymentMethodDocument, options);
      }
export function useGetClientPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPaymentMethodQuery, GetClientPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPaymentMethodQuery, GetClientPaymentMethodQueryVariables>(GetClientPaymentMethodDocument, options);
        }
export type GetClientPaymentMethodQueryHookResult = ReturnType<typeof useGetClientPaymentMethodQuery>;
export type GetClientPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetClientPaymentMethodLazyQuery>;
export type GetClientPaymentMethodQueryResult = Apollo.QueryResult<GetClientPaymentMethodQuery, GetClientPaymentMethodQueryVariables>;
export const GetClientPaymentMethodsManyDocument = gql`
    query GetClientPaymentMethodsMany($clientId: String!) {
  clientPaymentMethodsMany(clientId: $clientId) {
    id
    externalId
    name
    mask
    expiresAt
    isPrimary
    isComplete
    vendor
    merchant
    type
    accountType
    routingNumber
  }
}
    `;

/**
 * __useGetClientPaymentMethodsManyQuery__
 *
 * To run a query within a React component, call `useGetClientPaymentMethodsManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPaymentMethodsManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPaymentMethodsManyQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetClientPaymentMethodsManyQuery(baseOptions: Apollo.QueryHookOptions<GetClientPaymentMethodsManyQuery, GetClientPaymentMethodsManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPaymentMethodsManyQuery, GetClientPaymentMethodsManyQueryVariables>(GetClientPaymentMethodsManyDocument, options);
      }
export function useGetClientPaymentMethodsManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPaymentMethodsManyQuery, GetClientPaymentMethodsManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPaymentMethodsManyQuery, GetClientPaymentMethodsManyQueryVariables>(GetClientPaymentMethodsManyDocument, options);
        }
export type GetClientPaymentMethodsManyQueryHookResult = ReturnType<typeof useGetClientPaymentMethodsManyQuery>;
export type GetClientPaymentMethodsManyLazyQueryHookResult = ReturnType<typeof useGetClientPaymentMethodsManyLazyQuery>;
export type GetClientPaymentMethodsManyQueryResult = Apollo.QueryResult<GetClientPaymentMethodsManyQuery, GetClientPaymentMethodsManyQueryVariables>;
export const GetNewPaymentMethodDocument = gql`
    subscription GetNewPaymentMethod($paymentMethodId: String!) {
  newPaymentMethodSubscription(paymentMethodId: $paymentMethodId) {
    newPaymentMethod {
      id
      externalId
      name
      mask
      expiresAt
      isPrimary
      isComplete
      vendor
      merchant
      type
      accountType
      routingNumber
    }
  }
}
    `;

/**
 * __useGetNewPaymentMethodSubscription__
 *
 * To run a query within a React component, call `useGetNewPaymentMethodSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetNewPaymentMethodSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewPaymentMethodSubscription({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useGetNewPaymentMethodSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetNewPaymentMethodSubscription, GetNewPaymentMethodSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetNewPaymentMethodSubscription, GetNewPaymentMethodSubscriptionVariables>(GetNewPaymentMethodDocument, options);
      }
export type GetNewPaymentMethodSubscriptionHookResult = ReturnType<typeof useGetNewPaymentMethodSubscription>;
export type GetNewPaymentMethodSubscriptionResult = Apollo.SubscriptionResult<GetNewPaymentMethodSubscription>;
export const PaymentMethodSampleCsvDocument = gql`
    query paymentMethodSampleCSV {
  paymentMethodSampleCSV
}
    `;

/**
 * __usePaymentMethodSampleCsvQuery__
 *
 * To run a query within a React component, call `usePaymentMethodSampleCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodSampleCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodSampleCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodSampleCsvQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodSampleCsvQuery, PaymentMethodSampleCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodSampleCsvQuery, PaymentMethodSampleCsvQueryVariables>(PaymentMethodSampleCsvDocument, options);
      }
export function usePaymentMethodSampleCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodSampleCsvQuery, PaymentMethodSampleCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodSampleCsvQuery, PaymentMethodSampleCsvQueryVariables>(PaymentMethodSampleCsvDocument, options);
        }
export type PaymentMethodSampleCsvQueryHookResult = ReturnType<typeof usePaymentMethodSampleCsvQuery>;
export type PaymentMethodSampleCsvLazyQueryHookResult = ReturnType<typeof usePaymentMethodSampleCsvLazyQuery>;
export type PaymentMethodSampleCsvQueryResult = Apollo.QueryResult<PaymentMethodSampleCsvQuery, PaymentMethodSampleCsvQueryVariables>;
export const GetCardsExpirationReportDocument = gql`
    query GetCardsExpirationReport($data: CustomReportInput!) {
  cardsExpirationReport(data: $data) {
    id
    signedAgreement {
      client {
        migrationId
        lastVisitDate
        user {
          firstName
          lastName
          phoneNumber
          email
        }
      }
      paymentMethod {
        merchant
        mask
        name
        expiresAt
        isPrimary
      }
    }
    location {
      name
    }
  }
}
    `;

/**
 * __useGetCardsExpirationReportQuery__
 *
 * To run a query within a React component, call `useGetCardsExpirationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardsExpirationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardsExpirationReportQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCardsExpirationReportQuery(baseOptions: Apollo.QueryHookOptions<GetCardsExpirationReportQuery, GetCardsExpirationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardsExpirationReportQuery, GetCardsExpirationReportQueryVariables>(GetCardsExpirationReportDocument, options);
      }
export function useGetCardsExpirationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardsExpirationReportQuery, GetCardsExpirationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardsExpirationReportQuery, GetCardsExpirationReportQueryVariables>(GetCardsExpirationReportDocument, options);
        }
export type GetCardsExpirationReportQueryHookResult = ReturnType<typeof useGetCardsExpirationReportQuery>;
export type GetCardsExpirationReportLazyQueryHookResult = ReturnType<typeof useGetCardsExpirationReportLazyQuery>;
export type GetCardsExpirationReportQueryResult = Apollo.QueryResult<GetCardsExpirationReportQuery, GetCardsExpirationReportQueryVariables>;
export const DownloadCardsExpirationReportDocument = gql`
    query DownloadCardsExpirationReport($data: CustomReportInput!) {
  downloadCardsExpirationReport(data: $data)
}
    `;

/**
 * __useDownloadCardsExpirationReportQuery__
 *
 * To run a query within a React component, call `useDownloadCardsExpirationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCardsExpirationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCardsExpirationReportQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDownloadCardsExpirationReportQuery(baseOptions: Apollo.QueryHookOptions<DownloadCardsExpirationReportQuery, DownloadCardsExpirationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadCardsExpirationReportQuery, DownloadCardsExpirationReportQueryVariables>(DownloadCardsExpirationReportDocument, options);
      }
export function useDownloadCardsExpirationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCardsExpirationReportQuery, DownloadCardsExpirationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadCardsExpirationReportQuery, DownloadCardsExpirationReportQueryVariables>(DownloadCardsExpirationReportDocument, options);
        }
export type DownloadCardsExpirationReportQueryHookResult = ReturnType<typeof useDownloadCardsExpirationReportQuery>;
export type DownloadCardsExpirationReportLazyQueryHookResult = ReturnType<typeof useDownloadCardsExpirationReportLazyQuery>;
export type DownloadCardsExpirationReportQueryResult = Apollo.QueryResult<DownloadCardsExpirationReportQuery, DownloadCardsExpirationReportQueryVariables>;
export const GetTimeClockEntriesPageDocument = gql`
    query GetTimeClockEntriesPage($pagination: PaginationInput!, $locationId: String!, $employeeId: String) {
  timeClockEntryPage(
    pagination: $pagination
    locationId: $locationId
    employeeId: $employeeId
  ) {
    items {
      id
      employee {
        user {
          firstName
          lastName
        }
      }
      editedBy {
        user {
          firstName
          lastName
        }
      }
      editedAt
      updatedDate
      startedAt
      endedAt
      createdDate
    }
    totalRows
  }
}
    `;

/**
 * __useGetTimeClockEntriesPageQuery__
 *
 * To run a query within a React component, call `useGetTimeClockEntriesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeClockEntriesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeClockEntriesPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      locationId: // value for 'locationId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetTimeClockEntriesPageQuery(baseOptions: Apollo.QueryHookOptions<GetTimeClockEntriesPageQuery, GetTimeClockEntriesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeClockEntriesPageQuery, GetTimeClockEntriesPageQueryVariables>(GetTimeClockEntriesPageDocument, options);
      }
export function useGetTimeClockEntriesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeClockEntriesPageQuery, GetTimeClockEntriesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeClockEntriesPageQuery, GetTimeClockEntriesPageQueryVariables>(GetTimeClockEntriesPageDocument, options);
        }
export type GetTimeClockEntriesPageQueryHookResult = ReturnType<typeof useGetTimeClockEntriesPageQuery>;
export type GetTimeClockEntriesPageLazyQueryHookResult = ReturnType<typeof useGetTimeClockEntriesPageLazyQuery>;
export type GetTimeClockEntriesPageQueryResult = Apollo.QueryResult<GetTimeClockEntriesPageQuery, GetTimeClockEntriesPageQueryVariables>;
export const GetTimeClockEntryDocument = gql`
    query GetTimeClockEntry($id: String!) {
  timeClockEntryOne(id: $id) {
    id
    station {
      id
    }
    employee {
      id
    }
    startedAt
    endedAt
  }
}
    `;

/**
 * __useGetTimeClockEntryQuery__
 *
 * To run a query within a React component, call `useGetTimeClockEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeClockEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeClockEntryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTimeClockEntryQuery(baseOptions: Apollo.QueryHookOptions<GetTimeClockEntryQuery, GetTimeClockEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeClockEntryQuery, GetTimeClockEntryQueryVariables>(GetTimeClockEntryDocument, options);
      }
export function useGetTimeClockEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeClockEntryQuery, GetTimeClockEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeClockEntryQuery, GetTimeClockEntryQueryVariables>(GetTimeClockEntryDocument, options);
        }
export type GetTimeClockEntryQueryHookResult = ReturnType<typeof useGetTimeClockEntryQuery>;
export type GetTimeClockEntryLazyQueryHookResult = ReturnType<typeof useGetTimeClockEntryLazyQuery>;
export type GetTimeClockEntryQueryResult = Apollo.QueryResult<GetTimeClockEntryQuery, GetTimeClockEntryQueryVariables>;
export const GetValidCreditAllotmemtsDocument = gql`
    query getValidCreditAllotmemts($locationServiceId: String, $privateSessionId: String, $clientId: String!) {
  getValidCreditAllotmemts(
    locationServiceId: $locationServiceId
    privateSessionId: $privateSessionId
    clientId: $clientId
  ) {
    id
    agreement {
      name
    }
    expiresAt
    count
    name
  }
}
    `;

/**
 * __useGetValidCreditAllotmemtsQuery__
 *
 * To run a query within a React component, call `useGetValidCreditAllotmemtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidCreditAllotmemtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidCreditAllotmemtsQuery({
 *   variables: {
 *      locationServiceId: // value for 'locationServiceId'
 *      privateSessionId: // value for 'privateSessionId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetValidCreditAllotmemtsQuery(baseOptions: Apollo.QueryHookOptions<GetValidCreditAllotmemtsQuery, GetValidCreditAllotmemtsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidCreditAllotmemtsQuery, GetValidCreditAllotmemtsQueryVariables>(GetValidCreditAllotmemtsDocument, options);
      }
export function useGetValidCreditAllotmemtsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidCreditAllotmemtsQuery, GetValidCreditAllotmemtsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidCreditAllotmemtsQuery, GetValidCreditAllotmemtsQueryVariables>(GetValidCreditAllotmemtsDocument, options);
        }
export type GetValidCreditAllotmemtsQueryHookResult = ReturnType<typeof useGetValidCreditAllotmemtsQuery>;
export type GetValidCreditAllotmemtsLazyQueryHookResult = ReturnType<typeof useGetValidCreditAllotmemtsLazyQuery>;
export type GetValidCreditAllotmemtsQueryResult = Apollo.QueryResult<GetValidCreditAllotmemtsQuery, GetValidCreditAllotmemtsQueryVariables>;
export const GetCreditAllotmentManyDocument = gql`
    query GetCreditAllotmentMany($clientId: String!) {
  creditAllotmentMany(clientId: $clientId) {
    id
    name
    count
    expiresAt
    services {
      name
    }
    privateSessions {
      id
      session {
        name
      }
      duration
    }
    agreement {
      id
      name
    }
    package {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCreditAllotmentManyQuery__
 *
 * To run a query within a React component, call `useGetCreditAllotmentManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAllotmentManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAllotmentManyQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetCreditAllotmentManyQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAllotmentManyQuery, GetCreditAllotmentManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAllotmentManyQuery, GetCreditAllotmentManyQueryVariables>(GetCreditAllotmentManyDocument, options);
      }
export function useGetCreditAllotmentManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAllotmentManyQuery, GetCreditAllotmentManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAllotmentManyQuery, GetCreditAllotmentManyQueryVariables>(GetCreditAllotmentManyDocument, options);
        }
export type GetCreditAllotmentManyQueryHookResult = ReturnType<typeof useGetCreditAllotmentManyQuery>;
export type GetCreditAllotmentManyLazyQueryHookResult = ReturnType<typeof useGetCreditAllotmentManyLazyQuery>;
export type GetCreditAllotmentManyQueryResult = Apollo.QueryResult<GetCreditAllotmentManyQuery, GetCreditAllotmentManyQueryVariables>;
export const GetRevenueDashboardDocument = gql`
    query GetRevenueDashboard($data: DashboardInput!) {
  revenueDashboard(data: $data) {
    initial {
      revenue
      category
    }
    recurring {
      category
      revenue
    }
  }
}
    `;

/**
 * __useGetRevenueDashboardQuery__
 *
 * To run a query within a React component, call `useGetRevenueDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueDashboardQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetRevenueDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetRevenueDashboardQuery, GetRevenueDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueDashboardQuery, GetRevenueDashboardQueryVariables>(GetRevenueDashboardDocument, options);
      }
export function useGetRevenueDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueDashboardQuery, GetRevenueDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueDashboardQuery, GetRevenueDashboardQueryVariables>(GetRevenueDashboardDocument, options);
        }
export type GetRevenueDashboardQueryHookResult = ReturnType<typeof useGetRevenueDashboardQuery>;
export type GetRevenueDashboardLazyQueryHookResult = ReturnType<typeof useGetRevenueDashboardLazyQuery>;
export type GetRevenueDashboardQueryResult = Apollo.QueryResult<GetRevenueDashboardQuery, GetRevenueDashboardQueryVariables>;
export const GetRevenueReportPageDocument = gql`
    query GetRevenueReportPage($pagination: PaginationInput!, $data: DashboardInput!) {
  revenueReportPage(pagination: $pagination, data: $data) {
    items {
      id
      revenueCat {
        name
      }
      client {
        id
        user {
          firstName
          lastName
        }
      }
      transaction {
        id
        transactionStatus
        agreement {
          name
        }
        isRecurring
      }
      completedAt
      amount
    }
    totalRows
  }
}
    `;

/**
 * __useGetRevenueReportPageQuery__
 *
 * To run a query within a React component, call `useGetRevenueReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueReportPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetRevenueReportPageQuery(baseOptions: Apollo.QueryHookOptions<GetRevenueReportPageQuery, GetRevenueReportPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueReportPageQuery, GetRevenueReportPageQueryVariables>(GetRevenueReportPageDocument, options);
      }
export function useGetRevenueReportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueReportPageQuery, GetRevenueReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueReportPageQuery, GetRevenueReportPageQueryVariables>(GetRevenueReportPageDocument, options);
        }
export type GetRevenueReportPageQueryHookResult = ReturnType<typeof useGetRevenueReportPageQuery>;
export type GetRevenueReportPageLazyQueryHookResult = ReturnType<typeof useGetRevenueReportPageLazyQuery>;
export type GetRevenueReportPageQueryResult = Apollo.QueryResult<GetRevenueReportPageQuery, GetRevenueReportPageQueryVariables>;
export const GetAgreementDashboardDocument = gql`
    query GetAgreementDashboard($data: DashboardInput!) {
  agreementDashboard(data: $data) {
    name
    totalRevenue
    totalSales
  }
}
    `;

/**
 * __useGetAgreementDashboardQuery__
 *
 * To run a query within a React component, call `useGetAgreementDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementDashboardQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetAgreementDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementDashboardQuery, GetAgreementDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementDashboardQuery, GetAgreementDashboardQueryVariables>(GetAgreementDashboardDocument, options);
      }
export function useGetAgreementDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementDashboardQuery, GetAgreementDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementDashboardQuery, GetAgreementDashboardQueryVariables>(GetAgreementDashboardDocument, options);
        }
export type GetAgreementDashboardQueryHookResult = ReturnType<typeof useGetAgreementDashboardQuery>;
export type GetAgreementDashboardLazyQueryHookResult = ReturnType<typeof useGetAgreementDashboardLazyQuery>;
export type GetAgreementDashboardQueryResult = Apollo.QueryResult<GetAgreementDashboardQuery, GetAgreementDashboardQueryVariables>;
export const GetAgreementReportPageDocument = gql`
    query GetAgreementReportPage($pagination: PaginationInput!, $data: DashboardInput!) {
  agreementReportPage(pagination: $pagination, data: $data) {
    items {
      id
      transactionStatus
      agreementId
      agreement {
        id
        name
        isMembership
        isAutoRenew
      }
      subscription {
        signedAgreement {
          termEnd
          termStart
          client {
            id
            user {
              firstName
              lastName
            }
          }
        }
        subscriptionStatus
        nextDraftDate
        startDate
        endDate
      }
      completedAt
      createdDate
      isRecurring
    }
    totalRows
  }
}
    `;

/**
 * __useGetAgreementReportPageQuery__
 *
 * To run a query within a React component, call `useGetAgreementReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementReportPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetAgreementReportPageQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementReportPageQuery, GetAgreementReportPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementReportPageQuery, GetAgreementReportPageQueryVariables>(GetAgreementReportPageDocument, options);
      }
export function useGetAgreementReportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementReportPageQuery, GetAgreementReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementReportPageQuery, GetAgreementReportPageQueryVariables>(GetAgreementReportPageDocument, options);
        }
export type GetAgreementReportPageQueryHookResult = ReturnType<typeof useGetAgreementReportPageQuery>;
export type GetAgreementReportPageLazyQueryHookResult = ReturnType<typeof useGetAgreementReportPageLazyQuery>;
export type GetAgreementReportPageQueryResult = Apollo.QueryResult<GetAgreementReportPageQuery, GetAgreementReportPageQueryVariables>;
export const GetPackageDashboardDocument = gql`
    query GetPackageDashboard($data: DashboardInput!) {
  packageDashboard(data: $data) {
    name
    totalRevenue
    totalSales
  }
}
    `;

/**
 * __useGetPackageDashboardQuery__
 *
 * To run a query within a React component, call `useGetPackageDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageDashboardQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPackageDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetPackageDashboardQuery, GetPackageDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageDashboardQuery, GetPackageDashboardQueryVariables>(GetPackageDashboardDocument, options);
      }
export function useGetPackageDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageDashboardQuery, GetPackageDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageDashboardQuery, GetPackageDashboardQueryVariables>(GetPackageDashboardDocument, options);
        }
export type GetPackageDashboardQueryHookResult = ReturnType<typeof useGetPackageDashboardQuery>;
export type GetPackageDashboardLazyQueryHookResult = ReturnType<typeof useGetPackageDashboardLazyQuery>;
export type GetPackageDashboardQueryResult = Apollo.QueryResult<GetPackageDashboardQuery, GetPackageDashboardQueryVariables>;
export const GetPosDashboardDocument = gql`
    query GetPOSDashboard($sortType: SortType!, $data: DashboardInput!) {
  posDashboard(sortType: $sortType, data: $data) {
    productObject {
      totalSales
      totalRevenue
      name
    }
    revenueItem {
      revenue
      category
    }
  }
}
    `;

/**
 * __useGetPosDashboardQuery__
 *
 * To run a query within a React component, call `useGetPosDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosDashboardQuery({
 *   variables: {
 *      sortType: // value for 'sortType'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPosDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetPosDashboardQuery, GetPosDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosDashboardQuery, GetPosDashboardQueryVariables>(GetPosDashboardDocument, options);
      }
export function useGetPosDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosDashboardQuery, GetPosDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosDashboardQuery, GetPosDashboardQueryVariables>(GetPosDashboardDocument, options);
        }
export type GetPosDashboardQueryHookResult = ReturnType<typeof useGetPosDashboardQuery>;
export type GetPosDashboardLazyQueryHookResult = ReturnType<typeof useGetPosDashboardLazyQuery>;
export type GetPosDashboardQueryResult = Apollo.QueryResult<GetPosDashboardQuery, GetPosDashboardQueryVariables>;
export const GetPosReportPageDocument = gql`
    query GetPOSReportPage($data: DashboardInput!, $pagination: PaginationInput!) {
  posReportPage(data: $data, pagination: $pagination) {
    items {
      id
      product {
        id
        name
        sku
      }
      count
      discount
      tax
      commissionValue
      productType
      location {
        name
      }
      transaction {
        id
        subtotal
        performedBy {
          user {
            firstName
            lastName
          }
        }
        chargedTo {
          id
          user {
            firstName
            lastName
          }
        }
        isRefund
        discountCode {
          name
          code
        }
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetPosReportPageQuery__
 *
 * To run a query within a React component, call `useGetPosReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosReportPageQuery({
 *   variables: {
 *      data: // value for 'data'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPosReportPageQuery(baseOptions: Apollo.QueryHookOptions<GetPosReportPageQuery, GetPosReportPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosReportPageQuery, GetPosReportPageQueryVariables>(GetPosReportPageDocument, options);
      }
export function useGetPosReportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosReportPageQuery, GetPosReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosReportPageQuery, GetPosReportPageQueryVariables>(GetPosReportPageDocument, options);
        }
export type GetPosReportPageQueryHookResult = ReturnType<typeof useGetPosReportPageQuery>;
export type GetPosReportPageLazyQueryHookResult = ReturnType<typeof useGetPosReportPageLazyQuery>;
export type GetPosReportPageQueryResult = Apollo.QueryResult<GetPosReportPageQuery, GetPosReportPageQueryVariables>;
export const GetProjectedIncomeDashboardDocument = gql`
    query GetProjectedIncomeDashboard($data: DashboardInput!) {
  projectedIncome(data: $data) {
    revenueGroup
    totalAmount
  }
}
    `;

/**
 * __useGetProjectedIncomeDashboardQuery__
 *
 * To run a query within a React component, call `useGetProjectedIncomeDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectedIncomeDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectedIncomeDashboardQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetProjectedIncomeDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetProjectedIncomeDashboardQuery, GetProjectedIncomeDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectedIncomeDashboardQuery, GetProjectedIncomeDashboardQueryVariables>(GetProjectedIncomeDashboardDocument, options);
      }
export function useGetProjectedIncomeDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectedIncomeDashboardQuery, GetProjectedIncomeDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectedIncomeDashboardQuery, GetProjectedIncomeDashboardQueryVariables>(GetProjectedIncomeDashboardDocument, options);
        }
export type GetProjectedIncomeDashboardQueryHookResult = ReturnType<typeof useGetProjectedIncomeDashboardQuery>;
export type GetProjectedIncomeDashboardLazyQueryHookResult = ReturnType<typeof useGetProjectedIncomeDashboardLazyQuery>;
export type GetProjectedIncomeDashboardQueryResult = Apollo.QueryResult<GetProjectedIncomeDashboardQuery, GetProjectedIncomeDashboardQueryVariables>;
export const DicountCodePageDocument = gql`
    query DicountCodePage($pagination: PaginationInput!) {
  dicountCodePage(pagination: $pagination) {
    totalRows
    items {
      code
      createdDate
      discountCodeType
      id
      isPercent
      isRestricted
      description
      name
      recurring
      startAt
      useLimit
      value
    }
  }
}
    `;

/**
 * __useDicountCodePageQuery__
 *
 * To run a query within a React component, call `useDicountCodePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDicountCodePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDicountCodePageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDicountCodePageQuery(baseOptions: Apollo.QueryHookOptions<DicountCodePageQuery, DicountCodePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DicountCodePageQuery, DicountCodePageQueryVariables>(DicountCodePageDocument, options);
      }
export function useDicountCodePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DicountCodePageQuery, DicountCodePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DicountCodePageQuery, DicountCodePageQueryVariables>(DicountCodePageDocument, options);
        }
export type DicountCodePageQueryHookResult = ReturnType<typeof useDicountCodePageQuery>;
export type DicountCodePageLazyQueryHookResult = ReturnType<typeof useDicountCodePageLazyQuery>;
export type DicountCodePageQueryResult = Apollo.QueryResult<DicountCodePageQuery, DicountCodePageQueryVariables>;
export const DiscountCodeOneDocument = gql`
    query DiscountCodeOne($discountCodeOneId: String!) {
  discountCodeOne(id: $discountCodeOneId) {
    id
    createdDate
    updatedDate
    deletedDate
    name
    description
    startAt
    isPercent
    value
    code
    discountCodeType
    recurring
    useLimit
    isStaffOnly
    locations {
      name
      id
    }
    expiration {
      id
      unit
      expirationMode
      isExpired
      expiresAt
      value
    }
    isRestricted
  }
}
    `;

/**
 * __useDiscountCodeOneQuery__
 *
 * To run a query within a React component, call `useDiscountCodeOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountCodeOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountCodeOneQuery({
 *   variables: {
 *      discountCodeOneId: // value for 'discountCodeOneId'
 *   },
 * });
 */
export function useDiscountCodeOneQuery(baseOptions: Apollo.QueryHookOptions<DiscountCodeOneQuery, DiscountCodeOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountCodeOneQuery, DiscountCodeOneQueryVariables>(DiscountCodeOneDocument, options);
      }
export function useDiscountCodeOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountCodeOneQuery, DiscountCodeOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountCodeOneQuery, DiscountCodeOneQueryVariables>(DiscountCodeOneDocument, options);
        }
export type DiscountCodeOneQueryHookResult = ReturnType<typeof useDiscountCodeOneQuery>;
export type DiscountCodeOneLazyQueryHookResult = ReturnType<typeof useDiscountCodeOneLazyQuery>;
export type DiscountCodeOneQueryResult = Apollo.QueryResult<DiscountCodeOneQuery, DiscountCodeOneQueryVariables>;
export const DiscountCodeAgreementsDocument = gql`
    query DiscountCodeAgreements($discountCodeOneId: String!, $isAgreement: Boolean!) {
  discountCodeAgreementsOrProducts(
    id: $discountCodeOneId
    isAgreement: $isAgreement
  ) {
    id
    agreements {
      id
      name
    }
  }
}
    `;

/**
 * __useDiscountCodeAgreementsQuery__
 *
 * To run a query within a React component, call `useDiscountCodeAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountCodeAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountCodeAgreementsQuery({
 *   variables: {
 *      discountCodeOneId: // value for 'discountCodeOneId'
 *      isAgreement: // value for 'isAgreement'
 *   },
 * });
 */
export function useDiscountCodeAgreementsQuery(baseOptions: Apollo.QueryHookOptions<DiscountCodeAgreementsQuery, DiscountCodeAgreementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountCodeAgreementsQuery, DiscountCodeAgreementsQueryVariables>(DiscountCodeAgreementsDocument, options);
      }
export function useDiscountCodeAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountCodeAgreementsQuery, DiscountCodeAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountCodeAgreementsQuery, DiscountCodeAgreementsQueryVariables>(DiscountCodeAgreementsDocument, options);
        }
export type DiscountCodeAgreementsQueryHookResult = ReturnType<typeof useDiscountCodeAgreementsQuery>;
export type DiscountCodeAgreementsLazyQueryHookResult = ReturnType<typeof useDiscountCodeAgreementsLazyQuery>;
export type DiscountCodeAgreementsQueryResult = Apollo.QueryResult<DiscountCodeAgreementsQuery, DiscountCodeAgreementsQueryVariables>;
export const DiscountCodeProductsDocument = gql`
    query DiscountCodeProducts($discountCodeOneId: String!, $isAgreement: Boolean!) {
  discountCodeAgreementsOrProducts(
    id: $discountCodeOneId
    isAgreement: $isAgreement
  ) {
    id
    products {
      name
      id
    }
  }
}
    `;

/**
 * __useDiscountCodeProductsQuery__
 *
 * To run a query within a React component, call `useDiscountCodeProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountCodeProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountCodeProductsQuery({
 *   variables: {
 *      discountCodeOneId: // value for 'discountCodeOneId'
 *      isAgreement: // value for 'isAgreement'
 *   },
 * });
 */
export function useDiscountCodeProductsQuery(baseOptions: Apollo.QueryHookOptions<DiscountCodeProductsQuery, DiscountCodeProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountCodeProductsQuery, DiscountCodeProductsQueryVariables>(DiscountCodeProductsDocument, options);
      }
export function useDiscountCodeProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountCodeProductsQuery, DiscountCodeProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountCodeProductsQuery, DiscountCodeProductsQueryVariables>(DiscountCodeProductsDocument, options);
        }
export type DiscountCodeProductsQueryHookResult = ReturnType<typeof useDiscountCodeProductsQuery>;
export type DiscountCodeProductsLazyQueryHookResult = ReturnType<typeof useDiscountCodeProductsLazyQuery>;
export type DiscountCodeProductsQueryResult = Apollo.QueryResult<DiscountCodeProductsQuery, DiscountCodeProductsQueryVariables>;
export const DiscountByCodeDocument = gql`
    query discountByCode($locationId: String!, $code: String!) {
  discountByCode(locationId: $locationId, code: $code) {
    name
    id
    value
    useLimit
    isPercent
    products {
      id
      name
      cost
    }
  }
}
    `;

/**
 * __useDiscountByCodeQuery__
 *
 * To run a query within a React component, call `useDiscountByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountByCodeQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useDiscountByCodeQuery(baseOptions: Apollo.QueryHookOptions<DiscountByCodeQuery, DiscountByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountByCodeQuery, DiscountByCodeQueryVariables>(DiscountByCodeDocument, options);
      }
export function useDiscountByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountByCodeQuery, DiscountByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountByCodeQuery, DiscountByCodeQueryVariables>(DiscountByCodeDocument, options);
        }
export type DiscountByCodeQueryHookResult = ReturnType<typeof useDiscountByCodeQuery>;
export type DiscountByCodeLazyQueryHookResult = ReturnType<typeof useDiscountByCodeLazyQuery>;
export type DiscountByCodeQueryResult = Apollo.QueryResult<DiscountByCodeQuery, DiscountByCodeQueryVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees {
  employeeMany {
    id
    user {
      id
      username
      role
      firstName
      middleName
      lastName
      email
      phoneNumber
      createdDate
      profilePicUrl
    }
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetEmployeesNameDocument = gql`
    query GetEmployeesName($locationId: String, $orgId: String) {
  employeeMany(locationId: $locationId, orgId: $orgId) {
    id
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetEmployeesNameQuery__
 *
 * To run a query within a React component, call `useGetEmployeesNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesNameQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetEmployeesNameQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesNameQuery, GetEmployeesNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesNameQuery, GetEmployeesNameQueryVariables>(GetEmployeesNameDocument, options);
      }
export function useGetEmployeesNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesNameQuery, GetEmployeesNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesNameQuery, GetEmployeesNameQueryVariables>(GetEmployeesNameDocument, options);
        }
export type GetEmployeesNameQueryHookResult = ReturnType<typeof useGetEmployeesNameQuery>;
export type GetEmployeesNameLazyQueryHookResult = ReturnType<typeof useGetEmployeesNameLazyQuery>;
export type GetEmployeesNameQueryResult = Apollo.QueryResult<GetEmployeesNameQuery, GetEmployeesNameQueryVariables>;
export const GetEmployeeDocument = gql`
    query GetEmployee($id: String) {
  employeeOne(id: $id) {
    id
    staffId
    pin
    user {
      id
      username
      role
      firstName
      middleName
      lastName
      email
      phoneNumber
      createdDate
      profilePicUrl
    }
    organization {
      id
      name
    }
    locations {
      id
      name
      description
      logoUrl
      stationsEnabled
    }
    activeLocation {
      id
      name
      stationsEnabled
    }
    activeSession {
      location {
        id
        name
      }
      station {
        id
        name
      }
    }
    clockedIn
    role {
      id
      name
      description
      orgRoles
      orgPolicies
      orgAgreements
      orgPackages
      orgLocations
      orgDiscounts
      orgSettings
      orgService
      locPolicies
      locAgreements
      locPackages
      locServices
      locDiscounts
      locSettings
      locRooms
      locEmployees
      locProducts
      locRequests
      locTimeclock
      locDashboard
      locReports
      clients
      calendar
      catalog
      checkInQueue
      personalTimeClock
      employeeStations
    }
  }
}
    `;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetEmployeePageDocument = gql`
    query GetEmployeePage($locationId: String, $pagination: PaginationInput!) {
  employeePage(locationId: $locationId, pagination: $pagination) {
    items {
      id
      isActive
      user {
        id
        firstName
        middleName
        lastName
        email
        phoneNumber
        createdDate
        profilePicUrl
      }
      organization {
        id
        name
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetEmployeePageQuery__
 *
 * To run a query within a React component, call `useGetEmployeePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeePageQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetEmployeePageQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeePageQuery, GetEmployeePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeePageQuery, GetEmployeePageQueryVariables>(GetEmployeePageDocument, options);
      }
export function useGetEmployeePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeePageQuery, GetEmployeePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeePageQuery, GetEmployeePageQueryVariables>(GetEmployeePageDocument, options);
        }
export type GetEmployeePageQueryHookResult = ReturnType<typeof useGetEmployeePageQuery>;
export type GetEmployeePageLazyQueryHookResult = ReturnType<typeof useGetEmployeePageLazyQuery>;
export type GetEmployeePageQueryResult = Apollo.QueryResult<GetEmployeePageQuery, GetEmployeePageQueryVariables>;
export const GetEmployeeInfoDocument = gql`
    query GetEmployeeInfo($id: String) {
  employeeOne(id: $id) {
    id
    staffId
    pin
    role {
      id
      name
    }
    user {
      id
      firstName
      middleName
      lastName
      email
      phoneNumber
      profilePicUrl
    }
    locations {
      id
      name
      description
      logoUrl
      stationsEnabled
    }
    stations {
      id
      name
    }
  }
}
    `;

/**
 * __useGetEmployeeInfoQuery__
 *
 * To run a query within a React component, call `useGetEmployeeInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeInfoQuery, GetEmployeeInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeInfoQuery, GetEmployeeInfoQueryVariables>(GetEmployeeInfoDocument, options);
      }
export function useGetEmployeeInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeInfoQuery, GetEmployeeInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeInfoQuery, GetEmployeeInfoQueryVariables>(GetEmployeeInfoDocument, options);
        }
export type GetEmployeeInfoQueryHookResult = ReturnType<typeof useGetEmployeeInfoQuery>;
export type GetEmployeeInfoLazyQueryHookResult = ReturnType<typeof useGetEmployeeInfoLazyQuery>;
export type GetEmployeeInfoQueryResult = Apollo.QueryResult<GetEmployeeInfoQuery, GetEmployeeInfoQueryVariables>;
export const CheckEmployeePinDocument = gql`
    query checkEmployeePin($pin: String!) {
  checkEmployeePin(pin: $pin)
}
    `;

/**
 * __useCheckEmployeePinQuery__
 *
 * To run a query within a React component, call `useCheckEmployeePinQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmployeePinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmployeePinQuery({
 *   variables: {
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useCheckEmployeePinQuery(baseOptions: Apollo.QueryHookOptions<CheckEmployeePinQuery, CheckEmployeePinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckEmployeePinQuery, CheckEmployeePinQueryVariables>(CheckEmployeePinDocument, options);
      }
export function useCheckEmployeePinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckEmployeePinQuery, CheckEmployeePinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckEmployeePinQuery, CheckEmployeePinQueryVariables>(CheckEmployeePinDocument, options);
        }
export type CheckEmployeePinQueryHookResult = ReturnType<typeof useCheckEmployeePinQuery>;
export type CheckEmployeePinLazyQueryHookResult = ReturnType<typeof useCheckEmployeePinLazyQuery>;
export type CheckEmployeePinQueryResult = Apollo.QueryResult<CheckEmployeePinQuery, CheckEmployeePinQueryVariables>;
export const GetEmployeesNameLocDocument = gql`
    query GetEmployeesNameLoc($locationId: String, $orgId: String) {
  employeeMany(locationId: $locationId, orgId: $orgId) {
    id
    user {
      id
      firstName
      lastName
    }
    locations {
      id
      name
      stationsEnabled
    }
  }
}
    `;

/**
 * __useGetEmployeesNameLocQuery__
 *
 * To run a query within a React component, call `useGetEmployeesNameLocQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesNameLocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesNameLocQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetEmployeesNameLocQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesNameLocQuery, GetEmployeesNameLocQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesNameLocQuery, GetEmployeesNameLocQueryVariables>(GetEmployeesNameLocDocument, options);
      }
export function useGetEmployeesNameLocLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesNameLocQuery, GetEmployeesNameLocQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesNameLocQuery, GetEmployeesNameLocQueryVariables>(GetEmployeesNameLocDocument, options);
        }
export type GetEmployeesNameLocQueryHookResult = ReturnType<typeof useGetEmployeesNameLocQuery>;
export type GetEmployeesNameLocLazyQueryHookResult = ReturnType<typeof useGetEmployeesNameLocLazyQuery>;
export type GetEmployeesNameLocQueryResult = Apollo.QueryResult<GetEmployeesNameLocQuery, GetEmployeesNameLocQueryVariables>;
export const IsRoleAssignedDocument = gql`
    query isRoleAssigned($roleId: String!) {
  isRoleAssigned(roleId: $roleId)
}
    `;

/**
 * __useIsRoleAssignedQuery__
 *
 * To run a query within a React component, call `useIsRoleAssignedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsRoleAssignedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsRoleAssignedQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useIsRoleAssignedQuery(baseOptions: Apollo.QueryHookOptions<IsRoleAssignedQuery, IsRoleAssignedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsRoleAssignedQuery, IsRoleAssignedQueryVariables>(IsRoleAssignedDocument, options);
      }
export function useIsRoleAssignedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsRoleAssignedQuery, IsRoleAssignedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsRoleAssignedQuery, IsRoleAssignedQueryVariables>(IsRoleAssignedDocument, options);
        }
export type IsRoleAssignedQueryHookResult = ReturnType<typeof useIsRoleAssignedQuery>;
export type IsRoleAssignedLazyQueryHookResult = ReturnType<typeof useIsRoleAssignedLazyQuery>;
export type IsRoleAssignedQueryResult = Apollo.QueryResult<IsRoleAssignedQuery, IsRoleAssignedQueryVariables>;
export const GetEmployeeRoleNamesDocument = gql`
    query GetEmployeeRoleNames {
  employeeRoleMany {
    id
    name
  }
}
    `;

/**
 * __useGetEmployeeRoleNamesQuery__
 *
 * To run a query within a React component, call `useGetEmployeeRoleNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeRoleNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeRoleNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeRoleNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeRoleNamesQuery, GetEmployeeRoleNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeRoleNamesQuery, GetEmployeeRoleNamesQueryVariables>(GetEmployeeRoleNamesDocument, options);
      }
export function useGetEmployeeRoleNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeRoleNamesQuery, GetEmployeeRoleNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeRoleNamesQuery, GetEmployeeRoleNamesQueryVariables>(GetEmployeeRoleNamesDocument, options);
        }
export type GetEmployeeRoleNamesQueryHookResult = ReturnType<typeof useGetEmployeeRoleNamesQuery>;
export type GetEmployeeRoleNamesLazyQueryHookResult = ReturnType<typeof useGetEmployeeRoleNamesLazyQuery>;
export type GetEmployeeRoleNamesQueryResult = Apollo.QueryResult<GetEmployeeRoleNamesQuery, GetEmployeeRoleNamesQueryVariables>;
export const GetEmployeeRolePageDocument = gql`
    query GetEmployeeRolePage($pagination: PaginationInput!) {
  employeeRolePage(pagination: $pagination) {
    items {
      id
      name
      seedId
    }
    totalRows
  }
}
    `;

/**
 * __useGetEmployeeRolePageQuery__
 *
 * To run a query within a React component, call `useGetEmployeeRolePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeRolePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeRolePageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetEmployeeRolePageQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeRolePageQuery, GetEmployeeRolePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeRolePageQuery, GetEmployeeRolePageQueryVariables>(GetEmployeeRolePageDocument, options);
      }
export function useGetEmployeeRolePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeRolePageQuery, GetEmployeeRolePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeRolePageQuery, GetEmployeeRolePageQueryVariables>(GetEmployeeRolePageDocument, options);
        }
export type GetEmployeeRolePageQueryHookResult = ReturnType<typeof useGetEmployeeRolePageQuery>;
export type GetEmployeeRolePageLazyQueryHookResult = ReturnType<typeof useGetEmployeeRolePageLazyQuery>;
export type GetEmployeeRolePageQueryResult = Apollo.QueryResult<GetEmployeeRolePageQuery, GetEmployeeRolePageQueryVariables>;
export const GetEmployeeRoleDocument = gql`
    query GetEmployeeRole($id: String!) {
  employeeRoleOne(id: $id) {
    id
    name
    description
    orgRoles
    orgPolicies
    orgAgreements
    orgPackages
    orgLocations
    orgService
    orgDiscounts
    orgSettings
    locPolicies
    locAgreements
    locPackages
    locServices
    locDiscounts
    locSettings
    locRooms
    locEmployees
    locProducts
    locRequests
    locTimeclock
    locDashboard
    locReports
    clients
    calendar
    catalog
    checkInQueue
    personalTimeClock
    employeeStations
  }
}
    `;

/**
 * __useGetEmployeeRoleQuery__
 *
 * To run a query within a React component, call `useGetEmployeeRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeRoleQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeRoleQuery, GetEmployeeRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeRoleQuery, GetEmployeeRoleQueryVariables>(GetEmployeeRoleDocument, options);
      }
export function useGetEmployeeRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeRoleQuery, GetEmployeeRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeRoleQuery, GetEmployeeRoleQueryVariables>(GetEmployeeRoleDocument, options);
        }
export type GetEmployeeRoleQueryHookResult = ReturnType<typeof useGetEmployeeRoleQuery>;
export type GetEmployeeRoleLazyQueryHookResult = ReturnType<typeof useGetEmployeeRoleLazyQuery>;
export type GetEmployeeRoleQueryResult = Apollo.QueryResult<GetEmployeeRoleQuery, GetEmployeeRoleQueryVariables>;
export const GetEmployeeRoleNamesPossibleDocument = gql`
    query GetEmployeeRoleNamesPossible {
  employeeRolesPossible {
    id
    name
  }
}
    `;

/**
 * __useGetEmployeeRoleNamesPossibleQuery__
 *
 * To run a query within a React component, call `useGetEmployeeRoleNamesPossibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeRoleNamesPossibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeRoleNamesPossibleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeRoleNamesPossibleQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeRoleNamesPossibleQuery, GetEmployeeRoleNamesPossibleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeRoleNamesPossibleQuery, GetEmployeeRoleNamesPossibleQueryVariables>(GetEmployeeRoleNamesPossibleDocument, options);
      }
export function useGetEmployeeRoleNamesPossibleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeRoleNamesPossibleQuery, GetEmployeeRoleNamesPossibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeRoleNamesPossibleQuery, GetEmployeeRoleNamesPossibleQueryVariables>(GetEmployeeRoleNamesPossibleDocument, options);
        }
export type GetEmployeeRoleNamesPossibleQueryHookResult = ReturnType<typeof useGetEmployeeRoleNamesPossibleQuery>;
export type GetEmployeeRoleNamesPossibleLazyQueryHookResult = ReturnType<typeof useGetEmployeeRoleNamesPossibleLazyQuery>;
export type GetEmployeeRoleNamesPossibleQueryResult = Apollo.QueryResult<GetEmployeeRoleNamesPossibleQuery, GetEmployeeRoleNamesPossibleQueryVariables>;
export const GetEmployeesStationNameManyDocument = gql`
    query GetEmployeesStationNameMany($employeeId: String, $locationId: String) {
  employeeStationMany(employeeId: $employeeId, locationId: $locationId) {
    id
    name
  }
}
    `;

/**
 * __useGetEmployeesStationNameManyQuery__
 *
 * To run a query within a React component, call `useGetEmployeesStationNameManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesStationNameManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesStationNameManyQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetEmployeesStationNameManyQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesStationNameManyQuery, GetEmployeesStationNameManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesStationNameManyQuery, GetEmployeesStationNameManyQueryVariables>(GetEmployeesStationNameManyDocument, options);
      }
export function useGetEmployeesStationNameManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesStationNameManyQuery, GetEmployeesStationNameManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesStationNameManyQuery, GetEmployeesStationNameManyQueryVariables>(GetEmployeesStationNameManyDocument, options);
        }
export type GetEmployeesStationNameManyQueryHookResult = ReturnType<typeof useGetEmployeesStationNameManyQuery>;
export type GetEmployeesStationNameManyLazyQueryHookResult = ReturnType<typeof useGetEmployeesStationNameManyLazyQuery>;
export type GetEmployeesStationNameManyQueryResult = Apollo.QueryResult<GetEmployeesStationNameManyQuery, GetEmployeesStationNameManyQueryVariables>;
export const GetEmployeesStationManyDocument = gql`
    query GetEmployeesStationMany {
  employeeStationMany {
    id
    name
    description
    payRate
    minShift
    maxShift
  }
}
    `;

/**
 * __useGetEmployeesStationManyQuery__
 *
 * To run a query within a React component, call `useGetEmployeesStationManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesStationManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesStationManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeesStationManyQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesStationManyQuery, GetEmployeesStationManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesStationManyQuery, GetEmployeesStationManyQueryVariables>(GetEmployeesStationManyDocument, options);
      }
export function useGetEmployeesStationManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesStationManyQuery, GetEmployeesStationManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesStationManyQuery, GetEmployeesStationManyQueryVariables>(GetEmployeesStationManyDocument, options);
        }
export type GetEmployeesStationManyQueryHookResult = ReturnType<typeof useGetEmployeesStationManyQuery>;
export type GetEmployeesStationManyLazyQueryHookResult = ReturnType<typeof useGetEmployeesStationManyLazyQuery>;
export type GetEmployeesStationManyQueryResult = Apollo.QueryResult<GetEmployeesStationManyQuery, GetEmployeesStationManyQueryVariables>;
export const GetEmployeeStationDocument = gql`
    query GetEmployeeStation($id: String!) {
  employeeStationOne(id: $id) {
    id
    name
    description
    payRate
    minShift
    maxShift
  }
}
    `;

/**
 * __useGetEmployeeStationQuery__
 *
 * To run a query within a React component, call `useGetEmployeeStationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeStationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeStationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeStationQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeStationQuery, GetEmployeeStationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeStationQuery, GetEmployeeStationQueryVariables>(GetEmployeeStationDocument, options);
      }
export function useGetEmployeeStationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeStationQuery, GetEmployeeStationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeStationQuery, GetEmployeeStationQueryVariables>(GetEmployeeStationDocument, options);
        }
export type GetEmployeeStationQueryHookResult = ReturnType<typeof useGetEmployeeStationQuery>;
export type GetEmployeeStationLazyQueryHookResult = ReturnType<typeof useGetEmployeeStationLazyQuery>;
export type GetEmployeeStationQueryResult = Apollo.QueryResult<GetEmployeeStationQuery, GetEmployeeStationQueryVariables>;
export const GetEmployeeStationPageDocument = gql`
    query GetEmployeeStationPage($pagination: PaginationInput!) {
  employeeStationPage(pagination: $pagination) {
    items {
      id
      name
      description
      payRate
      minShift
      maxShift
    }
    totalRows
  }
}
    `;

/**
 * __useGetEmployeeStationPageQuery__
 *
 * To run a query within a React component, call `useGetEmployeeStationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeStationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeStationPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetEmployeeStationPageQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeStationPageQuery, GetEmployeeStationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeStationPageQuery, GetEmployeeStationPageQueryVariables>(GetEmployeeStationPageDocument, options);
      }
export function useGetEmployeeStationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeStationPageQuery, GetEmployeeStationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeStationPageQuery, GetEmployeeStationPageQueryVariables>(GetEmployeeStationPageDocument, options);
        }
export type GetEmployeeStationPageQueryHookResult = ReturnType<typeof useGetEmployeeStationPageQuery>;
export type GetEmployeeStationPageLazyQueryHookResult = ReturnType<typeof useGetEmployeeStationPageLazyQuery>;
export type GetEmployeeStationPageQueryResult = Apollo.QueryResult<GetEmployeeStationPageQuery, GetEmployeeStationPageQueryVariables>;
export const InitialChargeOneDocument = gql`
    query InitialChargeOne($initialChargeOneId: String!) {
  initialChargeOne(id: $initialChargeOneId) {
    id
    createdDate
    updatedDate
    deletedDate
    cost
    isDiscountable
    agreement {
      id
      name
    }
    package {
      id
      name
    }
    fee {
      id
      name
    }
    revenue {
      name
      id
    }
  }
}
    `;

/**
 * __useInitialChargeOneQuery__
 *
 * To run a query within a React component, call `useInitialChargeOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialChargeOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialChargeOneQuery({
 *   variables: {
 *      initialChargeOneId: // value for 'initialChargeOneId'
 *   },
 * });
 */
export function useInitialChargeOneQuery(baseOptions: Apollo.QueryHookOptions<InitialChargeOneQuery, InitialChargeOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialChargeOneQuery, InitialChargeOneQueryVariables>(InitialChargeOneDocument, options);
      }
export function useInitialChargeOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialChargeOneQuery, InitialChargeOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialChargeOneQuery, InitialChargeOneQueryVariables>(InitialChargeOneDocument, options);
        }
export type InitialChargeOneQueryHookResult = ReturnType<typeof useInitialChargeOneQuery>;
export type InitialChargeOneLazyQueryHookResult = ReturnType<typeof useInitialChargeOneLazyQuery>;
export type InitialChargeOneQueryResult = Apollo.QueryResult<InitialChargeOneQuery, InitialChargeOneQueryVariables>;
export const GetLocationDocument = gql`
    query GetLocation($id: String!) {
  locationOne(id: $id) {
    address
    city
    createdDate
    id
    description
    stationsEnabled
    notificationSenderNumber
    transactionProcessTime
    locationServices {
      id
      organizationService {
        name
      }
    }
    logoUrl
    name
    zip
    timezone
    organization {
      id
      name
    }
    state
    primaryContact {
      firstName
      lastName
      email
      phoneNumber
    }
    passportLocCode
  }
}
    `;

/**
 * __useGetLocationQuery__
 *
 * To run a query within a React component, call `useGetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationQuery(baseOptions: Apollo.QueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
      }
export function useGetLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
        }
export type GetLocationQueryHookResult = ReturnType<typeof useGetLocationQuery>;
export type GetLocationLazyQueryHookResult = ReturnType<typeof useGetLocationLazyQuery>;
export type GetLocationQueryResult = Apollo.QueryResult<GetLocationQuery, GetLocationQueryVariables>;
export const GetLocationsDocument = gql`
    query GetLocations {
  locationMany {
    id
    name
  }
}
    `;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export const GetLocationPageDocument = gql`
    query GetLocationPage($pagination: PaginationInput!) {
  locationPage(pagination: $pagination) {
    items {
      id
      name
      logoUrl
      address
      createdDate
    }
    totalRows
  }
}
    `;

/**
 * __useGetLocationPageQuery__
 *
 * To run a query within a React component, call `useGetLocationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetLocationPageQuery(baseOptions: Apollo.QueryHookOptions<GetLocationPageQuery, GetLocationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationPageQuery, GetLocationPageQueryVariables>(GetLocationPageDocument, options);
      }
export function useGetLocationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationPageQuery, GetLocationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationPageQuery, GetLocationPageQueryVariables>(GetLocationPageDocument, options);
        }
export type GetLocationPageQueryHookResult = ReturnType<typeof useGetLocationPageQuery>;
export type GetLocationPageLazyQueryHookResult = ReturnType<typeof useGetLocationPageLazyQuery>;
export type GetLocationPageQueryResult = Apollo.QueryResult<GetLocationPageQuery, GetLocationPageQueryVariables>;
export const GetLocationDetailCalendarDocument = gql`
    query GetLocationDetailCalendar($id: String!) {
  locationOne(id: $id) {
    id
    employees {
      id
      user {
        firstName
        lastName
      }
    }
    rooms {
      id
      name
    }
    locationServices {
      id
      organizationService {
        name
      }
    }
  }
}
    `;

/**
 * __useGetLocationDetailCalendarQuery__
 *
 * To run a query within a React component, call `useGetLocationDetailCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationDetailCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationDetailCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationDetailCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetLocationDetailCalendarQuery, GetLocationDetailCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationDetailCalendarQuery, GetLocationDetailCalendarQueryVariables>(GetLocationDetailCalendarDocument, options);
      }
export function useGetLocationDetailCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationDetailCalendarQuery, GetLocationDetailCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationDetailCalendarQuery, GetLocationDetailCalendarQueryVariables>(GetLocationDetailCalendarDocument, options);
        }
export type GetLocationDetailCalendarQueryHookResult = ReturnType<typeof useGetLocationDetailCalendarQuery>;
export type GetLocationDetailCalendarLazyQueryHookResult = ReturnType<typeof useGetLocationDetailCalendarLazyQuery>;
export type GetLocationDetailCalendarQueryResult = Apollo.QueryResult<GetLocationDetailCalendarQuery, GetLocationDetailCalendarQueryVariables>;
export const GetLocationRevenueDocument = gql`
    query GetLocationRevenue($id: String!) {
  locationOne(id: $id) {
    id
    locationRevenue {
      id
      payrocAccount {
        id
        merchantId
        payrocVirtualTerminalId
        payrocEmbeddedSecret
      }
    }
  }
}
    `;

/**
 * __useGetLocationRevenueQuery__
 *
 * To run a query within a React component, call `useGetLocationRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationRevenueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationRevenueQuery(baseOptions: Apollo.QueryHookOptions<GetLocationRevenueQuery, GetLocationRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationRevenueQuery, GetLocationRevenueQueryVariables>(GetLocationRevenueDocument, options);
      }
export function useGetLocationRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationRevenueQuery, GetLocationRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationRevenueQuery, GetLocationRevenueQueryVariables>(GetLocationRevenueDocument, options);
        }
export type GetLocationRevenueQueryHookResult = ReturnType<typeof useGetLocationRevenueQuery>;
export type GetLocationRevenueLazyQueryHookResult = ReturnType<typeof useGetLocationRevenueLazyQuery>;
export type GetLocationRevenueQueryResult = Apollo.QueryResult<GetLocationRevenueQuery, GetLocationRevenueQueryVariables>;
export const GetLocationRoomsDocument = gql`
    query GetLocationRooms {
  locationMany {
    id
    name
    rooms {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLocationRoomsQuery__
 *
 * To run a query within a React component, call `useGetLocationRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationRoomsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationRoomsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationRoomsQuery, GetLocationRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationRoomsQuery, GetLocationRoomsQueryVariables>(GetLocationRoomsDocument, options);
      }
export function useGetLocationRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationRoomsQuery, GetLocationRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationRoomsQuery, GetLocationRoomsQueryVariables>(GetLocationRoomsDocument, options);
        }
export type GetLocationRoomsQueryHookResult = ReturnType<typeof useGetLocationRoomsQuery>;
export type GetLocationRoomsLazyQueryHookResult = ReturnType<typeof useGetLocationRoomsLazyQuery>;
export type GetLocationRoomsQueryResult = Apollo.QueryResult<GetLocationRoomsQuery, GetLocationRoomsQueryVariables>;
export const GetLocationMonthlyFeesDocument = gql`
    query GetLocationMonthlyFees($locationRevenueId: String) {
  locationMonthlyFeeMany(locationRevenueId: $locationRevenueId) {
    name
    amount
    id
  }
}
    `;

/**
 * __useGetLocationMonthlyFeesQuery__
 *
 * To run a query within a React component, call `useGetLocationMonthlyFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationMonthlyFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationMonthlyFeesQuery({
 *   variables: {
 *      locationRevenueId: // value for 'locationRevenueId'
 *   },
 * });
 */
export function useGetLocationMonthlyFeesQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationMonthlyFeesQuery, GetLocationMonthlyFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationMonthlyFeesQuery, GetLocationMonthlyFeesQueryVariables>(GetLocationMonthlyFeesDocument, options);
      }
export function useGetLocationMonthlyFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationMonthlyFeesQuery, GetLocationMonthlyFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationMonthlyFeesQuery, GetLocationMonthlyFeesQueryVariables>(GetLocationMonthlyFeesDocument, options);
        }
export type GetLocationMonthlyFeesQueryHookResult = ReturnType<typeof useGetLocationMonthlyFeesQuery>;
export type GetLocationMonthlyFeesLazyQueryHookResult = ReturnType<typeof useGetLocationMonthlyFeesLazyQuery>;
export type GetLocationMonthlyFeesQueryResult = Apollo.QueryResult<GetLocationMonthlyFeesQuery, GetLocationMonthlyFeesQueryVariables>;
export const LocationOfferingManyDocument = gql`
    query LocationOfferingMany($locationId: String, $isPromoCode: Boolean) {
  locationOfferingMany(locationId: $locationId, isPromoCode: $isPromoCode) {
    header
    details
    id
    isActive
    promoCode
    location {
      name
      organization {
        id
      }
    }
    agreement {
      name
    }
    name
    subtext
  }
}
    `;

/**
 * __useLocationOfferingManyQuery__
 *
 * To run a query within a React component, call `useLocationOfferingManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationOfferingManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationOfferingManyQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      isPromoCode: // value for 'isPromoCode'
 *   },
 * });
 */
export function useLocationOfferingManyQuery(baseOptions?: Apollo.QueryHookOptions<LocationOfferingManyQuery, LocationOfferingManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationOfferingManyQuery, LocationOfferingManyQueryVariables>(LocationOfferingManyDocument, options);
      }
export function useLocationOfferingManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationOfferingManyQuery, LocationOfferingManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationOfferingManyQuery, LocationOfferingManyQueryVariables>(LocationOfferingManyDocument, options);
        }
export type LocationOfferingManyQueryHookResult = ReturnType<typeof useLocationOfferingManyQuery>;
export type LocationOfferingManyLazyQueryHookResult = ReturnType<typeof useLocationOfferingManyLazyQuery>;
export type LocationOfferingManyQueryResult = Apollo.QueryResult<LocationOfferingManyQuery, LocationOfferingManyQueryVariables>;
export const LocationOfferingOneDocument = gql`
    query LocationOfferingOne($id: String!) {
  locationOfferingOne(id: $id) {
    location {
      id
    }
    agreement {
      id
      name
      description
      locations {
        id
        name
        address
        primaryContact {
          phoneNumber
        }
      }
      recurringCharges {
        id
        name
        cost
      }
      initialCharges {
        id
        cost
        revenue {
          name
        }
      }
      additionalPolicies {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useLocationOfferingOneQuery__
 *
 * To run a query within a React component, call `useLocationOfferingOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationOfferingOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationOfferingOneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationOfferingOneQuery(baseOptions: Apollo.QueryHookOptions<LocationOfferingOneQuery, LocationOfferingOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationOfferingOneQuery, LocationOfferingOneQueryVariables>(LocationOfferingOneDocument, options);
      }
export function useLocationOfferingOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationOfferingOneQuery, LocationOfferingOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationOfferingOneQuery, LocationOfferingOneQueryVariables>(LocationOfferingOneDocument, options);
        }
export type LocationOfferingOneQueryHookResult = ReturnType<typeof useLocationOfferingOneQuery>;
export type LocationOfferingOneLazyQueryHookResult = ReturnType<typeof useLocationOfferingOneLazyQuery>;
export type LocationOfferingOneQueryResult = Apollo.QueryResult<LocationOfferingOneQuery, LocationOfferingOneQueryVariables>;
export const GetLocationOfferingListDocument = gql`
    query GetLocationOfferingList($locationId: String, $isPromoCode: Boolean) {
  locationOfferingMany(locationId: $locationId, isPromoCode: $isPromoCode) {
    id
    isActive
    agreement {
      id
      name
    }
    name
  }
}
    `;

/**
 * __useGetLocationOfferingListQuery__
 *
 * To run a query within a React component, call `useGetLocationOfferingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationOfferingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationOfferingListQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      isPromoCode: // value for 'isPromoCode'
 *   },
 * });
 */
export function useGetLocationOfferingListQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationOfferingListQuery, GetLocationOfferingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationOfferingListQuery, GetLocationOfferingListQueryVariables>(GetLocationOfferingListDocument, options);
      }
export function useGetLocationOfferingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationOfferingListQuery, GetLocationOfferingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationOfferingListQuery, GetLocationOfferingListQueryVariables>(GetLocationOfferingListDocument, options);
        }
export type GetLocationOfferingListQueryHookResult = ReturnType<typeof useGetLocationOfferingListQuery>;
export type GetLocationOfferingListLazyQueryHookResult = ReturnType<typeof useGetLocationOfferingListLazyQuery>;
export type GetLocationOfferingListQueryResult = Apollo.QueryResult<GetLocationOfferingListQuery, GetLocationOfferingListQueryVariables>;
export const GetLocationOfferingDetailDocument = gql`
    query GetLocationOfferingDetail($id: String!) {
  locationOfferingOne(id: $id) {
    agreement {
      id
    }
    header
    details
    name
    name
    subtext
    promoCode
  }
}
    `;

/**
 * __useGetLocationOfferingDetailQuery__
 *
 * To run a query within a React component, call `useGetLocationOfferingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationOfferingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationOfferingDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationOfferingDetailQuery(baseOptions: Apollo.QueryHookOptions<GetLocationOfferingDetailQuery, GetLocationOfferingDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationOfferingDetailQuery, GetLocationOfferingDetailQueryVariables>(GetLocationOfferingDetailDocument, options);
      }
export function useGetLocationOfferingDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationOfferingDetailQuery, GetLocationOfferingDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationOfferingDetailQuery, GetLocationOfferingDetailQueryVariables>(GetLocationOfferingDetailDocument, options);
        }
export type GetLocationOfferingDetailQueryHookResult = ReturnType<typeof useGetLocationOfferingDetailQuery>;
export type GetLocationOfferingDetailLazyQueryHookResult = ReturnType<typeof useGetLocationOfferingDetailLazyQuery>;
export type GetLocationOfferingDetailQueryResult = Apollo.QueryResult<GetLocationOfferingDetailQuery, GetLocationOfferingDetailQueryVariables>;
export const LocationOfferingByPromoCodeDocument = gql`
    query LocationOfferingByPromoCode($promoCode: String!) {
  locationOfferingByPromoCode(promoCode: $promoCode) {
    header
    details
    id
    isActive
    promoCode
    location {
      name
      organization {
        id
      }
    }
    agreement {
      name
    }
    name
    subtext
  }
}
    `;

/**
 * __useLocationOfferingByPromoCodeQuery__
 *
 * To run a query within a React component, call `useLocationOfferingByPromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationOfferingByPromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationOfferingByPromoCodeQuery({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useLocationOfferingByPromoCodeQuery(baseOptions: Apollo.QueryHookOptions<LocationOfferingByPromoCodeQuery, LocationOfferingByPromoCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationOfferingByPromoCodeQuery, LocationOfferingByPromoCodeQueryVariables>(LocationOfferingByPromoCodeDocument, options);
      }
export function useLocationOfferingByPromoCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationOfferingByPromoCodeQuery, LocationOfferingByPromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationOfferingByPromoCodeQuery, LocationOfferingByPromoCodeQueryVariables>(LocationOfferingByPromoCodeDocument, options);
        }
export type LocationOfferingByPromoCodeQueryHookResult = ReturnType<typeof useLocationOfferingByPromoCodeQuery>;
export type LocationOfferingByPromoCodeLazyQueryHookResult = ReturnType<typeof useLocationOfferingByPromoCodeLazyQuery>;
export type LocationOfferingByPromoCodeQueryResult = Apollo.QueryResult<LocationOfferingByPromoCodeQuery, LocationOfferingByPromoCodeQueryVariables>;
export const GetRevenueByLocationDocument = gql`
    query GetRevenueByLocation($locationId: String!) {
  locationRevenueByLocation(locationId: $locationId) {
    id
    payrocAccount {
      id
      merchantId
      payrocVirtualTerminalId
      payrocEmbeddedSecret
    }
  }
}
    `;

/**
 * __useGetRevenueByLocationQuery__
 *
 * To run a query within a React component, call `useGetRevenueByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueByLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetRevenueByLocationQuery(baseOptions: Apollo.QueryHookOptions<GetRevenueByLocationQuery, GetRevenueByLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueByLocationQuery, GetRevenueByLocationQueryVariables>(GetRevenueByLocationDocument, options);
      }
export function useGetRevenueByLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueByLocationQuery, GetRevenueByLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueByLocationQuery, GetRevenueByLocationQueryVariables>(GetRevenueByLocationDocument, options);
        }
export type GetRevenueByLocationQueryHookResult = ReturnType<typeof useGetRevenueByLocationQuery>;
export type GetRevenueByLocationLazyQueryHookResult = ReturnType<typeof useGetRevenueByLocationLazyQuery>;
export type GetRevenueByLocationQueryResult = Apollo.QueryResult<GetRevenueByLocationQuery, GetRevenueByLocationQueryVariables>;
export const GetLocationTaxRatesDocument = gql`
    query GetLocationTaxRates($locationId: String) {
  locationTaxRateMany(locationId: $locationId) {
    taxRate
    id
    organizationTaxRate {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLocationTaxRatesQuery__
 *
 * To run a query within a React component, call `useGetLocationTaxRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationTaxRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationTaxRatesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationTaxRatesQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationTaxRatesQuery, GetLocationTaxRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationTaxRatesQuery, GetLocationTaxRatesQueryVariables>(GetLocationTaxRatesDocument, options);
      }
export function useGetLocationTaxRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationTaxRatesQuery, GetLocationTaxRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationTaxRatesQuery, GetLocationTaxRatesQueryVariables>(GetLocationTaxRatesDocument, options);
        }
export type GetLocationTaxRatesQueryHookResult = ReturnType<typeof useGetLocationTaxRatesQuery>;
export type GetLocationTaxRatesLazyQueryHookResult = ReturnType<typeof useGetLocationTaxRatesLazyQuery>;
export type GetLocationTaxRatesQueryResult = Apollo.QueryResult<GetLocationTaxRatesQuery, GetLocationTaxRatesQueryVariables>;
export const GetLocationTaxRateNamesDocument = gql`
    query GetLocationTaxRateNames($locationId: String) {
  locationTaxRateMany(locationId: $locationId) {
    id
    organizationTaxRate {
      name
    }
  }
}
    `;

/**
 * __useGetLocationTaxRateNamesQuery__
 *
 * To run a query within a React component, call `useGetLocationTaxRateNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationTaxRateNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationTaxRateNamesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationTaxRateNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationTaxRateNamesQuery, GetLocationTaxRateNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationTaxRateNamesQuery, GetLocationTaxRateNamesQueryVariables>(GetLocationTaxRateNamesDocument, options);
      }
export function useGetLocationTaxRateNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationTaxRateNamesQuery, GetLocationTaxRateNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationTaxRateNamesQuery, GetLocationTaxRateNamesQueryVariables>(GetLocationTaxRateNamesDocument, options);
        }
export type GetLocationTaxRateNamesQueryHookResult = ReturnType<typeof useGetLocationTaxRateNamesQuery>;
export type GetLocationTaxRateNamesLazyQueryHookResult = ReturnType<typeof useGetLocationTaxRateNamesLazyQuery>;
export type GetLocationTaxRateNamesQueryResult = Apollo.QueryResult<GetLocationTaxRateNamesQuery, GetLocationTaxRateNamesQueryVariables>;
export const GetLocationTransactionFeesDocument = gql`
    query GetLocationTransactionFees($locationRevenueId: String) {
  locationTransactionFeeMany(locationRevenueId: $locationRevenueId) {
    percentage
    type
    flatRate
    id
  }
}
    `;

/**
 * __useGetLocationTransactionFeesQuery__
 *
 * To run a query within a React component, call `useGetLocationTransactionFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationTransactionFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationTransactionFeesQuery({
 *   variables: {
 *      locationRevenueId: // value for 'locationRevenueId'
 *   },
 * });
 */
export function useGetLocationTransactionFeesQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationTransactionFeesQuery, GetLocationTransactionFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationTransactionFeesQuery, GetLocationTransactionFeesQueryVariables>(GetLocationTransactionFeesDocument, options);
      }
export function useGetLocationTransactionFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationTransactionFeesQuery, GetLocationTransactionFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationTransactionFeesQuery, GetLocationTransactionFeesQueryVariables>(GetLocationTransactionFeesDocument, options);
        }
export type GetLocationTransactionFeesQueryHookResult = ReturnType<typeof useGetLocationTransactionFeesQuery>;
export type GetLocationTransactionFeesLazyQueryHookResult = ReturnType<typeof useGetLocationTransactionFeesLazyQuery>;
export type GetLocationTransactionFeesQueryResult = Apollo.QueryResult<GetLocationTransactionFeesQuery, GetLocationTransactionFeesQueryVariables>;
export const GetMeetingDocument = gql`
    query GetMeeting($id: String!) {
  meetingOne(id: $id) {
    id
    imgUrl
    name
    duration
    isSelfEnroll
    description
    waitlistMax
    isWaitlistEnabled
    maxOccupancy
    startAt
    endAt
    series {
      id
      dows
      doms
      seriesInterval
      scheduleTo
      scheduleFrom
    }
    isPrivateSession
    session {
      id
      name
    }
    privateSession {
      id
      duration
    }
    attendees {
      id
      client {
        user {
          firstName
          lastName
        }
      }
    }
    service {
      id
      organizationService {
        name
      }
    }
    instructor {
      id
      user {
        firstName
        lastName
      }
    }
    room {
      id
      name
    }
    location {
      id
      name
    }
    attendances {
      id
      attendanceStatus
      attendee {
        id
        attendeeType
        client {
          id
          user {
            firstName
            lastName
          }
        }
      }
      isPaid
    }
    waitlistees {
      id
      client {
        id
        user {
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useGetMeetingQuery__
 *
 * To run a query within a React component, call `useGetMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMeetingQuery(baseOptions: Apollo.QueryHookOptions<GetMeetingQuery, GetMeetingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingQuery, GetMeetingQueryVariables>(GetMeetingDocument, options);
      }
export function useGetMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingQuery, GetMeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingQuery, GetMeetingQueryVariables>(GetMeetingDocument, options);
        }
export type GetMeetingQueryHookResult = ReturnType<typeof useGetMeetingQuery>;
export type GetMeetingLazyQueryHookResult = ReturnType<typeof useGetMeetingLazyQuery>;
export type GetMeetingQueryResult = Apollo.QueryResult<GetMeetingQuery, GetMeetingQueryVariables>;
export const GetMeetingsDocument = gql`
    query getMeetings($locationId: String!, $endAt: DateTime, $startAt: DateTime) {
  meetingMany(locationId: $locationId, endAt: $endAt, startAt: $startAt) {
    id
    name
    startAt
    endAt
    room {
      id
      name
    }
    service {
      id
    }
    instructor {
      id
      user {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetMeetingsQuery__
 *
 * To run a query within a React component, call `useGetMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      endAt: // value for 'endAt'
 *      startAt: // value for 'startAt'
 *   },
 * });
 */
export function useGetMeetingsQuery(baseOptions: Apollo.QueryHookOptions<GetMeetingsQuery, GetMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingsQuery, GetMeetingsQueryVariables>(GetMeetingsDocument, options);
      }
export function useGetMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingsQuery, GetMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingsQuery, GetMeetingsQueryVariables>(GetMeetingsDocument, options);
        }
export type GetMeetingsQueryHookResult = ReturnType<typeof useGetMeetingsQuery>;
export type GetMeetingsLazyQueryHookResult = ReturnType<typeof useGetMeetingsLazyQuery>;
export type GetMeetingsQueryResult = Apollo.QueryResult<GetMeetingsQuery, GetMeetingsQueryVariables>;
export const GetCalendarFilterLocDocument = gql`
    query GetCalendarFilterLoc($locationId: String!) {
  calendarFilterLocation(locationId: $locationId) {
    id
    services {
      id
    }
    location {
      id
      name
    }
    instructors {
      id
    }
    rooms {
      id
    }
  }
}
    `;

/**
 * __useGetCalendarFilterLocQuery__
 *
 * To run a query within a React component, call `useGetCalendarFilterLocQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarFilterLocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarFilterLocQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetCalendarFilterLocQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarFilterLocQuery, GetCalendarFilterLocQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarFilterLocQuery, GetCalendarFilterLocQueryVariables>(GetCalendarFilterLocDocument, options);
      }
export function useGetCalendarFilterLocLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarFilterLocQuery, GetCalendarFilterLocQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarFilterLocQuery, GetCalendarFilterLocQueryVariables>(GetCalendarFilterLocDocument, options);
        }
export type GetCalendarFilterLocQueryHookResult = ReturnType<typeof useGetCalendarFilterLocQuery>;
export type GetCalendarFilterLocLazyQueryHookResult = ReturnType<typeof useGetCalendarFilterLocLazyQuery>;
export type GetCalendarFilterLocQueryResult = Apollo.QueryResult<GetCalendarFilterLocQuery, GetCalendarFilterLocQueryVariables>;
export const GetEventDetailDocument = gql`
    query GetEventDetail($id: String!) {
  meetingOne(id: $id) {
    id
    name
    isSelfEnroll
    description
    waitlistMax
    isWaitlistEnabled
    maxOccupancy
    startAt
    endAt
    instructor {
      user {
        profilePicUrl
        firstName
        lastName
      }
    }
    room {
      name
    }
    location {
      name
    }
    attendees {
      id
    }
    waitlistees {
      id
    }
    service {
      id
      imgUrl
      cost
      organizationService {
        name
      }
      product {
        id
      }
      location {
        id
      }
    }
    privateSession {
      id
      cost
      session {
        imageUrl
        name
      }
      product {
        id
        isTaxable
        taxRates {
          id
          taxRate
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventDetailQuery__
 *
 * To run a query within a React component, call `useGetEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventDetailQuery(baseOptions: Apollo.QueryHookOptions<GetEventDetailQuery, GetEventDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventDetailQuery, GetEventDetailQueryVariables>(GetEventDetailDocument, options);
      }
export function useGetEventDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventDetailQuery, GetEventDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventDetailQuery, GetEventDetailQueryVariables>(GetEventDetailDocument, options);
        }
export type GetEventDetailQueryHookResult = ReturnType<typeof useGetEventDetailQuery>;
export type GetEventDetailLazyQueryHookResult = ReturnType<typeof useGetEventDetailLazyQuery>;
export type GetEventDetailQueryResult = Apollo.QueryResult<GetEventDetailQuery, GetEventDetailQueryVariables>;
export const GetMeetingPageDocument = gql`
    query GetMeetingPage($pagination: PaginationInput!, $startAt: DateTime, $endAt: DateTime) {
  meetingPage(pagination: $pagination, startAt: $startAt, endAt: $endAt) {
    items {
      maxOccupancy
      startAt
      id
      name
      imgUrl
      attendees {
        id
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetMeetingPageQuery__
 *
 * To run a query within a React component, call `useGetMeetingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *   },
 * });
 */
export function useGetMeetingPageQuery(baseOptions: Apollo.QueryHookOptions<GetMeetingPageQuery, GetMeetingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingPageQuery, GetMeetingPageQueryVariables>(GetMeetingPageDocument, options);
      }
export function useGetMeetingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingPageQuery, GetMeetingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingPageQuery, GetMeetingPageQueryVariables>(GetMeetingPageDocument, options);
        }
export type GetMeetingPageQueryHookResult = ReturnType<typeof useGetMeetingPageQuery>;
export type GetMeetingPageLazyQueryHookResult = ReturnType<typeof useGetMeetingPageLazyQuery>;
export type GetMeetingPageQueryResult = Apollo.QueryResult<GetMeetingPageQuery, GetMeetingPageQueryVariables>;
export const GetMeetingSeriesDetailsDocument = gql`
    query GetMeetingSeriesDetails($id: String!) {
  meetingSeriesOne(id: $id) {
    id
    name
    description
    duration
    startAt
    endAt
    isSelfEnroll
    isWaitlistEnabled
    room {
      id
      name
    }
    isPrivateSession
    session {
      id
      name
    }
    privateSession {
      id
      duration
    }
    attendees {
      id
      client {
        user {
          firstName
          lastName
        }
      }
    }
    service {
      id
    }
    instructor {
      id
      user {
        firstName
        lastName
      }
    }
    location {
      id
      name
    }
    seriesInterval
    maxOccupancy
    waitlistMax
    scheduleFrom
    scheduleTo
    dows
    doms
  }
}
    `;

/**
 * __useGetMeetingSeriesDetailsQuery__
 *
 * To run a query within a React component, call `useGetMeetingSeriesDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingSeriesDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingSeriesDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMeetingSeriesDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMeetingSeriesDetailsQuery, GetMeetingSeriesDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingSeriesDetailsQuery, GetMeetingSeriesDetailsQueryVariables>(GetMeetingSeriesDetailsDocument, options);
      }
export function useGetMeetingSeriesDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingSeriesDetailsQuery, GetMeetingSeriesDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingSeriesDetailsQuery, GetMeetingSeriesDetailsQueryVariables>(GetMeetingSeriesDetailsDocument, options);
        }
export type GetMeetingSeriesDetailsQueryHookResult = ReturnType<typeof useGetMeetingSeriesDetailsQuery>;
export type GetMeetingSeriesDetailsLazyQueryHookResult = ReturnType<typeof useGetMeetingSeriesDetailsLazyQuery>;
export type GetMeetingSeriesDetailsQueryResult = Apollo.QueryResult<GetMeetingSeriesDetailsQuery, GetMeetingSeriesDetailsQueryVariables>;
export const GetMeetingSeriesPageDocument = gql`
    query GetMeetingSeriesPage($pagination: PaginationInput!, $locationId: String!, $startAt: DateTime, $endAt: DateTime) {
  meetingSeriesPage(
    pagination: $pagination
    locationId: $locationId
    startAt: $startAt
    endAt: $endAt
  ) {
    items {
      id
      name
      description
      startAt
      endAt
      room {
        id
        name
      }
      service {
        id
      }
      instructor {
        id
        user {
          firstName
          lastName
        }
      }
      location {
        id
        name
      }
      scheduleFrom
      scheduleTo
      dows
      doms
    }
    totalRows
  }
}
    `;

/**
 * __useGetMeetingSeriesPageQuery__
 *
 * To run a query within a React component, call `useGetMeetingSeriesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingSeriesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingSeriesPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      locationId: // value for 'locationId'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *   },
 * });
 */
export function useGetMeetingSeriesPageQuery(baseOptions: Apollo.QueryHookOptions<GetMeetingSeriesPageQuery, GetMeetingSeriesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeetingSeriesPageQuery, GetMeetingSeriesPageQueryVariables>(GetMeetingSeriesPageDocument, options);
      }
export function useGetMeetingSeriesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeetingSeriesPageQuery, GetMeetingSeriesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeetingSeriesPageQuery, GetMeetingSeriesPageQueryVariables>(GetMeetingSeriesPageDocument, options);
        }
export type GetMeetingSeriesPageQueryHookResult = ReturnType<typeof useGetMeetingSeriesPageQuery>;
export type GetMeetingSeriesPageLazyQueryHookResult = ReturnType<typeof useGetMeetingSeriesPageLazyQuery>;
export type GetMeetingSeriesPageQueryResult = Apollo.QueryResult<GetMeetingSeriesPageQuery, GetMeetingSeriesPageQueryVariables>;
export const GetNotesDocument = gql`
    query GetNotes($clientId: String) {
  notesMany(clientId: $clientId) {
    id
    content
    isMigrated
    author {
      id
      user {
        id
        firstName
        lastName
        profilePicUrl
      }
    }
    updatedDate
  }
}
    `;

/**
 * __useGetNotesQuery__
 *
 * To run a query within a React component, call `useGetNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
      }
export function useGetNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
export type GetNotesQueryHookResult = ReturnType<typeof useGetNotesQuery>;
export type GetNotesLazyQueryHookResult = ReturnType<typeof useGetNotesLazyQuery>;
export type GetNotesQueryResult = Apollo.QueryResult<GetNotesQuery, GetNotesQueryVariables>;
export const NotesSampleCsvDocument = gql`
    query notesSampleCSV {
  notesSampleCSV
}
    `;

/**
 * __useNotesSampleCsvQuery__
 *
 * To run a query within a React component, call `useNotesSampleCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesSampleCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesSampleCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotesSampleCsvQuery(baseOptions?: Apollo.QueryHookOptions<NotesSampleCsvQuery, NotesSampleCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesSampleCsvQuery, NotesSampleCsvQueryVariables>(NotesSampleCsvDocument, options);
      }
export function useNotesSampleCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesSampleCsvQuery, NotesSampleCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesSampleCsvQuery, NotesSampleCsvQueryVariables>(NotesSampleCsvDocument, options);
        }
export type NotesSampleCsvQueryHookResult = ReturnType<typeof useNotesSampleCsvQuery>;
export type NotesSampleCsvLazyQueryHookResult = ReturnType<typeof useNotesSampleCsvLazyQuery>;
export type NotesSampleCsvQueryResult = Apollo.QueryResult<NotesSampleCsvQuery, NotesSampleCsvQueryVariables>;
export const GetOrganizationDocument = gql`
    query GetOrganization($id: String!) {
  organizationOne(id: $id) {
    id
    name
    description
    logoUrl
    street
    zipCode
    city
    country
    state
    categoryOptions {
      id
      name
      type
      isActive
    }
    locations {
      id
      name
      description
      logoUrl
      stationsEnabled
    }
    organizationBranding {
      brandingLogoImg
      id
      primaryColor
      secondaryColor
    }
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetOrganizationPageDocument = gql`
    query GetOrganizationPage($pagination: PaginationInput!) {
  organizationPage(pagination: $pagination) {
    items {
      id
      name
      description
      logoUrl
      createdDate
    }
    totalRows
  }
}
    `;

/**
 * __useGetOrganizationPageQuery__
 *
 * To run a query within a React component, call `useGetOrganizationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetOrganizationPageQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationPageQuery, GetOrganizationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationPageQuery, GetOrganizationPageQueryVariables>(GetOrganizationPageDocument, options);
      }
export function useGetOrganizationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationPageQuery, GetOrganizationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationPageQuery, GetOrganizationPageQueryVariables>(GetOrganizationPageDocument, options);
        }
export type GetOrganizationPageQueryHookResult = ReturnType<typeof useGetOrganizationPageQuery>;
export type GetOrganizationPageLazyQueryHookResult = ReturnType<typeof useGetOrganizationPageLazyQuery>;
export type GetOrganizationPageQueryResult = Apollo.QueryResult<GetOrganizationPageQuery, GetOrganizationPageQueryVariables>;
export const GetOrganizationRevenueFeeDocument = gql`
    query GetOrganizationRevenueFee($id: String!) {
  organizationOne(id: $id) {
    id
    locations {
      id
      name
      logoUrl
      locationRevenue {
        payrocAccount {
          id
          merchantId
          payrocVirtualTerminalId
          payrocEmbeddedSecret
        }
        id
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationRevenueFeeQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRevenueFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRevenueFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRevenueFeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationRevenueFeeQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationRevenueFeeQuery, GetOrganizationRevenueFeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationRevenueFeeQuery, GetOrganizationRevenueFeeQueryVariables>(GetOrganizationRevenueFeeDocument, options);
      }
export function useGetOrganizationRevenueFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationRevenueFeeQuery, GetOrganizationRevenueFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationRevenueFeeQuery, GetOrganizationRevenueFeeQueryVariables>(GetOrganizationRevenueFeeDocument, options);
        }
export type GetOrganizationRevenueFeeQueryHookResult = ReturnType<typeof useGetOrganizationRevenueFeeQuery>;
export type GetOrganizationRevenueFeeLazyQueryHookResult = ReturnType<typeof useGetOrganizationRevenueFeeLazyQuery>;
export type GetOrganizationRevenueFeeQueryResult = Apollo.QueryResult<GetOrganizationRevenueFeeQuery, GetOrganizationRevenueFeeQueryVariables>;
export const GetOrganizationBrandingDocument = gql`
    query GetOrganizationBranding($organizationId: String) {
  organizationBrandingOne(organizationId: $organizationId) {
    brandingLogoImg
    id
    primaryColor
    secondaryColor
  }
}
    `;

/**
 * __useGetOrganizationBrandingQuery__
 *
 * To run a query within a React component, call `useGetOrganizationBrandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationBrandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationBrandingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationBrandingQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationBrandingQuery, GetOrganizationBrandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationBrandingQuery, GetOrganizationBrandingQueryVariables>(GetOrganizationBrandingDocument, options);
      }
export function useGetOrganizationBrandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationBrandingQuery, GetOrganizationBrandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationBrandingQuery, GetOrganizationBrandingQueryVariables>(GetOrganizationBrandingDocument, options);
        }
export type GetOrganizationBrandingQueryHookResult = ReturnType<typeof useGetOrganizationBrandingQuery>;
export type GetOrganizationBrandingLazyQueryHookResult = ReturnType<typeof useGetOrganizationBrandingLazyQuery>;
export type GetOrganizationBrandingQueryResult = Apollo.QueryResult<GetOrganizationBrandingQuery, GetOrganizationBrandingQueryVariables>;
export const GetOrganizationSettingsDocument = gql`
    query GetOrganizationSettings($organizationId: String!) {
  organizationSettingsOne(id: $organizationId) {
    id
    freezeExtendsTerm
    seriesGenInterval
    seriesGenRange
  }
}
    `;

/**
 * __useGetOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
      }
export function useGetOrganizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
        }
export type GetOrganizationSettingsQueryHookResult = ReturnType<typeof useGetOrganizationSettingsQuery>;
export type GetOrganizationSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganizationSettingsLazyQuery>;
export type GetOrganizationSettingsQueryResult = Apollo.QueryResult<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>;
export const GetOrganizationTaxRatesDocument = gql`
    query GetOrganizationTaxRates($organizationId: String) {
  organizationTaxRateMany(organizationId: $organizationId) {
    name
    taxRate
    id
  }
}
    `;

/**
 * __useGetOrganizationTaxRatesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationTaxRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationTaxRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationTaxRatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationTaxRatesQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationTaxRatesQuery, GetOrganizationTaxRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationTaxRatesQuery, GetOrganizationTaxRatesQueryVariables>(GetOrganizationTaxRatesDocument, options);
      }
export function useGetOrganizationTaxRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationTaxRatesQuery, GetOrganizationTaxRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationTaxRatesQuery, GetOrganizationTaxRatesQueryVariables>(GetOrganizationTaxRatesDocument, options);
        }
export type GetOrganizationTaxRatesQueryHookResult = ReturnType<typeof useGetOrganizationTaxRatesQuery>;
export type GetOrganizationTaxRatesLazyQueryHookResult = ReturnType<typeof useGetOrganizationTaxRatesLazyQuery>;
export type GetOrganizationTaxRatesQueryResult = Apollo.QueryResult<GetOrganizationTaxRatesQuery, GetOrganizationTaxRatesQueryVariables>;
export const GetPackageDocument = gql`
    query GetPackage($id: String!) {
  packageOne(id: $id) {
    name
    description
    isOrg
    isGeneric
    locations {
      id
      name
    }
    additionalPolicies {
      id
      name
    }
    initialCharges {
      id
      cost
      isTaxable
      isPostTax
      taxRates {
        id
        organizationTaxRate {
          name
        }
      }
      revenue {
        id
        name
      }
      fee {
        id
        name
      }
      isDiscountable
    }
    initialAllotments {
      id
      name
      credits
    }
    product {
      id
      imgUrl
      tags {
        id
        name
      }
      revenue {
        id
        name
      }
      isActive
    }
  }
}
    `;

/**
 * __useGetPackageQuery__
 *
 * To run a query within a React component, call `useGetPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPackageQuery(baseOptions: Apollo.QueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
      }
export function useGetPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
        }
export type GetPackageQueryHookResult = ReturnType<typeof useGetPackageQuery>;
export type GetPackageLazyQueryHookResult = ReturnType<typeof useGetPackageLazyQuery>;
export type GetPackageQueryResult = Apollo.QueryResult<GetPackageQuery, GetPackageQueryVariables>;
export const GetPackagePageDocument = gql`
    query GetPackagePage($pagination: PaginationInput!, $locationIds: [GenericConnectInput!]) {
  PackagePage(pagination: $pagination, locationIds: $locationIds) {
    items {
      id
      name
      description
      createdDate
      isActive
      isOrg
    }
    totalRows
  }
}
    `;

/**
 * __useGetPackagePageQuery__
 *
 * To run a query within a React component, call `useGetPackagePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagePageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useGetPackagePageQuery(baseOptions: Apollo.QueryHookOptions<GetPackagePageQuery, GetPackagePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagePageQuery, GetPackagePageQueryVariables>(GetPackagePageDocument, options);
      }
export function useGetPackagePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagePageQuery, GetPackagePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagePageQuery, GetPackagePageQueryVariables>(GetPackagePageDocument, options);
        }
export type GetPackagePageQueryHookResult = ReturnType<typeof useGetPackagePageQuery>;
export type GetPackagePageLazyQueryHookResult = ReturnType<typeof useGetPackagePageLazyQuery>;
export type GetPackagePageQueryResult = Apollo.QueryResult<GetPackagePageQuery, GetPackagePageQueryVariables>;
export const GetTerminalsByLocationDocument = gql`
    query GetTerminalsByLocation($locationId: String) {
  paymentTerminalMany(locationId: $locationId) {
    id
    externalId
    physicalId
    name
    location {
      id
    }
  }
}
    `;

/**
 * __useGetTerminalsByLocationQuery__
 *
 * To run a query within a React component, call `useGetTerminalsByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminalsByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTerminalsByLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetTerminalsByLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetTerminalsByLocationQuery, GetTerminalsByLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTerminalsByLocationQuery, GetTerminalsByLocationQueryVariables>(GetTerminalsByLocationDocument, options);
      }
export function useGetTerminalsByLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTerminalsByLocationQuery, GetTerminalsByLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTerminalsByLocationQuery, GetTerminalsByLocationQueryVariables>(GetTerminalsByLocationDocument, options);
        }
export type GetTerminalsByLocationQueryHookResult = ReturnType<typeof useGetTerminalsByLocationQuery>;
export type GetTerminalsByLocationLazyQueryHookResult = ReturnType<typeof useGetTerminalsByLocationLazyQuery>;
export type GetTerminalsByLocationQueryResult = Apollo.QueryResult<GetTerminalsByLocationQuery, GetTerminalsByLocationQueryVariables>;
export const GetPolicyDocument = gql`
    query GetPolicy($id: String!) {
  policyOne(id: $id) {
    name
    isPdf
    fileUrl
    data
    documentId
  }
}
    `;

/**
 * __useGetPolicyQuery__
 *
 * To run a query within a React component, call `useGetPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPolicyQuery, GetPolicyQueryVariables>(GetPolicyDocument, options);
      }
export function useGetPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPolicyQuery, GetPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPolicyQuery, GetPolicyQueryVariables>(GetPolicyDocument, options);
        }
export type GetPolicyQueryHookResult = ReturnType<typeof useGetPolicyQuery>;
export type GetPolicyLazyQueryHookResult = ReturnType<typeof useGetPolicyLazyQuery>;
export type GetPolicyQueryResult = Apollo.QueryResult<GetPolicyQuery, GetPolicyQueryVariables>;
export const GetPoliciesDocument = gql`
    query GetPolicies {
  policyMany {
    id
    name
  }
}
    `;

/**
 * __useGetPoliciesQuery__
 *
 * To run a query within a React component, call `useGetPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPoliciesQuery(baseOptions?: Apollo.QueryHookOptions<GetPoliciesQuery, GetPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoliciesQuery, GetPoliciesQueryVariables>(GetPoliciesDocument, options);
      }
export function useGetPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPoliciesQuery, GetPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoliciesQuery, GetPoliciesQueryVariables>(GetPoliciesDocument, options);
        }
export type GetPoliciesQueryHookResult = ReturnType<typeof useGetPoliciesQuery>;
export type GetPoliciesLazyQueryHookResult = ReturnType<typeof useGetPoliciesLazyQuery>;
export type GetPoliciesQueryResult = Apollo.QueryResult<GetPoliciesQuery, GetPoliciesQueryVariables>;
export const GetPolicyPageDocument = gql`
    query GetPolicyPage($pagination: PaginationInput!) {
  policyPage(pagination: $pagination) {
    items {
      id
      name
      createdDate
      fileUrl
      data
      isActive
    }
    totalRows
  }
}
    `;

/**
 * __useGetPolicyPageQuery__
 *
 * To run a query within a React component, call `useGetPolicyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPolicyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPolicyPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPolicyPageQuery(baseOptions: Apollo.QueryHookOptions<GetPolicyPageQuery, GetPolicyPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPolicyPageQuery, GetPolicyPageQueryVariables>(GetPolicyPageDocument, options);
      }
export function useGetPolicyPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPolicyPageQuery, GetPolicyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPolicyPageQuery, GetPolicyPageQueryVariables>(GetPolicyPageDocument, options);
        }
export type GetPolicyPageQueryHookResult = ReturnType<typeof useGetPolicyPageQuery>;
export type GetPolicyPageLazyQueryHookResult = ReturnType<typeof useGetPolicyPageLazyQuery>;
export type GetPolicyPageQueryResult = Apollo.QueryResult<GetPolicyPageQuery, GetPolicyPageQueryVariables>;
export const GetEditorLinkDocument = gql`
    query GetEditorLink($id: String!) {
  getEditorLink(id: $id)
}
    `;

/**
 * __useGetEditorLinkQuery__
 *
 * To run a query within a React component, call `useGetEditorLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditorLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditorLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEditorLinkQuery(baseOptions: Apollo.QueryHookOptions<GetEditorLinkQuery, GetEditorLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEditorLinkQuery, GetEditorLinkQueryVariables>(GetEditorLinkDocument, options);
      }
export function useGetEditorLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEditorLinkQuery, GetEditorLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEditorLinkQuery, GetEditorLinkQueryVariables>(GetEditorLinkDocument, options);
        }
export type GetEditorLinkQueryHookResult = ReturnType<typeof useGetEditorLinkQuery>;
export type GetEditorLinkLazyQueryHookResult = ReturnType<typeof useGetEditorLinkLazyQuery>;
export type GetEditorLinkQueryResult = Apollo.QueryResult<GetEditorLinkQuery, GetEditorLinkQueryVariables>;
export const GetPrivateSessionPageDocument = gql`
    query GetPrivateSessionPage($pagination: PaginationInput!) {
  privateSessionPage(pagination: $pagination) {
    items {
      id
      name
      minDuration
      maxDuration
      isActive
      serviceType {
        name
      }
      revenueCategory {
        name
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetPrivateSessionPageQuery__
 *
 * To run a query within a React component, call `useGetPrivateSessionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateSessionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateSessionPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPrivateSessionPageQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateSessionPageQuery, GetPrivateSessionPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateSessionPageQuery, GetPrivateSessionPageQueryVariables>(GetPrivateSessionPageDocument, options);
      }
export function useGetPrivateSessionPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateSessionPageQuery, GetPrivateSessionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateSessionPageQuery, GetPrivateSessionPageQueryVariables>(GetPrivateSessionPageDocument, options);
        }
export type GetPrivateSessionPageQueryHookResult = ReturnType<typeof useGetPrivateSessionPageQuery>;
export type GetPrivateSessionPageLazyQueryHookResult = ReturnType<typeof useGetPrivateSessionPageLazyQuery>;
export type GetPrivateSessionPageQueryResult = Apollo.QueryResult<GetPrivateSessionPageQuery, GetPrivateSessionPageQueryVariables>;
export const GetPrivateSessionDocument = gql`
    query GetPrivateSession($id: String!) {
  privateSessionOne(id: $id) {
    id
    name
    description
    intervalDuration
    isTaxable
    isPostTax
    isOrg
    isRoomRequired
    isEmployeeRequired
    isOrg
    minDuration
    maxDuration
    serviceType {
      id
      name
    }
    revenueCategory {
      id
      name
    }
    organization {
      id
    }
    imageUrl
    policies {
      id
      name
    }
    rooms {
      id
      location {
        id
        name
      }
      taxRates {
        id
        organizationTaxRate {
          name
        }
      }
    }
    durations {
      id
      duration
    }
    overrides {
      id
      employee {
        id
        user {
          firstName
          lastName
        }
        locations {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetPrivateSessionQuery__
 *
 * To run a query within a React component, call `useGetPrivateSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPrivateSessionQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateSessionQuery, GetPrivateSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateSessionQuery, GetPrivateSessionQueryVariables>(GetPrivateSessionDocument, options);
      }
export function useGetPrivateSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateSessionQuery, GetPrivateSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateSessionQuery, GetPrivateSessionQueryVariables>(GetPrivateSessionDocument, options);
        }
export type GetPrivateSessionQueryHookResult = ReturnType<typeof useGetPrivateSessionQuery>;
export type GetPrivateSessionLazyQueryHookResult = ReturnType<typeof useGetPrivateSessionLazyQuery>;
export type GetPrivateSessionQueryResult = Apollo.QueryResult<GetPrivateSessionQuery, GetPrivateSessionQueryVariables>;
export const GetPrivateSessionsDetailDocument = gql`
    query GetPrivateSessionsDetail($locationId: String) {
  privateSessionMany(locationId: $locationId) {
    id
    name
    isRoomRequired
    isEmployeeRequired
    minDuration
    maxDuration
    durations {
      id
      duration
    }
    rooms {
      rooms {
        id
        name
        totalCapacity
      }
    }
    overrides {
      minDuration
      maxDuration
      employee {
        id
        user {
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useGetPrivateSessionsDetailQuery__
 *
 * To run a query within a React component, call `useGetPrivateSessionsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateSessionsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateSessionsDetailQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetPrivateSessionsDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetPrivateSessionsDetailQuery, GetPrivateSessionsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateSessionsDetailQuery, GetPrivateSessionsDetailQueryVariables>(GetPrivateSessionsDetailDocument, options);
      }
export function useGetPrivateSessionsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateSessionsDetailQuery, GetPrivateSessionsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateSessionsDetailQuery, GetPrivateSessionsDetailQueryVariables>(GetPrivateSessionsDetailDocument, options);
        }
export type GetPrivateSessionsDetailQueryHookResult = ReturnType<typeof useGetPrivateSessionsDetailQuery>;
export type GetPrivateSessionsDetailLazyQueryHookResult = ReturnType<typeof useGetPrivateSessionsDetailLazyQuery>;
export type GetPrivateSessionsDetailQueryResult = Apollo.QueryResult<GetPrivateSessionsDetailQuery, GetPrivateSessionsDetailQueryVariables>;
export const GetPrivateSessionDurationDocument = gql`
    query GetPrivateSessionDuration($id: String!) {
  privateSessionDurationOne(id: $id) {
    duration
    session {
      id
    }
    cost
  }
}
    `;

/**
 * __useGetPrivateSessionDurationQuery__
 *
 * To run a query within a React component, call `useGetPrivateSessionDurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateSessionDurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateSessionDurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPrivateSessionDurationQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateSessionDurationQuery, GetPrivateSessionDurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateSessionDurationQuery, GetPrivateSessionDurationQueryVariables>(GetPrivateSessionDurationDocument, options);
      }
export function useGetPrivateSessionDurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateSessionDurationQuery, GetPrivateSessionDurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateSessionDurationQuery, GetPrivateSessionDurationQueryVariables>(GetPrivateSessionDurationDocument, options);
        }
export type GetPrivateSessionDurationQueryHookResult = ReturnType<typeof useGetPrivateSessionDurationQuery>;
export type GetPrivateSessionDurationLazyQueryHookResult = ReturnType<typeof useGetPrivateSessionDurationLazyQuery>;
export type GetPrivateSessionDurationQueryResult = Apollo.QueryResult<GetPrivateSessionDurationQuery, GetPrivateSessionDurationQueryVariables>;
export const GetPrivateSessionDurationsNameDocument = gql`
    query GetPrivateSessionDurationsName {
  privateSessionDurationMany {
    duration
    id
    session {
      name
    }
  }
}
    `;

/**
 * __useGetPrivateSessionDurationsNameQuery__
 *
 * To run a query within a React component, call `useGetPrivateSessionDurationsNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateSessionDurationsNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateSessionDurationsNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrivateSessionDurationsNameQuery(baseOptions?: Apollo.QueryHookOptions<GetPrivateSessionDurationsNameQuery, GetPrivateSessionDurationsNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateSessionDurationsNameQuery, GetPrivateSessionDurationsNameQueryVariables>(GetPrivateSessionDurationsNameDocument, options);
      }
export function useGetPrivateSessionDurationsNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateSessionDurationsNameQuery, GetPrivateSessionDurationsNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateSessionDurationsNameQuery, GetPrivateSessionDurationsNameQueryVariables>(GetPrivateSessionDurationsNameDocument, options);
        }
export type GetPrivateSessionDurationsNameQueryHookResult = ReturnType<typeof useGetPrivateSessionDurationsNameQuery>;
export type GetPrivateSessionDurationsNameLazyQueryHookResult = ReturnType<typeof useGetPrivateSessionDurationsNameLazyQuery>;
export type GetPrivateSessionDurationsNameQueryResult = Apollo.QueryResult<GetPrivateSessionDurationsNameQuery, GetPrivateSessionDurationsNameQueryVariables>;
export const GetPrivateSessionLocationRoomsDocument = gql`
    query GetPrivateSessionLocationRooms($id: String!) {
  privateSessionLocationRoomsOne(id: $id) {
    rooms {
      id
      name
    }
    session {
      id
    }
    location {
      id
      name
    }
    taxRates {
      id
      organizationTaxRate {
        name
      }
    }
  }
}
    `;

/**
 * __useGetPrivateSessionLocationRoomsQuery__
 *
 * To run a query within a React component, call `useGetPrivateSessionLocationRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateSessionLocationRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateSessionLocationRoomsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPrivateSessionLocationRoomsQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateSessionLocationRoomsQuery, GetPrivateSessionLocationRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateSessionLocationRoomsQuery, GetPrivateSessionLocationRoomsQueryVariables>(GetPrivateSessionLocationRoomsDocument, options);
      }
export function useGetPrivateSessionLocationRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateSessionLocationRoomsQuery, GetPrivateSessionLocationRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateSessionLocationRoomsQuery, GetPrivateSessionLocationRoomsQueryVariables>(GetPrivateSessionLocationRoomsDocument, options);
        }
export type GetPrivateSessionLocationRoomsQueryHookResult = ReturnType<typeof useGetPrivateSessionLocationRoomsQuery>;
export type GetPrivateSessionLocationRoomsLazyQueryHookResult = ReturnType<typeof useGetPrivateSessionLocationRoomsLazyQuery>;
export type GetPrivateSessionLocationRoomsQueryResult = Apollo.QueryResult<GetPrivateSessionLocationRoomsQuery, GetPrivateSessionLocationRoomsQueryVariables>;
export const GetPrivateSessionOverrideDocument = gql`
    query GetPrivateSessionOverride($id: String!) {
  privateSessionOverrideOne(id: $id) {
    id
    name
    description
    commission
    isPercent
    minDuration
    maxDuration
    employee {
      id
      user {
        firstName
        lastName
      }
    }
    session {
      id
    }
    locations {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPrivateSessionOverrideQuery__
 *
 * To run a query within a React component, call `useGetPrivateSessionOverrideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateSessionOverrideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateSessionOverrideQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPrivateSessionOverrideQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateSessionOverrideQuery, GetPrivateSessionOverrideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateSessionOverrideQuery, GetPrivateSessionOverrideQueryVariables>(GetPrivateSessionOverrideDocument, options);
      }
export function useGetPrivateSessionOverrideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateSessionOverrideQuery, GetPrivateSessionOverrideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateSessionOverrideQuery, GetPrivateSessionOverrideQueryVariables>(GetPrivateSessionOverrideDocument, options);
        }
export type GetPrivateSessionOverrideQueryHookResult = ReturnType<typeof useGetPrivateSessionOverrideQuery>;
export type GetPrivateSessionOverrideLazyQueryHookResult = ReturnType<typeof useGetPrivateSessionOverrideLazyQuery>;
export type GetPrivateSessionOverrideQueryResult = Apollo.QueryResult<GetPrivateSessionOverrideQuery, GetPrivateSessionOverrideQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($id: String!) {
  productOne(id: $id) {
    name
    cost
    description
    isActive
    isCommissionable
    isCommissionPercent
    commissionValue
    isTaxable
    isPostTax
    stock
    imgUrl
    metricValues {
      id
      name
      metric {
        name
        id
      }
    }
    tags {
      id
      name
    }
    revenue {
      id
      name
    }
    barcode
    sku
    taxRates {
      id
      organizationTaxRate {
        name
      }
    }
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const ProductPageDocument = gql`
    query ProductPage($pagination: PaginationInput!) {
  productPage(pagination: $pagination) {
    items {
      id
      name
      cost
      sku
      barcode
      description
      location {
        id
        name
      }
      imgUrl
    }
    totalRows
  }
}
    `;

/**
 * __useProductPageQuery__
 *
 * To run a query within a React component, call `useProductPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useProductPageQuery(baseOptions: Apollo.QueryHookOptions<ProductPageQuery, ProductPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPageQuery, ProductPageQueryVariables>(ProductPageDocument, options);
      }
export function useProductPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPageQuery, ProductPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPageQuery, ProductPageQueryVariables>(ProductPageDocument, options);
        }
export type ProductPageQueryHookResult = ReturnType<typeof useProductPageQuery>;
export type ProductPageLazyQueryHookResult = ReturnType<typeof useProductPageLazyQuery>;
export type ProductPageQueryResult = Apollo.QueryResult<ProductPageQuery, ProductPageQueryVariables>;
export const GetProductGroupDocument = gql`
    query GetProductGroup($productGroupOneId: String!) {
  productGroupOne(id: $productGroupOneId) {
    name
    description
    imgUrl
    location {
      id
    }
    revenueCategory {
      id
      name
    }
    products {
      id
      name
      stock
      imgUrl
      metricValues {
        id
      }
    }
    metrics {
      id
      name
      values {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetProductGroupQuery__
 *
 * To run a query within a React component, call `useGetProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGroupQuery({
 *   variables: {
 *      productGroupOneId: // value for 'productGroupOneId'
 *   },
 * });
 */
export function useGetProductGroupQuery(baseOptions: Apollo.QueryHookOptions<GetProductGroupQuery, GetProductGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductGroupQuery, GetProductGroupQueryVariables>(GetProductGroupDocument, options);
      }
export function useGetProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductGroupQuery, GetProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductGroupQuery, GetProductGroupQueryVariables>(GetProductGroupDocument, options);
        }
export type GetProductGroupQueryHookResult = ReturnType<typeof useGetProductGroupQuery>;
export type GetProductGroupLazyQueryHookResult = ReturnType<typeof useGetProductGroupLazyQuery>;
export type GetProductGroupQueryResult = Apollo.QueryResult<GetProductGroupQuery, GetProductGroupQueryVariables>;
export const GetProductGroupPageDocument = gql`
    query GetProductGroupPage($pagination: PaginationInput!, $locationId: String) {
  productGroupPage(pagination: $pagination, locationId: $locationId) {
    items {
      id
      name
      description
      imgUrl
      createdDate
    }
    totalRows
  }
}
    `;

/**
 * __useGetProductGroupPageQuery__
 *
 * To run a query within a React component, call `useGetProductGroupPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGroupPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGroupPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetProductGroupPageQuery(baseOptions: Apollo.QueryHookOptions<GetProductGroupPageQuery, GetProductGroupPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductGroupPageQuery, GetProductGroupPageQueryVariables>(GetProductGroupPageDocument, options);
      }
export function useGetProductGroupPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductGroupPageQuery, GetProductGroupPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductGroupPageQuery, GetProductGroupPageQueryVariables>(GetProductGroupPageDocument, options);
        }
export type GetProductGroupPageQueryHookResult = ReturnType<typeof useGetProductGroupPageQuery>;
export type GetProductGroupPageLazyQueryHookResult = ReturnType<typeof useGetProductGroupPageLazyQuery>;
export type GetProductGroupPageQueryResult = Apollo.QueryResult<GetProductGroupPageQuery, GetProductGroupPageQueryVariables>;
export const GetProductGroupPageDetailDocument = gql`
    query GetProductGroupPageDetail($pagination: PaginationInput!, $locationId: String, $getByProductsCount: Boolean, $includeVirtual: Boolean) {
  productGroupPage(
    pagination: $pagination
    locationId: $locationId
    getByProductsCount: $getByProductsCount
    includeVirtual: $includeVirtual
  ) {
    items {
      id
      name
      description
      imgUrl
      createdDate
      products {
        id
        name
        cost
        stock
        imgUrl
        description
        taxRates {
          organizationTaxRate {
            name
          }
          taxRate
        }
        isTaxable
        isPostTax
        productGroup {
          id
        }
        metricValues {
          id
        }
        isActive
      }
      metrics {
        id
        name
        values {
          id
          name
        }
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetProductGroupPageDetailQuery__
 *
 * To run a query within a React component, call `useGetProductGroupPageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductGroupPageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductGroupPageDetailQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      locationId: // value for 'locationId'
 *      getByProductsCount: // value for 'getByProductsCount'
 *      includeVirtual: // value for 'includeVirtual'
 *   },
 * });
 */
export function useGetProductGroupPageDetailQuery(baseOptions: Apollo.QueryHookOptions<GetProductGroupPageDetailQuery, GetProductGroupPageDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductGroupPageDetailQuery, GetProductGroupPageDetailQueryVariables>(GetProductGroupPageDetailDocument, options);
      }
export function useGetProductGroupPageDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductGroupPageDetailQuery, GetProductGroupPageDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductGroupPageDetailQuery, GetProductGroupPageDetailQueryVariables>(GetProductGroupPageDetailDocument, options);
        }
export type GetProductGroupPageDetailQueryHookResult = ReturnType<typeof useGetProductGroupPageDetailQuery>;
export type GetProductGroupPageDetailLazyQueryHookResult = ReturnType<typeof useGetProductGroupPageDetailLazyQuery>;
export type GetProductGroupPageDetailQueryResult = Apollo.QueryResult<GetProductGroupPageDetailQuery, GetProductGroupPageDetailQueryVariables>;
export const GetRecurringChargeOneDocument = gql`
    query GetRecurringChargeOne($recurringChargeOneId: String!) {
  recurringChargeOne(id: $recurringChargeOneId) {
    id
    cost
    name
    isTaxable
    isPostTax
    taxRates {
      id
      organizationTaxRate {
        name
      }
    }
    categoryOption {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRecurringChargeOneQuery__
 *
 * To run a query within a React component, call `useGetRecurringChargeOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurringChargeOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurringChargeOneQuery({
 *   variables: {
 *      recurringChargeOneId: // value for 'recurringChargeOneId'
 *   },
 * });
 */
export function useGetRecurringChargeOneQuery(baseOptions: Apollo.QueryHookOptions<GetRecurringChargeOneQuery, GetRecurringChargeOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurringChargeOneQuery, GetRecurringChargeOneQueryVariables>(GetRecurringChargeOneDocument, options);
      }
export function useGetRecurringChargeOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurringChargeOneQuery, GetRecurringChargeOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurringChargeOneQuery, GetRecurringChargeOneQueryVariables>(GetRecurringChargeOneDocument, options);
        }
export type GetRecurringChargeOneQueryHookResult = ReturnType<typeof useGetRecurringChargeOneQuery>;
export type GetRecurringChargeOneLazyQueryHookResult = ReturnType<typeof useGetRecurringChargeOneLazyQuery>;
export type GetRecurringChargeOneQueryResult = Apollo.QueryResult<GetRecurringChargeOneQuery, GetRecurringChargeOneQueryVariables>;
export const PaymentRecordSampleCsvDocument = gql`
    query paymentRecordSampleCSV {
  paymentRecordSampleCSV
}
    `;

/**
 * __usePaymentRecordSampleCsvQuery__
 *
 * To run a query within a React component, call `usePaymentRecordSampleCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentRecordSampleCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentRecordSampleCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentRecordSampleCsvQuery(baseOptions?: Apollo.QueryHookOptions<PaymentRecordSampleCsvQuery, PaymentRecordSampleCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentRecordSampleCsvQuery, PaymentRecordSampleCsvQueryVariables>(PaymentRecordSampleCsvDocument, options);
      }
export function usePaymentRecordSampleCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentRecordSampleCsvQuery, PaymentRecordSampleCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentRecordSampleCsvQuery, PaymentRecordSampleCsvQueryVariables>(PaymentRecordSampleCsvDocument, options);
        }
export type PaymentRecordSampleCsvQueryHookResult = ReturnType<typeof usePaymentRecordSampleCsvQuery>;
export type PaymentRecordSampleCsvLazyQueryHookResult = ReturnType<typeof usePaymentRecordSampleCsvLazyQuery>;
export type PaymentRecordSampleCsvQueryResult = Apollo.QueryResult<PaymentRecordSampleCsvQuery, PaymentRecordSampleCsvQueryVariables>;
export const RoomManyDocument = gql`
    query RoomMany($locationId: String!) {
  roomMany(locationId: $locationId) {
    id
    name
    services {
      id
      imgUrl
      organizationService {
        id
        name
      }
    }
    totalCapacity
    description
  }
}
    `;

/**
 * __useRoomManyQuery__
 *
 * To run a query within a React component, call `useRoomManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomManyQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useRoomManyQuery(baseOptions: Apollo.QueryHookOptions<RoomManyQuery, RoomManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomManyQuery, RoomManyQueryVariables>(RoomManyDocument, options);
      }
export function useRoomManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomManyQuery, RoomManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomManyQuery, RoomManyQueryVariables>(RoomManyDocument, options);
        }
export type RoomManyQueryHookResult = ReturnType<typeof useRoomManyQuery>;
export type RoomManyLazyQueryHookResult = ReturnType<typeof useRoomManyLazyQuery>;
export type RoomManyQueryResult = Apollo.QueryResult<RoomManyQuery, RoomManyQueryVariables>;
export const RoomPageDocument = gql`
    query RoomPage($pagination: PaginationInput!, $activeLocationId: String) {
  roomPage(pagination: $pagination, activeLocationId: $activeLocationId) {
    items {
      createdDate
      id
      name
      description
      totalCapacity
      isActive
      location {
        id
        logoUrl
        name
      }
      services {
        id
        organizationService {
          name
        }
      }
    }
    totalRows
  }
}
    `;

/**
 * __useRoomPageQuery__
 *
 * To run a query within a React component, call `useRoomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      activeLocationId: // value for 'activeLocationId'
 *   },
 * });
 */
export function useRoomPageQuery(baseOptions: Apollo.QueryHookOptions<RoomPageQuery, RoomPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomPageQuery, RoomPageQueryVariables>(RoomPageDocument, options);
      }
export function useRoomPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomPageQuery, RoomPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomPageQuery, RoomPageQueryVariables>(RoomPageDocument, options);
        }
export type RoomPageQueryHookResult = ReturnType<typeof useRoomPageQuery>;
export type RoomPageLazyQueryHookResult = ReturnType<typeof useRoomPageLazyQuery>;
export type RoomPageQueryResult = Apollo.QueryResult<RoomPageQuery, RoomPageQueryVariables>;
export const GetRoomNamesDocument = gql`
    query GetRoomNames($locationId: String!) {
  roomMany(locationId: $locationId) {
    id
    name
  }
}
    `;

/**
 * __useGetRoomNamesQuery__
 *
 * To run a query within a React component, call `useGetRoomNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomNamesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetRoomNamesQuery(baseOptions: Apollo.QueryHookOptions<GetRoomNamesQuery, GetRoomNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomNamesQuery, GetRoomNamesQueryVariables>(GetRoomNamesDocument, options);
      }
export function useGetRoomNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomNamesQuery, GetRoomNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomNamesQuery, GetRoomNamesQueryVariables>(GetRoomNamesDocument, options);
        }
export type GetRoomNamesQueryHookResult = ReturnType<typeof useGetRoomNamesQuery>;
export type GetRoomNamesLazyQueryHookResult = ReturnType<typeof useGetRoomNamesLazyQuery>;
export type GetRoomNamesQueryResult = Apollo.QueryResult<GetRoomNamesQuery, GetRoomNamesQueryVariables>;
export const ScheduledChargesOneDocument = gql`
    query scheduledChargesOne($id: String!) {
  scheduledChargesOne(id: $id) {
    id
    subscription {
      id
    }
    cost
    isTaxable
    isPostTax
    taxRates {
      id
      organizationTaxRate {
        id
        name
      }
    }
    revenueCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useScheduledChargesOneQuery__
 *
 * To run a query within a React component, call `useScheduledChargesOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledChargesOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledChargesOneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduledChargesOneQuery(baseOptions: Apollo.QueryHookOptions<ScheduledChargesOneQuery, ScheduledChargesOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledChargesOneQuery, ScheduledChargesOneQueryVariables>(ScheduledChargesOneDocument, options);
      }
export function useScheduledChargesOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledChargesOneQuery, ScheduledChargesOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledChargesOneQuery, ScheduledChargesOneQueryVariables>(ScheduledChargesOneDocument, options);
        }
export type ScheduledChargesOneQueryHookResult = ReturnType<typeof useScheduledChargesOneQuery>;
export type ScheduledChargesOneLazyQueryHookResult = ReturnType<typeof useScheduledChargesOneLazyQuery>;
export type ScheduledChargesOneQueryResult = Apollo.QueryResult<ScheduledChargesOneQuery, ScheduledChargesOneQueryVariables>;
export const ScheduledChargesByTransactionIdDocument = gql`
    query scheduledChargesByTransactionId($id: String!) {
  scheduledChargesByTransactionId(id: $id) {
    id
    name
    cost
    isTaxable
    isPostTax
    taxRates {
      id
      organizationTaxRate {
        id
        name
      }
    }
    revenueCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useScheduledChargesByTransactionIdQuery__
 *
 * To run a query within a React component, call `useScheduledChargesByTransactionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledChargesByTransactionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledChargesByTransactionIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduledChargesByTransactionIdQuery(baseOptions: Apollo.QueryHookOptions<ScheduledChargesByTransactionIdQuery, ScheduledChargesByTransactionIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledChargesByTransactionIdQuery, ScheduledChargesByTransactionIdQueryVariables>(ScheduledChargesByTransactionIdDocument, options);
      }
export function useScheduledChargesByTransactionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledChargesByTransactionIdQuery, ScheduledChargesByTransactionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledChargesByTransactionIdQuery, ScheduledChargesByTransactionIdQueryVariables>(ScheduledChargesByTransactionIdDocument, options);
        }
export type ScheduledChargesByTransactionIdQueryHookResult = ReturnType<typeof useScheduledChargesByTransactionIdQuery>;
export type ScheduledChargesByTransactionIdLazyQueryHookResult = ReturnType<typeof useScheduledChargesByTransactionIdLazyQuery>;
export type ScheduledChargesByTransactionIdQueryResult = Apollo.QueryResult<ScheduledChargesByTransactionIdQuery, ScheduledChargesByTransactionIdQueryVariables>;
export const ScheduledTransactionsByClientIdDocument = gql`
    query scheduledTransactionsByClientId($clientId: String!) {
  scheduledTransactionsByClientId(clientId: $clientId) {
    id
    processAt
    location {
      id
      name
    }
    charges {
      id
      name
      cost
    }
    transaction {
      paymentMethod {
        mask
        merchant
        type
      }
    }
  }
}
    `;

/**
 * __useScheduledTransactionsByClientIdQuery__
 *
 * To run a query within a React component, call `useScheduledTransactionsByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledTransactionsByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledTransactionsByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useScheduledTransactionsByClientIdQuery(baseOptions: Apollo.QueryHookOptions<ScheduledTransactionsByClientIdQuery, ScheduledTransactionsByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledTransactionsByClientIdQuery, ScheduledTransactionsByClientIdQueryVariables>(ScheduledTransactionsByClientIdDocument, options);
      }
export function useScheduledTransactionsByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledTransactionsByClientIdQuery, ScheduledTransactionsByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledTransactionsByClientIdQuery, ScheduledTransactionsByClientIdQueryVariables>(ScheduledTransactionsByClientIdDocument, options);
        }
export type ScheduledTransactionsByClientIdQueryHookResult = ReturnType<typeof useScheduledTransactionsByClientIdQuery>;
export type ScheduledTransactionsByClientIdLazyQueryHookResult = ReturnType<typeof useScheduledTransactionsByClientIdLazyQuery>;
export type ScheduledTransactionsByClientIdQueryResult = Apollo.QueryResult<ScheduledTransactionsByClientIdQuery, ScheduledTransactionsByClientIdQueryVariables>;
export const GetSendgridTemplateDocument = gql`
    query GetSendgridTemplate($id: String!) {
  sendgridTemplateOne(id: $id) {
    id
    name
    type
    description
    isActive
    trigger_
    fromEmail
    fromName
    subjectLine
    location {
      id
      name
    }
    organization {
      id
      name
    }
    dynamicFields {
      id
      field
      keyword
      entity
      type
      isDefault
    }
  }
}
    `;

/**
 * __useGetSendgridTemplateQuery__
 *
 * To run a query within a React component, call `useGetSendgridTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendgridTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendgridTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSendgridTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetSendgridTemplateQuery, GetSendgridTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSendgridTemplateQuery, GetSendgridTemplateQueryVariables>(GetSendgridTemplateDocument, options);
      }
export function useGetSendgridTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSendgridTemplateQuery, GetSendgridTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSendgridTemplateQuery, GetSendgridTemplateQueryVariables>(GetSendgridTemplateDocument, options);
        }
export type GetSendgridTemplateQueryHookResult = ReturnType<typeof useGetSendgridTemplateQuery>;
export type GetSendgridTemplateLazyQueryHookResult = ReturnType<typeof useGetSendgridTemplateLazyQuery>;
export type GetSendgridTemplateQueryResult = Apollo.QueryResult<GetSendgridTemplateQuery, GetSendgridTemplateQueryVariables>;
export const GetSendgridTemplateManyDocument = gql`
    query GetSendgridTemplateMany($id: String!, $includeAll: Boolean) {
  sendgridTemplateMany(locationId: $id, includeAll: $includeAll) {
    id
    name
    type
    isActive
    trigger_
  }
}
    `;

/**
 * __useGetSendgridTemplateManyQuery__
 *
 * To run a query within a React component, call `useGetSendgridTemplateManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendgridTemplateManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendgridTemplateManyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeAll: // value for 'includeAll'
 *   },
 * });
 */
export function useGetSendgridTemplateManyQuery(baseOptions: Apollo.QueryHookOptions<GetSendgridTemplateManyQuery, GetSendgridTemplateManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSendgridTemplateManyQuery, GetSendgridTemplateManyQueryVariables>(GetSendgridTemplateManyDocument, options);
      }
export function useGetSendgridTemplateManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSendgridTemplateManyQuery, GetSendgridTemplateManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSendgridTemplateManyQuery, GetSendgridTemplateManyQueryVariables>(GetSendgridTemplateManyDocument, options);
        }
export type GetSendgridTemplateManyQueryHookResult = ReturnType<typeof useGetSendgridTemplateManyQuery>;
export type GetSendgridTemplateManyLazyQueryHookResult = ReturnType<typeof useGetSendgridTemplateManyLazyQuery>;
export type GetSendgridTemplateManyQueryResult = Apollo.QueryResult<GetSendgridTemplateManyQuery, GetSendgridTemplateManyQueryVariables>;
export const GetSendgridDynamicFieldManyDocument = gql`
    query GetSendgridDynamicFieldMany {
  sendgridDynamicFieldMany {
    keyword
    triggers
  }
}
    `;

/**
 * __useGetSendgridDynamicFieldManyQuery__
 *
 * To run a query within a React component, call `useGetSendgridDynamicFieldManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendgridDynamicFieldManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendgridDynamicFieldManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSendgridDynamicFieldManyQuery(baseOptions?: Apollo.QueryHookOptions<GetSendgridDynamicFieldManyQuery, GetSendgridDynamicFieldManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSendgridDynamicFieldManyQuery, GetSendgridDynamicFieldManyQueryVariables>(GetSendgridDynamicFieldManyDocument, options);
      }
export function useGetSendgridDynamicFieldManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSendgridDynamicFieldManyQuery, GetSendgridDynamicFieldManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSendgridDynamicFieldManyQuery, GetSendgridDynamicFieldManyQueryVariables>(GetSendgridDynamicFieldManyDocument, options);
        }
export type GetSendgridDynamicFieldManyQueryHookResult = ReturnType<typeof useGetSendgridDynamicFieldManyQuery>;
export type GetSendgridDynamicFieldManyLazyQueryHookResult = ReturnType<typeof useGetSendgridDynamicFieldManyLazyQuery>;
export type GetSendgridDynamicFieldManyQueryResult = Apollo.QueryResult<GetSendgridDynamicFieldManyQuery, GetSendgridDynamicFieldManyQueryVariables>;
export const GetOrganizationServiceDocument = gql`
    query GetOrganizationService($id: String!) {
  organizationServiceOne(id: $id) {
    description
    duration
    isIndivdual
    isSelfEnroll
    isWaitlistEnabled
    name
    waitlistMax
    imgUrl
    serviceType {
      id
      name
    }
    policies {
      id
      name
    }
    revenueCategory {
      id
      name
    }
    locationServices {
      id
      cost
      isPrepay
      isActive
      description
      imgUrl
      location {
        id
        name
      }
      rooms {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationServiceQuery__
 *
 * To run a query within a React component, call `useGetOrganizationServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationServiceQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationServiceQuery, GetOrganizationServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationServiceQuery, GetOrganizationServiceQueryVariables>(GetOrganizationServiceDocument, options);
      }
export function useGetOrganizationServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationServiceQuery, GetOrganizationServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationServiceQuery, GetOrganizationServiceQueryVariables>(GetOrganizationServiceDocument, options);
        }
export type GetOrganizationServiceQueryHookResult = ReturnType<typeof useGetOrganizationServiceQuery>;
export type GetOrganizationServiceLazyQueryHookResult = ReturnType<typeof useGetOrganizationServiceLazyQuery>;
export type GetOrganizationServiceQueryResult = Apollo.QueryResult<GetOrganizationServiceQuery, GetOrganizationServiceQueryVariables>;
export const GetOrganizationServicesDocument = gql`
    query GetOrganizationServices($orgId: String!) {
  organizationServiceMany(orgId: $orgId) {
    id
    name
  }
}
    `;

/**
 * __useGetOrganizationServicesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationServicesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrganizationServicesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>(GetOrganizationServicesDocument, options);
      }
export function useGetOrganizationServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>(GetOrganizationServicesDocument, options);
        }
export type GetOrganizationServicesQueryHookResult = ReturnType<typeof useGetOrganizationServicesQuery>;
export type GetOrganizationServicesLazyQueryHookResult = ReturnType<typeof useGetOrganizationServicesLazyQuery>;
export type GetOrganizationServicesQueryResult = Apollo.QueryResult<GetOrganizationServicesQuery, GetOrganizationServicesQueryVariables>;
export const GetOrganizationServicePageDocument = gql`
    query GetOrganizationServicePage($pagination: PaginationInput!) {
  organizationServicePage(pagination: $pagination) {
    items {
      id
      name
      createdDate
      duration
      imgUrl
      serviceType {
        name
      }
      revenueCategory {
        name
      }
      locationServices {
        id
        location {
          id
        }
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetOrganizationServicePageQuery__
 *
 * To run a query within a React component, call `useGetOrganizationServicePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationServicePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationServicePageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetOrganizationServicePageQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationServicePageQuery, GetOrganizationServicePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationServicePageQuery, GetOrganizationServicePageQueryVariables>(GetOrganizationServicePageDocument, options);
      }
export function useGetOrganizationServicePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationServicePageQuery, GetOrganizationServicePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationServicePageQuery, GetOrganizationServicePageQueryVariables>(GetOrganizationServicePageDocument, options);
        }
export type GetOrganizationServicePageQueryHookResult = ReturnType<typeof useGetOrganizationServicePageQuery>;
export type GetOrganizationServicePageLazyQueryHookResult = ReturnType<typeof useGetOrganizationServicePageLazyQuery>;
export type GetOrganizationServicePageQueryResult = Apollo.QueryResult<GetOrganizationServicePageQuery, GetOrganizationServicePageQueryVariables>;
export const GetLocationServicesDocument = gql`
    query GetLocationServices($locationId: String!) {
  locationServiceMany(locationId: $locationId) {
    id
    rooms {
      id
      name
      totalCapacity
    }
    organizationService {
      imgUrl
      waitlistMax
      duration
      description
      name
      isWaitlistEnabled
      isSelfEnroll
    }
  }
}
    `;

/**
 * __useGetLocationServicesQuery__
 *
 * To run a query within a React component, call `useGetLocationServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationServicesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationServicesQuery(baseOptions: Apollo.QueryHookOptions<GetLocationServicesQuery, GetLocationServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationServicesQuery, GetLocationServicesQueryVariables>(GetLocationServicesDocument, options);
      }
export function useGetLocationServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationServicesQuery, GetLocationServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationServicesQuery, GetLocationServicesQueryVariables>(GetLocationServicesDocument, options);
        }
export type GetLocationServicesQueryHookResult = ReturnType<typeof useGetLocationServicesQuery>;
export type GetLocationServicesLazyQueryHookResult = ReturnType<typeof useGetLocationServicesLazyQuery>;
export type GetLocationServicesQueryResult = Apollo.QueryResult<GetLocationServicesQuery, GetLocationServicesQueryVariables>;
export const GetLocationServiceDocument = gql`
    query GetLocationService($id: String!) {
  locationServiceOne(id: $id) {
    id
    rooms {
      id
      name
      totalCapacity
    }
    location {
      id
      name
      employees {
        id
        user {
          firstName
          lastName
        }
      }
      meetings {
        id
        startAt
        endAt
        duration
        room {
          id
        }
        instructor {
          id
        }
        location {
          id
        }
      }
    }
    organizationService {
      imgUrl
      waitlistMax
      duration
      description
      name
      isWaitlistEnabled
      isSelfEnroll
    }
  }
}
    `;

/**
 * __useGetLocationServiceQuery__
 *
 * To run a query within a React component, call `useGetLocationServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationServiceQuery(baseOptions: Apollo.QueryHookOptions<GetLocationServiceQuery, GetLocationServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationServiceQuery, GetLocationServiceQueryVariables>(GetLocationServiceDocument, options);
      }
export function useGetLocationServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationServiceQuery, GetLocationServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationServiceQuery, GetLocationServiceQueryVariables>(GetLocationServiceDocument, options);
        }
export type GetLocationServiceQueryHookResult = ReturnType<typeof useGetLocationServiceQuery>;
export type GetLocationServiceLazyQueryHookResult = ReturnType<typeof useGetLocationServiceLazyQuery>;
export type GetLocationServiceQueryResult = Apollo.QueryResult<GetLocationServiceQuery, GetLocationServiceQueryVariables>;
export const GetLocationServicesNameDocument = gql`
    query GetLocationServicesName($locationId: String!) {
  locationServiceMany(locationId: $locationId) {
    id
    organizationService {
      name
    }
  }
}
    `;

/**
 * __useGetLocationServicesNameQuery__
 *
 * To run a query within a React component, call `useGetLocationServicesNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationServicesNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationServicesNameQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationServicesNameQuery(baseOptions: Apollo.QueryHookOptions<GetLocationServicesNameQuery, GetLocationServicesNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationServicesNameQuery, GetLocationServicesNameQueryVariables>(GetLocationServicesNameDocument, options);
      }
export function useGetLocationServicesNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationServicesNameQuery, GetLocationServicesNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationServicesNameQuery, GetLocationServicesNameQueryVariables>(GetLocationServicesNameDocument, options);
        }
export type GetLocationServicesNameQueryHookResult = ReturnType<typeof useGetLocationServicesNameQuery>;
export type GetLocationServicesNameLazyQueryHookResult = ReturnType<typeof useGetLocationServicesNameLazyQuery>;
export type GetLocationServicesNameQueryResult = Apollo.QueryResult<GetLocationServicesNameQuery, GetLocationServicesNameQueryVariables>;
export const GetLocationServicesNameGroupDocument = gql`
    query GetLocationServicesNameGroup($locationId: String!) {
  locationServiceMany(locationId: $locationId) {
    id
    organizationService {
      name
      isIndivdual
    }
  }
}
    `;

/**
 * __useGetLocationServicesNameGroupQuery__
 *
 * To run a query within a React component, call `useGetLocationServicesNameGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationServicesNameGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationServicesNameGroupQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationServicesNameGroupQuery(baseOptions: Apollo.QueryHookOptions<GetLocationServicesNameGroupQuery, GetLocationServicesNameGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationServicesNameGroupQuery, GetLocationServicesNameGroupQueryVariables>(GetLocationServicesNameGroupDocument, options);
      }
export function useGetLocationServicesNameGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationServicesNameGroupQuery, GetLocationServicesNameGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationServicesNameGroupQuery, GetLocationServicesNameGroupQueryVariables>(GetLocationServicesNameGroupDocument, options);
        }
export type GetLocationServicesNameGroupQueryHookResult = ReturnType<typeof useGetLocationServicesNameGroupQuery>;
export type GetLocationServicesNameGroupLazyQueryHookResult = ReturnType<typeof useGetLocationServicesNameGroupLazyQuery>;
export type GetLocationServicesNameGroupQueryResult = Apollo.QueryResult<GetLocationServicesNameGroupQuery, GetLocationServicesNameGroupQueryVariables>;
export const GetLocationServiceDetailDocument = gql`
    query GetLocationServiceDetail($id: String!) {
  locationServiceOne(id: $id) {
    id
    imgUrl
    description
    isPrepay
    isActive
    cost
    rooms {
      id
      name
    }
    organizationService {
      id
      duration
      name
      isSelfEnroll
      waitlistMax
      revenueCategory {
        id
        name
      }
      serviceType {
        id
        name
      }
      policies {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetLocationServiceDetailQuery__
 *
 * To run a query within a React component, call `useGetLocationServiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationServiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationServiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationServiceDetailQuery(baseOptions: Apollo.QueryHookOptions<GetLocationServiceDetailQuery, GetLocationServiceDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationServiceDetailQuery, GetLocationServiceDetailQueryVariables>(GetLocationServiceDetailDocument, options);
      }
export function useGetLocationServiceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationServiceDetailQuery, GetLocationServiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationServiceDetailQuery, GetLocationServiceDetailQueryVariables>(GetLocationServiceDetailDocument, options);
        }
export type GetLocationServiceDetailQueryHookResult = ReturnType<typeof useGetLocationServiceDetailQuery>;
export type GetLocationServiceDetailLazyQueryHookResult = ReturnType<typeof useGetLocationServiceDetailLazyQuery>;
export type GetLocationServiceDetailQueryResult = Apollo.QueryResult<GetLocationServiceDetailQuery, GetLocationServiceDetailQueryVariables>;
export const GetServiceAllotmentDocument = gql`
    query GetServiceAllotment($serviceAllotmentOneId: String!) {
  serviceAllotmentOne(id: $serviceAllotmentOneId) {
    credits
    dailyLimit
    description
    serviceFrequency
    expiration {
      id
      isExpired
      expiresAt
      expirationMode
      unit
      value
    }
    id
    locations {
      id
      name
    }
    name
    services {
      id
      name
    }
    privateSessions {
      id
      duration
    }
    startAt
    startMode
  }
}
    `;

/**
 * __useGetServiceAllotmentQuery__
 *
 * To run a query within a React component, call `useGetServiceAllotmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceAllotmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceAllotmentQuery({
 *   variables: {
 *      serviceAllotmentOneId: // value for 'serviceAllotmentOneId'
 *   },
 * });
 */
export function useGetServiceAllotmentQuery(baseOptions: Apollo.QueryHookOptions<GetServiceAllotmentQuery, GetServiceAllotmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceAllotmentQuery, GetServiceAllotmentQueryVariables>(GetServiceAllotmentDocument, options);
      }
export function useGetServiceAllotmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceAllotmentQuery, GetServiceAllotmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceAllotmentQuery, GetServiceAllotmentQueryVariables>(GetServiceAllotmentDocument, options);
        }
export type GetServiceAllotmentQueryHookResult = ReturnType<typeof useGetServiceAllotmentQuery>;
export type GetServiceAllotmentLazyQueryHookResult = ReturnType<typeof useGetServiceAllotmentLazyQuery>;
export type GetServiceAllotmentQueryResult = Apollo.QueryResult<GetServiceAllotmentQuery, GetServiceAllotmentQueryVariables>;
export const ServiceAllotmentManyDocument = gql`
    query ServiceAllotmentMany {
  serviceAllotmentMany {
    agreement {
      id
      name
    }
    createdDate
    credits
    dailyLimit
    description
    expiration {
      id
      isExpired
      expiresAt
      expirationMode
      unit
      value
    }
    id
    locations {
      id
      name
    }
    name
    package {
      id
      name
    }
    services {
      id
      name
    }
    startAt
    version
    viid
    startMode
  }
}
    `;

/**
 * __useServiceAllotmentManyQuery__
 *
 * To run a query within a React component, call `useServiceAllotmentManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAllotmentManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAllotmentManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceAllotmentManyQuery(baseOptions?: Apollo.QueryHookOptions<ServiceAllotmentManyQuery, ServiceAllotmentManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceAllotmentManyQuery, ServiceAllotmentManyQueryVariables>(ServiceAllotmentManyDocument, options);
      }
export function useServiceAllotmentManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceAllotmentManyQuery, ServiceAllotmentManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceAllotmentManyQuery, ServiceAllotmentManyQueryVariables>(ServiceAllotmentManyDocument, options);
        }
export type ServiceAllotmentManyQueryHookResult = ReturnType<typeof useServiceAllotmentManyQuery>;
export type ServiceAllotmentManyLazyQueryHookResult = ReturnType<typeof useServiceAllotmentManyLazyQuery>;
export type ServiceAllotmentManyQueryResult = Apollo.QueryResult<ServiceAllotmentManyQuery, ServiceAllotmentManyQueryVariables>;
export const GetShoppingCartDocument = gql`
    query GetShoppingCart($id: String!) {
  shoppingCartOne(id: $id) {
    id
    subtotal
    discount
    tax
    total
    discounts
    taxes
    products
    lineItems {
      id
      count
      subtotal
      discount
      discounts
      product {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetShoppingCartQuery__
 *
 * To run a query within a React component, call `useGetShoppingCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShoppingCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShoppingCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShoppingCartQuery(baseOptions: Apollo.QueryHookOptions<GetShoppingCartQuery, GetShoppingCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShoppingCartQuery, GetShoppingCartQueryVariables>(GetShoppingCartDocument, options);
      }
export function useGetShoppingCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShoppingCartQuery, GetShoppingCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShoppingCartQuery, GetShoppingCartQueryVariables>(GetShoppingCartDocument, options);
        }
export type GetShoppingCartQueryHookResult = ReturnType<typeof useGetShoppingCartQuery>;
export type GetShoppingCartLazyQueryHookResult = ReturnType<typeof useGetShoppingCartLazyQuery>;
export type GetShoppingCartQueryResult = Apollo.QueryResult<GetShoppingCartQuery, GetShoppingCartQueryVariables>;
export const GetSignedAgreementsDocument = gql`
    query GetSignedAgreements($clientId: String!) {
  signedAgreementMany(clientId: $clientId) {
    id
    termStart
    termEnd
    status
    agreement {
      id
      name
      isOrg
      isAutoRenew
      description
      isMembership
      termValue
      Unit
      postponeUntil
      paymentFrequency
      draftMode
      additionalPolicies {
        name
      }
      initialCharges {
        id
        cost
      }
      recurringCharges {
        id
        name
        cost
        categoryOption {
          name
        }
      }
    }
    subscription {
      id
      subscriptionStatus
      nextDraftDate
      paymentStatus
      paymentFrequency
      recurringCharges {
        id
        name
        cost
        categoryOption {
          id
          name
        }
      }
      scheduledTransaction {
        id
        processAt
        location {
          id
          name
        }
        charges {
          id
          name
          cost
        }
      }
    }
    location {
      id
      name
    }
    paymentMethod {
      id
      mask
      expiresAt
      merchant
      type
    }
  }
}
    `;

/**
 * __useGetSignedAgreementsQuery__
 *
 * To run a query within a React component, call `useGetSignedAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedAgreementsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetSignedAgreementsQuery(baseOptions: Apollo.QueryHookOptions<GetSignedAgreementsQuery, GetSignedAgreementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedAgreementsQuery, GetSignedAgreementsQueryVariables>(GetSignedAgreementsDocument, options);
      }
export function useGetSignedAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedAgreementsQuery, GetSignedAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedAgreementsQuery, GetSignedAgreementsQueryVariables>(GetSignedAgreementsDocument, options);
        }
export type GetSignedAgreementsQueryHookResult = ReturnType<typeof useGetSignedAgreementsQuery>;
export type GetSignedAgreementsLazyQueryHookResult = ReturnType<typeof useGetSignedAgreementsLazyQuery>;
export type GetSignedAgreementsQueryResult = Apollo.QueryResult<GetSignedAgreementsQuery, GetSignedAgreementsQueryVariables>;
export const GetSignedAgreementDocument = gql`
    query GetSignedAgreement($id: String!) {
  signedAgreementOne(id: $id) {
    id
    termStart
    termEnd
    status
    agreement {
      id
      name
      isAutoRenew
      description
      isMembership
      termValue
      Unit
      postponeUntil
      paymentFrequency
      draftMode
      additionalPolicies {
        name
      }
      initialCharges {
        id
        cost
      }
    }
    subscription {
      id
      subscriptionStatus
      nextDraftDate
      paymentStatus
      paymentFrequency
      recurringCharges {
        id
        name
        cost
        categoryOption {
          id
          name
        }
      }
    }
    paymentMethod {
      id
      mask
      expiresAt
      merchant
      type
    }
  }
}
    `;

/**
 * __useGetSignedAgreementQuery__
 *
 * To run a query within a React component, call `useGetSignedAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedAgreementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSignedAgreementQuery(baseOptions: Apollo.QueryHookOptions<GetSignedAgreementQuery, GetSignedAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedAgreementQuery, GetSignedAgreementQueryVariables>(GetSignedAgreementDocument, options);
      }
export function useGetSignedAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedAgreementQuery, GetSignedAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedAgreementQuery, GetSignedAgreementQueryVariables>(GetSignedAgreementDocument, options);
        }
export type GetSignedAgreementQueryHookResult = ReturnType<typeof useGetSignedAgreementQuery>;
export type GetSignedAgreementLazyQueryHookResult = ReturnType<typeof useGetSignedAgreementLazyQuery>;
export type GetSignedAgreementQueryResult = Apollo.QueryResult<GetSignedAgreementQuery, GetSignedAgreementQueryVariables>;
export const GetSignedAgreementCheckoutDocument = gql`
    query GetSignedAgreementCheckout($id: String!) {
  signedAgreementOne(id: $id) {
    id
    agreement {
      id
      name
      initialCharges {
        id
        cost
      }
      recurringCharges {
        id
        cost
      }
    }
  }
}
    `;

/**
 * __useGetSignedAgreementCheckoutQuery__
 *
 * To run a query within a React component, call `useGetSignedAgreementCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedAgreementCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedAgreementCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSignedAgreementCheckoutQuery(baseOptions: Apollo.QueryHookOptions<GetSignedAgreementCheckoutQuery, GetSignedAgreementCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedAgreementCheckoutQuery, GetSignedAgreementCheckoutQueryVariables>(GetSignedAgreementCheckoutDocument, options);
      }
export function useGetSignedAgreementCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedAgreementCheckoutQuery, GetSignedAgreementCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedAgreementCheckoutQuery, GetSignedAgreementCheckoutQueryVariables>(GetSignedAgreementCheckoutDocument, options);
        }
export type GetSignedAgreementCheckoutQueryHookResult = ReturnType<typeof useGetSignedAgreementCheckoutQuery>;
export type GetSignedAgreementCheckoutLazyQueryHookResult = ReturnType<typeof useGetSignedAgreementCheckoutLazyQuery>;
export type GetSignedAgreementCheckoutQueryResult = Apollo.QueryResult<GetSignedAgreementCheckoutQuery, GetSignedAgreementCheckoutQueryVariables>;
export const CheckForSignedAgreementDocument = gql`
    query checkForSignedAgreement($clientId: String!, $locationId: String!, $agreementId: String!) {
  checkForSignedAgreement(
    clientId: $clientId
    locationId: $locationId
    agreementId: $agreementId
  ) {
    id
  }
}
    `;

/**
 * __useCheckForSignedAgreementQuery__
 *
 * To run a query within a React component, call `useCheckForSignedAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForSignedAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForSignedAgreementQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      locationId: // value for 'locationId'
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useCheckForSignedAgreementQuery(baseOptions: Apollo.QueryHookOptions<CheckForSignedAgreementQuery, CheckForSignedAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckForSignedAgreementQuery, CheckForSignedAgreementQueryVariables>(CheckForSignedAgreementDocument, options);
      }
export function useCheckForSignedAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckForSignedAgreementQuery, CheckForSignedAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckForSignedAgreementQuery, CheckForSignedAgreementQueryVariables>(CheckForSignedAgreementDocument, options);
        }
export type CheckForSignedAgreementQueryHookResult = ReturnType<typeof useCheckForSignedAgreementQuery>;
export type CheckForSignedAgreementLazyQueryHookResult = ReturnType<typeof useCheckForSignedAgreementLazyQuery>;
export type CheckForSignedAgreementQueryResult = Apollo.QueryResult<CheckForSignedAgreementQuery, CheckForSignedAgreementQueryVariables>;
export const GetSignedAgreementDocumentsDocument = gql`
    query GetSignedAgreementDocuments($id: String!) {
  signedAgreementOne(id: $id) {
    id
    status
    signedDocGroup {
      id
    }
  }
}
    `;

/**
 * __useGetSignedAgreementDocumentsQuery__
 *
 * To run a query within a React component, call `useGetSignedAgreementDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedAgreementDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedAgreementDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSignedAgreementDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetSignedAgreementDocumentsQuery, GetSignedAgreementDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedAgreementDocumentsQuery, GetSignedAgreementDocumentsQueryVariables>(GetSignedAgreementDocumentsDocument, options);
      }
export function useGetSignedAgreementDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedAgreementDocumentsQuery, GetSignedAgreementDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedAgreementDocumentsQuery, GetSignedAgreementDocumentsQueryVariables>(GetSignedAgreementDocumentsDocument, options);
        }
export type GetSignedAgreementDocumentsQueryHookResult = ReturnType<typeof useGetSignedAgreementDocumentsQuery>;
export type GetSignedAgreementDocumentsLazyQueryHookResult = ReturnType<typeof useGetSignedAgreementDocumentsLazyQuery>;
export type GetSignedAgreementDocumentsQueryResult = Apollo.QueryResult<GetSignedAgreementDocumentsQuery, GetSignedAgreementDocumentsQueryVariables>;
export const GetSignedAgreementOnPaymentDocument = gql`
    query GetSignedAgreementOnPayment($clientId: String!, $locationId: String!, $agreementId: String!) {
  checkForSignedAgreement(
    clientId: $clientId
    locationId: $locationId
    agreementId: $agreementId
  ) {
    id
    agreement {
      id
      name
      isAutoRenew
      description
      isMembership
      termValue
      Unit
      postponeUntil
      paymentFrequency
      draftMode
      additionalPolicies {
        name
      }
      initialCharges {
        id
        cost
      }
      recurringCharges {
        id
        cost
      }
    }
  }
}
    `;

/**
 * __useGetSignedAgreementOnPaymentQuery__
 *
 * To run a query within a React component, call `useGetSignedAgreementOnPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedAgreementOnPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedAgreementOnPaymentQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      locationId: // value for 'locationId'
 *      agreementId: // value for 'agreementId'
 *   },
 * });
 */
export function useGetSignedAgreementOnPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetSignedAgreementOnPaymentQuery, GetSignedAgreementOnPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedAgreementOnPaymentQuery, GetSignedAgreementOnPaymentQueryVariables>(GetSignedAgreementOnPaymentDocument, options);
      }
export function useGetSignedAgreementOnPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedAgreementOnPaymentQuery, GetSignedAgreementOnPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedAgreementOnPaymentQuery, GetSignedAgreementOnPaymentQueryVariables>(GetSignedAgreementOnPaymentDocument, options);
        }
export type GetSignedAgreementOnPaymentQueryHookResult = ReturnType<typeof useGetSignedAgreementOnPaymentQuery>;
export type GetSignedAgreementOnPaymentLazyQueryHookResult = ReturnType<typeof useGetSignedAgreementOnPaymentLazyQuery>;
export type GetSignedAgreementOnPaymentQueryResult = Apollo.QueryResult<GetSignedAgreementOnPaymentQuery, GetSignedAgreementOnPaymentQueryVariables>;
export const GetEmbeddedLinkDocument = gql`
    query getEmbeddedLink($signedAgreementId: String!) {
  getEmbeddedLink(signedAgreementId: $signedAgreementId)
}
    `;

/**
 * __useGetEmbeddedLinkQuery__
 *
 * To run a query within a React component, call `useGetEmbeddedLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmbeddedLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmbeddedLinkQuery({
 *   variables: {
 *      signedAgreementId: // value for 'signedAgreementId'
 *   },
 * });
 */
export function useGetEmbeddedLinkQuery(baseOptions: Apollo.QueryHookOptions<GetEmbeddedLinkQuery, GetEmbeddedLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmbeddedLinkQuery, GetEmbeddedLinkQueryVariables>(GetEmbeddedLinkDocument, options);
      }
export function useGetEmbeddedLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmbeddedLinkQuery, GetEmbeddedLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmbeddedLinkQuery, GetEmbeddedLinkQueryVariables>(GetEmbeddedLinkDocument, options);
        }
export type GetEmbeddedLinkQueryHookResult = ReturnType<typeof useGetEmbeddedLinkQuery>;
export type GetEmbeddedLinkLazyQueryHookResult = ReturnType<typeof useGetEmbeddedLinkLazyQuery>;
export type GetEmbeddedLinkQueryResult = Apollo.QueryResult<GetEmbeddedLinkQuery, GetEmbeddedLinkQueryVariables>;
export const GetAgreementReportDocument = gql`
    query GetAgreementReport($data: CustomReportInput!) {
  agreementReport(data: $data) {
    id
    client {
      memberStatus
      lastVisitDate
      user {
        firstName
        lastName
      }
    }
    location {
      name
    }
    agreement {
      version
      name
      paymentFrequency
      termValue
      isMembership
    }
    termEnd
    termStart
    isAutoRenew
  }
}
    `;

/**
 * __useGetAgreementReportQuery__
 *
 * To run a query within a React component, call `useGetAgreementReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementReportQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetAgreementReportQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementReportQuery, GetAgreementReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementReportQuery, GetAgreementReportQueryVariables>(GetAgreementReportDocument, options);
      }
export function useGetAgreementReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementReportQuery, GetAgreementReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementReportQuery, GetAgreementReportQueryVariables>(GetAgreementReportDocument, options);
        }
export type GetAgreementReportQueryHookResult = ReturnType<typeof useGetAgreementReportQuery>;
export type GetAgreementReportLazyQueryHookResult = ReturnType<typeof useGetAgreementReportLazyQuery>;
export type GetAgreementReportQueryResult = Apollo.QueryResult<GetAgreementReportQuery, GetAgreementReportQueryVariables>;
export const DownloadAgreementReportDocument = gql`
    query DownloadAgreementReport($data: CustomReportInput!) {
  downloadAgreementReport(data: $data)
}
    `;

/**
 * __useDownloadAgreementReportQuery__
 *
 * To run a query within a React component, call `useDownloadAgreementReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAgreementReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAgreementReportQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDownloadAgreementReportQuery(baseOptions: Apollo.QueryHookOptions<DownloadAgreementReportQuery, DownloadAgreementReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadAgreementReportQuery, DownloadAgreementReportQueryVariables>(DownloadAgreementReportDocument, options);
      }
export function useDownloadAgreementReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAgreementReportQuery, DownloadAgreementReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadAgreementReportQuery, DownloadAgreementReportQueryVariables>(DownloadAgreementReportDocument, options);
        }
export type DownloadAgreementReportQueryHookResult = ReturnType<typeof useDownloadAgreementReportQuery>;
export type DownloadAgreementReportLazyQueryHookResult = ReturnType<typeof useDownloadAgreementReportLazyQuery>;
export type DownloadAgreementReportQueryResult = Apollo.QueryResult<DownloadAgreementReportQuery, DownloadAgreementReportQueryVariables>;
export const SubscriptionSampleCsvDocument = gql`
    query subscriptionSampleCSV {
  subscriptionSampleCSV
}
    `;

/**
 * __useSubscriptionSampleCsvQuery__
 *
 * To run a query within a React component, call `useSubscriptionSampleCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionSampleCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionSampleCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionSampleCsvQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionSampleCsvQuery, SubscriptionSampleCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionSampleCsvQuery, SubscriptionSampleCsvQueryVariables>(SubscriptionSampleCsvDocument, options);
      }
export function useSubscriptionSampleCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionSampleCsvQuery, SubscriptionSampleCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionSampleCsvQuery, SubscriptionSampleCsvQueryVariables>(SubscriptionSampleCsvDocument, options);
        }
export type SubscriptionSampleCsvQueryHookResult = ReturnType<typeof useSubscriptionSampleCsvQuery>;
export type SubscriptionSampleCsvLazyQueryHookResult = ReturnType<typeof useSubscriptionSampleCsvLazyQuery>;
export type SubscriptionSampleCsvQueryResult = Apollo.QueryResult<SubscriptionSampleCsvQuery, SubscriptionSampleCsvQueryVariables>;
export const GetTransactionsManyDocument = gql`
    query GetTransactionsMany {
  transactionMany {
    id
    createdDate
    updatedDate
    externalId
    amount
    subtotal
    tax
    discount
    transactionStatus
    completedAt
    performedBy {
      id
      user {
        firstName
        lastName
      }
    }
    location {
      name
      state
      city
    }
  }
}
    `;

/**
 * __useGetTransactionsManyQuery__
 *
 * To run a query within a React component, call `useGetTransactionsManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionsManyQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionsManyQuery, GetTransactionsManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsManyQuery, GetTransactionsManyQueryVariables>(GetTransactionsManyDocument, options);
      }
export function useGetTransactionsManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsManyQuery, GetTransactionsManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsManyQuery, GetTransactionsManyQueryVariables>(GetTransactionsManyDocument, options);
        }
export type GetTransactionsManyQueryHookResult = ReturnType<typeof useGetTransactionsManyQuery>;
export type GetTransactionsManyLazyQueryHookResult = ReturnType<typeof useGetTransactionsManyLazyQuery>;
export type GetTransactionsManyQueryResult = Apollo.QueryResult<GetTransactionsManyQuery, GetTransactionsManyQueryVariables>;
export const GetTransactionByClientDocument = gql`
    query GetTransactionByClient($clientId: String!) {
  transactionByClient(clientId: $clientId) {
    id
    createdDate
    amount
    transactionStatus
    location {
      name
    }
    paymentMethod {
      mask
      type
      merchant
    }
    paymentTerminal {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTransactionByClientQuery__
 *
 * To run a query within a React component, call `useGetTransactionByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionByClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetTransactionByClientQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionByClientQuery, GetTransactionByClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionByClientQuery, GetTransactionByClientQueryVariables>(GetTransactionByClientDocument, options);
      }
export function useGetTransactionByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionByClientQuery, GetTransactionByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionByClientQuery, GetTransactionByClientQueryVariables>(GetTransactionByClientDocument, options);
        }
export type GetTransactionByClientQueryHookResult = ReturnType<typeof useGetTransactionByClientQuery>;
export type GetTransactionByClientLazyQueryHookResult = ReturnType<typeof useGetTransactionByClientLazyQuery>;
export type GetTransactionByClientQueryResult = Apollo.QueryResult<GetTransactionByClientQuery, GetTransactionByClientQueryVariables>;
export const GetTransactionRecordDocument = gql`
    query GetTransactionRecord($clientId: String!) {
  transactionByClient(clientId: $clientId) {
    id
    createdDate
    amount
    transactionStatus
    location {
      name
    }
    agreement {
      name
    }
    shoppingCart {
      products
    }
    package {
      name
    }
  }
}
    `;

/**
 * __useGetTransactionRecordQuery__
 *
 * To run a query within a React component, call `useGetTransactionRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionRecordQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetTransactionRecordQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionRecordQuery, GetTransactionRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionRecordQuery, GetTransactionRecordQueryVariables>(GetTransactionRecordDocument, options);
      }
export function useGetTransactionRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionRecordQuery, GetTransactionRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionRecordQuery, GetTransactionRecordQueryVariables>(GetTransactionRecordDocument, options);
        }
export type GetTransactionRecordQueryHookResult = ReturnType<typeof useGetTransactionRecordQuery>;
export type GetTransactionRecordLazyQueryHookResult = ReturnType<typeof useGetTransactionRecordLazyQuery>;
export type GetTransactionRecordQueryResult = Apollo.QueryResult<GetTransactionRecordQuery, GetTransactionRecordQueryVariables>;
export const GetTransactionPageClientGuestDocument = gql`
    query GetTransactionPageClientGuest($pagination: PaginationInput!) {
  transactionPage(pagination: $pagination) {
    items {
      id
      createdDate
      amount
      transactionStatus
      location {
        name
      }
      paymentMethod {
        mask
        type
        merchant
      }
      paymentTerminal {
        id
        name
      }
    }
    totalRows
  }
}
    `;

/**
 * __useGetTransactionPageClientGuestQuery__
 *
 * To run a query within a React component, call `useGetTransactionPageClientGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionPageClientGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionPageClientGuestQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTransactionPageClientGuestQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionPageClientGuestQuery, GetTransactionPageClientGuestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionPageClientGuestQuery, GetTransactionPageClientGuestQueryVariables>(GetTransactionPageClientGuestDocument, options);
      }
export function useGetTransactionPageClientGuestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionPageClientGuestQuery, GetTransactionPageClientGuestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionPageClientGuestQuery, GetTransactionPageClientGuestQueryVariables>(GetTransactionPageClientGuestDocument, options);
        }
export type GetTransactionPageClientGuestQueryHookResult = ReturnType<typeof useGetTransactionPageClientGuestQuery>;
export type GetTransactionPageClientGuestLazyQueryHookResult = ReturnType<typeof useGetTransactionPageClientGuestLazyQuery>;
export type GetTransactionPageClientGuestQueryResult = Apollo.QueryResult<GetTransactionPageClientGuestQuery, GetTransactionPageClientGuestQueryVariables>;
export const SubscribeToTransactionDocument = gql`
    subscription SubscribeToTransaction($id: String!) {
  resolveTransactionSubscription(id: $id) {
    transaction {
      id
      completedAt
      transactionStatus
    }
  }
}
    `;

/**
 * __useSubscribeToTransactionSubscription__
 *
 * To run a query within a React component, call `useSubscribeToTransactionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToTransactionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToTransactionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscribeToTransactionSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToTransactionSubscription, SubscribeToTransactionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToTransactionSubscription, SubscribeToTransactionSubscriptionVariables>(SubscribeToTransactionDocument, options);
      }
export type SubscribeToTransactionSubscriptionHookResult = ReturnType<typeof useSubscribeToTransactionSubscription>;
export type SubscribeToTransactionSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTransactionSubscription>;
export const GetPosReportDocument = gql`
    query GetPOSReport($data: CustomReportInput!) {
  posReport(data: $data) {
    id
    createdDate
    updatedDate
    externalId
    amount
    subtotal
    tax
    discount
    transactionStatus
    completedAt
    isRefund
    chargedTo {
      user {
        firstName
        lastName
      }
    }
    performedBy {
      user {
        firstName
        lastName
      }
    }
    paymentMethod {
      id
      name
      mask
      vendor
      type
    }
  }
}
    `;

/**
 * __useGetPosReportQuery__
 *
 * To run a query within a React component, call `useGetPosReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosReportQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPosReportQuery(baseOptions: Apollo.QueryHookOptions<GetPosReportQuery, GetPosReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosReportQuery, GetPosReportQueryVariables>(GetPosReportDocument, options);
      }
export function useGetPosReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosReportQuery, GetPosReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosReportQuery, GetPosReportQueryVariables>(GetPosReportDocument, options);
        }
export type GetPosReportQueryHookResult = ReturnType<typeof useGetPosReportQuery>;
export type GetPosReportLazyQueryHookResult = ReturnType<typeof useGetPosReportLazyQuery>;
export type GetPosReportQueryResult = Apollo.QueryResult<GetPosReportQuery, GetPosReportQueryVariables>;
export const DownloadPosReportDocument = gql`
    query DownloadPosReport($data: CustomReportInput!) {
  downloadPosReport(data: $data)
}
    `;

/**
 * __useDownloadPosReportQuery__
 *
 * To run a query within a React component, call `useDownloadPosReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadPosReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadPosReportQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDownloadPosReportQuery(baseOptions: Apollo.QueryHookOptions<DownloadPosReportQuery, DownloadPosReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadPosReportQuery, DownloadPosReportQueryVariables>(DownloadPosReportDocument, options);
      }
export function useDownloadPosReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadPosReportQuery, DownloadPosReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadPosReportQuery, DownloadPosReportQueryVariables>(DownloadPosReportDocument, options);
        }
export type DownloadPosReportQueryHookResult = ReturnType<typeof useDownloadPosReportQuery>;
export type DownloadPosReportLazyQueryHookResult = ReturnType<typeof useDownloadPosReportLazyQuery>;
export type DownloadPosReportQueryResult = Apollo.QueryResult<DownloadPosReportQuery, DownloadPosReportQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers {
  userMany {
    id
    username
    role
    firstName
    middleName
    lastName
    email
    phoneNumber
    createdDate
    profilePicUrl
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: String, $orgId: String) {
  userOne(id: $id, orgId: $orgId) {
    id
    username
    role
    firstName
    middleName
    lastName
    email
    phoneNumber
    createdDate
    acceptedTAC
    smsConsent
    profilePicUrl
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserPageDocument = gql`
    query GetUserPage($pagination: PaginationInput!) {
  userPage(pagination: $pagination) {
    items {
      id
      username
      role
      firstName
      lastName
      email
      phoneNumber
      createdDate
      profilePicUrl
    }
    totalRows
  }
}
    `;

/**
 * __useGetUserPageQuery__
 *
 * To run a query within a React component, call `useGetUserPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUserPageQuery(baseOptions: Apollo.QueryHookOptions<GetUserPageQuery, GetUserPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPageQuery, GetUserPageQueryVariables>(GetUserPageDocument, options);
      }
export function useGetUserPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPageQuery, GetUserPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPageQuery, GetUserPageQueryVariables>(GetUserPageDocument, options);
        }
export type GetUserPageQueryHookResult = ReturnType<typeof useGetUserPageQuery>;
export type GetUserPageLazyQueryHookResult = ReturnType<typeof useGetUserPageLazyQuery>;
export type GetUserPageQueryResult = Apollo.QueryResult<GetUserPageQuery, GetUserPageQueryVariables>;
export const GetIsUsernameAvailableDocument = gql`
    query GetIsUsernameAvailable($username: String!) {
  checkUsernameAvailability(username: $username)
}
    `;

/**
 * __useGetIsUsernameAvailableQuery__
 *
 * To run a query within a React component, call `useGetIsUsernameAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsUsernameAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsUsernameAvailableQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetIsUsernameAvailableQuery(baseOptions: Apollo.QueryHookOptions<GetIsUsernameAvailableQuery, GetIsUsernameAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsUsernameAvailableQuery, GetIsUsernameAvailableQueryVariables>(GetIsUsernameAvailableDocument, options);
      }
export function useGetIsUsernameAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsUsernameAvailableQuery, GetIsUsernameAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsUsernameAvailableQuery, GetIsUsernameAvailableQueryVariables>(GetIsUsernameAvailableDocument, options);
        }
export type GetIsUsernameAvailableQueryHookResult = ReturnType<typeof useGetIsUsernameAvailableQuery>;
export type GetIsUsernameAvailableLazyQueryHookResult = ReturnType<typeof useGetIsUsernameAvailableLazyQuery>;
export type GetIsUsernameAvailableQueryResult = Apollo.QueryResult<GetIsUsernameAvailableQuery, GetIsUsernameAvailableQueryVariables>;